(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired530"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired530"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1IVwU", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("9eRl8"))($parcel$resolve("jba44")),
    (parcelRequire("eg86f"))($parcel$resolve("jHiBg"))
]).then(function() {
    return parcelRequire('2jXMD');
});

});
parcelRegister("9eRl8", function(module, exports) {
"use strict";

var $31a2I = parcelRequire("31a2I");
module.exports = $31a2I(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("31a2I", function(module, exports) {
"use strict";
var $23294162c634ba05$var$cachedBundles = {};
var $23294162c634ba05$var$cachedPreloads = {};
var $23294162c634ba05$var$cachedPrefetches = {};
function $23294162c634ba05$var$getCache(type) {
    switch(type){
        case 'preload':
            return $23294162c634ba05$var$cachedPreloads;
        case 'prefetch':
            return $23294162c634ba05$var$cachedPrefetches;
        default:
            return $23294162c634ba05$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $23294162c634ba05$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("eg86f", function(module, exports) {
"use strict";

var $31a2I = parcelRequire("31a2I");
module.exports = $31a2I(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});


parcelRegister("6PUGT", function(module, exports) {

var $cYr9j = parcelRequire("cYr9j");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $FuVm8 = parcelRequire("FuVm8");

var $l29cN = parcelRequire("l29cN");
function _asyncIterator(t) {
    var e, r1, _$i, s = 2;
    for("undefined" != typeof Symbol && (r1 = Symbol.asyncIterator, _$i = Symbol.iterator); s--;){
        if (r1 && null != (e = t[r1])) return e.call(t);
        if (_$i && null != (e = t[_$i])) return new AsyncFromSyncIterator(e.call(t));
        r1 = "@@asyncIterator", _$i = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(t) {
    function e(t) {
        if (Object(t) !== t) return Promise.reject(new TypeError(t + " is not an object."));
        var e = t.done;
        return Promise.resolve(t.value).then(function(t) {
            return {
                value: t,
                done: e
            };
        });
    }
    return AsyncFromSyncIterator = function AsyncFromSyncIterator1(t) {
        this.s = t, this.n = t.next;
    }, AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function next() {
            return e(this.n.apply(this.s, arguments));
        },
        return: function _return(t) {
            var r1 = this.s.return;
            return void 0 === r1 ? Promise.resolve({
                value: t,
                done: !0
            }) : e(r1.apply(this.s, arguments));
        },
        throw: function _throw(t) {
            var r1 = this.s.return;
            return void 0 === r1 ? Promise.reject(t) : e(r1.apply(this.s, arguments));
        }
    }, new AsyncFromSyncIterator(t);
}
var REACT_ELEMENT_TYPE;
function _jsx(t, e, r1, i) {
    REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
    var s = t && t.defaultProps, a = arguments.length - 3;
    if (e || 0 === a || (e = {
        children: void 0
    }), 1 === a) e.children = i;
    else if (a > 1) {
        for(var n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o + 3];
        e.children = n;
    }
    if (e && s) for(var h in s)void 0 === e[h] && (e[h] = s[h]);
    else e || (e = s || {});
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: t,
        key: void 0 === r1 ? null : "" + r1,
        ref: null,
        props: e,
        _owner: null
    };
}
function ownKeys(t, e) {
    var r1 = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var _$i = Object.getOwnPropertySymbols(t);
        e && (_$i = _$i.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r1.push.apply(r1, _$i);
    }
    return r1;
}
function _objectSpread2(t) {
    for(var e = 1; e < arguments.length; e++){
        var r1 = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ownKeys(Object(r1), !0).forEach(function(e) {
            _defineProperty(t, e, r1[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r1)) : ownKeys(Object(r1)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r1, e));
        });
    }
    return t;
}
function _typeof(t) {
    return _typeof = "function" == typeof Symbol && "symbol" == (0, $l0HdX._)(Symbol.iterator) ? function _typeof1(t) {
        return typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
    }, _typeof(t);
}
function _wrapRegExp() {
    _wrapRegExp = function _wrapRegExp1(t, e) {
        return new r1(t, void 0, e);
    };
    var t = RegExp.prototype, e = new WeakMap;
    function r1(t, i, s) {
        var a = new RegExp(t, i);
        return e.set(a, s || e.get(t)), _setPrototypeOf(a, r1.prototype);
    }
    function i(t, r1) {
        var _$i = e.get(r1);
        return Object.keys(_$i).reduce(function(e, r1) {
            return e[r1] = t[_$i[r1]], e;
        }, Object.create(null));
    }
    return _inherits1(r1, RegExp), r1.prototype.exec = function(e) {
        var _$r = t.exec.call(this, e);
        return _$r && (_$r.groups = i(_$r, this)), _$r;
    }, r1.prototype[Symbol.replace] = function(r1, s) {
        if ("string" == typeof s) {
            var a = e.get(this);
            return t[Symbol.replace].call(this, r1, s.replace(/\$<([^>]+)>/g, function(t, e) {
                return "$" + a[e];
            }));
        }
        if ("function" == typeof s) {
            var n = this;
            return t[Symbol.replace].call(this, r1, function() {
                var t = arguments;
                return "object" != (0, $l0HdX._)(t[t.length - 1]) && (t = [].slice.call(t)).push(i(t, n)), s.apply(this, t);
            });
        }
        return t[Symbol.replace].call(this, r1, s);
    }, _wrapRegExp.apply(this, arguments);
}
function _AwaitValue(t) {
    this.wrapped = t;
}
function _AsyncGenerator(t) {
    var e, r1;
    function i(e, r1) {
        try {
            var a = t[e](r1), n = a.value, o = n instanceof _AwaitValue;
            Promise.resolve(o ? n.wrapped : n).then(function(t) {
                o ? i("return" === e ? "return" : "next", t) : s(a.done ? "return" : "normal", t);
            }, function(t) {
                i("throw", t);
            });
        } catch (t) {
            s("throw", t);
        }
    }
    function s(t, s) {
        switch(t){
            case "return":
                e.resolve({
                    value: s,
                    done: !0
                });
                break;
            case "throw":
                e.reject(s);
                break;
            default:
                e.resolve({
                    value: s,
                    done: !1
                });
        }
        (e = e.next) ? i(e.key, e.arg) : r1 = null;
    }
    this._invoke = function(t, s) {
        return new Promise(function(a, n) {
            var o = {
                key: t,
                arg: s,
                resolve: a,
                reject: n,
                next: null
            };
            r1 ? r1 = r1.next = o : (e = r1 = o, i(t, s));
        });
    }, "function" != typeof t.return && (this.return = void 0);
}
function _wrapAsyncGenerator(t) {
    return function() {
        return new _AsyncGenerator(t.apply(this, arguments));
    };
}
function _awaitAsyncGenerator(t) {
    return new _AwaitValue(t);
}
function _asyncGeneratorDelegate(t, e) {
    var r1 = {}, _$i = !1;
    function s(r1, s) {
        return _$i = !0, s = new Promise(function(e) {
            e(t[r1](s));
        }), {
            done: !1,
            value: e(s)
        };
    }
    return r1["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function() {
        return this;
    }, r1.next = function(t) {
        return _$i ? (_$i = !1, t) : s("next", t);
    }, "function" == typeof t.throw && (r1.throw = function(t) {
        if (_$i) throw _$i = !1, t;
        return s("throw", t);
    }), "function" == typeof t.return && (r1.return = function(t) {
        return _$i ? (_$i = !1, t) : s("return", t);
    }), r1;
}
function asyncGeneratorStep(t, e, r1, i, s, a, n) {
    try {
        var o = t[a](n), h = o.value;
    } catch (t) {
        return void r1(t);
    }
    o.done ? e(h) : Promise.resolve(h).then(i, s);
}
function _asyncToGenerator(t) {
    return function() {
        var e = this, r1 = arguments;
        return new Promise(function(i, s) {
            var a = t.apply(e, r1);
            function n(t) {
                asyncGeneratorStep(a, i, s, n, o, "next", t);
            }
            function o(t) {
                asyncGeneratorStep(a, i, s, n, o, "throw", t);
            }
            n(void 0);
        });
    };
}
function _classCallCheck(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, e) {
    for(var r1 = 0; r1 < e.length; r1++){
        var _$i = e[r1];
        _$i.enumerable = _$i.enumerable || !1, _$i.configurable = !0, "value" in _$i && (_$i.writable = !0), Object.defineProperty(t, _$i.key, _$i);
    }
}
function _createClass(t, e, r1) {
    return e && _defineProperties(t.prototype, e), r1 && _defineProperties(t, r1), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
function _defineEnumerableProperties(t, e) {
    for(var r1 in e)(a = e[r1]).configurable = a.enumerable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, r1, a);
    if (Object.getOwnPropertySymbols) for(var _$i = Object.getOwnPropertySymbols(e), s = 0; s < _$i.length; s++){
        var a, n = _$i[s];
        (a = e[n]).configurable = a.enumerable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, n, a);
    }
    return t;
}
function _defaults(t, e) {
    for(var r1 = Object.getOwnPropertyNames(e), _$i = 0; _$i < r1.length; _$i++){
        var s = r1[_$i], a = Object.getOwnPropertyDescriptor(e, s);
        a && a.configurable && void 0 === t[s] && Object.defineProperty(t, s, a);
    }
    return t;
}
function _defineProperty(t, e, r1) {
    return e in t ? Object.defineProperty(t, e, {
        value: r1,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = r1, t;
}
function _extends() {
    return _extends = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var r1 = arguments[e];
            for(var _$i in r1)Object.prototype.hasOwnProperty.call(r1, _$i) && (t[_$i] = r1[_$i]);
        }
        return t;
    }, _extends.apply(this, arguments);
}
function _objectSpread(t) {
    for(var e = 1; e < arguments.length; e++){
        var r1 = null != arguments[e] ? Object(arguments[e]) : {}, _$i = Object.keys(r1);
        "function" == typeof Object.getOwnPropertySymbols && _$i.push.apply(_$i, Object.getOwnPropertySymbols(r1).filter(function(t) {
            return Object.getOwnPropertyDescriptor(r1, t).enumerable;
        })), _$i.forEach(function(e) {
            _defineProperty(t, e, r1[e]);
        });
    }
    return t;
}
function _inherits1(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && _setPrototypeOf(t, e);
}
function _inheritsLoose(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf1(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch (t) {
        return !1;
    }
}
function _construct(t, e, r1) {
    return _construct = _isNativeReflectConstruct() ? Reflect.construct : function _construct1(t, e, r1) {
        var _$i = [
            null
        ];
        _$i.push.apply(_$i, e);
        var s = new (Function.bind.apply(t, _$i));
        return r1 && _setPrototypeOf(s, r1.prototype), s;
    }, _construct.apply(null, arguments);
}
function _isNativeFunction(t) {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
}
function _wrapNativeSuper(t) {
    var e = "function" == typeof Map ? new Map : void 0;
    return _wrapNativeSuper = function _wrapNativeSuper1(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, r1);
        }
        function r1() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return r1.prototype = Object.create(t.prototype, {
            constructor: {
                value: r1,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(r1, t);
    }, _wrapNativeSuper(t);
}
function _instanceof(t, e) {
    return null != e && "undefined" != typeof Symbol && e[Symbol.hasInstance] ? !!e[Symbol.hasInstance](t) : t instanceof e;
}
function _interopRequireDefault(t) {
    return t && t.__esModule ? t : {
        default: t
    };
}
function _getRequireWildcardCache(t) {
    if ("function" != typeof WeakMap) return null;
    var e = new WeakMap, r1 = new WeakMap;
    return (_getRequireWildcardCache = function _getRequireWildcardCache1(t) {
        return t ? r1 : e;
    })(t);
}
function _interopRequireWildcard(t, e) {
    if (!e && t && t.__esModule) return t;
    if (null === t || "object" != (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) && "function" != typeof t) return {
        default: t
    };
    var r1 = _getRequireWildcardCache(e);
    if (r1 && r1.has(t)) return r1.get(t);
    var _$i = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var a in t)if ("default" !== a && Object.prototype.hasOwnProperty.call(t, a)) {
        var n = s ? Object.getOwnPropertyDescriptor(t, a) : null;
        n && (n.get || n.set) ? Object.defineProperty(_$i, a, n) : _$i[a] = t[a];
    }
    return _$i.default = t, r1 && r1.set(t, _$i), _$i;
}
function _newArrowCheck(t, e) {
    if (t !== e) throw new TypeError("Cannot instantiate an arrow function");
}
function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure undefined");
}
function _objectWithoutPropertiesLoose(t, e) {
    if (null == t) return {};
    var r1, _$i, s = {}, a = Object.keys(t);
    for(_$i = 0; _$i < a.length; _$i++)r1 = a[_$i], e.indexOf(r1) >= 0 || (s[r1] = t[r1]);
    return s;
}
function _objectWithoutProperties(t, e) {
    if (null == t) return {};
    var r1, _$i, s = _objectWithoutPropertiesLoose(t, e);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        for(_$i = 0; _$i < a.length; _$i++)r1 = a[_$i], e.indexOf(r1) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r1) && (s[r1] = t[r1]);
    }
    return s;
}
function _assertThisInitialized(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
}
function _createSuper(t) {
    var e = _isNativeReflectConstruct();
    return function() {
        var r1, _$i = _getPrototypeOf(t);
        if (e) {
            var s = _getPrototypeOf(this).constructor;
            r1 = Reflect.construct(_$i, arguments, s);
        } else r1 = _$i.apply(this, arguments);
        return _possibleConstructorReturn(this, r1);
    };
}
function _superPropBase(t, e) {
    for(; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = _getPrototypeOf(t)););
    return t;
}
function _get1() {
    return _get1 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function _get11(t, e, r1) {
        var _$i = _superPropBase(t, e);
        if (_$i) {
            var s = Object.getOwnPropertyDescriptor(_$i, e);
            return s.get ? s.get.call(arguments.length < 3 ? t : r1) : s.value;
        }
    }, _get1.apply(this, arguments);
}
function set(t, e, r1, i) {
    return set = "undefined" != typeof Reflect && Reflect.set ? Reflect.set : function set1(t, e, r1, i) {
        var s, a = _superPropBase(t, e);
        if (a) {
            if ((s = Object.getOwnPropertyDescriptor(a, e)).set) return s.set.call(i, r1), !0;
            if (!s.writable) return !1;
        }
        if (s = Object.getOwnPropertyDescriptor(i, e)) {
            if (!s.writable) return !1;
            s.value = r1, Object.defineProperty(i, e, s);
        } else _defineProperty(i, e, r1);
        return !0;
    }, set(t, e, r1, i);
}
function _set(t, e, r1, i, s) {
    if (!set(t, e, r1, i || t) && s) throw new Error("failed to set property");
    return r1;
}
function _taggedTemplateLiteral(t, e) {
    return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
        raw: {
            value: Object.freeze(e)
        }
    }));
}
function _taggedTemplateLiteralLoose(t, e) {
    return e || (e = t.slice(0)), t.raw = e, t;
}
function _readOnlyError(t) {
    throw new TypeError('"' + t + '" is read-only');
}
function _writeOnlyError(t) {
    throw new TypeError('"' + t + '" is write-only');
}
function _classNameTDZError(t) {
    throw new Error('Class "' + t + '" cannot be referenced in computed property keys.');
}
function _temporalUndefined() {}
function _tdz(t) {
    throw new ReferenceError(t + " is not defined - temporal dead zone");
}
function _temporalRef(t, e) {
    return t === _temporalUndefined ? _tdz(e) : t;
}
function _slicedToArray(t, e) {
    return _arrayWithHoles(t) || _iterableToArrayLimit(t, e) || _unsupportedIterableToArray(t, e) || _nonIterableRest();
}
function _slicedToArrayLoose(t, e) {
    return _arrayWithHoles(t) || _iterableToArrayLimitLoose(t, e) || _unsupportedIterableToArray(t, e) || _nonIterableRest();
}
function _toArray(t) {
    return _arrayWithHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableRest();
}
function _toConsumableArray(t) {
    return _arrayWithoutHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableSpread();
}
function _arrayWithoutHoles(t) {
    if (Array.isArray(t)) return _arrayLikeToArray(t);
}
function _arrayWithHoles(t) {
    if (Array.isArray(t)) return t;
}
function _maybeArrayLike(t, e, r1) {
    if (e && !Array.isArray(e) && "number" == typeof e.length) {
        var _$i = e.length;
        return _arrayLikeToArray(e, void 0 !== r1 && r1 < _$i ? r1 : _$i);
    }
    return t(e, r1);
}
function _iterableToArray(t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
}
function _iterableToArrayLimit(t, e) {
    var r1 = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null != r1) {
        var _$i, s, a = [], n = !0, o = !1;
        try {
            for(r1 = r1.call(t); !(n = (_$i = r1.next()).done) && (a.push(_$i.value), !e || a.length !== e); n = !0);
        } catch (t) {
            o = !0, s = t;
        } finally{
            try {
                n || null == r1.return || r1.return();
            } finally{
                if (o) throw s;
            }
        }
        return a;
    }
}
function _iterableToArrayLimitLoose(t, e) {
    var r1 = t && ("undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"]);
    if (null != r1) {
        var _$i = [];
        for(r1 = r1.call(t), _step; !(_step = r1.next()).done && (_$i.push(_step.value), !e || _$i.length !== e););
        return _$i;
    }
}
function _unsupportedIterableToArray(t, e) {
    if (t) {
        if ("string" == typeof t) return _arrayLikeToArray(t, e);
        var r1 = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === r1 && t.constructor && (r1 = t.constructor.name), "Map" === r1 || "Set" === r1 ? Array.from(t) : "Arguments" === r1 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r1) ? _arrayLikeToArray(t, e) : void 0;
    }
}
function _arrayLikeToArray(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var r1 = 0, _$i = new Array(e); r1 < e; r1++)_$i[r1] = t[r1];
    return _$i;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(t, e) {
    var r1 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (!r1) {
        if (Array.isArray(t) || (r1 = _unsupportedIterableToArray(t)) || e && t && "number" == typeof t.length) {
            r1 && (t = r1);
            var _$i = 0, s = function s() {};
            return {
                s: s,
                n: function n() {
                    return _$i >= t.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t[_$i++]
                    };
                },
                e: function e(t) {
                    throw t;
                },
                f: s
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var a, n = !0, o = !1;
    return {
        s: function s() {
            r1 = r1.call(t);
        },
        n: function n1() {
            var _$t = r1.next();
            return n = _$t.done, _$t;
        },
        e: function e(t) {
            o = !0, a = t;
        },
        f: function f() {
            try {
                n || null == r1.return || r1.return();
            } finally{
                if (o) throw a;
            }
        }
    };
}
function _createForOfIteratorHelperLoose(t, e) {
    var r1 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (r1) return (r1 = r1.call(t)).next.bind(r1);
    if (Array.isArray(t) || (r1 = _unsupportedIterableToArray(t)) || e && t && "number" == typeof t.length) {
        r1 && (t = r1);
        var _$i = 0;
        return function() {
            return _$i >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[_$i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _skipFirstGeneratorNext(t) {
    return function() {
        var e = t.apply(this, arguments);
        return e.next(), e;
    };
}
function _toPrimitive(t, e) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) || null === t) return t;
    var r1 = t[Symbol.toPrimitive];
    if (void 0 !== r1) {
        var _$i = r1.call(t, e || "default");
        if ("object" != (typeof _$i === "undefined" ? "undefined" : (0, $l0HdX._)(_$i))) return _$i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
}
function _toPropertyKey(t) {
    var e = _toPrimitive(t, "string");
    return "symbol" == (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) ? e : String(e);
}
function _initializerWarningHelper(t, e) {
    throw new Error("Decorating class property failed. Please ensure that proposal-class-properties is enabled and runs after the decorators transform.");
}
function _initializerDefineProperty(t, e, r1, i) {
    r1 && Object.defineProperty(t, e, {
        enumerable: r1.enumerable,
        configurable: r1.configurable,
        writable: r1.writable,
        value: r1.initializer ? r1.initializer.call(i) : void 0
    });
}
function _applyDecoratedDescriptor(t, e, r1, i, s) {
    var a = {};
    return Object.keys(i).forEach(function(t) {
        a[t] = i[t];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r1.slice().reverse().reduce(function(r1, i) {
        return i(t, e, r1) || r1;
    }, a), s && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(s) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(t, e, a), a = null), a;
}
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
}, _AsyncGenerator.prototype.next = function(t) {
    return this._invoke("next", t);
}, _AsyncGenerator.prototype.throw = function(t) {
    return this._invoke("throw", t);
}, _AsyncGenerator.prototype.return = function(t) {
    return this._invoke("return", t);
};
var id = 0;
function _classPrivateFieldLooseKey(t) {
    return "__private_" + id++ + "_" + t;
}
function _classPrivateFieldLooseBase(t, e) {
    if (!Object.prototype.hasOwnProperty.call(t, e)) throw new TypeError("attempted to use private field on non-instance");
    return t;
}
function _classPrivateFieldGet(t, e) {
    return _classApplyDescriptorGet(t, _classExtractFieldDescriptor(t, e, "get"));
}
function _classPrivateFieldSet(t, e, r1) {
    return _classApplyDescriptorSet(t, _classExtractFieldDescriptor(t, e, "set"), r1), r1;
}
function _classPrivateFieldDestructureSet(t, e) {
    return _classApplyDescriptorDestructureSet(t, _classExtractFieldDescriptor(t, e, "set"));
}
function _classExtractFieldDescriptor(t, e, r1) {
    if (!e.has(t)) throw new TypeError("attempted to " + r1 + " private field on non-instance");
    return e.get(t);
}
function _classStaticPrivateFieldSpecGet(t, e, r1) {
    return _classCheckPrivateStaticAccess(t, e), _classCheckPrivateStaticFieldDescriptor(r1, "get"), _classApplyDescriptorGet(t, r1);
}
function _classStaticPrivateFieldSpecSet(t, e, r1, i) {
    return _classCheckPrivateStaticAccess(t, e), _classCheckPrivateStaticFieldDescriptor(r1, "set"), _classApplyDescriptorSet(t, r1, i), i;
}
function _classStaticPrivateMethodGet(t, e, r1) {
    return _classCheckPrivateStaticAccess(t, e), r1;
}
function _classStaticPrivateMethodSet() {
    throw new TypeError("attempted to set read only static private field");
}
function _classApplyDescriptorGet(t, e) {
    return e.get ? e.get.call(t) : e.value;
}
function _classApplyDescriptorSet(t, e, r1) {
    if (e.set) e.set.call(t, r1);
    else {
        if (!e.writable) throw new TypeError("attempted to set read only private field");
        e.value = r1;
    }
}
function _classApplyDescriptorDestructureSet(t, e) {
    if (e.set) return "__destrObj" in e || (e.__destrObj = {
        set value (r){
            e.set.call(t, r);
        }
    }), e.__destrObj;
    if (!e.writable) throw new TypeError("attempted to set read only private field");
    return e;
}
function _classStaticPrivateFieldDestructureSet(t, e, r1) {
    return _classCheckPrivateStaticAccess(t, e), _classCheckPrivateStaticFieldDescriptor(r1, "set"), _classApplyDescriptorDestructureSet(t, r1);
}
function _classCheckPrivateStaticAccess(t, e) {
    if (t !== e) throw new TypeError("Private static access of wrong provenance");
}
function _classCheckPrivateStaticFieldDescriptor(t, e) {
    if (void 0 === t) throw new TypeError("attempted to " + e + " private static field before its declaration");
}
function _decorate(t, e, r1, i) {
    var s = _getDecoratorsApi();
    if (i) for(var a = 0; a < i.length; a++)s = i[a](s);
    var n = e(function(t) {
        s.initializeInstanceElements(t, o.elements);
    }, r1), o = s.decorateClass(_coalesceClassElements(n.d.map(_createElementDescriptor)), t);
    return s.initializeClassElements(n.F, o.elements), s.runClassFinishers(n.F, o.finishers);
}
function _getDecoratorsApi() {
    _getDecoratorsApi = function _getDecoratorsApi1() {
        return t;
    };
    var t = {
        elementsDefinitionOrder: [
            [
                "method"
            ],
            [
                "field"
            ]
        ],
        initializeInstanceElements: function initializeInstanceElements(t, e) {
            [
                "method",
                "field"
            ].forEach(function(r1) {
                e.forEach(function(e) {
                    e.kind === r1 && "own" === e.placement && this.defineClassElement(t, e);
                }, this);
            }, this);
        },
        initializeClassElements: function initializeClassElements(t, e) {
            var r1 = t.prototype;
            [
                "method",
                "field"
            ].forEach(function(i) {
                e.forEach(function(e) {
                    var s = e.placement;
                    if (e.kind === i && ("static" === s || "prototype" === s)) {
                        var a = "static" === s ? t : r1;
                        this.defineClassElement(a, e);
                    }
                }, this);
            }, this);
        },
        defineClassElement: function defineClassElement(t, e) {
            var r1 = e.descriptor;
            if ("field" === e.kind) {
                var _$i = e.initializer;
                r1 = {
                    enumerable: r1.enumerable,
                    writable: r1.writable,
                    configurable: r1.configurable,
                    value: void 0 === _$i ? void 0 : _$i.call(t)
                };
            }
            Object.defineProperty(t, e.key, r1);
        },
        decorateClass: function decorateClass(t, e) {
            var r1 = [], _$i = [], s = {
                static: [],
                prototype: [],
                own: []
            };
            if (t.forEach(function(t) {
                this.addElementPlacement(t, s);
            }, this), t.forEach(function(t) {
                if (!_hasDecorators(t)) return r1.push(t);
                var _$e = this.decorateElement(t, s);
                r1.push(_$e.element), r1.push.apply(r1, _$e.extras), _$i.push.apply(_$i, _$e.finishers);
            }, this), !e) return {
                elements: r1,
                finishers: _$i
            };
            var a = this.decorateConstructor(r1, e);
            return _$i.push.apply(_$i, a.finishers), a.finishers = _$i, a;
        },
        addElementPlacement: function addElementPlacement(t, e, r1) {
            var _$i = e[t.placement];
            if (!r1 && -1 !== _$i.indexOf(t.key)) throw new TypeError("Duplicated element (" + t.key + ")");
            _$i.push(t.key);
        },
        decorateElement: function decorateElement(t, e) {
            for(var r1 = [], _$i = [], s = t.decorators, a = s.length - 1; a >= 0; a--){
                var n = e[t.placement];
                n.splice(n.indexOf(t.key), 1);
                var o = this.fromElementDescriptor(t), h = this.toElementFinisherExtras((0, s[a])(o) || o);
                t = h.element, this.addElementPlacement(t, e), h.finisher && _$i.push(h.finisher);
                var l = h.extras;
                if (l) {
                    for(var p = 0; p < l.length; p++)this.addElementPlacement(l[p], e);
                    r1.push.apply(r1, l);
                }
            }
            return {
                element: t,
                finishers: _$i,
                extras: r1
            };
        },
        decorateConstructor: function decorateConstructor(t, e) {
            for(var r1 = [], _$i = e.length - 1; _$i >= 0; _$i--){
                var s = this.fromClassDescriptor(t), a = this.toClassDescriptor((0, e[_$i])(s) || s);
                if (void 0 !== a.finisher && r1.push(a.finisher), void 0 !== a.elements) {
                    t = a.elements;
                    for(var n = 0; n < t.length - 1; n++)for(var o = n + 1; o < t.length; o++)if (t[n].key === t[o].key && t[n].placement === t[o].placement) throw new TypeError("Duplicated element (" + t[n].key + ")");
                }
            }
            return {
                elements: t,
                finishers: r1
            };
        },
        fromElementDescriptor: function fromElementDescriptor(t) {
            var e = {
                kind: t.kind,
                key: t.key,
                placement: t.placement,
                descriptor: t.descriptor
            };
            return Object.defineProperty(e, Symbol.toStringTag, {
                value: "Descriptor",
                configurable: !0
            }), "field" === t.kind && (e.initializer = t.initializer), e;
        },
        toElementDescriptors: function toElementDescriptors(t) {
            if (void 0 !== t) return _toArray(t).map(function(t) {
                var e = this.toElementDescriptor(t);
                return this.disallowProperty(t, "finisher", "An element descriptor"), this.disallowProperty(t, "extras", "An element descriptor"), e;
            }, this);
        },
        toElementDescriptor: function toElementDescriptor(t) {
            var e = String(t.kind);
            if ("method" !== e && "field" !== e) throw new TypeError('An element descriptor\'s .kind property must be either "method" or "field", but a decorator created an element descriptor with .kind "' + e + '"');
            var r1 = _toPropertyKey(t.key), _$i = String(t.placement);
            if ("static" !== _$i && "prototype" !== _$i && "own" !== _$i) throw new TypeError('An element descriptor\'s .placement property must be one of "static", "prototype" or "own", but a decorator created an element descriptor with .placement "' + _$i + '"');
            var s = t.descriptor;
            this.disallowProperty(t, "elements", "An element descriptor");
            var a = {
                kind: e,
                key: r1,
                placement: _$i,
                descriptor: Object.assign({}, s)
            };
            return "field" !== e ? this.disallowProperty(t, "initializer", "A method descriptor") : (this.disallowProperty(s, "get", "The property descriptor of a field descriptor"), this.disallowProperty(s, "set", "The property descriptor of a field descriptor"), this.disallowProperty(s, "value", "The property descriptor of a field descriptor"), a.initializer = t.initializer), a;
        },
        toElementFinisherExtras: function toElementFinisherExtras(t) {
            return {
                element: this.toElementDescriptor(t),
                finisher: _optionalCallableProperty(t, "finisher"),
                extras: this.toElementDescriptors(t.extras)
            };
        },
        fromClassDescriptor: function fromClassDescriptor(t) {
            var e = {
                kind: "class",
                elements: t.map(this.fromElementDescriptor, this)
            };
            return Object.defineProperty(e, Symbol.toStringTag, {
                value: "Descriptor",
                configurable: !0
            }), e;
        },
        toClassDescriptor: function toClassDescriptor(t) {
            var e = String(t.kind);
            if ("class" !== e) throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator created a class descriptor with .kind "' + e + '"');
            this.disallowProperty(t, "key", "A class descriptor"), this.disallowProperty(t, "placement", "A class descriptor"), this.disallowProperty(t, "descriptor", "A class descriptor"), this.disallowProperty(t, "initializer", "A class descriptor"), this.disallowProperty(t, "extras", "A class descriptor");
            var r1 = _optionalCallableProperty(t, "finisher");
            return {
                elements: this.toElementDescriptors(t.elements),
                finisher: r1
            };
        },
        runClassFinishers: function runClassFinishers(t, e) {
            for(var r1 = 0; r1 < e.length; r1++){
                var _$i = (0, e[r1])(t);
                if (void 0 !== _$i) {
                    if ("function" != typeof _$i) throw new TypeError("Finishers must return a constructor.");
                    t = _$i;
                }
            }
            return t;
        },
        disallowProperty: function disallowProperty(t, e, r1) {
            if (void 0 !== t[e]) throw new TypeError(r1 + " can't have a ." + e + " property.");
        }
    };
    return t;
}
function _createElementDescriptor(t) {
    var e, r1 = _toPropertyKey(t.key);
    "method" === t.kind ? e = {
        value: t.value,
        writable: !0,
        configurable: !0,
        enumerable: !1
    } : "get" === t.kind ? e = {
        get: t.value,
        configurable: !0,
        enumerable: !1
    } : "set" === t.kind ? e = {
        set: t.value,
        configurable: !0,
        enumerable: !1
    } : "field" === t.kind && (e = {
        configurable: !0,
        writable: !0,
        enumerable: !0
    });
    var _$i = {
        kind: "field" === t.kind ? "field" : "method",
        key: r1,
        placement: t.static ? "static" : "field" === t.kind ? "own" : "prototype",
        descriptor: e
    };
    return t.decorators && (_$i.decorators = t.decorators), "field" === t.kind && (_$i.initializer = t.value), _$i;
}
function _coalesceGetterSetter(t, e) {
    void 0 !== t.descriptor.get ? e.descriptor.get = t.descriptor.get : e.descriptor.set = t.descriptor.set;
}
function _coalesceClassElements(t) {
    for(var e = [], r1 = function r1(t) {
        return "method" === t.kind && t.key === a.key && t.placement === a.placement;
    }, _$i = 0; _$i < t.length; _$i++){
        var s, a = t[_$i];
        if ("method" === a.kind && (s = e.find(r1))) {
            if (_isDataDescriptor(a.descriptor) || _isDataDescriptor(s.descriptor)) {
                if (_hasDecorators(a) || _hasDecorators(s)) throw new ReferenceError("Duplicated methods (" + a.key + ") can't be decorated.");
                s.descriptor = a.descriptor;
            } else {
                if (_hasDecorators(a)) {
                    if (_hasDecorators(s)) throw new ReferenceError("Decorators can't be placed on different accessors with for the same property (" + a.key + ").");
                    s.decorators = a.decorators;
                }
                _coalesceGetterSetter(a, s);
            }
        } else e.push(a);
    }
    return e;
}
function _hasDecorators(t) {
    return t.decorators && t.decorators.length;
}
function _isDataDescriptor(t) {
    return void 0 !== t && !(void 0 === t.value && void 0 === t.writable);
}
function _optionalCallableProperty(t, e) {
    var r1 = t[e];
    if (void 0 !== r1 && "function" != typeof r1) throw new TypeError("Expected '" + e + "' to be a function");
    return r1;
}
function _classPrivateMethodGet(t, e, r1) {
    if (!e.has(t)) throw new TypeError("attempted to get private field on non-instance");
    return r1;
}
function _checkPrivateRedeclaration(t, e) {
    if (e.has(t)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classPrivateFieldInitSpec(t, e, r1) {
    _checkPrivateRedeclaration(t, e), e.set(t, r1);
}
function _classPrivateMethodInitSpec(t, e) {
    _checkPrivateRedeclaration(t, e), e.add(t);
}
function _classPrivateMethodSet() {
    throw new TypeError("attempted to reassign private method");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var _extendStatics = function _extendStatics1(t, e) {
    return _extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r1 in e)Object.prototype.hasOwnProperty.call(e, r1) && (t[r1] = e[r1]);
    }, _extendStatics(t, e);
};
function __extends(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r1() {
        this.constructor = t;
    }
    _extendStatics(t, e), t.prototype = null === e ? Object.create(e) : (r1.prototype = e.prototype, new r1);
}
var _assign = function _assign1() {
    return _assign = Object.assign || function(t) {
        for(var e, r1 = 1, _$i = arguments.length; r1 < _$i; r1++)for(var s in e = arguments[r1])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
        return t;
    }, _assign.apply(this, arguments);
};
function __rest(t, e) {
    var r1 = {};
    for(var _$i in t)Object.prototype.hasOwnProperty.call(t, _$i) && e.indexOf(_$i) < 0 && (r1[_$i] = t[_$i]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var s = 0;
        for(_$i = Object.getOwnPropertySymbols(t); s < _$i.length; s++)e.indexOf(_$i[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, _$i[s]) && (r1[_$i[s]] = t[_$i[s]]);
    }
    return r1;
}
function __decorate(t, e, r1, i) {
    var s, a = arguments.length, n = a < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, r1) : i;
    if ("object" == (typeof Reflect === "undefined" ? "undefined" : (0, $l0HdX._)(Reflect)) && "function" == typeof Reflect.decorate) n = Reflect.decorate(t, e, r1, i);
    else for(var o = t.length - 1; o >= 0; o--)(s = t[o]) && (n = (a < 3 ? s(n) : a > 3 ? s(e, r1, n) : s(e, r1)) || n);
    return a > 3 && n && Object.defineProperty(e, r1, n), n;
}
function __param(t, e) {
    return function(r1, i) {
        e(r1, i, t);
    };
}
function __metadata(t, e) {
    if ("object" == (typeof Reflect === "undefined" ? "undefined" : (0, $l0HdX._)(Reflect)) && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
}
function __awaiter(t, e, r1, i) {
    return new (r1 || (r1 = Promise))(function(s, a) {
        function n(t) {
            try {
                h(i.next(t));
            } catch (t) {
                a(t);
            }
        }
        function o(t) {
            try {
                h(i.throw(t));
            } catch (t) {
                a(t);
            }
        }
        function h(t) {
            var _$e;
            t.done ? s(t.value) : (_$e = t.value, _$e instanceof r1 ? _$e : new r1(function(t) {
                t(_$e);
            })).then(n, o);
        }
        h((i = i.apply(t, e || [])).next());
    });
}
function __generator(t, e) {
    var r1, _$i, s, a, n = {
        label: 0,
        sent: function sent() {
            if (1 & s[0]) throw s[1];
            return s[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function o(a) {
        return function(o) {
            return function(a) {
                if (r1) throw new TypeError("Generator is already executing.");
                for(; n;)try {
                    if (r1 = 1, _$i && (s = 2 & a[0] ? _$i.return : a[0] ? _$i.throw || ((s = _$i.return) && s.call(_$i), 0) : _$i.next) && !(s = s.call(_$i, a[1])).done) return s;
                    switch(_$i = 0, s && (a = [
                        2 & a[0],
                        s.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            s = a;
                            break;
                        case 4:
                            return n.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            n.label++, _$i = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = n.ops.pop(), n.trys.pop();
                            continue;
                        default:
                            if (!(s = n.trys, (s = s.length > 0 && s[s.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                n = 0;
                                continue;
                            }
                            if (3 === a[0] && (!s || a[1] > s[0] && a[1] < s[3])) {
                                n.label = a[1];
                                break;
                            }
                            if (6 === a[0] && n.label < s[1]) {
                                n.label = s[1], s = a;
                                break;
                            }
                            if (s && n.label < s[2]) {
                                n.label = s[2], n.ops.push(a);
                                break;
                            }
                            s[2] && n.ops.pop(), n.trys.pop();
                            continue;
                    }
                    a = e.call(t, n);
                } catch (t) {
                    a = [
                        6,
                        t
                    ], _$i = 0;
                } finally{
                    r1 = s = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                o
            ]);
        };
    }
}
var __createBinding = Object.create ? function __createBinding(t, e, r1, i) {
    void 0 === i && (i = r1), Object.defineProperty(t, i, {
        enumerable: !0,
        get: function get() {
            return e[r1];
        }
    });
} : function(t, e, r1, i) {
    void 0 === i && (i = r1), t[i] = e[r1];
};
function __exportStar(t, e) {
    for(var r1 in t)"default" === r1 || Object.prototype.hasOwnProperty.call(e, r1) || __createBinding(e, t, r1);
}
function __values(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r1 = e && t[e], _$i = 0;
    if (r1) return r1.call(t);
    if (t && "number" == typeof t.length) return {
        next: function next() {
            return t && _$i >= t.length && (t = void 0), {
                value: t && t[_$i++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(t, e) {
    var r1 = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r1) return t;
    var _$i, s, a = r1.call(t), n = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(_$i = a.next()).done;)n.push(_$i.value);
    } catch (t) {
        s = {
            error: t
        };
    } finally{
        try {
            _$i && !_$i.done && (r1 = a.return) && r1.call(a);
        } finally{
            if (s) throw s.error;
        }
    }
    return n;
}
function __spread() {
    for(var t = [], e = 0; e < arguments.length; e++)t = t.concat(__read(arguments[e]));
    return t;
}
function __spreadArrays() {
    for(var t = 0, e = 0, r1 = arguments.length; e < r1; e++)t += arguments[e].length;
    var _$i = Array(t), s = 0;
    for(e = 0; e < r1; e++)for(var a = arguments[e], n = 0, o = a.length; n < o; n++, s++)_$i[s] = a[n];
    return _$i;
}
function __spreadArray(t, e, r1) {
    if (r1 || 2 === arguments.length) for(var _$i, s = 0, a = e.length; s < a; s++)!_$i && s in e || (_$i || (_$i = Array.prototype.slice.call(e, 0, s)), _$i[s] = e[s]);
    return t.concat(_$i || Array.prototype.slice.call(e));
}
function __await(t) {
    return this instanceof __await ? (this.v = t, this) : new __await(t);
}
function __asyncGenerator(t, e, r1) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var _$i, s = r1.apply(t, e || []), a = [];
    return _$i = {}, n("next"), n("throw"), n("return"), _$i[Symbol.asyncIterator] = function() {
        return this;
    }, _$i;
    function n(t) {
        s[t] && (_$i[t] = function(e) {
            return new Promise(function(r1, i) {
                a.push([
                    t,
                    e,
                    r1,
                    i
                ]) > 1 || o(t, e);
            });
        });
    }
    function o(t, e) {
        try {
            !function(t) {
                t.value instanceof __await ? Promise.resolve(t.value.v).then(h, l) : p(a[0][2], t);
            }(s[t](e));
        } catch (t) {
            p(a[0][3], t);
        }
    }
    function h(t) {
        o("next", t);
    }
    function l(t) {
        o("throw", t);
    }
    function p(t, e) {
        t(e), a.shift(), a.length && o(a[0][0], a[0][1]);
    }
}
function __asyncDelegator(t) {
    var e, r1;
    return e = {}, i("next"), i("throw", function(t) {
        throw t;
    }), i("return"), e[Symbol.iterator] = function() {
        return this;
    }, e;
    function i(i, s) {
        e[i] = t[i] ? function(e) {
            return (r1 = !r1) ? {
                value: __await(t[i](e)),
                done: "return" === i
            } : s ? s(e) : e;
        } : s;
    }
}
function __asyncValues(t) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var e, r1 = t[Symbol.asyncIterator];
    return r1 ? r1.call(t) : (t = "function" == typeof __values ? __values(t) : t[Symbol.iterator](), e = {}, i("next"), i("throw"), i("return"), e[Symbol.asyncIterator] = function() {
        return this;
    }, e);
    function i(r1) {
        e[r1] = t[r1] && function(e) {
            return new Promise(function(i, s) {
                (function(t, e, r1, i) {
                    Promise.resolve(i).then(function(e) {
                        t({
                            value: e,
                            done: r1
                        });
                    }, e);
                })(i, s, (e = t[r1](e)).done, e.value);
            });
        };
    }
}
function __makeTemplateObject(t, e) {
    return Object.defineProperty ? Object.defineProperty(t, "raw", {
        value: e
    }) : t.raw = e, t;
}
var __setModuleDefault = Object.create ? function __setModuleDefault(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
};
function __importStar(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for(var r1 in t)"default" !== r1 && Object.prototype.hasOwnProperty.call(t, r1) && __createBinding(e, t, r1);
    return __setModuleDefault(e, t), e;
}
function __importDefault(t) {
    return t && t.__esModule ? t : {
        default: t
    };
}
function __classPrivateFieldGet(t, e, r1, i) {
    if ("a" === r1 && !i) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r1 ? i : "a" === r1 ? i.call(t) : i ? i.value : e.get(t);
}
function __classPrivateFieldSet(t, e, r1, i, s) {
    if ("m" === i) throw new TypeError("Private method is not writable");
    if ("a" === i && !s) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof e ? t !== e || !s : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === i ? s.call(t, r1) : s ? s.value = r1 : e.set(t, r1), r1;
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ }
var t$3 = window.ShadowRoot && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, e$8 = Symbol(), n$5 = new Map;
var s$3 = /*#__PURE__*/ function() {
    "use strict";
    function s$3(t, e) {
        (0, $4GJKx._)(this, s$3);
        if (this._$cssResult$ = !0, e !== e$8) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t;
    }
    (0, $1wc17._)(s$3, [
        {
            key: "styleSheet",
            get: function get() {
                var t = n$5.get(this.cssText);
                return t$3 && void 0 === t && (n$5.set(this.cssText, t = new CSSStyleSheet), t.replaceSync(this.cssText)), t;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.cssText;
            }
        }
    ]);
    return s$3;
}();
var o$5 = function(t) {
    return new s$3("string" == typeof t ? t : t + "", e$8);
}, r$3 = function r$3(t) {
    for(var e = arguments.length, r1 = new Array(e > 1 ? e - 1 : 0), _$i = 1; _$i < e; _$i++)r1[_$i - 1] = arguments[_$i];
    var s = 1 === t.length ? t[0] : r1.reduce(function(e, r1, i) {
        return e + function(t) {
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        }(r1) + t[i + 1];
    }, t[0]);
    return new s$3(s, e$8);
}, i$3 = function(t, e) {
    t$3 ? t.adoptedStyleSheets = e.map(function(t) {
        return t instanceof CSSStyleSheet ? t : t.styleSheet;
    }) : e.forEach(function(e) {
        var r1 = document.createElement("style"), _$i = window.litNonce;
        void 0 !== _$i && r1.setAttribute("nonce", _$i), r1.textContent = e.cssText, t.appendChild(r1);
    });
}, S$1 = t$3 ? function(t) {
    return t;
} : function(t) {
    return t instanceof CSSStyleSheet ? function(t) {
        var e = "";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t.cssRules[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r1 = _step1.value;
                e += r1.cssText;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return o$5(e);
    }(t) : t;
}, s$2, e$7 = window.trustedTypes, r$2 = e$7 ? e$7.emptyScript : "", h$2 = window.reactiveElementPolyfillSupport, o$4 = {
    toAttribute: function(t, e) {
        switch(e){
            case Boolean:
                t = t ? r$2 : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute: function(t, e) {
        var r1 = t;
        switch(e){
            case Boolean:
                r1 = null !== t;
                break;
            case Number:
                r1 = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    r1 = JSON.parse(t);
                } catch (t) {
                    r1 = null;
                }
        }
        return r1;
    }
}, n$4 = function(t, e) {
    return e !== t && (e == e || t == t);
}, l$3 = {
    attribute: !0,
    type: String,
    converter: o$4,
    reflect: !1,
    hasChanged: n$4
}, t$2;
var a$1 = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $dcsZi._)(a$1, HTMLElement1);
    function a$1() {
        (0, $4GJKx._)(this, a$1);
        var _this;
        _this = (0, $cYr9j._)(this, a$1), _this._$Et = new Map, _this.isUpdatePending = !1, _this.hasUpdated = !1, _this._$Ei = null, _this.o();
        return _this;
    }
    (0, $1wc17._)(a$1, [
        {
            key: "o",
            value: function o() {
                var _this = this;
                var t;
                this._$Ep = new Promise(function(t) {
                    return _this.enableUpdating = t;
                }), this._$AL = new Map, this._$Em(), this.requestUpdate(), null === (t = this.constructor.l) || void 0 === t || t.forEach(function(t) {
                    return t(_this);
                });
            }
        },
        {
            key: "addController",
            value: function addController(t) {
                var e, r1;
                (null !== (e = this._$Eg) && void 0 !== e ? e : this._$Eg = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (r1 = t.hostConnected) || void 0 === r1 || r1.call(t));
            }
        },
        {
            key: "removeController",
            value: function removeController(t) {
                var e;
                null === (e = this._$Eg) || void 0 === e || e.splice(this._$Eg.indexOf(t) >>> 0, 1);
            }
        },
        {
            key: "_$Em",
            value: function _$Em() {
                var _this = this;
                this.constructor.elementProperties.forEach(function(t, e) {
                    _this.hasOwnProperty(e) && (_this._$Et.set(e, _this[e]), delete _this[e]);
                });
            }
        },
        {
            key: "createRenderRoot",
            value: function createRenderRoot() {
                var t, e = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
                return i$3(e, this.constructor.elementStyles), e;
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var t;
                void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$Eg) || void 0 === t || t.forEach(function(t) {
                    var e;
                    return null === (e = t.hostConnected) || void 0 === e ? void 0 : e.call(t);
                });
            }
        },
        {
            key: "enableUpdating",
            value: function enableUpdating(t) {}
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var t;
                null === (t = this._$Eg) || void 0 === t || t.forEach(function(t) {
                    var e;
                    return null === (e = t.hostDisconnected) || void 0 === e ? void 0 : e.call(t);
                });
            }
        },
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(t, e, r1) {
                this._$AK(t, r1);
            }
        },
        {
            key: "_$ES",
            value: function _$ES(t, e) {
                var r1, _$i, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l$3, a = this.constructor._$Eh(t, s);
                if (void 0 !== a && !0 === s.reflect) {
                    var n = (null !== (_$i = null === (r1 = s.converter) || void 0 === r1 ? void 0 : r1.toAttribute) && void 0 !== _$i ? _$i : o$4.toAttribute)(e, s.type);
                    this._$Ei = t, null == n ? this.removeAttribute(a) : this.setAttribute(a, n), this._$Ei = null;
                }
            }
        },
        {
            key: "_$AK",
            value: function _$AK(t, e) {
                var r1, _$i, s, a = this.constructor, n = a._$Eu.get(t);
                if (void 0 !== n && this._$Ei !== n) {
                    var o = a.getPropertyOptions(n), h = o.converter, l = null !== (s = null !== (_$i = null === (r1 = h) || void 0 === r1 ? void 0 : r1.fromAttribute) && void 0 !== _$i ? _$i : "function" == typeof h ? h : null) && void 0 !== s ? s : o$4.fromAttribute;
                    this._$Ei = n, this[n] = l(e, o.type), this._$Ei = null;
                }
            }
        },
        {
            key: "requestUpdate",
            value: function requestUpdate(t, e, r1) {
                var _$i = !0;
                void 0 !== t && (((r1 = r1 || this.constructor.getPropertyOptions(t)).hasChanged || n$4)(this[t], e) ? (this._$AL.has(t) || this._$AL.set(t, e), !0 === r1.reflect && this._$Ei !== t && (void 0 === this._$E_ && (this._$E_ = new Map), this._$E_.set(t, r1))) : _$i = !1), !this.isUpdatePending && _$i && (this._$Ep = this._$EC());
            }
        },
        {
            key: "_$EC",
            value: function _$EC() {
                var t = this;
                return _asyncToGenerator(function() {
                    var e, _$e, _tmp;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t.isUpdatePending = !0;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    t._$Ep
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                Promise.reject(e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _$e = t.scheduleUpdate();
                                _tmp = null != _$e;
                                if (!_tmp) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _$e
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    2,
                                    (_tmp, !t.isUpdatePending)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scheduleUpdate",
            value: function scheduleUpdate() {
                return this.performUpdate();
            }
        },
        {
            key: "performUpdate",
            value: function performUpdate() {
                var _this = this;
                var _$t;
                if (this.isUpdatePending) {
                    this.hasUpdated, this._$Et && (this._$Et.forEach(function(t, e) {
                        return _this[e] = t;
                    }), this._$Et = void 0);
                    var e = !1, r1 = this._$AL;
                    try {
                        (e = this.shouldUpdate(r1)) ? (this.willUpdate(r1), null === (_$t = this._$Eg) || void 0 === _$t || _$t.forEach(function(t) {
                            var e;
                            return null === (e = t.hostUpdate) || void 0 === e ? void 0 : e.call(t);
                        }), this.update(r1)) : this._$EU();
                    } catch (t) {
                        throw e = !1, this._$EU(), t;
                    }
                    e && this._$AE(r1);
                }
            }
        },
        {
            key: "willUpdate",
            value: function willUpdate(t) {}
        },
        {
            key: "_$AE",
            value: function _$AE(t) {
                var e;
                null === (e = this._$Eg) || void 0 === e || e.forEach(function(t) {
                    var e;
                    return null === (e = t.hostUpdated) || void 0 === e ? void 0 : e.call(t);
                }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
            }
        },
        {
            key: "_$EU",
            value: function _$EU() {
                this._$AL = new Map, this.isUpdatePending = !1;
            }
        },
        {
            key: "updateComplete",
            get: function get() {
                return this.getUpdateComplete();
            }
        },
        {
            key: "getUpdateComplete",
            value: function getUpdateComplete() {
                return this._$Ep;
            }
        },
        {
            key: "shouldUpdate",
            value: function shouldUpdate(t) {
                return !0;
            }
        },
        {
            key: "update",
            value: function update(t) {
                var _this = this;
                void 0 !== this._$E_ && (this._$E_.forEach(function(t, e) {
                    return _this._$ES(e, _this[e], t);
                }), this._$E_ = void 0), this._$EU();
            }
        },
        {
            key: "updated",
            value: function updated(t) {}
        },
        {
            key: "firstUpdated",
            value: function firstUpdated(t) {}
        }
    ], [
        {
            key: "addInitializer",
            value: function addInitializer(t) {
                var e;
                null !== (e = this.l) && void 0 !== e || (this.l = []), this.l.push(t);
            }
        },
        {
            key: "observedAttributes",
            get: function get() {
                var _this = this;
                this.finalize();
                var t = [];
                return this.elementProperties.forEach(function(e, r1) {
                    var _$i = _this._$Eh(r1, e);
                    void 0 !== _$i && (_this._$Eu.set(_$i, r1), t.push(_$i));
                }), t;
            }
        },
        {
            key: "createProperty",
            value: function createProperty(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l$3;
                if (e.state && (e.attribute = !1), this.finalize(), this.elementProperties.set(t, e), !e.noAccessor && !this.prototype.hasOwnProperty(t)) {
                    var r1 = "symbol" == (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) ? Symbol() : "__" + t, _$i = this.getPropertyDescriptor(t, r1, e);
                    void 0 !== _$i && Object.defineProperty(this.prototype, t, _$i);
                }
            }
        },
        {
            key: "getPropertyDescriptor",
            value: function getPropertyDescriptor(t, e, r1) {
                return {
                    get: function() {
                        return this[e];
                    },
                    set: function(i) {
                        var s = this[t];
                        this[e] = i, this.requestUpdate(t, s, r1);
                    },
                    configurable: !0,
                    enumerable: !0
                };
            }
        },
        {
            key: "getPropertyOptions",
            value: function getPropertyOptions(t) {
                return this.elementProperties.get(t) || l$3;
            }
        },
        {
            key: "finalize",
            value: function finalize() {
                if (this.hasOwnProperty("finalized")) return !1;
                this.finalized = !0;
                var t = Object.getPrototypeOf(this);
                if (t.finalize(), this.elementProperties = new Map(t.elementProperties), this._$Eu = new Map, this.hasOwnProperty("properties")) {
                    var e = this.properties, r1 = (0, $c6Xmf._)(Object.getOwnPropertyNames(e)).concat((0, $c6Xmf._)(Object.getOwnPropertySymbols(e)));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$i = _step1.value;
                            this.createProperty(_$i, e[_$i]);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return this.elementStyles = this.finalizeStyles(this.styles), !0;
            }
        },
        {
            key: "finalizeStyles",
            value: function finalizeStyles(t) {
                var e = [];
                if (Array.isArray(t)) {
                    var r1 = new Set(t.flat(1 / 0).reverse());
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$i = _step1.value;
                            e.unshift(S$1(_$i));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else void 0 !== t && e.push(S$1(t));
                return e;
            }
        },
        {
            key: "_$Eh",
            value: function _$Eh(t, e) {
                var r1 = e.attribute;
                return !1 === r1 ? void 0 : "string" == typeof r1 ? r1 : "string" == typeof t ? t.toLowerCase() : void 0;
            }
        }
    ]);
    return a$1;
}((0, $FuVm8._)(HTMLElement));
a$1.finalized = !0, a$1.elementProperties = new Map, a$1.elementStyles = [], a$1.shadowRootOptions = {
    mode: "open"
}, null == h$2 || h$2({
    ReactiveElement: a$1
}), (null !== (s$2 = globalThis.reactiveElementVersions) && void 0 !== s$2 ? s$2 : globalThis.reactiveElementVersions = []).push("1.2.1");
var i$2 = globalThis.trustedTypes, s$1 = i$2 ? i$2.createPolicy("lit-html", {
    createHTML: function(t) {
        return t;
    }
}) : void 0, e$6 = "lit$".concat((Math.random() + "").slice(9), "$"), o$3 = "?" + e$6, n$3 = "<".concat(o$3, ">"), l$2 = document, h$1 = function h$1() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return l$2.createComment(t);
}, r$1 = function(t) {
    return null === t || "object" != (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) && "function" != typeof t;
}, d = Array.isArray, u = function(t) {
    var e;
    return d(t) || "function" == typeof (null === (e = t) || void 0 === e ? void 0 : e[Symbol.iterator]);
}, c = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, v = /-->/g, a = />/g, f = />|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g, _ = /'/g, m = /"/g, g = /^(?:script|style|textarea)$/i, p = function(t) {
    return function p(e) {
        for(var r1 = arguments.length, _$i = new Array(r1 > 1 ? r1 - 1 : 0), s = 1; s < r1; s++)_$i[s - 1] = arguments[s];
        return {
            _$litType$: t,
            strings: e,
            values: _$i
        };
    };
}, $ = p(1), y = p(2), b = Symbol.for("lit-noChange"), w = Symbol.for("lit-nothing"), T = new WeakMap, x = function(t, e, r1) {
    var _$i, s, a = null !== (_$i = null == r1 ? void 0 : r1.renderBefore) && void 0 !== _$i ? _$i : e, n = a._$litPart$;
    if (void 0 === n) {
        var o = null !== (s = null == r1 ? void 0 : r1.renderBefore) && void 0 !== s ? s : null;
        a._$litPart$ = n = new N(e.insertBefore(h$1(), o), o, void 0, null != r1 ? r1 : {});
    }
    return n._$AI(t), n;
}, A = l$2.createTreeWalker(l$2, 129, null, !1), C = function(t, e) {
    for(var r1, _$i = t.length - 1, s = [], n = 2 === e ? "<svg>" : "", o = c, h = 0; h < _$i; h++){
        for(var l = t[h], p = void 0, u = void 0, d = -1, y = 0; y < l.length && (o.lastIndex = y, null !== (u = o.exec(l)));)y = o.lastIndex, o === c ? "!--" === u[1] ? o = v : void 0 !== u[1] ? o = a : void 0 !== u[2] ? (g.test(u[2]) && (r1 = RegExp("</" + u[2], "g")), o = f) : void 0 !== u[3] && (o = f) : o === f ? ">" === u[0] ? (o = null != r1 ? r1 : c, d = -1) : void 0 === u[1] ? d = -2 : (d = o.lastIndex - u[2].length, p = u[1], o = void 0 === u[3] ? f : '"' === u[3] ? m : _) : o === m || o === _ ? o = f : o === v || o === a ? o = c : (o = f, r1 = void 0);
        var b = o === f && t[h + 1].startsWith("/>") ? " " : "";
        n += o === c ? l + n$3 : d >= 0 ? (s.push(p), l.slice(0, d) + "$lit$" + l.slice(d) + e$6 + b) : l + e$6 + (-2 === d ? (s.push(void 0), h) : b);
    }
    var _$P = n + (t[_$i] || "<?>") + (2 === e ? "</svg>" : "");
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== s$1 ? s$1.createHTML(_$P) : _$P,
        s
    ];
};
var E = /*#__PURE__*/ function() {
    "use strict";
    function E(t, e) {
        (0, $4GJKx._)(this, E);
        var r1, _$i = t.strings, s = t._$litType$;
        this.parts = [];
        var a = 0, n = 0, o = _$i.length - 1, h = this.parts, _C = (0, $cv9Rk._)(C(_$i, s), 2), l = _C[0], p = _C[1];
        if (this.el = E.createElement(l, e), A.currentNode = this.el.content, 2 === s) {
            var _c;
            var c = this.el.content, f = c.firstChild;
            f.remove(), (_c = c).append.apply(_c, (0, $c6Xmf._)(f.childNodes));
        }
        for(; null !== (r1 = A.nextNode()) && h.length < o;){
            if (1 === r1.nodeType) {
                if (r1.hasAttributes()) {
                    var u = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r1.getAttributeNames()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var d = _step1.value;
                            if (d.endsWith("$lit$") || d.startsWith(e$6)) {
                                var m = p[n++];
                                if (u.push(d), void 0 !== m) {
                                    var y = r1.getAttribute(m.toLowerCase() + "$lit$").split(e$6), v = /([.?@])?(.*)/.exec(m);
                                    h.push({
                                        type: 1,
                                        index: a,
                                        name: v[2],
                                        strings: y,
                                        ctor: "." === v[1] ? M : "?" === v[1] ? H : "@" === v[1] ? I : S
                                    });
                                } else h.push({
                                    type: 6,
                                    index: a
                                });
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = u[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var b = _step2.value;
                            r1.removeAttribute(b);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                if (g.test(r1.tagName)) {
                    var _ = r1.textContent.split(e$6), _$P = _.length - 1;
                    if (_$P > 0) {
                        r1.textContent = i$2 ? i$2.emptyScript : "";
                        for(var x = 0; x < _$P; x++)r1.append(_[x], h$1()), A.nextNode(), h.push({
                            type: 2,
                            index: ++a
                        });
                        r1.append(_[_$P], h$1());
                    }
                }
            } else if (8 === r1.nodeType) {
                if (r1.data === o$3) h.push({
                    type: 2,
                    index: a
                });
                else for(var w = -1; -1 !== (w = r1.data.indexOf(e$6, w + 1));)h.push({
                    type: 7,
                    index: a
                }), w += e$6.length - 1;
            }
            a++;
        }
    }
    (0, $1wc17._)(E, null, [
        {
            key: "createElement",
            value: function createElement(t, e) {
                var r1 = l$2.createElement("template");
                return r1.innerHTML = t, r1;
            }
        }
    ]);
    return E;
}();
function P(t, e) {
    var r1, _$i, s, a, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t, o = arguments.length > 3 ? arguments[3] : void 0;
    if (e === b) return e;
    var h = void 0 !== o ? null === (r1 = n._$Cl) || void 0 === r1 ? void 0 : r1[o] : n._$Cu, l = r$1(e) ? void 0 : e._$litDirective$;
    return (null == h ? void 0 : h.constructor) !== l && (null === (_$i = null == h ? void 0 : h._$AO) || void 0 === _$i || _$i.call(h, !1), void 0 === l ? h = void 0 : (h = new l(t))._$AT(t, n, o), void 0 !== o ? (null !== (s = (a = n)._$Cl) && void 0 !== s ? s : a._$Cl = [])[o] = h : n._$Cu = h), void 0 !== h && (e = P(t, h._$AS(t, e.values), h, o)), e;
}
var V = /*#__PURE__*/ function() {
    "use strict";
    function V(t, e) {
        (0, $4GJKx._)(this, V);
        this.v = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
    }
    (0, $1wc17._)(V, [
        {
            key: "parentNode",
            get: function get() {
                return this._$AM.parentNode;
            }
        },
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "p",
            value: function p(t) {
                var e, _this__$AD = this._$AD, _this__$AD_el = _this__$AD.el, r1 = _this__$AD_el.content, _$i = _this__$AD.parts, s = (null !== (e = null == t ? void 0 : t.creationScope) && void 0 !== e ? e : l$2).importNode(r1, !0);
                A.currentNode = s;
                for(var a = A.nextNode(), n = 0, o = 0, h = _$i[0]; void 0 !== h;){
                    if (n === h.index) {
                        var l = void 0;
                        2 === h.type ? l = new N(a, a.nextSibling, this, t) : 1 === h.type ? l = new h.ctor(a, h.name, h.strings, this, t) : 6 === h.type && (l = new L(a, this, t)), this.v.push(l), h = _$i[++o];
                    }
                    n !== (null == h ? void 0 : h.index) && (a = A.nextNode(), n++);
                }
                return s;
            }
        },
        {
            key: "m",
            value: function m(t) {
                var e = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.v[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r1 = _step1.value;
                        void 0 !== r1 && (void 0 !== r1.strings ? (r1._$AI(t, r1, e), e += r1.strings.length - 2) : r1._$AI(t[e])), e++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return V;
}();
var N = /*#__PURE__*/ function() {
    "use strict";
    function N(t, e, r1, i) {
        (0, $4GJKx._)(this, N);
        var s;
        this.type = 2, this._$AH = w, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = r1, this.options = i, this._$Cg = null === (s = null == i ? void 0 : i.isConnected) || void 0 === s || s;
    }
    (0, $1wc17._)(N, [
        {
            key: "_$AU",
            get: function get() {
                var t, e;
                return null !== (e = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== e ? e : this._$Cg;
            }
        },
        {
            key: "parentNode",
            get: function get() {
                var t = this._$AA.parentNode, e = this._$AM;
                return void 0 !== e && 11 === t.nodeType && (t = e.parentNode), t;
            }
        },
        {
            key: "startNode",
            get: function get() {
                return this._$AA;
            }
        },
        {
            key: "endNode",
            get: function get() {
                return this._$AB;
            }
        },
        {
            key: "_$AI",
            value: function _$AI(t) {
                t = P(this, t, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this), r$1(t) ? t === w || null == t || "" === t ? (this._$AH !== w && this._$AR(), this._$AH = w) : t !== this._$AH && t !== b && this.$(t) : void 0 !== t._$litType$ ? this.T(t) : void 0 !== t.nodeType ? this.S(t) : u(t) ? this.A(t) : this.$(t);
            }
        },
        {
            key: "M",
            value: function M(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._$AB;
                return this._$AA.parentNode.insertBefore(t, e);
            }
        },
        {
            key: "S",
            value: function S(t) {
                this._$AH !== t && (this._$AR(), this._$AH = this.M(t));
            }
        },
        {
            key: "$",
            value: function $(t) {
                this._$AH !== w && r$1(this._$AH) ? this._$AA.nextSibling.data = t : this.S(l$2.createTextNode(t)), this._$AH = t;
            }
        },
        {
            key: "T",
            value: function T1(t) {
                var e, r1 = t.values, _$i = t._$litType$, s = "number" == typeof _$i ? this._$AC(t) : (void 0 === _$i.el && (_$i.el = E.createElement(_$i.h, this.options)), _$i);
                if ((null === (e = this._$AH) || void 0 === e ? void 0 : e._$AD) === s) this._$AH.m(r1);
                else {
                    var a = new V(s, this), n = a.p(this.options);
                    a.m(r1), this.S(n), this._$AH = a;
                }
            }
        },
        {
            key: "_$AC",
            value: function _$AC(t) {
                var e = T.get(t.strings);
                return void 0 === e && T.set(t.strings, e = new E(t)), e;
            }
        },
        {
            key: "A",
            value: function A(t) {
                d(this._$AH) || (this._$AH = [], this._$AR());
                var e, r1 = this._$AH, _$i = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step1.value;
                        _$i === r1.length ? r1.push(e = new N(this.M(h$1()), this.M(h$1()), this, this.options)) : e = r1[_$i], e._$AI(s), _$i++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                _$i < r1.length && (this._$AR(e && e._$AB.nextSibling, _$i), r1.length = _$i);
            }
        },
        {
            key: "_$AR",
            value: function _$AR() {
                var t, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._$AA.nextSibling, r1 = arguments.length > 1 ? arguments[1] : void 0;
                for(null === (t = this._$AP) || void 0 === t || t.call(this, !1, !0, r1); e && e !== this._$AB;){
                    var _$i = e.nextSibling;
                    e.remove(), e = _$i;
                }
            }
        },
        {
            key: "setConnected",
            value: function setConnected(t) {
                var e;
                void 0 === this._$AM && (this._$Cg = t, null === (e = this._$AP) || void 0 === e || e.call(this, t));
            }
        }
    ]);
    return N;
}();
var S = /*#__PURE__*/ function() {
    "use strict";
    function S(t, e, r1, i, s) {
        (0, $4GJKx._)(this, S);
        this.type = 1, this._$AH = w, this._$AN = void 0, this.element = t, this.name = e, this._$AM = i, this.options = s, r1.length > 2 || "" !== r1[0] || "" !== r1[1] ? (this._$AH = Array(r1.length - 1).fill(new String), this.strings = r1) : this._$AH = w;
    }
    (0, $1wc17._)(S, [
        {
            key: "tagName",
            get: function get() {
                return this.element.tagName;
            }
        },
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "_$AI",
            value: function _$AI(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, r1 = arguments.length > 2 ? arguments[2] : void 0, _$i = arguments.length > 3 ? arguments[3] : void 0, s = this.strings, a = !1;
                if (void 0 === s) t = P(this, t, e, 0), (a = !r$1(t) || t !== this._$AH && t !== b) && (this._$AH = t);
                else {
                    var n, o, h = t;
                    for(t = s[0], n = 0; n < s.length - 1; n++)(o = P(this, h[r1 + n], e, n)) === b && (o = this._$AH[n]), a || (a = !r$1(o) || o !== this._$AH[n]), o === w ? t = w : t !== w && (t += (null != o ? o : "") + s[n + 1]), this._$AH[n] = o;
                }
                a && !_$i && this.k(t);
            }
        },
        {
            key: "k",
            value: function k(t) {
                t === w ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
            }
        }
    ]);
    return S;
}();
var M = /*#__PURE__*/ function(S) {
    "use strict";
    (0, $dcsZi._)(M, S);
    function M() {
        (0, $4GJKx._)(this, M);
        var _this;
        _this = (0, $cYr9j._)(this, M, arguments), _this.type = 3;
        return _this;
    }
    (0, $1wc17._)(M, [
        {
            key: "k",
            value: function k(t) {
                this.element[this.name] = t === w ? void 0 : t;
            }
        }
    ]);
    return M;
}(S);
var k = i$2 ? i$2.emptyScript : "";
var H = /*#__PURE__*/ function(S) {
    "use strict";
    (0, $dcsZi._)(H, S);
    function H() {
        (0, $4GJKx._)(this, H);
        var _this;
        _this = (0, $cYr9j._)(this, H, arguments), _this.type = 4;
        return _this;
    }
    (0, $1wc17._)(H, [
        {
            key: "k",
            value: function k1(t) {
                t && t !== w ? this.element.setAttribute(this.name, k) : this.element.removeAttribute(this.name);
            }
        }
    ]);
    return H;
}(S);
var I = /*#__PURE__*/ function(S) {
    "use strict";
    (0, $dcsZi._)(I, S);
    function I(t, e, r1, i, s) {
        (0, $4GJKx._)(this, I);
        var _this;
        _this = (0, $cYr9j._)(this, I, [
            t,
            e,
            r1,
            i,
            s
        ]), _this.type = 5;
        return _this;
    }
    (0, $1wc17._)(I, [
        {
            key: "_$AI",
            value: function _$AI(t) {
                var e;
                if ((t = null !== (e = P(this, t, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, 0)) && void 0 !== e ? e : w) !== b) {
                    var r1 = this._$AH, _$i = t === w && r1 !== w || t.capture !== r1.capture || t.once !== r1.once || t.passive !== r1.passive, s = t !== w && (r1 === w || _$i);
                    _$i && this.element.removeEventListener(this.name, this, r1), s && this.element.addEventListener(this.name, this, t), this._$AH = t;
                }
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(t) {
                var e, r1;
                "function" == typeof this._$AH ? this._$AH.call(null !== (r1 = null === (e = this.options) || void 0 === e ? void 0 : e.host) && void 0 !== r1 ? r1 : this.element, t) : this._$AH.handleEvent(t);
            }
        }
    ]);
    return I;
}(S);
var L = /*#__PURE__*/ function() {
    "use strict";
    function L(t, e, r1) {
        (0, $4GJKx._)(this, L);
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = r1;
    }
    (0, $1wc17._)(L, [
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "_$AI",
            value: function _$AI(t) {
                P(this, t);
            }
        }
    ]);
    return L;
}();
var R = {
    P: "$lit$",
    V: e$6,
    L: o$3,
    I: 1,
    N: C,
    R: V,
    D: u,
    j: P,
    H: N,
    O: S,
    F: H,
    B: I,
    W: M,
    Z: L
}, z = window.litHtmlPolyfillSupport, l$1, o$2;
null == z || z(E, N), (null !== (t$2 = globalThis.litHtmlVersions) && void 0 !== t$2 ? t$2 : globalThis.litHtmlVersions = []).push("2.1.2");
var r1 = a$1;
var s = /*#__PURE__*/ function(a$1) {
    "use strict";
    (0, $dcsZi._)(s, a$1);
    function s() {
        (0, $4GJKx._)(this, s);
        var _this;
        _this = (0, $cYr9j._)(this, s, arguments), _this.renderOptions = {
            host: _this
        }, _this._$Dt = void 0;
        return _this;
    }
    (0, $1wc17._)(s, [
        {
            key: "createRenderRoot",
            value: function createRenderRoot() {
                var t, e, r1 = (0, $04RAu._)((0, $b8Rim._)(s.prototype), "createRenderRoot", this).call(this);
                return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = r1.firstChild), r1;
            }
        },
        {
            key: "update",
            value: function update(t) {
                var e = this.render();
                this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), (0, $04RAu._)((0, $b8Rim._)(s.prototype), "update", this).call(this, t), this._$Dt = x(e, this.renderRoot, this.renderOptions);
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var t;
                (0, $04RAu._)((0, $b8Rim._)(s.prototype), "connectedCallback", this).call(this), null === (t = this._$Dt) || void 0 === t || t.setConnected(!0);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var t;
                (0, $04RAu._)((0, $b8Rim._)(s.prototype), "disconnectedCallback", this).call(this), null === (t = this._$Dt) || void 0 === t || t.setConnected(!1);
            }
        },
        {
            key: "render",
            value: function render() {
                return b;
            }
        }
    ]);
    return s;
}(a$1);
s.finalized = !0, s._$litElement$ = !0, null === (l$1 = globalThis.litElementHydrateSupport) || void 0 === l$1 || l$1.call(globalThis, {
    LitElement: s
});
var n$2 = globalThis.litElementPolyfillSupport;
null == n$2 || n$2({
    LitElement: s
});
var h = {
    _$AK: function(t, e, r1) {
        t._$AK(e, r1);
    },
    _$AL: function(t) {
        return t._$AL;
    }
};
(null !== (o$2 = globalThis.litElementVersions) && void 0 !== o$2 ? o$2 : globalThis.litElementVersions = []).push("3.1.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var n$1 = function(t) {
    return function(e) {
        return "function" == typeof e ? function(t, e) {
            return window.customElements.define(t, e), e;
        }(t, e) : function(t, e) {
            var r1 = e.kind, _$i = e.elements;
            return {
                kind: r1,
                elements: _$i,
                finisher: function(e) {
                    window.customElements.define(t, e);
                }
            };
        }(t, e);
    };
}, i$1 = function(t, e) {
    return "method" === e.kind && e.descriptor && !("value" in e.descriptor) ? _objectSpread2(_objectSpread2({}, e), {}, {
        finisher: function(r1) {
            r1.createProperty(e.key, t);
        }
    }) : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer: function() {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher: function(r1) {
            r1.createProperty(e.key, t);
        }
    };
};
function e$5(t) {
    return function(e, r1) {
        return void 0 !== r1 ? function(t, e, r1) {
            e.constructor.createProperty(r1, t);
        }(t, e, r1) : i$1(t, e);
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function t$1(t) {
    return e$5(_objectSpread2(_objectSpread2({}, t), {}, {
        state: !0
    }));
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var e$4 = function(t, e, r1) {
    Object.defineProperty(e, r1, t);
}, t = function(t, e) {
    return {
        kind: "method",
        placement: "prototype",
        key: e.key,
        descriptor: t
    };
}, o$1 = function(t) {
    var e = t.finisher, r1 = t.descriptor;
    return function(t, i) {
        var s;
        if (void 0 === i) {
            var a = null !== (s = t.originalKey) && void 0 !== s ? s : t.key, n = null != r1 ? {
                kind: "method",
                placement: "prototype",
                key: a,
                descriptor: r1(t.key)
            } : _objectSpread2(_objectSpread2({}, t), {}, {
                key: a
            });
            return null != e && (n.finisher = function(t) {
                e(t, a);
            }), n;
        }
        var o = t.constructor;
        void 0 !== r1 && Object.defineProperty(t, i, r1(i)), null == e || e(o, i);
    };
}, n;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e$3(t) {
    return o$1({
        finisher: function(e, r1) {
            Object.assign(e.prototype[r1], t);
        }
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function i(t, e) {
    return o$1({
        descriptor: function(r1) {
            var _$i = {
                get: function() {
                    var _$e, _$r;
                    return null !== (_$r = null === (_$e = this.renderRoot) || void 0 === _$e ? void 0 : _$e.querySelector(t)) && void 0 !== _$r ? _$r : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (e) {
                var s = "symbol" == (typeof r1 === "undefined" ? "undefined" : (0, $l0HdX._)(r1)) ? Symbol() : "__" + r1;
                _$i.get = function() {
                    var _$e, _$r;
                    return void 0 === this[s] && (this[s] = null !== (_$r = null === (_$e = this.renderRoot) || void 0 === _$e ? void 0 : _$e.querySelector(t)) && void 0 !== _$r ? _$r : null), this[s];
                };
            }
            return _$i;
        }
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e$2(t) {
    return o$1({
        descriptor: function(e) {
            return {
                get: function() {
                    var e, r1;
                    return null !== (r1 = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelectorAll(t)) && void 0 !== r1 ? r1 : [];
                },
                enumerable: !0,
                configurable: !0
            };
        }
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e$1(t) {
    return o$1({
        descriptor: function(e) {
            return {
                get: function() {
                    var e = this;
                    return _asyncToGenerator(function() {
                        var r1;
                        return (0, $l29cN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        e.updateComplete
                                    ];
                                case 1:
                                    return [
                                        2,
                                        (_state.sent(), null === (r1 = e.renderRoot) || void 0 === r1 ? void 0 : r1.querySelector(t))
                                    ];
                            }
                        });
                    })();
                },
                enumerable: !0,
                configurable: !0
            };
        }
    });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var e = null != (null === (n = window.HTMLSlotElement) || void 0 === n ? void 0 : n.prototype.assignedElements) ? function(t, e) {
    return t.assignedElements(e);
} : function(t, e) {
    return t.assignedNodes(e).filter(function(t) {
        return t.nodeType === Node.ELEMENT_NODE;
    });
};
function l(t) {
    var _ref = null != t ? t : {}, r1 = _ref.slot, _$i = _ref.selector;
    return o$1({
        descriptor: function(s) {
            return {
                get: function() {
                    var s, a = "slot" + (r1 ? "[name=".concat(r1, "]") : ":not([name])"), n = null === (s = this.renderRoot) || void 0 === s ? void 0 : s.querySelector(a), o = null != n ? e(n, t) : [];
                    return _$i ? o.filter(function(t) {
                        return t.matches(_$i);
                    }) : o;
                },
                enumerable: !0,
                configurable: !0
            };
        }
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function o(t, e, r1) {
    var _$i, s = t;
    return "object" == (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) ? (s = t.slot, _$i = t) : _$i = {
        flatten: e
    }, r1 ? l({
        slot: s,
        flatten: e,
        selector: r1
    }) : o$1({
        descriptor: function(t) {
            return {
                get: function() {
                    var _$t, _$e, _$r = "slot" + (s ? "[name=".concat(s, "]") : ":not([name])"), a = null === (_$t = this.renderRoot) || void 0 === _$t ? void 0 : _$t.querySelector(_$r);
                    return null !== (_$e = null == a ? void 0 : a.assignedNodes(_$i)) && void 0 !== _$e ? _$e : [];
                },
                enumerable: !0,
                configurable: !0
            };
        }
    });
}
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function getDefaultExportFromCjs(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function getDefaultExportFromNamespaceIfPresent(t) {
    return t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function getDefaultExportFromNamespaceIfNotNamed(t) {
    return t && Object.prototype.hasOwnProperty.call(t, "default") && 1 === Object.keys(t).length ? t.default : t;
}
function getAugmentedNamespace(t) {
    if (t.__esModule) return t;
    var e = Object.defineProperty({}, "__esModule", {
        value: !0
    });
    return Object.keys(t).forEach(function(r1) {
        var _$i = Object.getOwnPropertyDescriptor(t, r1);
        Object.defineProperty(e, r1, _$i.get ? _$i : {
            enumerable: !0,
            get: function get() {
                return t[r1];
            }
        });
    }), e;
}
function commonjsRequire(t) {
    throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var lottie$1 = {
    exports: {}
};
(function(module, exports) {
    var factory;
    "undefined" != typeof navigator && (factory = function factory() {
        var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function setWebWorker(t) {
            _useWebWorker = !!t;
        }, getWebWorker = function getWebWorker() {
            return _useWebWorker;
        }, setLocationHref = function setLocationHref(t) {
            locationHref = t;
        }, getLocationHref = function getLocationHref() {
            return locationHref;
        };
        function createTag(t) {
            return document.createElement(t);
        }
        function extendPrototype(t, e) {
            var r1, _$i, s = t.length;
            for(r1 = 0; r1 < s; r1 += 1)for(var a in _$i = t[r1].prototype)Object.prototype.hasOwnProperty.call(_$i, a) && (e.prototype[a] = _$i[a]);
        }
        function getDescriptor(t, e) {
            return Object.getOwnPropertyDescriptor(t, e);
        }
        function createProxyFunction(t) {
            function e() {}
            return e.prototype = t, e;
        }
        var audioControllerFactory = function() {
            function t(t) {
                this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
            }
            return t.prototype = {
                addAudio: function addAudio(t) {
                    this.audios.push(t);
                },
                pause: function pause() {
                    var _$t, e = this.audios.length;
                    for(_$t = 0; _$t < e; _$t += 1)this.audios[_$t].pause();
                },
                resume: function resume() {
                    var _$t, e = this.audios.length;
                    for(_$t = 0; _$t < e; _$t += 1)this.audios[_$t].resume();
                },
                setRate: function setRate(t) {
                    var e, r1 = this.audios.length;
                    for(e = 0; e < r1; e += 1)this.audios[e].setRate(t);
                },
                createAudio: function createAudio(t) {
                    return this.audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
                        src: [
                            t
                        ]
                    }) : {
                        isPlaying: !1,
                        play: function play() {
                            this.isPlaying = !0;
                        },
                        seek: function seek() {
                            this.isPlaying = !1;
                        },
                        playing: function playing() {},
                        rate: function rate() {},
                        setVolume: function setVolume() {}
                    };
                },
                setAudioFactory: function setAudioFactory(t) {
                    this.audioFactory = t;
                },
                setVolume: function setVolume(t) {
                    this._volume = t, this._updateVolume();
                },
                mute: function mute() {
                    this._isMuted = !0, this._updateVolume();
                },
                unmute: function unmute() {
                    this._isMuted = !1, this._updateVolume();
                },
                getVolume: function getVolume() {
                    return this._volume;
                },
                _updateVolume: function _updateVolume() {
                    var _$t, e = this.audios.length;
                    for(_$t = 0; _$t < e; _$t += 1)this.audios[_$t].volume(this._volume * (this._isMuted ? 0 : 1));
                }
            }, function() {
                return new t;
            };
        }(), createTypedArray = function() {
            function t(t, e) {
                var r1, _$i = 0, s = [];
                switch(t){
                    case "int16":
                    case "uint8c":
                        r1 = 1;
                        break;
                    default:
                        r1 = 1.1;
                }
                for(_$i = 0; _$i < e; _$i += 1)s.push(r1);
                return s;
            }
            return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(e, r1) {
                return "float32" === e ? new Float32Array(r1) : "int16" === e ? new Int16Array(r1) : "uint8c" === e ? new Uint8ClampedArray(r1) : t(e, r1);
            } : t;
        }();
        function createSizedArray(t) {
            return Array.apply(null, {
                length: t
            });
        }
        function _typeof$6(t) {
            return _typeof$6 = "function" == typeof Symbol && "symbol" == (0, $l0HdX._)(Symbol.iterator) ? function _typeof$61(t) {
                return typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            }, _typeof$6(t);
        }
        var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), _shouldRoundValues = !1, bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
        function ProjectInterface$1() {
            return {};
        }
        !function() {
            var t, e = [
                "abs",
                "acos",
                "acosh",
                "asin",
                "asinh",
                "atan",
                "atanh",
                "atan2",
                "ceil",
                "cbrt",
                "expm1",
                "clz32",
                "cos",
                "cosh",
                "exp",
                "floor",
                "fround",
                "hypot",
                "imul",
                "log",
                "log1p",
                "log2",
                "log10",
                "max",
                "min",
                "pow",
                "random",
                "round",
                "sign",
                "sin",
                "sinh",
                "sqrt",
                "tan",
                "tanh",
                "trunc",
                "E",
                "LN10",
                "LN2",
                "LOG10E",
                "LOG2E",
                "PI",
                "SQRT1_2",
                "SQRT2"
            ], r1 = e.length;
            for(t = 0; t < r1; t += 1)BMMath[e[t]] = Math[e[t]];
        }(), BMMath.random = Math.random, BMMath.abs = function(t) {
            if ("object" === _typeof$6(t) && t.length) {
                var e, r1 = createSizedArray(t.length), _$i = t.length;
                for(e = 0; e < _$i; e += 1)r1[e] = Math.abs(t[e]);
                return r1;
            }
            return Math.abs(t);
        };
        var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
        function roundValues(t) {
            _shouldRoundValues = !!t;
        }
        function bmRnd(t) {
            return _shouldRoundValues ? Math.round(t) : t;
        }
        function styleDiv(t) {
            t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = "0 0", t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = "visible", t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = "preserve-3d", t.style.webkitTransformStyle = "preserve-3d", t.style.mozTransformStyle = "preserve-3d";
        }
        function BMEnterFrameEvent(t, e, r1, i) {
            this.type = t, this.currentTime = e, this.totalTime = r1, this.direction = i < 0 ? -1 : 1;
        }
        function BMCompleteEvent(t, e) {
            this.type = t, this.direction = e < 0 ? -1 : 1;
        }
        function BMCompleteLoopEvent(t, e, r1, i) {
            this.type = t, this.currentLoop = r1, this.totalLoops = e, this.direction = i < 0 ? -1 : 1;
        }
        function BMSegmentStartEvent(t, e, r1) {
            this.type = t, this.firstFrame = e, this.totalFrames = r1;
        }
        function BMDestroyEvent(t, e) {
            this.type = t, this.target = e;
        }
        function BMRenderFrameErrorEvent(t, e) {
            this.type = "renderFrameError", this.nativeError = t, this.currentTime = e;
        }
        function BMConfigErrorEvent(t) {
            this.type = "configError", this.nativeError = t;
        }
        function BMAnimationConfigErrorEvent(t, e) {
            this.type = t, this.nativeError = e;
        }
        var createElementID = (_count = 0, function createElementID() {
            return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }), _count;
        function HSVtoRGB(t, e, r1) {
            var _$i, s, a, n, o, h, l, p;
            switch(h = r1 * (1 - e), l = r1 * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e), p = r1 * (1 - (1 - o) * e), n % 6){
                case 0:
                    _$i = r1, s = p, a = h;
                    break;
                case 1:
                    _$i = l, s = r1, a = h;
                    break;
                case 2:
                    _$i = h, s = r1, a = p;
                    break;
                case 3:
                    _$i = h, s = l, a = r1;
                    break;
                case 4:
                    _$i = p, s = h, a = r1;
                    break;
                case 5:
                    _$i = r1, s = h, a = l;
            }
            return [
                _$i,
                s,
                a
            ];
        }
        function RGBtoHSV(t, e, r1) {
            var _$i, s = Math.max(t, e, r1), a = Math.min(t, e, r1), n = s - a, o = 0 === s ? 0 : n / s, h = s / 255;
            switch(s){
                case a:
                    _$i = 0;
                    break;
                case t:
                    _$i = e - r1 + n * (e < r1 ? 6 : 0), _$i /= 6 * n;
                    break;
                case e:
                    _$i = r1 - t + 2 * n, _$i /= 6 * n;
                    break;
                case r1:
                    _$i = t - e + 4 * n, _$i /= 6 * n;
            }
            return [
                _$i,
                o,
                h
            ];
        }
        function addSaturationToRGB(t, e) {
            var r1 = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r1[1] += e, r1[1] > 1 ? r1[1] = 1 : r1[1] <= 0 && (r1[1] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        function addBrightnessToRGB(t, e) {
            var r1 = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r1[2] += e, r1[2] > 1 ? r1[2] = 1 : r1[2] < 0 && (r1[2] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        function addHueToRGB(t, e) {
            var r1 = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r1[0] += e / 360, r1[0] > 1 ? r1[0] -= 1 : r1[0] < 0 && (r1[0] += 1), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        var rgbToHex = function() {
            var t, e, r1 = [];
            for(t = 0; t < 256; t += 1)e = t.toString(16), r1[t] = 1 === e.length ? "0" + e : e;
            return function(t, e, i) {
                return t < 0 && (t = 0), e < 0 && (e = 0), i < 0 && (i = 0), "#" + r1[t] + r1[e] + r1[i];
            };
        }(), setSubframeEnabled = function setSubframeEnabled(t) {
            subframeEnabled = !!t;
        }, getSubframeEnabled = function getSubframeEnabled() {
            return subframeEnabled;
        }, setExpressionsPlugin = function setExpressionsPlugin(t) {
            expressionsPlugin = t;
        }, getExpressionsPlugin = function getExpressionsPlugin() {
            return expressionsPlugin;
        }, setExpressionInterfaces = function setExpressionInterfaces(t) {
            expressionsInterfaces = t;
        }, getExpressionInterfaces = function getExpressionInterfaces() {
            return expressionsInterfaces;
        }, setDefaultCurveSegments = function setDefaultCurveSegments(t) {
            defaultCurveSegments = t;
        }, getDefaultCurveSegments = function getDefaultCurveSegments() {
            return defaultCurveSegments;
        }, setIdPrefix = function setIdPrefix(t) {
            idPrefix$1 = t;
        }, getIdPrefix = function getIdPrefix() {
            return idPrefix$1;
        };
        function createNS(t) {
            return document.createElementNS(svgNS, t);
        }
        function _typeof$5(t) {
            return _typeof$5 = "function" == typeof Symbol && "symbol" == (0, $l0HdX._)(Symbol.iterator) ? function _typeof$51(t) {
                return typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            }, _typeof$5(t);
        }
        var dataManager = function() {
            var t, e, r1 = 1, _$i = [], s = {
                onmessage: function onmessage() {},
                postMessage: function postMessage(e) {
                    t({
                        data: e
                    });
                }
            }, _workerSelf = {
                postMessage: function postMessage(t) {
                    s.onmessage({
                        data: t
                    });
                }
            };
            function a() {
                e || (e = function(e) {
                    if (window.Worker && window.Blob && getWebWorker()) {
                        var r1 = new Blob([
                            "var _workerSelf = self; self.onmessage = ",
                            e.toString()
                        ], {
                            type: "text/javascript"
                        }), _$i = URL.createObjectURL(r1);
                        return new Worker(_$i);
                    }
                    return t = e, s;
                }(function(t) {
                    if (_workerSelf.dataManager || (_workerSelf.dataManager = function() {
                        function t(s, a) {
                            var n, o, h, l, p, f, u = s.length;
                            for(o = 0; o < u; o += 1)if ("ks" in (n = s[o]) && !n.completed) {
                                if (n.completed = !0, n.hasMask) {
                                    var d = n.masksProperties;
                                    for(l = d.length, h = 0; h < l; h += 1)if (d[h].pt.k.i) i(d[h].pt.k);
                                    else for(f = d[h].pt.k.length, p = 0; p < f; p += 1)d[h].pt.k[p].s && i(d[h].pt.k[p].s[0]), d[h].pt.k[p].e && i(d[h].pt.k[p].e[0]);
                                }
                                0 === n.ty ? (n.layers = e(n.refId, a), t(n.layers, a)) : 4 === n.ty ? r1(n.shapes) : 5 === n.ty && c(n);
                            }
                        }
                        function e(t, e) {
                            var r1 = function(t, e) {
                                for(var r1 = 0, _$i = e.length; r1 < _$i;){
                                    if (e[r1].id === t) return e[r1];
                                    r1 += 1;
                                }
                                return null;
                            }(t, e);
                            return r1 ? r1.layers.__used ? JSON.parse(JSON.stringify(r1.layers)) : (r1.layers.__used = !0, r1.layers) : null;
                        }
                        function r1(t) {
                            var e, s, a;
                            for(e = t.length - 1; e >= 0; e -= 1)if ("sh" === t[e].ty) {
                                if (t[e].ks.k.i) i(t[e].ks.k);
                                else for(a = t[e].ks.k.length, s = 0; s < a; s += 1)t[e].ks.k[s].s && i(t[e].ks.k[s].s[0]), t[e].ks.k[s].e && i(t[e].ks.k[s].e[0]);
                            } else "gr" === t[e].ty && r1(t[e].it);
                        }
                        function i(t) {
                            var e, r1 = t.i.length;
                            for(e = 0; e < r1; e += 1)t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
                        }
                        function s(t, e) {
                            var r1 = e ? e.split(".") : [
                                100,
                                100,
                                100
                            ];
                            return t[0] > r1[0] || !(r1[0] > t[0]) && (t[1] > r1[1] || !(r1[1] > t[1]) && (t[2] > r1[2] || !(r1[2] > t[2]) && null));
                        }
                        var a, n = function() {
                            var _$t = [
                                4,
                                4,
                                14
                            ];
                            function e(t) {
                                var e, r1, _$i, s = t.length;
                                for(e = 0; e < s; e += 1)5 === t[e].ty && (_$i = void 0, _$i = (r1 = t[e]).t.d, r1.t.d = {
                                    k: [
                                        {
                                            s: _$i,
                                            t: 0
                                        }
                                    ]
                                });
                            }
                            return function(r1) {
                                if (s(_$t, r1.v) && (e(r1.layers), r1.assets)) {
                                    var _$i, a = r1.assets.length;
                                    for(_$i = 0; _$i < a; _$i += 1)r1.assets[_$i].layers && e(r1.assets[_$i].layers);
                                }
                            };
                        }(), o = (a = [
                            4,
                            7,
                            99
                        ], function o(t) {
                            if (t.chars && !s(a, t.v)) {
                                var e, _$i = t.chars.length;
                                for(e = 0; e < _$i; e += 1){
                                    var n = t.chars[e];
                                    n.data && n.data.shapes && (r1(n.data.shapes), n.data.ip = 0, n.data.op = 99999, n.data.st = 0, n.data.sr = 1, n.data.ks = {
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        }
                                    }, t.chars[e].t || (n.data.shapes.push({
                                        ty: "no"
                                    }), n.data.shapes[0].it.push({
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        },
                                        sk: {
                                            k: 0,
                                            a: 0
                                        },
                                        sa: {
                                            k: 0,
                                            a: 0
                                        },
                                        ty: "tr"
                                    })));
                                }
                            }
                        }), h = function() {
                            var _$t = [
                                5,
                                7,
                                15
                            ];
                            function e(t) {
                                var e, r1, _$i = t.length;
                                for(e = 0; e < _$i; e += 1)5 === t[e].ty && (r1 = void 0, "number" == typeof (r1 = t[e].t.p).a && (r1.a = {
                                    a: 0,
                                    k: r1.a
                                }), "number" == typeof r1.p && (r1.p = {
                                    a: 0,
                                    k: r1.p
                                }), "number" == typeof r1.r && (r1.r = {
                                    a: 0,
                                    k: r1.r
                                }));
                            }
                            return function(r1) {
                                if (s(_$t, r1.v) && (e(r1.layers), r1.assets)) {
                                    var _$i, a = r1.assets.length;
                                    for(_$i = 0; _$i < a; _$i += 1)r1.assets[_$i].layers && e(r1.assets[_$i].layers);
                                }
                            };
                        }(), l = function() {
                            var _$t = [
                                4,
                                1,
                                9
                            ];
                            function e(t) {
                                var r1, _$i, s, a = t.length;
                                for(r1 = 0; r1 < a; r1 += 1)if ("gr" === t[r1].ty) e(t[r1].it);
                                else if ("fl" === t[r1].ty || "st" === t[r1].ty) {
                                    if (t[r1].c.k && t[r1].c.k[0].i) for(s = t[r1].c.k.length, _$i = 0; _$i < s; _$i += 1)t[r1].c.k[_$i].s && (t[r1].c.k[_$i].s[0] /= 255, t[r1].c.k[_$i].s[1] /= 255, t[r1].c.k[_$i].s[2] /= 255, t[r1].c.k[_$i].s[3] /= 255), t[r1].c.k[_$i].e && (t[r1].c.k[_$i].e[0] /= 255, t[r1].c.k[_$i].e[1] /= 255, t[r1].c.k[_$i].e[2] /= 255, t[r1].c.k[_$i].e[3] /= 255);
                                    else t[r1].c.k[0] /= 255, t[r1].c.k[1] /= 255, t[r1].c.k[2] /= 255, t[r1].c.k[3] /= 255;
                                }
                            }
                            function r1(t) {
                                var r1, _$i = t.length;
                                for(r1 = 0; r1 < _$i; r1 += 1)4 === t[r1].ty && e(t[r1].shapes);
                            }
                            return function(e) {
                                if (s(_$t, e.v) && (r1(e.layers), e.assets)) {
                                    var _$i, a = e.assets.length;
                                    for(_$i = 0; _$i < a; _$i += 1)e.assets[_$i].layers && r1(e.assets[_$i].layers);
                                }
                            };
                        }(), p = function() {
                            var _$t = [
                                4,
                                4,
                                18
                            ];
                            function e(t) {
                                var r1, _$i, s;
                                for(r1 = t.length - 1; r1 >= 0; r1 -= 1)if ("sh" === t[r1].ty) {
                                    if (t[r1].ks.k.i) t[r1].ks.k.c = t[r1].closed;
                                    else for(s = t[r1].ks.k.length, _$i = 0; _$i < s; _$i += 1)t[r1].ks.k[_$i].s && (t[r1].ks.k[_$i].s[0].c = t[r1].closed), t[r1].ks.k[_$i].e && (t[r1].ks.k[_$i].e[0].c = t[r1].closed);
                                } else "gr" === t[r1].ty && e(t[r1].it);
                            }
                            function r1(t) {
                                var r1, _$i, s, a, n, o, h = t.length;
                                for(_$i = 0; _$i < h; _$i += 1){
                                    if ((r1 = t[_$i]).hasMask) {
                                        var l = r1.masksProperties;
                                        for(a = l.length, s = 0; s < a; s += 1)if (l[s].pt.k.i) l[s].pt.k.c = l[s].cl;
                                        else for(o = l[s].pt.k.length, n = 0; n < o; n += 1)l[s].pt.k[n].s && (l[s].pt.k[n].s[0].c = l[s].cl), l[s].pt.k[n].e && (l[s].pt.k[n].e[0].c = l[s].cl);
                                    }
                                    4 === r1.ty && e(r1.shapes);
                                }
                            }
                            return function(e) {
                                if (s(_$t, e.v) && (r1(e.layers), e.assets)) {
                                    var _$i, a = e.assets.length;
                                    for(_$i = 0; _$i < a; _$i += 1)e.assets[_$i].layers && r1(e.assets[_$i].layers);
                                }
                            };
                        }();
                        function c(t) {
                            0 === t.t.a.length && t.t.p;
                        }
                        var f = {
                            completeData: function completeData(r1) {
                                r1.__complete || (l(r1), n(r1), o(r1), h(r1), p(r1), t(r1.layers, r1.assets), function(r1, i) {
                                    if (r1) {
                                        var s = 0, a = r1.length;
                                        for(s = 0; s < a; s += 1)1 === r1[s].t && (r1[s].data.layers = e(r1[s].data.refId, i), t(r1[s].data.layers, i));
                                    }
                                }(r1.chars, r1.assets), r1.__complete = !0);
                            }
                        };
                        return f.checkColors = l, f.checkChars = o, f.checkPathProperties = h, f.checkShapes = p, f.completeLayers = t, f;
                    }()), _workerSelf.assetLoader || (_workerSelf.assetLoader = function() {
                        function t(t) {
                            var e = t.getResponseHeader("content-type");
                            return e && "json" === t.responseType && -1 !== e.indexOf("json") || t.response && "object" === _typeof$5(t.response) ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
                        }
                        return {
                            load: function load(e, r1, i, s) {
                                var a, n = new XMLHttpRequest;
                                try {
                                    n.responseType = "json";
                                } catch (t) {}
                                n.onreadystatechange = function() {
                                    if (4 === n.readyState) {
                                        if (200 === n.status) a = t(n), i(a);
                                        else try {
                                            a = t(n), i(a);
                                        } catch (t) {
                                            s && s(t);
                                        }
                                    }
                                };
                                try {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), e, !0);
                                } catch (t) {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), r1 + "/" + e, !0);
                                }
                                n.send();
                            }
                        };
                    }()), "loadAnimation" === t.data.type) _workerSelf.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        _workerSelf.dataManager.completeData(e), _workerSelf.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                    else if ("complete" === t.data.type) {
                        var e = t.data.animation;
                        _workerSelf.dataManager.completeData(e), _workerSelf.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    } else "loadData" === t.data.type && _workerSelf.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        _workerSelf.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                }), e.onmessage = function(t) {
                    var e = t.data, r1 = e.id, s = _$i[r1];
                    _$i[r1] = null, "success" === e.status ? s.onComplete(e.payload) : s.onError && s.onError();
                });
            }
            function n(t, e) {
                var s = "processId_" + (r1 += 1);
                return _$i[s] = {
                    onComplete: t,
                    onError: e
                }, s;
            }
            return {
                loadAnimation: function loadAnimation(t, r1, i) {
                    a();
                    var s = n(r1, i);
                    e.postMessage({
                        type: "loadAnimation",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: s
                    });
                },
                loadData: function loadData(t, r1, i) {
                    a();
                    var s = n(r1, i);
                    e.postMessage({
                        type: "loadData",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: s
                    });
                },
                completeAnimation: function completeAnimation(t, r1, i) {
                    a();
                    var s = n(r1, i);
                    e.postMessage({
                        type: "complete",
                        animation: t,
                        id: s
                    });
                }
            };
        }(), ImagePreloader = function() {
            var t = function() {
                var t = createTag("canvas");
                t.width = 1, t.height = 1;
                var _$e = t.getContext("2d");
                return _$e.fillStyle = "rgba(0,0,0,0)", _$e.fillRect(0, 0, 1, 1), t;
            }();
            function e() {
                this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function r1() {
                this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function i(t, e, r1) {
                var _$i = "";
                if (t.e) _$i = t.p;
                else if (e) {
                    var s = t.p;
                    -1 !== s.indexOf("images/") && (s = s.split("/")[1]), _$i = e + s;
                } else _$i = r1, _$i += t.u ? t.u : "", _$i += t.p;
                return _$i;
            }
            function s(t) {
                var _$e = 0, _$r = setInterval((function() {
                    (t.getBBox().width || _$e > 500) && (this._imageLoaded(), clearInterval(_$r)), _$e += 1;
                }).bind(this), 50);
            }
            function a(t) {
                var _$e = {
                    assetData: t
                }, _$r = i(t, this.assetsPath, this.path);
                return dataManager.loadData(_$r, (function(t) {
                    _$e.img = t, this._footageLoaded();
                }).bind(this), (function() {
                    _$e.img = {}, this._footageLoaded();
                }).bind(this)), _$e;
            }
            function n() {
                this._imageLoaded = e.bind(this), this._footageLoaded = r1.bind(this), this.testImageLoaded = s.bind(this), this.createFootageData = a.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
            }
            return n.prototype = {
                loadAssets: function loadAssets(t, e) {
                    var _$r;
                    this.imagesLoadedCb = e;
                    var _$i = t.length;
                    for(_$r = 0; _$r < _$i; _$r += 1)t[_$r].layers || (t[_$r].t && "seq" !== t[_$r].t ? 3 === t[_$r].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t[_$r]))) : (this.totalImages += 1, this.images.push(this._createImageData(t[_$r]))));
                },
                setAssetsPath: function setAssetsPath(t) {
                    this.assetsPath = t || "";
                },
                setPath: function setPath(t) {
                    this.path = t || "";
                },
                loadedImages: function loadedImages() {
                    return this.totalImages === this.loadedAssets;
                },
                loadedFootages: function loadedFootages() {
                    return this.totalFootages === this.loadedFootagesCount;
                },
                destroy: function destroy() {
                    this.imagesLoadedCb = null, this.images.length = 0;
                },
                getAsset: function getAsset(t) {
                    for(var _$e = 0, _$r = this.images.length; _$e < _$r;){
                        if (this.images[_$e].assetData === t) return this.images[_$e].img;
                        _$e += 1;
                    }
                    return null;
                },
                createImgData: function createImgData(e) {
                    var _$r = i(e, this.assetsPath, this.path), s = createTag("img");
                    s.crossOrigin = "anonymous", s.addEventListener("load", this._imageLoaded, !1), s.addEventListener("error", (function() {
                        a.img = t, this._imageLoaded();
                    }).bind(this), !1), s.src = _$r;
                    var a = {
                        img: s,
                        assetData: e
                    };
                    return a;
                },
                createImageData: function createImageData(e) {
                    var _$r = i(e, this.assetsPath, this.path), s = createNS("image");
                    isSafari ? this.testImageLoaded(s) : s.addEventListener("load", this._imageLoaded, !1), s.addEventListener("error", (function() {
                        a.img = t, this._imageLoaded();
                    }).bind(this), !1), s.setAttributeNS("http://www.w3.org/1999/xlink", "href", _$r), this._elementHelper.append ? this._elementHelper.append(s) : this._elementHelper.appendChild(s);
                    var a = {
                        img: s,
                        assetData: e
                    };
                    return a;
                },
                imageLoaded: e,
                footageLoaded: r1,
                setCacheType: function setCacheType(t, e) {
                    "svg" === t ? (this._elementHelper = e, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
                }
            }, n;
        }();
        function BaseEvent() {}
        BaseEvent.prototype = {
            triggerEvent: function triggerEvent(t, e) {
                if (this._cbs[t]) for(var r1 = this._cbs[t], _$i = 0; _$i < r1.length; _$i += 1)r1[_$i](e);
            },
            addEventListener: function addEventListener(t, e) {
                return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e), (function() {
                    this.removeEventListener(t, e);
                }).bind(this);
            },
            removeEventListener: function removeEventListener(t, e) {
                if (e) {
                    if (this._cbs[t]) {
                        for(var r1 = 0, _$i = this._cbs[t].length; r1 < _$i;)this._cbs[t][r1] === e && (this._cbs[t].splice(r1, 1), r1 -= 1, _$i -= 1), r1 += 1;
                        this._cbs[t].length || (this._cbs[t] = null);
                    }
                } else this._cbs[t] = null;
            }
        };
        var markerParser = function() {
            function t(t) {
                for(var e, r1 = t.split("\r\n"), _$i = {}, s = 0, a = 0; a < r1.length; a += 1)2 === (e = r1[a].split(":")).length && (_$i[e[0]] = e[1].trim(), s += 1);
                if (0 === s) throw new Error;
                return _$i;
            }
            return function(e) {
                for(var r1 = [], _$i = 0; _$i < e.length; _$i += 1){
                    var s = e[_$i], a = {
                        time: s.tm,
                        duration: s.dr
                    };
                    try {
                        a.payload = JSON.parse(e[_$i].cm);
                    } catch (r1) {
                        try {
                            a.payload = t(e[_$i].cm);
                        } catch (t) {
                            a.payload = {
                                name: e[_$i].cm
                            };
                        }
                    }
                    r1.push(a);
                }
                return r1;
            };
        }(), ProjectInterface = function() {
            function t(t) {
                this.compositions.push(t);
            }
            return function() {
                function e(t) {
                    for(var _$e = 0, r1 = this.compositions.length; _$e < r1;){
                        if (this.compositions[_$e].data && this.compositions[_$e].data.nm === t) return this.compositions[_$e].prepareFrame && this.compositions[_$e].data.xt && this.compositions[_$e].prepareFrame(this.currentFrame), this.compositions[_$e].compInterface;
                        _$e += 1;
                    }
                    return null;
                }
                return e.compositions = [], e.currentFrame = 0, e.registerComposition = t, e;
            };
        }(), renderers = {}, registerRenderer = function registerRenderer(t, e) {
            renderers[t] = e;
        };
        function getRenderer(t) {
            return renderers[t];
        }
        function getRegisteredRenderer() {
            if (renderers.canvas) return "canvas";
            for(var t in renderers)if (renderers[t]) return t;
            return "";
        }
        function _typeof$4(t) {
            return _typeof$4 = "function" == typeof Symbol && "symbol" == (0, $l0HdX._)(Symbol.iterator) ? function _typeof$41(t) {
                return typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            }, _typeof$4(t);
        }
        var AnimationItem = function AnimationItem() {
            this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
        };
        extendPrototype([
            BaseEvent
        ], AnimationItem), AnimationItem.prototype.setParams = function(t) {
            (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
            var e = "svg";
            t.animType ? e = t.animType : t.renderer && (e = t.renderer);
            var r1 = getRenderer(e);
            this.renderer = new r1(this, t.rendererSettings), this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? this.loop = !0 : !1 === t.loop ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
        }, AnimationItem.prototype.onSetupError = function() {
            this.trigger("data_failed");
        }, AnimationItem.prototype.setupAnimation = function(t) {
            dataManager.completeAnimation(t, this.configAnimation);
        }, AnimationItem.prototype.setData = function(t, e) {
            e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
            var r1 = {
                wrapper: t,
                animationData: e
            }, _$i = t.attributes;
            r1.path = _$i.getNamedItem("data-animation-path") ? _$i.getNamedItem("data-animation-path").value : _$i.getNamedItem("data-bm-path") ? _$i.getNamedItem("data-bm-path").value : _$i.getNamedItem("bm-path") ? _$i.getNamedItem("bm-path").value : "", r1.animType = _$i.getNamedItem("data-anim-type") ? _$i.getNamedItem("data-anim-type").value : _$i.getNamedItem("data-bm-type") ? _$i.getNamedItem("data-bm-type").value : _$i.getNamedItem("bm-type") ? _$i.getNamedItem("bm-type").value : _$i.getNamedItem("data-bm-renderer") ? _$i.getNamedItem("data-bm-renderer").value : _$i.getNamedItem("bm-renderer") ? _$i.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
            var s = _$i.getNamedItem("data-anim-loop") ? _$i.getNamedItem("data-anim-loop").value : _$i.getNamedItem("data-bm-loop") ? _$i.getNamedItem("data-bm-loop").value : _$i.getNamedItem("bm-loop") ? _$i.getNamedItem("bm-loop").value : "";
            "false" === s ? r1.loop = !1 : "true" === s ? r1.loop = !0 : "" !== s && (r1.loop = parseInt(s, 10));
            var a = _$i.getNamedItem("data-anim-autoplay") ? _$i.getNamedItem("data-anim-autoplay").value : _$i.getNamedItem("data-bm-autoplay") ? _$i.getNamedItem("data-bm-autoplay").value : !_$i.getNamedItem("bm-autoplay") || _$i.getNamedItem("bm-autoplay").value;
            r1.autoplay = "false" !== a, r1.name = _$i.getNamedItem("data-name") ? _$i.getNamedItem("data-name").value : _$i.getNamedItem("data-bm-name") ? _$i.getNamedItem("data-bm-name").value : _$i.getNamedItem("bm-name") ? _$i.getNamedItem("bm-name").value : "", "false" === (_$i.getNamedItem("data-anim-prerender") ? _$i.getNamedItem("data-anim-prerender").value : _$i.getNamedItem("data-bm-prerender") ? _$i.getNamedItem("data-bm-prerender").value : _$i.getNamedItem("bm-prerender") ? _$i.getNamedItem("bm-prerender").value : "") && (r1.prerender = !1), r1.path ? this.setParams(r1) : this.trigger("destroy");
        }, AnimationItem.prototype.includeLayers = function(t) {
            t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
            var e, r1, _$i = this.animationData.layers, s = _$i.length, a = t.layers, n = a.length;
            for(r1 = 0; r1 < n; r1 += 1)for(e = 0; e < s;){
                if (_$i[e].id === a[r1].id) {
                    _$i[e] = a[r1];
                    break;
                }
                e += 1;
            }
            if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for(s = t.assets.length, e = 0; e < s; e += 1)this.animationData.assets.push(t.assets[e]);
            this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
        }, AnimationItem.prototype.onSegmentComplete = function(t) {
            this.animationData = t;
            var e = getExpressionsPlugin();
            e && e.initExpressions(this), this.loadNextSegment();
        }, AnimationItem.prototype.loadNextSegment = function() {
            var t = this.animationData.segments;
            if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
            var e = t.shift();
            this.timeCompleted = e.time * this.frameRate;
            var r1 = this.path + this.fileName + "_" + this.segmentPos + ".json";
            this.segmentPos += 1, dataManager.loadData(r1, this.includeLayers.bind(this), (function() {
                this.trigger("data_failed");
            }).bind(this));
        }, AnimationItem.prototype.loadSegments = function() {
            this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
        }, AnimationItem.prototype.imagesLoaded = function() {
            this.trigger("loaded_images"), this.checkLoaded();
        }, AnimationItem.prototype.preloadImages = function() {
            this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
        }, AnimationItem.prototype.configAnimation = function(t) {
            if (this.renderer) try {
                this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = markerParser(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
            } catch (t) {
                this.triggerConfigError(t);
            }
        }, AnimationItem.prototype.waitForFontsLoaded = function() {
            this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
        }, AnimationItem.prototype.checkLoaded = function() {
            if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                this.isLoaded = !0;
                var t = getExpressionsPlugin();
                t && t.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
                    this.trigger("DOMLoaded");
                }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
            }
        }, AnimationItem.prototype.resize = function(t, e) {
            var r1 = "number" == typeof t ? t : void 0, _$i = "number" == typeof e ? e : void 0;
            this.renderer.updateContainerSize(r1, _$i);
        }, AnimationItem.prototype.setSubframe = function(t) {
            this.isSubframeEnabled = !!t;
        }, AnimationItem.prototype.gotoFrame = function() {
            this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
        }, AnimationItem.prototype.renderFrame = function() {
            if (!1 !== this.isLoaded && this.renderer) try {
                this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
            } catch (t) {
                this.triggerRenderFrameError(t);
            }
        }, AnimationItem.prototype.play = function(t) {
            t && this.name !== t || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
        }, AnimationItem.prototype.pause = function(t) {
            t && this.name !== t || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
        }, AnimationItem.prototype.togglePause = function(t) {
            t && this.name !== t || (!0 === this.isPaused ? this.play() : this.pause());
        }, AnimationItem.prototype.stop = function(t) {
            t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
        }, AnimationItem.prototype.getMarkerData = function(t) {
            for(var e, r1 = 0; r1 < this.markers.length; r1 += 1)if ((e = this.markers[r1]).payload && e.payload.name === t) return e;
            return null;
        }, AnimationItem.prototype.goToAndStop = function(t, e, r1) {
            if (!r1 || this.name === r1) {
                var _$i = Number(t);
                if (isNaN(_$i)) {
                    var s = this.getMarkerData(t);
                    s && this.goToAndStop(s.time, !0);
                } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                this.pause();
            }
        }, AnimationItem.prototype.goToAndPlay = function(t, e, r1) {
            if (!r1 || this.name === r1) {
                var _$i = Number(t);
                if (isNaN(_$i)) {
                    var s = this.getMarkerData(t);
                    s && (s.duration ? this.playSegments([
                        s.time,
                        s.time + s.duration
                    ], !0) : this.goToAndStop(s.time, !0));
                } else this.goToAndStop(_$i, e, r1);
                this.play();
            }
        }, AnimationItem.prototype.advanceTime = function(t) {
            if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                var e = this.currentRawFrame + t * this.frameModifier, r1 = !1;
                e >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (r1 = !0, e = this.totalFrames - 1) : e < 0 ? this.checkSegments(e % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (r1 = !0, e = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e), r1 && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
            }
        }, AnimationItem.prototype.adjustSegment = function(t, e) {
            this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(.001 + e)), this.trigger("segmentStart");
        }, AnimationItem.prototype.setSegment = function(t, e) {
            var r1 = -1;
            this.isPaused && (this.currentRawFrame + this.firstFrame < t ? r1 = t : this.currentRawFrame + this.firstFrame > e && (r1 = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, -1 !== r1 && this.goToAndStop(r1, !0);
        }, AnimationItem.prototype.playSegments = function(t, e) {
            if (e && (this.segments.length = 0), "object" === _typeof$4(t[0])) {
                var r1, _$i = t.length;
                for(r1 = 0; r1 < _$i; r1 += 1)this.segments.push(t[r1]);
            } else this.segments.push(t);
            this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
        }, AnimationItem.prototype.resetSegments = function(t) {
            this.segments.length = 0, this.segments.push([
                this.animationData.ip,
                this.animationData.op
            ]), t && this.checkSegments(0);
        }, AnimationItem.prototype.checkSegments = function(t) {
            return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
        }, AnimationItem.prototype.destroy = function(t) {
            t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
        }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
            this.currentRawFrame = t, this.gotoFrame();
        }, AnimationItem.prototype.setSpeed = function(t) {
            this.playSpeed = t, this.updaFrameModifier();
        }, AnimationItem.prototype.setDirection = function(t) {
            this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
        }, AnimationItem.prototype.setLoop = function(t) {
            this.loop = t;
        }, AnimationItem.prototype.setVolume = function(t, e) {
            e && this.name !== e || this.audioController.setVolume(t);
        }, AnimationItem.prototype.getVolume = function() {
            return this.audioController.getVolume();
        }, AnimationItem.prototype.mute = function(t) {
            t && this.name !== t || this.audioController.mute();
        }, AnimationItem.prototype.unmute = function(t) {
            t && this.name !== t || this.audioController.unmute();
        }, AnimationItem.prototype.updaFrameModifier = function() {
            this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
        }, AnimationItem.prototype.getPath = function() {
            return this.path;
        }, AnimationItem.prototype.getAssetsPath = function(t) {
            var e = "";
            if (t.e) e = t.p;
            else if (this.assetsPath) {
                var r1 = t.p;
                -1 !== r1.indexOf("images/") && (r1 = r1.split("/")[1]), e = this.assetsPath + r1;
            } else e = this.path, e += t.u ? t.u : "", e += t.p;
            return e;
        }, AnimationItem.prototype.getAssetData = function(t) {
            for(var e = 0, r1 = this.assets.length; e < r1;){
                if (t === this.assets[e].id) return this.assets[e];
                e += 1;
            }
            return null;
        }, AnimationItem.prototype.hide = function() {
            this.renderer.hide();
        }, AnimationItem.prototype.show = function() {
            this.renderer.show();
        }, AnimationItem.prototype.getDuration = function(t) {
            return t ? this.totalFrames : this.totalFrames / this.frameRate;
        }, AnimationItem.prototype.updateDocumentData = function(t, e, r1) {
            try {
                this.renderer.getElementByPath(t).updateDocumentData(e, r1);
            } catch (t) {}
        }, AnimationItem.prototype.trigger = function(t) {
            if (this._cbs && this._cbs[t]) switch(t){
                case "enterFrame":
                    this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
                    break;
                case "drawnFrame":
                    this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
                    break;
                case "loopComplete":
                    this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
                    break;
                case "complete":
                    this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
                    break;
                case "segmentStart":
                    this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
                    break;
                case "destroy":
                    this.triggerEvent(t, new BMDestroyEvent(t, this));
                    break;
                default:
                    this.triggerEvent(t);
            }
            "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
        }, AnimationItem.prototype.triggerRenderFrameError = function(t) {
            var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        }, AnimationItem.prototype.triggerConfigError = function(t) {
            var e = new BMConfigErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        };
        var animationManager = function() {
            var t = {}, e = [], r1 = 0, _$i = 0, s = 0, a = !0, n = !1;
            function o(t) {
                for(var r1 = 0, s = t.target; r1 < _$i;)e[r1].animation === s && (e.splice(r1, 1), r1 -= 1, _$i -= 1, s.isPaused || p()), r1 += 1;
            }
            function h(t, r1) {
                if (!t) return null;
                for(var s = 0; s < _$i;){
                    if (e[s].elem === t && null !== e[s].elem) return e[s].animation;
                    s += 1;
                }
                var a = new AnimationItem;
                return c(a, t), a.setData(t, r1), a;
            }
            function l() {
                s += 1, d();
            }
            function p() {
                s -= 1;
            }
            function c(t, r1) {
                t.addEventListener("destroy", o), t.addEventListener("_active", l), t.addEventListener("_idle", p), e.push({
                    elem: r1,
                    animation: t
                }), _$i += 1;
            }
            function f(t) {
                var o, _$h = t - r1;
                for(o = 0; o < _$i; o += 1)e[o].animation.advanceTime(_$h);
                r1 = t, s && !n ? window.requestAnimationFrame(f) : a = !0;
            }
            function u(t) {
                r1 = t, window.requestAnimationFrame(f);
            }
            function d() {
                !n && s && a && (window.requestAnimationFrame(u), a = !1);
            }
            return t.registerAnimation = h, t.loadAnimation = function(t) {
                var e = new AnimationItem;
                return c(e, null), e.setParams(t), e;
            }, t.setSpeed = function(t, r1) {
                var s;
                for(s = 0; s < _$i; s += 1)e[s].animation.setSpeed(t, r1);
            }, t.setDirection = function(t, r1) {
                var s;
                for(s = 0; s < _$i; s += 1)e[s].animation.setDirection(t, r1);
            }, t.play = function(t) {
                var r1;
                for(r1 = 0; r1 < _$i; r1 += 1)e[r1].animation.play(t);
            }, t.pause = function(t) {
                var r1;
                for(r1 = 0; r1 < _$i; r1 += 1)e[r1].animation.pause(t);
            }, t.stop = function(t) {
                var r1;
                for(r1 = 0; r1 < _$i; r1 += 1)e[r1].animation.stop(t);
            }, t.togglePause = function(t) {
                var r1;
                for(r1 = 0; r1 < _$i; r1 += 1)e[r1].animation.togglePause(t);
            }, t.searchAnimations = function(t, e, r1) {
                var _$i, s = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), a = s.length;
                for(_$i = 0; _$i < a; _$i += 1)r1 && s[_$i].setAttribute("data-bm-type", r1), h(s[_$i], t);
                if (e && 0 === a) {
                    r1 || (r1 = "svg");
                    var n = document.getElementsByTagName("body")[0];
                    n.innerText = "";
                    var o = createTag("div");
                    o.style.width = "100%", o.style.height = "100%", o.setAttribute("data-bm-type", r1), n.appendChild(o), h(o, t);
                }
            }, t.resize = function() {
                var t;
                for(t = 0; t < _$i; t += 1)e[t].animation.resize();
            }, t.goToAndStop = function(t, r1, s) {
                var a;
                for(a = 0; a < _$i; a += 1)e[a].animation.goToAndStop(t, r1, s);
            }, t.destroy = function(t) {
                var r1;
                for(r1 = _$i - 1; r1 >= 0; r1 -= 1)e[r1].animation.destroy(t);
            }, t.freeze = function() {
                n = !0;
            }, t.unfreeze = function() {
                n = !1, d();
            }, t.setVolume = function(t, r1) {
                var s;
                for(s = 0; s < _$i; s += 1)e[s].animation.setVolume(t, r1);
            }, t.mute = function(t) {
                var r1;
                for(r1 = 0; r1 < _$i; r1 += 1)e[r1].animation.mute(t);
            }, t.unmute = function(t) {
                var r1;
                for(r1 = 0; r1 < _$i; r1 += 1)e[r1].animation.unmute(t);
            }, t.getRegisteredAnimations = function() {
                var t, r1 = e.length, _$i = [];
                for(t = 0; t < r1; t += 1)_$i.push(e[t].animation);
                return _$i;
            }, t;
        }(), BezierFactory = function() {
            var t = {
                getBezierEasing: function getBezierEasing(t, r1, i, s, a) {
                    var n = a || ("bez_" + t + "_" + r1 + "_" + i + "_" + s).replace(/\./g, "p");
                    if (e[n]) return e[n];
                    var o = new l([
                        t,
                        r1,
                        i,
                        s
                    ]);
                    return e[n] = o, o;
                }
            }, e = {}, r1 = .1, _$i = "function" == typeof Float32Array;
            function s(t, e) {
                return 1 - 3 * e + 3 * t;
            }
            function a(t, e) {
                return 3 * e - 6 * t;
            }
            function n(t) {
                return 3 * t;
            }
            function o(t, e, r1) {
                return ((s(e, r1) * t + a(e, r1)) * t + n(e)) * t;
            }
            function h(t, e, r1) {
                return 3 * s(e, r1) * t * t + 2 * a(e, r1) * t + n(e);
            }
            function l(t) {
                this._p = t, this._mSampleValues = _$i ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
            }
            return l.prototype = {
                get: function get(t) {
                    var e = this._p[0], r1 = this._p[1], _$i = this._p[2], s = this._p[3];
                    return this._precomputed || this._precompute(), e === r1 && _$i === s ? t : 0 === t ? 0 : 1 === t ? 1 : o(this._getTForX(t), r1, s);
                },
                _precompute: function _precompute() {
                    var t = this._p[0], e = this._p[1], r1 = this._p[2], _$i = this._p[3];
                    this._precomputed = !0, t === e && r1 === _$i || this._calcSampleValues();
                },
                _calcSampleValues: function _calcSampleValues() {
                    for(var t = this._p[0], e = this._p[2], _$i = 0; _$i < 11; ++_$i)this._mSampleValues[_$i] = o(_$i * r1, t, e);
                },
                _getTForX: function _getTForX(t) {
                    for(var e = this._p[0], _$i = this._p[2], s = this._mSampleValues, a = 0, n = 1; 10 !== n && s[n] <= t; ++n)a += r1;
                    var _$l = a + (t - s[--n]) / (s[n + 1] - s[n]) * r1, p = h(_$l, e, _$i);
                    return p >= .001 ? function(t, e, r1, i) {
                        for(var s = 0; s < 4; ++s){
                            var a = h(e, r1, i);
                            if (0 === a) return e;
                            e -= (o(e, r1, i) - t) / a;
                        }
                        return e;
                    }(t, _$l, e, _$i) : 0 === p ? _$l : function(t, e, r1, i, s) {
                        var a, n, _$h = 0;
                        do (a = o(n = e + (r1 - e) / 2, i, s) - t) > 0 ? r1 = n : e = n;
                        while (Math.abs(a) > 1e-7 && ++_$h < 10);
                        return n;
                    }(t, a, a + r1, e, _$i);
                }
            }, t;
        }(), pooling = {
            double: function double(t) {
                return t.concat(createSizedArray(t.length));
            }
        }, poolFactory = function poolFactory(t, e, r1) {
            var _$i = 0, s = t, a = createSizedArray(s);
            return {
                newElement: function newElement() {
                    return _$i ? a[_$i -= 1] : e();
                },
                release: function release(t) {
                    _$i === s && (a = pooling.double(a), s *= 2), r1 && r1(t), a[_$i] = t, _$i += 1;
                }
            };
        }, bezierLengthPool = poolFactory(8, function() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }), segmentsLengthPool = poolFactory(8, function() {
            return {
                lengths: [],
                totalLength: 0
            };
        }, function(t) {
            var e, r1 = t.lengths.length;
            for(e = 0; e < r1; e += 1)bezierLengthPool.release(t.lengths[e]);
            t.lengths.length = 0;
        });
        function bezFunction() {
            var t = Math;
            function e(t, e, r1, i, s, a) {
                var n = t * i + e * s + r1 * a - s * i - a * t - r1 * e;
                return n > -0.001 && n < .001;
            }
            var r1 = function r1(t, e, _r, i) {
                var s, a, n, o, h, l, p = getDefaultCurveSegments(), c = 0, f = [], u = [], d = bezierLengthPool.newElement();
                for(n = _r.length, s = 0; s < p; s += 1){
                    for(h = s / (p - 1), l = 0, a = 0; a < n; a += 1)o = bmPow(1 - h, 3) * t[a] + 3 * bmPow(1 - h, 2) * h * _r[a] + 3 * (1 - h) * bmPow(h, 2) * i[a] + bmPow(h, 3) * e[a], f[a] = o, null !== u[a] && (l += bmPow(f[a] - u[a], 2)), u[a] = f[a];
                    l && (c += l = bmSqrt(l)), d.percents[s] = h, d.lengths[s] = c;
                }
                return d.addedLength = c, d;
            };
            function i(t) {
                this.segmentLength = 0, this.points = new Array(t);
            }
            function s(t, e) {
                this.partialLength = t, this.point = e;
            }
            var a, n = (a = {}, function n(t, r1, _n, o) {
                var h = (t[0] + "_" + t[1] + "_" + r1[0] + "_" + r1[1] + "_" + _n[0] + "_" + _n[1] + "_" + o[0] + "_" + o[1]).replace(/\./g, "p");
                if (!a[h]) {
                    var l, p, c, f, u, d, m, y = getDefaultCurveSegments(), g = 0, v = null;
                    2 === t.length && (t[0] !== r1[0] || t[1] !== r1[1]) && e(t[0], t[1], r1[0], r1[1], t[0] + _n[0], t[1] + _n[1]) && e(t[0], t[1], r1[0], r1[1], r1[0] + o[0], r1[1] + o[1]) && (y = 2);
                    var b = new i(y);
                    for(c = _n.length, l = 0; l < y; l += 1){
                        for(m = createSizedArray(c), u = l / (y - 1), d = 0, p = 0; p < c; p += 1)f = bmPow(1 - u, 3) * t[p] + 3 * bmPow(1 - u, 2) * u * (t[p] + _n[p]) + 3 * (1 - u) * bmPow(u, 2) * (r1[p] + o[p]) + bmPow(u, 3) * r1[p], m[p] = f, null !== v && (d += bmPow(m[p] - v[p], 2));
                        g += d = bmSqrt(d), b.points[l] = new s(d, m), v = m;
                    }
                    b.segmentLength = g, a[h] = b;
                }
                return a[h];
            });
            function o(t, e) {
                var r1 = e.percents, _$i = e.lengths, s = r1.length, a = bmFloor((s - 1) * t), n = t * e.addedLength, o = 0;
                if (a === s - 1 || 0 === a || n === _$i[a]) return r1[a];
                for(var h = _$i[a] > n ? -1 : 1, l = !0; l;)if (_$i[a] <= n && _$i[a + 1] > n ? (o = (n - _$i[a]) / (_$i[a + 1] - _$i[a]), l = !1) : a += h, a < 0 || a >= s - 1) {
                    if (a === s - 1) return r1[a];
                    l = !1;
                }
                return r1[a] + (r1[a + 1] - r1[a]) * o;
            }
            var h = createTypedArray("float32", 8);
            return {
                getSegmentsLength: function getSegmentsLength(t) {
                    var _$e, _$i = segmentsLengthPool.newElement(), s = t.c, a = t.v, n = t.o, o = t.i, h = t._length, l = _$i.lengths, p = 0;
                    for(_$e = 0; _$e < h - 1; _$e += 1)l[_$e] = r1(a[_$e], a[_$e + 1], n[_$e], o[_$e + 1]), p += l[_$e].addedLength;
                    return s && h && (l[_$e] = r1(a[_$e], a[0], n[_$e], o[0]), p += l[_$e].addedLength), _$i.totalLength = p, _$i;
                },
                getNewSegment: function getNewSegment(e, r1, i, s, a, n, l) {
                    a < 0 ? a = 0 : a > 1 && (a = 1);
                    var p, c = o(a, l), f = o(n = n > 1 ? 1 : n, l), u = e.length, d = 1 - c, m = 1 - f, y = d * d * d, g = c * d * d * 3, v = c * c * d * 3, b = c * c * c, _ = d * d * m, _$P = c * d * m + d * c * m + d * d * f, S = c * c * m + d * c * f + c * d * f, E = c * c * f, x = d * m * m, C = c * m * m + d * f * m + d * m * f, A = c * f * m + d * f * f + c * m * f, w = c * f * f, k = m * m * m, T = f * m * m + m * f * m + m * m * f, M = f * f * m + m * f * f + f * m * f, D = f * f * f;
                    for(p = 0; p < u; p += 1)h[4 * p] = t.round(1e3 * (y * e[p] + g * i[p] + v * s[p] + b * r1[p])) / 1e3, h[4 * p + 1] = t.round(1e3 * (_ * e[p] + _$P * i[p] + S * s[p] + E * r1[p])) / 1e3, h[4 * p + 2] = t.round(1e3 * (x * e[p] + C * i[p] + A * s[p] + w * r1[p])) / 1e3, h[4 * p + 3] = t.round(1e3 * (k * e[p] + T * i[p] + M * s[p] + D * r1[p])) / 1e3;
                    return h;
                },
                getPointInSegment: function getPointInSegment(e, r1, i, s, a, n) {
                    var h = o(a, n), l = 1 - h;
                    return [
                        t.round(1e3 * (l * l * l * e[0] + (h * l * l + l * h * l + l * l * h) * i[0] + (h * h * l + l * h * h + h * l * h) * s[0] + h * h * h * r1[0])) / 1e3,
                        t.round(1e3 * (l * l * l * e[1] + (h * l * l + l * h * l + l * l * h) * i[1] + (h * h * l + l * h * h + h * l * h) * s[1] + h * h * h * r1[1])) / 1e3
                    ];
                },
                buildBezierData: n,
                pointOnLine2D: e,
                pointOnLine3D: function pointOnLine3D(r1, i, s, a, n, o, h, l, p) {
                    if (0 === s && 0 === o && 0 === p) return e(r1, i, a, n, h, l);
                    var c, f = t.sqrt(t.pow(a - r1, 2) + t.pow(n - i, 2) + t.pow(o - s, 2)), u = t.sqrt(t.pow(h - r1, 2) + t.pow(l - i, 2) + t.pow(p - s, 2)), d = t.sqrt(t.pow(h - a, 2) + t.pow(l - n, 2) + t.pow(p - o, 2));
                    return (c = f > u ? f > d ? f - u - d : d - u - f : d > u ? d - u - f : u - f - d) > -0.0001 && c < 1e-4;
                }
            };
        }
        var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
        function interpolateValue(t, e) {
            var r1, _$i = this.offsetTime;
            "multidimensional" === this.propType && (r1 = createTypedArray("float32", this.pv.length));
            for(var s, a, n, o, h, l, p, c, f, u = e.lastIndex, d = u, m = this.keyframes.length - 1, y = !0; y;){
                if (s = this.keyframes[d], a = this.keyframes[d + 1], d === m - 1 && t >= a.t - _$i) {
                    s.h && (s = a), u = 0;
                    break;
                }
                if (a.t - _$i > t) {
                    u = d;
                    break;
                }
                d < m - 1 ? d += 1 : (u = 0, y = !1);
            }
            n = this.keyframesMetadata[d] || {};
            var g, v = a.t - _$i, b = s.t - _$i;
            if (s.to) {
                n.bezierData || (n.bezierData = bez.buildBezierData(s.s, a.s || s.e, s.to, s.ti));
                var _ = n.bezierData;
                if (t >= v || t < b) {
                    var _$P = t >= v ? _.points.length - 1 : 0;
                    for(h = _.points[_$P].point.length, o = 0; o < h; o += 1)r1[o] = _.points[_$P].point[o];
                } else {
                    n.__fnct ? f = n.__fnct : (f = BezierFactory.getBezierEasing(s.o.x, s.o.y, s.i.x, s.i.y, s.n).get, n.__fnct = f), l = f((t - b) / (v - b));
                    var S, E = _.segmentLength * l, x = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastAddedLength : 0;
                    for(c = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastPoint : 0, y = !0, p = _.points.length; y;){
                        if (x += _.points[c].partialLength, 0 === E || 0 === l || c === _.points.length - 1) {
                            for(h = _.points[c].point.length, o = 0; o < h; o += 1)r1[o] = _.points[c].point[o];
                            break;
                        }
                        if (E >= x && E < x + _.points[c + 1].partialLength) {
                            for(S = (E - x) / _.points[c + 1].partialLength, h = _.points[c].point.length, o = 0; o < h; o += 1)r1[o] = _.points[c].point[o] + (_.points[c + 1].point[o] - _.points[c].point[o]) * S;
                            break;
                        }
                        c < p - 1 ? c += 1 : y = !1;
                    }
                    e._lastPoint = c, e._lastAddedLength = x - _.points[c].partialLength, e._lastKeyframeIndex = d;
                }
            } else {
                var C, A, w, k, T;
                if (m = s.s.length, g = a.s || s.e, this.sh && 1 !== s.h) t >= v ? (r1[0] = g[0], r1[1] = g[1], r1[2] = g[2]) : t <= b ? (r1[0] = s.s[0], r1[1] = s.s[1], r1[2] = s.s[2]) : quaternionToEuler(r1, slerp(createQuaternion(s.s), createQuaternion(g), (t - b) / (v - b)));
                else for(d = 0; d < m; d += 1)1 !== s.h && (t >= v ? l = 1 : t < b ? l = 0 : (s.o.x.constructor === Array ? (n.__fnct || (n.__fnct = []), n.__fnct[d] ? f = n.__fnct[d] : (C = void 0 === s.o.x[d] ? s.o.x[0] : s.o.x[d], A = void 0 === s.o.y[d] ? s.o.y[0] : s.o.y[d], w = void 0 === s.i.x[d] ? s.i.x[0] : s.i.x[d], k = void 0 === s.i.y[d] ? s.i.y[0] : s.i.y[d], f = BezierFactory.getBezierEasing(C, A, w, k).get, n.__fnct[d] = f)) : n.__fnct ? f = n.__fnct : (C = s.o.x, A = s.o.y, w = s.i.x, k = s.i.y, f = BezierFactory.getBezierEasing(C, A, w, k).get, s.keyframeMetadata = f), l = f((t - b) / (v - b)))), g = a.s || s.e, T = 1 === s.h ? s.s[d] : s.s[d] + (g[d] - s.s[d]) * l, "multidimensional" === this.propType ? r1[d] = T : r1 = T;
            }
            return e.lastIndex = u, r1;
        }
        function slerp(t, e, r1) {
            var _$i, s, a, n, o, h = [], l = t[0], p = t[1], c = t[2], f = t[3], u = e[0], d = e[1], m = e[2], y = e[3];
            return (s = l * u + p * d + c * m + f * y) < 0 && (s = -s, u = -u, d = -d, m = -m, y = -y), 1 - s > 1e-6 ? (_$i = Math.acos(s), a = Math.sin(_$i), n = Math.sin((1 - r1) * _$i) / a, o = Math.sin(r1 * _$i) / a) : (n = 1 - r1, o = r1), h[0] = n * l + o * u, h[1] = n * p + o * d, h[2] = n * c + o * m, h[3] = n * f + o * y, h;
        }
        function quaternionToEuler(t, e) {
            var r1 = e[0], _$i = e[1], s = e[2], a = e[3], n = Math.atan2(2 * _$i * a - 2 * r1 * s, 1 - 2 * _$i * _$i - 2 * s * s), o = Math.asin(2 * r1 * _$i + 2 * s * a), h = Math.atan2(2 * r1 * a - 2 * _$i * s, 1 - 2 * r1 * r1 - 2 * s * s);
            t[0] = n / degToRads, t[1] = o / degToRads, t[2] = h / degToRads;
        }
        function createQuaternion(t) {
            var e = t[0] * degToRads, r1 = t[1] * degToRads, _$i = t[2] * degToRads, s = Math.cos(e / 2), a = Math.cos(r1 / 2), n = Math.cos(_$i / 2), o = Math.sin(e / 2), h = Math.sin(r1 / 2), l = Math.sin(_$i / 2);
            return [
                o * h * n + s * a * l,
                o * a * n + s * h * l,
                s * h * n - o * a * l,
                s * a * n - o * h * l
            ];
        }
        function getValueAtCurrentTime() {
            var t = this.comp.renderedFrame - this.offsetTime, e = this.keyframes[0].t - this.offsetTime, r1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            if (!(t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= r1 && t >= r1 || this._caching.lastFrame < e && t < e))) {
                this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                var _$i = this.interpolateValue(t, this._caching);
                this.pv = _$i;
            }
            return this._caching.lastFrame = t, this.pv;
        }
        function setVValue(t) {
            var e;
            if ("unidimensional" === this.propType) e = t * this.mult, mathAbs(this.v - e) > 1e-5 && (this.v = e, this._mdf = !0);
            else for(var r1 = 0, _$i = this.v.length; r1 < _$i;)e = t[r1] * this.mult, mathAbs(this.v[r1] - e) > 1e-5 && (this.v[r1] = e, this._mdf = !0), r1 += 1;
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                if (this.lock) this.setVValue(this.pv);
                else {
                    var t;
                    this.lock = !0, this._mdf = this._isFirstFrame;
                    var e = this.effectsSequence.length, r1 = this.kf ? this.pv : this.data.k;
                    for(t = 0; t < e; t += 1)r1 = this.effectsSequence[t](r1);
                    this.setVValue(r1), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }
        function addEffect(t) {
            this.effectsSequence.push(t), this.container.addDynamicProperty(this);
        }
        function ValueProperty(t, e, r1, i) {
            this.propType = "unidimensional", this.mult = r1 || 1, this.data = e, this.v = r1 ? e.k * r1 : e.k, this.pv = e.k, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function MultiDimensionalProperty(t, e, r1, i) {
            var s;
            this.propType = "multidimensional", this.mult = r1 || 1, this.data = e, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
            var a = e.k.length;
            for(this.v = createTypedArray("float32", a), this.pv = createTypedArray("float32", a), this.vel = createTypedArray("float32", a), s = 0; s < a; s += 1)this.v[s] = e.k[s] * this.mult, this.pv[s] = e.k[s];
            this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function KeyframedValueProperty(t, e, r1, i) {
            this.propType = "unidimensional", this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.frameId = -1, this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: 0,
                _lastKeyframeIndex: -1
            }, this.k = !0, this.kf = !0, this.data = e, this.mult = r1 || 1, this.elem = t, this.container = i, this.comp = t.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.addEffect = addEffect;
        }
        function KeyframedMultidimensionalProperty(t, e, r1, i) {
            var s;
            this.propType = "multidimensional";
            var a, n, o, h, l = e.k.length;
            for(s = 0; s < l - 1; s += 1)e.k[s].to && e.k[s].s && e.k[s + 1] && e.k[s + 1].s && (a = e.k[s].s, n = e.k[s + 1].s, o = e.k[s].to, h = e.k[s].ti, (2 === a.length && (a[0] !== n[0] || a[1] !== n[1]) && bez.pointOnLine2D(a[0], a[1], n[0], n[1], a[0] + o[0], a[1] + o[1]) && bez.pointOnLine2D(a[0], a[1], n[0], n[1], n[0] + h[0], n[1] + h[1]) || 3 === a.length && (a[0] !== n[0] || a[1] !== n[1] || a[2] !== n[2]) && bez.pointOnLine3D(a[0], a[1], a[2], n[0], n[1], n[2], a[0] + o[0], a[1] + o[1], a[2] + o[2]) && bez.pointOnLine3D(a[0], a[1], a[2], n[0], n[1], n[2], n[0] + h[0], n[1] + h[1], n[2] + h[2])) && (e.k[s].to = null, e.k[s].ti = null), a[0] === n[0] && a[1] === n[1] && 0 === o[0] && 0 === o[1] && 0 === h[0] && 0 === h[1] && (2 === a.length || a[2] === n[2] && 0 === o[2] && 0 === h[2]) && (e.k[s].to = null, e.k[s].ti = null));
            this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.data = e, this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = r1 || 1, this.elem = t, this.container = i, this.comp = t.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
            var p = e.k[0].s.length;
            for(this.v = createTypedArray("float32", p), this.pv = createTypedArray("float32", p), s = 0; s < p; s += 1)this.v[s] = initFrame, this.pv[s] = initFrame;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: createTypedArray("float32", p)
            }, this.addEffect = addEffect;
        }
        var PropertyFactory = (ob = {
            getProp: function getProp(t, e, r1, i, s) {
                var a;
                if (e.sid && (e = t.globalData.slotManager.getProp(e)), e.k.length) {
                    if ("number" == typeof e.k[0]) a = new MultiDimensionalProperty(t, e, i, s);
                    else switch(r1){
                        case 0:
                            a = new KeyframedValueProperty(t, e, i, s);
                            break;
                        case 1:
                            a = new KeyframedMultidimensionalProperty(t, e, i, s);
                    }
                } else a = new ValueProperty(t, e, i, s);
                return a.effectsSequence.length && s.addDynamicProperty(a), a;
            }
        }, ob), ob;
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
            addDynamicProperty: function addDynamicProperty(t) {
                -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
            },
            iterateDynamicProperties: function iterateDynamicProperties() {
                var t;
                this._mdf = !1;
                var e = this.dynamicProperties.length;
                for(t = 0; t < e; t += 1)this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
            },
            initDynamicPropertyContainer: function initDynamicPropertyContainer(t) {
                this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
            }
        };
        var pointPool = poolFactory(8, function() {
            return createTypedArray("float32", 2);
        });
        function ShapePath() {
            this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
        }
        ShapePath.prototype.setPathData = function(t, e) {
            this.c = t, this.setLength(e);
            for(var r1 = 0; r1 < e;)this.v[r1] = pointPool.newElement(), this.o[r1] = pointPool.newElement(), this.i[r1] = pointPool.newElement(), r1 += 1;
        }, ShapePath.prototype.setLength = function(t) {
            for(; this._maxLength < t;)this.doubleArrayLength();
            this._length = t;
        }, ShapePath.prototype.doubleArrayLength = function() {
            this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
        }, ShapePath.prototype.setXYAt = function(t, e, r1, i, s) {
            var a;
            switch(this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), r1){
                case "v":
                    a = this.v;
                    break;
                case "i":
                    a = this.i;
                    break;
                case "o":
                    a = this.o;
                    break;
                default:
                    a = [];
            }
            (!a[i] || a[i] && !s) && (a[i] = pointPool.newElement()), a[i][0] = t, a[i][1] = e;
        }, ShapePath.prototype.setTripleAt = function(t, e, r1, i, s, a, n, o) {
            this.setXYAt(t, e, "v", n, o), this.setXYAt(r1, i, "o", n, o), this.setXYAt(s, a, "i", n, o);
        }, ShapePath.prototype.reverse = function() {
            var t = new ShapePath;
            t.setPathData(this.c, this._length);
            var e = this.v, r1 = this.o, _$i = this.i, s = 0;
            this.c && (t.setTripleAt(e[0][0], e[0][1], _$i[0][0], _$i[0][1], r1[0][0], r1[0][1], 0, !1), s = 1);
            var a, n = this._length - 1, o = this._length;
            for(a = s; a < o; a += 1)t.setTripleAt(e[n][0], e[n][1], _$i[n][0], _$i[n][1], r1[n][0], r1[n][1], a, !1), n -= 1;
            return t;
        }, ShapePath.prototype.length = function() {
            return this._length;
        };
        var shapePool = (factory = poolFactory(4, function() {
            return new ShapePath;
        }, function(t) {
            var e, r1 = t._length;
            for(e = 0; e < r1; e += 1)pointPool.release(t.v[e]), pointPool.release(t.i[e]), pointPool.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
            t._length = 0, t.c = !1;
        }), factory.clone = function shapePool(t) {
            var e, r1 = factory.newElement(), _$i = void 0 === t._length ? t.v.length : t._length;
            for(r1.setLength(_$i), r1.c = t.c, e = 0; e < _$i; e += 1)r1.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
            return r1;
        }, factory), factory;
        function ShapeCollection() {
            this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
        }
        ShapeCollection.prototype.addShape = function(t) {
            this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
        }, ShapeCollection.prototype.releaseShapes = function() {
            var t;
            for(t = 0; t < this._length; t += 1)shapePool.release(this.shapes[t]);
            this._length = 0;
        };
        var shapeCollectionPool = function() {
            var t = {
                newShapeCollection: function newShapeCollection() {
                    return e ? _$i[e -= 1] : new ShapeCollection;
                },
                release: function release(t) {
                    var s, a = t._length;
                    for(s = 0; s < a; s += 1)shapePool.release(t.shapes[s]);
                    t._length = 0, e === r1 && (_$i = pooling.double(_$i), r1 *= 2), _$i[e] = t, e += 1;
                }
            }, e = 0, r1 = 4, _$i = createSizedArray(r1);
            return t;
        }(), ShapePropertyFactory = function() {
            var t = -999999;
            function e(t, e, r1) {
                var _$i, _$s, _$a, _$n, _$o, _$h, l, p, c, f = r1.lastIndex, u = this.keyframes;
                if (t < u[0].t - this.offsetTime) _$i = u[0].s[0], _$a = !0, f = 0;
                else if (t >= u[u.length - 1].t - this.offsetTime) _$i = u[u.length - 1].s ? u[u.length - 1].s[0] : u[u.length - 2].e[0], _$a = !0;
                else {
                    for(var d, m, y, g = f, v = u.length - 1, b = !0; b && (d = u[g], !((m = u[g + 1]).t - this.offsetTime > t));)g < v - 1 ? g += 1 : b = !1;
                    if (y = this.keyframesMetadata[g] || {}, f = g, !(_$a = 1 === d.h)) {
                        if (t >= m.t - this.offsetTime) p = 1;
                        else if (t < d.t - this.offsetTime) p = 0;
                        else {
                            var _;
                            y.__fnct ? _ = y.__fnct : (_ = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y).get, y.__fnct = _), p = _((t - (d.t - this.offsetTime)) / (m.t - this.offsetTime - (d.t - this.offsetTime)));
                        }
                        _$s = m.s ? m.s[0] : d.e[0];
                    }
                    _$i = d.s[0];
                }
                for(_$h = e._length, l = _$i.i[0].length, r1.lastIndex = f, _$n = 0; _$n < _$h; _$n += 1)for(_$o = 0; _$o < l; _$o += 1)c = _$a ? _$i.i[_$n][_$o] : _$i.i[_$n][_$o] + (_$s.i[_$n][_$o] - _$i.i[_$n][_$o]) * p, e.i[_$n][_$o] = c, c = _$a ? _$i.o[_$n][_$o] : _$i.o[_$n][_$o] + (_$s.o[_$n][_$o] - _$i.o[_$n][_$o]) * p, e.o[_$n][_$o] = c, c = _$a ? _$i.v[_$n][_$o] : _$i.v[_$n][_$o] + (_$s.v[_$n][_$o] - _$i.v[_$n][_$o]) * p, e.v[_$n][_$o] = c;
            }
            function r1() {
                var _$e = this.comp.renderedFrame - this.offsetTime, r1 = this.keyframes[0].t - this.offsetTime, _$i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, _$s = this._caching.lastFrame;
                return _$s !== t && (_$s < r1 && _$e < r1 || _$s > _$i && _$e > _$i) || (this._caching.lastIndex = _$s < _$e ? this._caching.lastIndex : 0, this.interpolateShape(_$e, this.pv, this._caching)), this._caching.lastFrame = _$e, this.pv;
            }
            function i() {
                this.paths = this.localShapeCollection;
            }
            function s(t) {
                (function(t, e) {
                    if (t._length !== e._length || t.c !== e.c) return !1;
                    var r1, _$i = t._length;
                    for(r1 = 0; r1 < _$i; r1 += 1)if (t.v[r1][0] !== e.v[r1][0] || t.v[r1][1] !== e.v[r1][1] || t.o[r1][0] !== e.o[r1][0] || t.o[r1][1] !== e.o[r1][1] || t.i[r1][0] !== e.i[r1][0] || t.i[r1][1] !== e.i[r1][1]) return !1;
                    return !0;
                })(this.v, t) || (this.v = shapePool.clone(t), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
            }
            function a() {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this.effectsSequence.length) {
                        if (this.lock) this.setVValue(this.pv);
                        else {
                            var t, _$e;
                            this.lock = !0, this._mdf = !1, t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                            var r1 = this.effectsSequence.length;
                            for(_$e = 0; _$e < r1; _$e += 1)t = this.effectsSequence[_$e](t);
                            this.setVValue(t), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                        }
                    } else this._mdf = !1;
                }
            }
            function n(t, e, r1) {
                this.propType = "shape", this.comp = t.comp, this.container = t, this.elem = t, this.data = e, this.k = !1, this.kf = !1, this._mdf = !1;
                var _$s = 3 === r1 ? e.pt.k : e.ks.k;
                this.v = shapePool.clone(_$s), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = i, this.effectsSequence = [];
            }
            function o(t) {
                this.effectsSequence.push(t), this.container.addDynamicProperty(this);
            }
            function h(e, s, a) {
                this.propType = "shape", this.comp = e.comp, this.elem = e, this.container = e, this.offsetTime = e.data.st, this.keyframes = 3 === a ? s.pt.k : s.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                var _$n = this.keyframes[0].s[0].i.length;
                this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, _$n), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = t, this.reset = i, this._caching = {
                    lastFrame: t,
                    lastIndex: 0
                }, this.effectsSequence = [
                    r1.bind(this)
                ];
            }
            n.prototype.interpolateShape = e, n.prototype.getValue = a, n.prototype.setVValue = s, n.prototype.addEffect = o, h.prototype.getValue = a, h.prototype.interpolateShape = e, h.prototype.setVValue = s, h.prototype.addEffect = o;
            var l = function() {
                var t = roundCorner;
                function e(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e.d, this.elem = t, this.comp = t.comp, this.frameId = -1, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
                }
                return e.prototype = {
                    reset: i,
                    getValue: function getValue() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                    },
                    convertEllToPath: function convertEllToPath() {
                        var _$e = this.p.v[0], r1 = this.p.v[1], _$i = this.s.v[0] / 2, _$s = this.s.v[1] / 2, _$a = 3 !== this.d, _$n = this.v;
                        _$n.v[0][0] = _$e, _$n.v[0][1] = r1 - _$s, _$n.v[1][0] = _$a ? _$e + _$i : _$e - _$i, _$n.v[1][1] = r1, _$n.v[2][0] = _$e, _$n.v[2][1] = r1 + _$s, _$n.v[3][0] = _$a ? _$e - _$i : _$e + _$i, _$n.v[3][1] = r1, _$n.i[0][0] = _$a ? _$e - _$i * t : _$e + _$i * t, _$n.i[0][1] = r1 - _$s, _$n.i[1][0] = _$a ? _$e + _$i : _$e - _$i, _$n.i[1][1] = r1 - _$s * t, _$n.i[2][0] = _$a ? _$e + _$i * t : _$e - _$i * t, _$n.i[2][1] = r1 + _$s, _$n.i[3][0] = _$a ? _$e - _$i : _$e + _$i, _$n.i[3][1] = r1 + _$s * t, _$n.o[0][0] = _$a ? _$e + _$i * t : _$e - _$i * t, _$n.o[0][1] = r1 - _$s, _$n.o[1][0] = _$a ? _$e + _$i : _$e - _$i, _$n.o[1][1] = r1 + _$s * t, _$n.o[2][0] = _$a ? _$e - _$i * t : _$e + _$i * t, _$n.o[2][1] = r1 + _$s, _$n.o[3][0] = _$a ? _$e - _$i : _$e + _$i, _$n.o[3][1] = r1 - _$s * t;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], e), e;
            }(), p = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t, this.comp = t.comp, this.data = e, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? (this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this), this.is = PropertyFactory.getProp(t, e.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t, e.or, 0, 0, this), this.os = PropertyFactory.getProp(t, e.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
                }
                return t.prototype = {
                    reset: i,
                    getValue: function getValue() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                    },
                    convertStarToPath: function convertStarToPath() {
                        var _$t, _$e, r1, _$i, _$s = 2 * Math.floor(this.pt.v), _$a = 2 * Math.PI / _$s, _$n = !0, _$o = this.or.v, _$h = this.ir.v, l = this.os.v, p = this.is.v, c = 2 * Math.PI * _$o / (2 * _$s), f = 2 * Math.PI * _$h / (2 * _$s), u = -Math.PI / 2;
                        u += this.r.v;
                        var d = 3 === this.data.d ? -1 : 1;
                        for(this.v._length = 0, _$t = 0; _$t < _$s; _$t += 1){
                            r1 = _$n ? l : p, _$i = _$n ? c : f;
                            var m = (_$e = _$n ? _$o : _$h) * Math.cos(u), y = _$e * Math.sin(u), g = 0 === m && 0 === y ? 0 : y / Math.sqrt(m * m + y * y), v = 0 === m && 0 === y ? 0 : -m / Math.sqrt(m * m + y * y);
                            m += +this.p.v[0], y += +this.p.v[1], this.v.setTripleAt(m, y, m - g * _$i * r1 * d, y - v * _$i * r1 * d, m + g * _$i * r1 * d, y + v * _$i * r1 * d, _$t, !0), _$n = !_$n, u += _$a * d;
                        }
                    },
                    convertPolygonToPath: function convertPolygonToPath() {
                        var _$t, _$e = Math.floor(this.pt.v), r1 = 2 * Math.PI / _$e, _$i = this.or.v, _$s = this.os.v, _$a = 2 * Math.PI * _$i / (4 * _$e), _$n = .5 * -Math.PI, _$o = 3 === this.data.d ? -1 : 1;
                        for(_$n += this.r.v, this.v._length = 0, _$t = 0; _$t < _$e; _$t += 1){
                            var _$h = _$i * Math.cos(_$n), l = _$i * Math.sin(_$n), p = 0 === _$h && 0 === l ? 0 : l / Math.sqrt(_$h * _$h + l * l), c = 0 === _$h && 0 === l ? 0 : -_$h / Math.sqrt(_$h * _$h + l * l);
                            _$h += +this.p.v[0], l += +this.p.v[1], this.v.setTripleAt(_$h, l, _$h - p * _$a * _$s * _$o, l - c * _$a * _$s * _$o, _$h + p * _$a * _$s * _$o, l + c * _$a * _$s * _$o, _$t, !0), _$n += r1 * _$o;
                        }
                        this.paths.length = 0, this.paths[0] = this.v;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }(), c = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t, this.comp = t.comp, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
                }
                return t.prototype = {
                    convertRectToPath: function convertRectToPath() {
                        var _$t = this.p.v[0], _$e = this.p.v[1], r1 = this.s.v[0] / 2, _$i = this.s.v[1] / 2, _$s = bmMin(r1, _$i, this.r.v), _$a = _$s * (1 - roundCorner);
                        this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(_$t + r1, _$e - _$i + _$s, _$t + r1, _$e - _$i + _$s, _$t + r1, _$e - _$i + _$a, 0, !0), this.v.setTripleAt(_$t + r1, _$e + _$i - _$s, _$t + r1, _$e + _$i - _$a, _$t + r1, _$e + _$i - _$s, 1, !0), 0 !== _$s ? (this.v.setTripleAt(_$t + r1 - _$s, _$e + _$i, _$t + r1 - _$s, _$e + _$i, _$t + r1 - _$a, _$e + _$i, 2, !0), this.v.setTripleAt(_$t - r1 + _$s, _$e + _$i, _$t - r1 + _$a, _$e + _$i, _$t - r1 + _$s, _$e + _$i, 3, !0), this.v.setTripleAt(_$t - r1, _$e + _$i - _$s, _$t - r1, _$e + _$i - _$s, _$t - r1, _$e + _$i - _$a, 4, !0), this.v.setTripleAt(_$t - r1, _$e - _$i + _$s, _$t - r1, _$e - _$i + _$a, _$t - r1, _$e - _$i + _$s, 5, !0), this.v.setTripleAt(_$t - r1 + _$s, _$e - _$i, _$t - r1 + _$s, _$e - _$i, _$t - r1 + _$a, _$e - _$i, 6, !0), this.v.setTripleAt(_$t + r1 - _$s, _$e - _$i, _$t + r1 - _$a, _$e - _$i, _$t + r1 - _$s, _$e - _$i, 7, !0)) : (this.v.setTripleAt(_$t - r1, _$e + _$i, _$t - r1 + _$a, _$e + _$i, _$t - r1, _$e + _$i, 2), this.v.setTripleAt(_$t - r1, _$e - _$i, _$t - r1, _$e - _$i + _$a, _$t - r1, _$e - _$i, 3))) : (this.v.setTripleAt(_$t + r1, _$e - _$i + _$s, _$t + r1, _$e - _$i + _$a, _$t + r1, _$e - _$i + _$s, 0, !0), 0 !== _$s ? (this.v.setTripleAt(_$t + r1 - _$s, _$e - _$i, _$t + r1 - _$s, _$e - _$i, _$t + r1 - _$a, _$e - _$i, 1, !0), this.v.setTripleAt(_$t - r1 + _$s, _$e - _$i, _$t - r1 + _$a, _$e - _$i, _$t - r1 + _$s, _$e - _$i, 2, !0), this.v.setTripleAt(_$t - r1, _$e - _$i + _$s, _$t - r1, _$e - _$i + _$s, _$t - r1, _$e - _$i + _$a, 3, !0), this.v.setTripleAt(_$t - r1, _$e + _$i - _$s, _$t - r1, _$e + _$i - _$a, _$t - r1, _$e + _$i - _$s, 4, !0), this.v.setTripleAt(_$t - r1 + _$s, _$e + _$i, _$t - r1 + _$s, _$e + _$i, _$t - r1 + _$a, _$e + _$i, 5, !0), this.v.setTripleAt(_$t + r1 - _$s, _$e + _$i, _$t + r1 - _$a, _$e + _$i, _$t + r1 - _$s, _$e + _$i, 6, !0), this.v.setTripleAt(_$t + r1, _$e + _$i - _$s, _$t + r1, _$e + _$i - _$s, _$t + r1, _$e + _$i - _$a, 7, !0)) : (this.v.setTripleAt(_$t - r1, _$e - _$i, _$t - r1 + _$a, _$e - _$i, _$t - r1, _$e - _$i, 1, !0), this.v.setTripleAt(_$t - r1, _$e + _$i, _$t - r1, _$e + _$i - _$a, _$t - r1, _$e + _$i, 2, !0), this.v.setTripleAt(_$t + r1, _$e + _$i, _$t + r1 - _$a, _$e + _$i, _$t + r1, _$e + _$i, 3, !0)));
                    },
                    getValue: function getValue() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                    },
                    reset: i
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }(), f = {
                getShapeProp: function getShapeProp(t, e, r1) {
                    var _$i;
                    return 3 === r1 || 4 === r1 ? _$i = (3 === r1 ? e.pt : e.ks).k.length ? new h(t, e, r1) : new n(t, e, r1) : 5 === r1 ? _$i = new c(t, e) : 6 === r1 ? _$i = new l(t, e) : 7 === r1 && (_$i = new p(t, e)), _$i.k && t.addDynamicProperty(_$i), _$i;
                },
                getConstructorFunction: function getConstructorFunction() {
                    return n;
                },
                getKeyframedConstructorFunction: function getKeyframedConstructorFunction() {
                    return h;
                }
            };
            return f;
        }(), Matrix = function() {
            var t = Math.cos, e = Math.sin, r1 = Math.tan, _$i = Math.round;
            function s() {
                return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
            }
            function a(r1) {
                if (0 === r1) return this;
                var _$i = t(r1), s = e(r1);
                return this._t(_$i, -s, 0, 0, s, _$i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function n(r1) {
                if (0 === r1) return this;
                var _$i = t(r1), s = e(r1);
                return this._t(1, 0, 0, 0, 0, _$i, -s, 0, 0, s, _$i, 0, 0, 0, 0, 1);
            }
            function o(r1) {
                if (0 === r1) return this;
                var _$i = t(r1), s = e(r1);
                return this._t(_$i, 0, s, 0, 0, 1, 0, 0, -s, 0, _$i, 0, 0, 0, 0, 1);
            }
            function h(r1) {
                if (0 === r1) return this;
                var _$i = t(r1), s = e(r1);
                return this._t(_$i, -s, 0, 0, s, _$i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function l(t, e) {
                return this._t(1, e, t, 1, 0, 0);
            }
            function p(t, e) {
                return this.shear(r1(t), r1(e));
            }
            function c(i, s) {
                var a = t(s), n = e(s);
                return this._t(a, n, 0, 0, -n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r1(i), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(a, -n, 0, 0, n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function f(t, e, r1) {
                return r1 || 0 === r1 || (r1 = 1), 1 === t && 1 === e && 1 === r1 ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r1, 0, 0, 0, 0, 1);
            }
            function u(t, e, r1, i, s, a, n, o, h, l, p, c, f, u, d, m) {
                return this.props[0] = t, this.props[1] = e, this.props[2] = r1, this.props[3] = i, this.props[4] = s, this.props[5] = a, this.props[6] = n, this.props[7] = o, this.props[8] = h, this.props[9] = l, this.props[10] = p, this.props[11] = c, this.props[12] = f, this.props[13] = u, this.props[14] = d, this.props[15] = m, this;
            }
            function d(t, e, r1) {
                return r1 = r1 || 0, 0 !== t || 0 !== e || 0 !== r1 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r1, 1) : this;
            }
            function m(t, e, r1, i, s, a, n, o, h, l, p, c, f, u, d, m) {
                var y = this.props;
                if (1 === t && 0 === e && 0 === r1 && 0 === i && 0 === s && 1 === a && 0 === n && 0 === o && 0 === h && 0 === l && 1 === p && 0 === c) return y[12] = y[12] * t + y[15] * f, y[13] = y[13] * a + y[15] * u, y[14] = y[14] * p + y[15] * d, y[15] *= m, this._identityCalculated = !1, this;
                var g = y[0], v = y[1], b = y[2], _ = y[3], _$P = y[4], S = y[5], E = y[6], x = y[7], C = y[8], A = y[9], w = y[10], k = y[11], T = y[12], M = y[13], D = y[14], F = y[15];
                return y[0] = g * t + v * s + b * h + _ * f, y[1] = g * e + v * a + b * l + _ * u, y[2] = g * r1 + v * n + b * p + _ * d, y[3] = g * i + v * o + b * c + _ * m, y[4] = _$P * t + S * s + E * h + x * f, y[5] = _$P * e + S * a + E * l + x * u, y[6] = _$P * r1 + S * n + E * p + x * d, y[7] = _$P * i + S * o + E * c + x * m, y[8] = C * t + A * s + w * h + k * f, y[9] = C * e + A * a + w * l + k * u, y[10] = C * r1 + A * n + w * p + k * d, y[11] = C * i + A * o + w * c + k * m, y[12] = T * t + M * s + D * h + F * f, y[13] = T * e + M * a + D * l + F * u, y[14] = T * r1 + M * n + D * p + F * d, y[15] = T * i + M * o + D * c + F * m, this._identityCalculated = !1, this;
            }
            function y(t) {
                var e = t.props;
                return this.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
            }
            function g() {
                return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
            }
            function v(t) {
                for(var e = 0; e < 16;){
                    if (t.props[e] !== this.props[e]) return !1;
                    e += 1;
                }
                return !0;
            }
            function b(t) {
                var e;
                for(e = 0; e < 16; e += 1)t.props[e] = this.props[e];
                return t;
            }
            function _(t) {
                var e;
                for(e = 0; e < 16; e += 1)this.props[e] = t[e];
            }
            function P(t, e, r1) {
                return {
                    x: t * this.props[0] + e * this.props[4] + r1 * this.props[8] + this.props[12],
                    y: t * this.props[1] + e * this.props[5] + r1 * this.props[9] + this.props[13],
                    z: t * this.props[2] + e * this.props[6] + r1 * this.props[10] + this.props[14]
                };
            }
            function S(t, e, r1) {
                return t * this.props[0] + e * this.props[4] + r1 * this.props[8] + this.props[12];
            }
            function E(t, e, r1) {
                return t * this.props[1] + e * this.props[5] + r1 * this.props[9] + this.props[13];
            }
            function x(t, e, r1) {
                return t * this.props[2] + e * this.props[6] + r1 * this.props[10] + this.props[14];
            }
            function C() {
                var t = this.props[0] * this.props[5] - this.props[1] * this.props[4], e = this.props[5] / t, r1 = -this.props[1] / t, _$i = -this.props[4] / t, s = this.props[0] / t, a = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t, n = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t, o = new Matrix;
                return o.props[0] = e, o.props[1] = r1, o.props[4] = _$i, o.props[5] = s, o.props[12] = a, o.props[13] = n, o;
            }
            function A(t) {
                return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
            }
            function w(t) {
                var e, r1 = t.length, _$i = [];
                for(e = 0; e < r1; e += 1)_$i[e] = A(t[e]);
                return _$i;
            }
            function k(t, e, r1) {
                var _$i = createTypedArray("float32", 6);
                if (this.isIdentity()) _$i[0] = t[0], _$i[1] = t[1], _$i[2] = e[0], _$i[3] = e[1], _$i[4] = r1[0], _$i[5] = r1[1];
                else {
                    var s = this.props[0], a = this.props[1], n = this.props[4], o = this.props[5], h = this.props[12], l = this.props[13];
                    _$i[0] = t[0] * s + t[1] * n + h, _$i[1] = t[0] * a + t[1] * o + l, _$i[2] = e[0] * s + e[1] * n + h, _$i[3] = e[0] * a + e[1] * o + l, _$i[4] = r1[0] * s + r1[1] * n + h, _$i[5] = r1[0] * a + r1[1] * o + l;
                }
                return _$i;
            }
            function T(t, e, r1) {
                return this.isIdentity() ? [
                    t,
                    e,
                    r1
                ] : [
                    t * this.props[0] + e * this.props[4] + r1 * this.props[8] + this.props[12],
                    t * this.props[1] + e * this.props[5] + r1 * this.props[9] + this.props[13],
                    t * this.props[2] + e * this.props[6] + r1 * this.props[10] + this.props[14]
                ];
            }
            function M(t, e) {
                if (this.isIdentity()) return t + "," + e;
                var r1 = this.props;
                return Math.round(100 * (t * r1[0] + e * r1[4] + r1[12])) / 100 + "," + Math.round(100 * (t * r1[1] + e * r1[5] + r1[13])) / 100;
            }
            function D() {
                for(var t = 0, e = this.props, r1 = "matrix3d("; t < 16;)r1 += _$i(1e4 * e[t]) / 1e4, r1 += 15 === t ? ")" : ",", t += 1;
                return r1;
            }
            function F(t) {
                return t < 1e-6 && t > 0 || t > -0.000001 && t < 0 ? _$i(1e4 * t) / 1e4 : t;
            }
            function I() {
                var t = this.props;
                return "matrix(" + F(t[0]) + "," + F(t[1]) + "," + F(t[4]) + "," + F(t[5]) + "," + F(t[12]) + "," + F(t[13]) + ")";
            }
            return function() {
                this.reset = s, this.rotate = a, this.rotateX = n, this.rotateY = o, this.rotateZ = h, this.skew = p, this.skewFromAxis = c, this.shear = l, this.scale = f, this.setTransform = u, this.translate = d, this.transform = m, this.multiply = y, this.applyToPoint = P, this.applyToX = S, this.applyToY = E, this.applyToZ = x, this.applyToPointArray = T, this.applyToTriplePoints = k, this.applyToPointStringified = M, this.toCSS = D, this.to2dCSS = I, this.clone = b, this.cloneFromProps = _, this.equals = v, this.inversePoints = w, this.inversePoint = A, this.getInverseMatrix = C, this._t = this.transform, this.isIdentity = g, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
            };
        }();
        function _typeof$3(t) {
            return _typeof$3 = "function" == typeof Symbol && "symbol" == (0, $l0HdX._)(Symbol.iterator) ? function _typeof$31(t) {
                return typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            }, _typeof$3(t);
        }
        var lottie = {}, standalone = "__[STANDALONE]__", animationData = "__[ANIMATIONDATA]__", renderer = "";
        function setLocation(t) {
            setLocationHref(t);
        }
        function searchAnimations() {
            !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
        }
        function setSubframeRendering(t) {
            setSubframeEnabled(t);
        }
        function setPrefix(t) {
            setIdPrefix(t);
        }
        function loadAnimation(t) {
            return !0 === standalone && (t.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t);
        }
        function setQuality(t) {
            if ("string" == typeof t) switch(t){
                case "high":
                    setDefaultCurveSegments(200);
                    break;
                default:
                case "medium":
                    setDefaultCurveSegments(50);
                    break;
                case "low":
                    setDefaultCurveSegments(10);
            }
            else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
            getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
        }
        function inBrowser() {
            return "undefined" != typeof navigator;
        }
        function installPlugin(t, e) {
            "expressions" === t && setExpressionsPlugin(e);
        }
        function getFactory(t) {
            switch(t){
                case "propertyFactory":
                    return PropertyFactory;
                case "shapePropertyFactory":
                    return ShapePropertyFactory;
                case "matrix":
                    return Matrix;
                default:
                    return null;
            }
        }
        function checkReady() {
            "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
        }
        function getQueryVariable(t) {
            for(var e = queryString.split("&"), r1 = 0; r1 < e.length; r1 += 1){
                var _$i = e[r1].split("=");
                if (decodeURIComponent(_$i[0]) == t) return decodeURIComponent(_$i[1]);
            }
            return null;
        }
        lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
        var queryString = "";
        if (standalone) {
            var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", renderer = getQueryVariable("renderer");
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
            "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
        } catch (t) {}
        var ShapeModifiers = function() {
            var t = {}, e = {};
            return t.registerModifier = function(t, r1) {
                e[t] || (e[t] = r1);
            }, t.getModifier = function(t, r1, i) {
                return new e[t](r1, i);
            }, t;
        }();
        function ShapeModifier() {}
        function TrimModifier() {}
        function PuckerAndBloatModifier() {}
        ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t) {
            if (!this.closed) {
                t.sh.container.addDynamicProperty(t.sh);
                var e = {
                    shape: t.sh,
                    data: t,
                    localShapeCollection: shapeCollectionPool.newShapeCollection()
                };
                this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
            }
        }, ShapeModifier.prototype.init = function(t, e) {
            this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, ShapeModifier.prototype.processKeys = function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
        }, extendPrototype([
            DynamicPropertyContainer
        ], ShapeModifier), extendPrototype([
            ShapeModifier
        ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t, e) {
            this.s = PropertyFactory.getProp(t, e.s, 0, .01, this), this.e = PropertyFactory.getProp(t, e.e, 0, .01, this), this.o = PropertyFactory.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
        }, TrimModifier.prototype.addShapeToModifier = function(t) {
            t.pathsData = [];
        }, TrimModifier.prototype.calculateShapeEdges = function(t, e, r1, i, s) {
            var a = [];
            e <= 1 ? a.push({
                s: t,
                e: e
            }) : t >= 1 ? a.push({
                s: t - 1,
                e: e - 1
            }) : (a.push({
                s: t,
                e: 1
            }), a.push({
                s: 0,
                e: e - 1
            }));
            var n, o, h = [], l = a.length;
            for(n = 0; n < l; n += 1){
                var p, c;
                (o = a[n]).e * s < i || o.s * s > i + r1 || (p = o.s * s <= i ? 0 : (o.s * s - i) / r1, c = o.e * s >= i + r1 ? 1 : (o.e * s - i) / r1, h.push([
                    p,
                    c
                ]));
            }
            return h.length || h.push([
                0,
                0
            ]), h;
        }, TrimModifier.prototype.releasePathsData = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)segmentsLengthPool.release(t[e]);
            return t.length = 0, t;
        }, TrimModifier.prototype.processShapes = function(t) {
            var e, r1, _$i, s;
            if (this._mdf || t) {
                var a = this.o.v % 360 / 360;
                if (a < 0 && (a += 1), (e = this.s.v > 1 ? 1 + a : this.s.v < 0 ? 0 + a : this.s.v + a) > (r1 = this.e.v > 1 ? 1 + a : this.e.v < 0 ? 0 + a : this.e.v + a)) {
                    var n = e;
                    e = r1, r1 = n;
                }
                e = 1e-4 * Math.round(1e4 * e), r1 = 1e-4 * Math.round(1e4 * r1), this.sValue = e, this.eValue = r1;
            } else e = this.sValue, r1 = this.eValue;
            var o, h, l, p, c, f = this.shapes.length, u = 0;
            if (r1 === e) for(s = 0; s < f; s += 1)this.shapes[s].localShapeCollection.releaseShapes(), this.shapes[s].shape._mdf = !0, this.shapes[s].shape.paths = this.shapes[s].localShapeCollection, this._mdf && (this.shapes[s].pathsData.length = 0);
            else if (1 === r1 && 0 === e || 0 === r1 && 1 === e) {
                if (this._mdf) for(s = 0; s < f; s += 1)this.shapes[s].pathsData.length = 0, this.shapes[s].shape._mdf = !0;
            } else {
                var d, m, y = [];
                for(s = 0; s < f; s += 1)if ((d = this.shapes[s]).shape._mdf || this._mdf || t || 2 === this.m) {
                    if (h = (_$i = d.shape.paths)._length, c = 0, !d.shape._mdf && d.pathsData.length) c = d.totalShapeLength;
                    else {
                        for(l = this.releasePathsData(d.pathsData), o = 0; o < h; o += 1)p = bez.getSegmentsLength(_$i.shapes[o]), l.push(p), c += p.totalLength;
                        d.totalShapeLength = c, d.pathsData = l;
                    }
                    u += c, d.shape._mdf = !0;
                } else d.shape.paths = d.localShapeCollection;
                var g, v = e, b = r1, _ = 0;
                for(s = f - 1; s >= 0; s -= 1)if ((d = this.shapes[s]).shape._mdf) {
                    for((m = d.localShapeCollection).releaseShapes(), 2 === this.m && f > 1 ? (g = this.calculateShapeEdges(e, r1, d.totalShapeLength, _, u), _ += d.totalShapeLength) : g = [
                        [
                            v,
                            b
                        ]
                    ], h = g.length, o = 0; o < h; o += 1){
                        v = g[o][0], b = g[o][1], y.length = 0, b <= 1 ? y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength * b
                        }) : v >= 1 ? y.push({
                            s: d.totalShapeLength * (v - 1),
                            e: d.totalShapeLength * (b - 1)
                        }) : (y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength
                        }), y.push({
                            s: 0,
                            e: d.totalShapeLength * (b - 1)
                        }));
                        var _$P = this.addShapes(d, y[0]);
                        if (y[0].s !== y[0].e) {
                            if (y.length > 1) {
                                if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                                    var S = _$P.pop();
                                    this.addPaths(_$P, m), _$P = this.addShapes(d, y[1], S);
                                } else this.addPaths(_$P, m), _$P = this.addShapes(d, y[1]);
                            }
                            this.addPaths(_$P, m);
                        }
                    }
                    d.shape.paths = m;
                }
            }
        }, TrimModifier.prototype.addPaths = function(t, e) {
            var r1, _$i = t.length;
            for(r1 = 0; r1 < _$i; r1 += 1)e.addShape(t[r1]);
        }, TrimModifier.prototype.addSegment = function(t, e, r1, i, s, a, n) {
            s.setXYAt(e[0], e[1], "o", a), s.setXYAt(r1[0], r1[1], "i", a + 1), n && s.setXYAt(t[0], t[1], "v", a), s.setXYAt(i[0], i[1], "v", a + 1);
        }, TrimModifier.prototype.addSegmentFromArray = function(t, e, r1, i) {
            e.setXYAt(t[1], t[5], "o", r1), e.setXYAt(t[2], t[6], "i", r1 + 1), i && e.setXYAt(t[0], t[4], "v", r1), e.setXYAt(t[3], t[7], "v", r1 + 1);
        }, TrimModifier.prototype.addShapes = function(t, e, r1) {
            var _$i, s, a, n, o, h, l, p, c = t.pathsData, f = t.shape.paths.shapes, u = t.shape.paths._length, d = 0, m = [], y = !0;
            for(r1 ? (o = r1._length, p = r1._length) : (r1 = shapePool.newElement(), o = 0, p = 0), m.push(r1), _$i = 0; _$i < u; _$i += 1){
                for(h = c[_$i].lengths, r1.c = f[_$i].c, a = f[_$i].c ? h.length : h.length + 1, s = 1; s < a; s += 1)if (d + (n = h[s - 1]).addedLength < e.s) d += n.addedLength, r1.c = !1;
                else {
                    if (d > e.e) {
                        r1.c = !1;
                        break;
                    }
                    e.s <= d && e.e >= d + n.addedLength ? (this.addSegment(f[_$i].v[s - 1], f[_$i].o[s - 1], f[_$i].i[s], f[_$i].v[s], r1, o, y), y = !1) : (l = bez.getNewSegment(f[_$i].v[s - 1], f[_$i].v[s], f[_$i].o[s - 1], f[_$i].i[s], (e.s - d) / n.addedLength, (e.e - d) / n.addedLength, h[s - 1]), this.addSegmentFromArray(l, r1, o, y), y = !1, r1.c = !1), d += n.addedLength, o += 1;
                }
                if (f[_$i].c && h.length) {
                    if (n = h[s - 1], d <= e.e) {
                        var g = h[s - 1].addedLength;
                        e.s <= d && e.e >= d + g ? (this.addSegment(f[_$i].v[s - 1], f[_$i].o[s - 1], f[_$i].i[0], f[_$i].v[0], r1, o, y), y = !1) : (l = bez.getNewSegment(f[_$i].v[s - 1], f[_$i].v[0], f[_$i].o[s - 1], f[_$i].i[0], (e.s - d) / g, (e.e - d) / g, h[s - 1]), this.addSegmentFromArray(l, r1, o, y), y = !1, r1.c = !1);
                    } else r1.c = !1;
                    d += n.addedLength, o += 1;
                }
                if (r1._length && (r1.setXYAt(r1.v[p][0], r1.v[p][1], "i", p), r1.setXYAt(r1.v[r1._length - 1][0], r1.v[r1._length - 1][1], "o", r1._length - 1)), d > e.e) break;
                _$i < u - 1 && (r1 = shapePool.newElement(), y = !0, m.push(r1), o = 0);
            }
            return m;
        }, extendPrototype([
            ShapeModifier
        ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
        }, PuckerAndBloatModifier.prototype.processPath = function(t, e) {
            var r1 = e / 100, _$i = [
                0,
                0
            ], s = t._length, a = 0;
            for(a = 0; a < s; a += 1)_$i[0] += t.v[a][0], _$i[1] += t.v[a][1];
            _$i[0] /= s, _$i[1] /= s;
            var n, o, h, l, p, c, f = shapePool.newElement();
            for(f.c = t.c, a = 0; a < s; a += 1)n = t.v[a][0] + (_$i[0] - t.v[a][0]) * r1, o = t.v[a][1] + (_$i[1] - t.v[a][1]) * r1, h = t.o[a][0] + (_$i[0] - t.o[a][0]) * -r1, l = t.o[a][1] + (_$i[1] - t.o[a][1]) * -r1, p = t.i[a][0] + (_$i[0] - t.i[a][0]) * -r1, c = t.i[a][1] + (_$i[1] - t.i[a][1]) * -r1, f.setTripleAt(n, o, h, l, p, c, a);
            return f;
        }, PuckerAndBloatModifier.prototype.processShapes = function(t) {
            var e, r1, _$i, s, a, n, o = this.shapes.length, h = this.amount.v;
            if (0 !== h) for(r1 = 0; r1 < o; r1 += 1){
                if (n = (a = this.shapes[r1]).localShapeCollection, a.shape._mdf || this._mdf || t) for(n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, s = a.shape.paths._length, _$i = 0; _$i < s; _$i += 1)n.addShape(this.processPath(e[_$i], h));
                a.shape.paths = a.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var TransformPropertyFactory = function() {
            var t = [
                0,
                0
            ];
            function e(t, e, r1) {
                if (this.elem = t, this.frameId = -1, this.propType = "transform", this.data = e, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(r1 || t), e.p && e.p.s ? (this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this), e.p.z && (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t, e.p || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), e.rx) {
                    if (this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this), e.or.k[0].ti) {
                        var _$i, s = e.or.k.length;
                        for(_$i = 0; _$i < s; _$i += 1)e.or.k[_$i].to = null, e.or.k[_$i].ti = null;
                    }
                    this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this), this.or.sh = !0;
                } else this.r = PropertyFactory.getProp(t, e.r || {
                    k: 0
                }, 0, degToRads, this);
                e.sk && (this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t, e.a || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s || {
                    k: [
                        100,
                        100,
                        100
                    ]
                }, 1, .01, this), e.o ? this.o = PropertyFactory.getProp(t, e.o, 0, .01, t) : this.o = {
                    _mdf: !1,
                    v: 1
                }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
            }
            return e.prototype = {
                applyToMatrix: function applyToMatrix(t) {
                    var _$e = this._mdf;
                    this.iterateDynamicProperties(), this._mdf = this._mdf || _$e, this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                },
                getValue: function getValue(e) {
                    if (this.elem.globalData.frameId !== this.frameId) {
                        if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e) {
                            var r1;
                            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                var _$i, s;
                                if (r1 = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (_$i = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / r1, 0), s = this.p.getValueAtTime(this.p.keyframes[0].t / r1, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (_$i = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r1, 0), s = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / r1, 0)) : (_$i = this.p.pv, s = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / r1, this.p.offsetTime));
                                else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                    _$i = [], s = [];
                                    var a = this.px, n = this.py;
                                    a._caching.lastFrame + a.offsetTime <= a.keyframes[0].t ? (_$i[0] = a.getValueAtTime((a.keyframes[0].t + .01) / r1, 0), _$i[1] = n.getValueAtTime((n.keyframes[0].t + .01) / r1, 0), s[0] = a.getValueAtTime(a.keyframes[0].t / r1, 0), s[1] = n.getValueAtTime(n.keyframes[0].t / r1, 0)) : a._caching.lastFrame + a.offsetTime >= a.keyframes[a.keyframes.length - 1].t ? (_$i[0] = a.getValueAtTime(a.keyframes[a.keyframes.length - 1].t / r1, 0), _$i[1] = n.getValueAtTime(n.keyframes[n.keyframes.length - 1].t / r1, 0), s[0] = a.getValueAtTime((a.keyframes[a.keyframes.length - 1].t - .01) / r1, 0), s[1] = n.getValueAtTime((n.keyframes[n.keyframes.length - 1].t - .01) / r1, 0)) : (_$i = [
                                        a.pv,
                                        n.pv
                                    ], s[0] = a.getValueAtTime((a._caching.lastFrame + a.offsetTime - .01) / r1, a.offsetTime), s[1] = n.getValueAtTime((n._caching.lastFrame + n.offsetTime - .01) / r1, n.offsetTime));
                                } else _$i = s = t;
                                this.v.rotate(-Math.atan2(_$i[1] - s[1], _$i[0] - s[0]));
                            }
                            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                    }
                },
                precalculateMatrix: function precalculateMatrix() {
                    if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                        if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                        }
                        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                    }
                },
                autoOrient: function autoOrient() {}
            }, extendPrototype([
                DynamicPropertyContainer
            ], e), e.prototype.addDynamicProperty = function(t) {
                this._addDynamicProperty(t), this.elem.addDynamicProperty(t), this._isDirty = !0;
            }, e.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
                getTransformProperty: function getTransformProperty(t, r1, i) {
                    return new e(t, r1, i);
                }
            };
        }();
        function RepeaterModifier() {}
        function RoundCornersModifier() {}
        function floatEqual(t, e) {
            return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
        }
        function floatZero(t) {
            return Math.abs(t) <= 1e-5;
        }
        function lerp(t, e, r1) {
            return t * (1 - r1) + e * r1;
        }
        function lerpPoint(t, e, r1) {
            return [
                lerp(t[0], e[0], r1),
                lerp(t[1], e[1], r1)
            ];
        }
        function quadRoots(t, e, r1) {
            if (0 === t) return [];
            var _$i = e * e - 4 * t * r1;
            if (_$i < 0) return [];
            var s = -e / (2 * t);
            if (0 === _$i) return [
                s
            ];
            var a = Math.sqrt(_$i) / (2 * t);
            return [
                s - a,
                s + a
            ];
        }
        function polynomialCoefficients(t, e, r1, i) {
            return [
                3 * e - t - 3 * r1 + i,
                3 * t - 6 * e + 3 * r1,
                -3 * t + 3 * e,
                t
            ];
        }
        function singlePoint(t) {
            return new PolynomialBezier(t, t, t, t, !1);
        }
        function PolynomialBezier(t, e, r1, i, s) {
            s && pointEqual(t, e) && (e = lerpPoint(t, i, 1 / 3)), s && pointEqual(r1, i) && (r1 = lerpPoint(t, i, 2 / 3));
            var a = polynomialCoefficients(t[0], e[0], r1[0], i[0]), n = polynomialCoefficients(t[1], e[1], r1[1], i[1]);
            this.a = [
                a[0],
                n[0]
            ], this.b = [
                a[1],
                n[1]
            ], this.c = [
                a[2],
                n[2]
            ], this.d = [
                a[3],
                n[3]
            ], this.points = [
                t,
                e,
                r1,
                i
            ];
        }
        function extrema(t, e) {
            var r1 = t.points[0][e], _$i = t.points[t.points.length - 1][e];
            if (r1 > _$i) {
                var s = _$i;
                _$i = r1, r1 = s;
            }
            for(var a = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), n = 0; n < a.length; n += 1)if (a[n] > 0 && a[n] < 1) {
                var o = t.point(a[n])[e];
                o < r1 ? r1 = o : o > _$i && (_$i = o);
            }
            return {
                min: r1,
                max: _$i
            };
        }
        function intersectData(t, e, r1) {
            var _$i = t.boundingBox();
            return {
                cx: _$i.cx,
                cy: _$i.cy,
                width: _$i.width,
                height: _$i.height,
                bez: t,
                t: (e + r1) / 2,
                t1: e,
                t2: r1
            };
        }
        function splitData(t) {
            var e = t.bez.split(.5);
            return [
                intersectData(e[0], t.t1, t.t),
                intersectData(e[1], t.t, t.t2)
            ];
        }
        function boxIntersect(t, e) {
            return 2 * Math.abs(t.cx - e.cx) < t.width + e.width && 2 * Math.abs(t.cy - e.cy) < t.height + e.height;
        }
        function intersectsImpl(t, e, r1, i, s, a) {
            if (boxIntersect(t, e)) {
                if (r1 >= a || t.width <= i && t.height <= i && e.width <= i && e.height <= i) s.push([
                    t.t,
                    e.t
                ]);
                else {
                    var n = splitData(t), o = splitData(e);
                    intersectsImpl(n[0], o[0], r1 + 1, i, s, a), intersectsImpl(n[0], o[1], r1 + 1, i, s, a), intersectsImpl(n[1], o[0], r1 + 1, i, s, a), intersectsImpl(n[1], o[1], r1 + 1, i, s, a);
                }
            }
        }
        function crossProduct(t, e) {
            return [
                t[1] * e[2] - t[2] * e[1],
                t[2] * e[0] - t[0] * e[2],
                t[0] * e[1] - t[1] * e[0]
            ];
        }
        function lineIntersection(t, e, r1, i) {
            var s = [
                t[0],
                t[1],
                1
            ], a = [
                e[0],
                e[1],
                1
            ], n = [
                r1[0],
                r1[1],
                1
            ], o = [
                i[0],
                i[1],
                1
            ], h = crossProduct(crossProduct(s, a), crossProduct(n, o));
            return floatZero(h[2]) ? null : [
                h[0] / h[2],
                h[1] / h[2]
            ];
        }
        function polarOffset(t, e, r1) {
            return [
                t[0] + Math.cos(e) * r1,
                t[1] - Math.sin(e) * r1
            ];
        }
        function pointDistance(t, e) {
            return Math.hypot(t[0] - e[0], t[1] - e[1]);
        }
        function pointEqual(t, e) {
            return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
        }
        function ZigZagModifier() {}
        function setPoint(t, e, r1, i, s, a, n) {
            var o = r1 - Math.PI / 2, h = r1 + Math.PI / 2, l = e[0] + Math.cos(r1) * i * s, p = e[1] - Math.sin(r1) * i * s;
            t.setTripleAt(l, p, l + Math.cos(o) * a, p - Math.sin(o) * a, l + Math.cos(h) * n, p - Math.sin(h) * n, t.length());
        }
        function getPerpendicularVector(t, e) {
            var r1 = [
                e[0] - t[0],
                e[1] - t[1]
            ], _$i = .5 * -Math.PI;
            return [
                Math.cos(_$i) * r1[0] - Math.sin(_$i) * r1[1],
                Math.sin(_$i) * r1[0] + Math.cos(_$i) * r1[1]
            ];
        }
        function getProjectingAngle(t, e) {
            var r1 = 0 === e ? t.length() - 1 : e - 1, _$i = (e + 1) % t.length(), s = getPerpendicularVector(t.v[r1], t.v[_$i]);
            return Math.atan2(0, 1) - Math.atan2(s[1], s[0]);
        }
        function zigZagCorner(t, e, r1, i, s, a, n) {
            var o = getProjectingAngle(e, r1), h = e.v[r1 % e._length], l = e.v[0 === r1 ? e._length - 1 : r1 - 1], p = e.v[(r1 + 1) % e._length], c = 2 === a ? Math.sqrt(Math.pow(h[0] - l[0], 2) + Math.pow(h[1] - l[1], 2)) : 0, f = 2 === a ? Math.sqrt(Math.pow(h[0] - p[0], 2) + Math.pow(h[1] - p[1], 2)) : 0;
            setPoint(t, e.v[r1 % e._length], o, n, i, f / (2 * (s + 1)), c / (2 * (s + 1)), a);
        }
        function zigZagSegment(t, e, r1, i, s, a) {
            for(var n = 0; n < i; n += 1){
                var o = (n + 1) / (i + 1), h = 2 === s ? Math.sqrt(Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2)) : 0, l = e.normalAngle(o);
                setPoint(t, e.point(o), l, a, r1, h / (2 * (i + 1)), h / (2 * (i + 1)), s), a = -a;
            }
            return a;
        }
        function linearOffset(t, e, r1) {
            var _$i = Math.atan2(e[0] - t[0], e[1] - t[1]);
            return [
                polarOffset(t, _$i, r1),
                polarOffset(e, _$i, r1)
            ];
        }
        function offsetSegment(t, e) {
            var r1, _$i, s, a, n, o, h;
            r1 = (h = linearOffset(t.points[0], t.points[1], e))[0], _$i = h[1], s = (h = linearOffset(t.points[1], t.points[2], e))[0], a = h[1], n = (h = linearOffset(t.points[2], t.points[3], e))[0], o = h[1];
            var l = lineIntersection(r1, _$i, s, a);
            null === l && (l = _$i);
            var p = lineIntersection(n, o, s, a);
            return null === p && (p = n), new PolynomialBezier(r1, l, p, o);
        }
        function joinLines(t, e, r1, i, s) {
            var a = e.points[3], n = r1.points[0];
            if (3 === i) return a;
            if (pointEqual(a, n)) return a;
            if (2 === i) {
                var o = -e.tangentAngle(1), h = -r1.tangentAngle(0) + Math.PI, l = lineIntersection(a, polarOffset(a, o + Math.PI / 2, 100), n, polarOffset(n, o + Math.PI / 2, 100)), p = l ? pointDistance(l, a) : pointDistance(a, n) / 2, c = polarOffset(a, o, 2 * p * roundCorner);
                return t.setXYAt(c[0], c[1], "o", t.length() - 1), c = polarOffset(n, h, 2 * p * roundCorner), t.setTripleAt(n[0], n[1], n[0], n[1], c[0], c[1], t.length()), n;
            }
            var f = lineIntersection(pointEqual(a, e.points[2]) ? e.points[0] : e.points[2], a, n, pointEqual(n, r1.points[1]) ? r1.points[3] : r1.points[1]);
            return f && pointDistance(f, a) < s ? (t.setTripleAt(f[0], f[1], f[0], f[1], f[0], f[1], t.length()), f) : a;
        }
        function getIntersection(t, e) {
            var r1 = t.intersections(e);
            return r1.length && floatEqual(r1[0][0], 1) && r1.shift(), r1.length ? r1[0] : null;
        }
        function pruneSegmentIntersection(t, e) {
            var r1 = t.slice(), _$i = e.slice(), s = getIntersection(t[t.length - 1], e[0]);
            return s && (r1[t.length - 1] = t[t.length - 1].split(s[0])[0], _$i[0] = e[0].split(s[1])[1]), t.length > 1 && e.length > 1 && (s = getIntersection(t[0], e[e.length - 1])) ? [
                [
                    t[0].split(s[0])[0]
                ],
                [
                    e[e.length - 1].split(s[1])[1]
                ]
            ] : [
                r1,
                _$i
            ];
        }
        function pruneIntersections(t) {
            for(var e, r1 = 1; r1 < t.length; r1 += 1)e = pruneSegmentIntersection(t[r1 - 1], t[r1]), t[r1 - 1] = e[0], t[r1] = e[1];
            return t.length > 1 && (e = pruneSegmentIntersection(t[t.length - 1], t[0]), t[t.length - 1] = e[0], t[0] = e[1]), t;
        }
        function offsetSegmentSplit(t, e) {
            var r1, _$i, s, a, n = t.inflectionPoints();
            if (0 === n.length) return [
                offsetSegment(t, e)
            ];
            if (1 === n.length || floatEqual(n[1], 1)) return r1 = (s = t.split(n[0]))[0], _$i = s[1], [
                offsetSegment(r1, e),
                offsetSegment(_$i, e)
            ];
            r1 = (s = t.split(n[0]))[0];
            var o = (n[1] - n[0]) / (1 - n[0]);
            return a = (s = s[1].split(o))[0], _$i = s[1], [
                offsetSegment(r1, e),
                offsetSegment(a, e),
                offsetSegment(_$i, e)
            ];
        }
        function OffsetPathModifier() {}
        function getFontProperties(t) {
            for(var e = t.fStyle ? t.fStyle.split(" ") : [], r1 = "normal", _$i = "normal", s = e.length, a = 0; a < s; a += 1)switch(e[a].toLowerCase()){
                case "italic":
                    _$i = "italic";
                    break;
                case "bold":
                    r1 = "700";
                    break;
                case "black":
                    r1 = "900";
                    break;
                case "medium":
                    r1 = "500";
                    break;
                case "regular":
                case "normal":
                    r1 = "400";
                    break;
                case "light":
                case "thin":
                    r1 = "200";
            }
            return {
                style: _$i,
                weight: t.fWeight || r1
            };
        }
        extendPrototype([
            ShapeModifier
        ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t, e.c, 0, null, this), this.o = PropertyFactory.getProp(t, e.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this), this.so = PropertyFactory.getProp(t, e.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, .01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
        }, RepeaterModifier.prototype.applyTransforms = function(t, e, r1, i, s, a) {
            var n = a ? -1 : 1, o = i.s.v[0] + (1 - i.s.v[0]) * (1 - s), h = i.s.v[1] + (1 - i.s.v[1]) * (1 - s);
            t.translate(i.p.v[0] * n * s, i.p.v[1] * n * s, i.p.v[2]), e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), e.rotate(-i.r.v * n * s), e.translate(i.a.v[0], i.a.v[1], i.a.v[2]), r1.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), r1.scale(a ? 1 / o : o, a ? 1 / h : h), r1.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
        }, RepeaterModifier.prototype.init = function(t, e, r1, i) {
            for(this.elem = t, this.arr = e, this.pos = r1, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[r1]); r1 > 0;)r1 -= 1, this._elements.unshift(e[r1]);
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, RepeaterModifier.prototype.resetElements = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it);
        }, RepeaterModifier.prototype.cloneElements = function(t) {
            var e = JSON.parse(JSON.stringify(t));
            return this.resetElements(e), e;
        }, RepeaterModifier.prototype.changeGroupRender = function(t, e) {
            var r1, _$i = t.length;
            for(r1 = 0; r1 < _$i; r1 += 1)t[r1]._render = e, "gr" === t[r1].ty && this.changeGroupRender(t[r1].it, e);
        }, RepeaterModifier.prototype.processShapes = function(t) {
            var e, r1, _$i, s, a, n = !1;
            if (this._mdf || t) {
                var o, h = Math.ceil(this.c.v);
                if (this._groups.length < h) {
                    for(; this._groups.length < h;){
                        var l = {
                            it: this.cloneElements(this._elements),
                            ty: "gr"
                        };
                        l.it.push({
                            a: {
                                a: 0,
                                ix: 1,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            nm: "Transform",
                            o: {
                                a: 0,
                                ix: 7,
                                k: 100
                            },
                            p: {
                                a: 0,
                                ix: 2,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            r: {
                                a: 1,
                                ix: 6,
                                k: [
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 0
                                    },
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 1
                                    }
                                ]
                            },
                            s: {
                                a: 0,
                                ix: 3,
                                k: [
                                    100,
                                    100
                                ]
                            },
                            sa: {
                                a: 0,
                                ix: 5,
                                k: 0
                            },
                            sk: {
                                a: 0,
                                ix: 4,
                                k: 0
                            },
                            ty: "tr"
                        }), this.arr.splice(0, 0, l), this._groups.splice(0, 0, l), this._currentCopies += 1;
                    }
                    this.elem.reloadShapes(), n = !0;
                }
                for(a = 0, _$i = 0; _$i <= this._groups.length - 1; _$i += 1){
                    if (o = a < h, this._groups[_$i]._render = o, this.changeGroupRender(this._groups[_$i].it, o), !o) {
                        var p = this.elemsData[_$i].it, c = p[p.length - 1];
                        0 !== c.transform.op.v ? (c.transform.op._mdf = !0, c.transform.op.v = 0) : c.transform.op._mdf = !1;
                    }
                    a += 1;
                }
                this._currentCopies = h;
                var f = this.o.v, u = f % 1, d = f > 0 ? Math.floor(f) : Math.ceil(f), m = this.pMatrix.props, y = this.rMatrix.props, g = this.sMatrix.props;
                this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                var v, b, _ = 0;
                if (f > 0) {
                    for(; _ < d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), _ += 1;
                    u && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, u, !1), _ += u);
                } else if (f < 0) {
                    for(; _ > d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), _ -= 1;
                    u && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -u, !0), _ -= u);
                }
                for(_$i = 1 === this.data.m ? 0 : this._currentCopies - 1, s = 1 === this.data.m ? 1 : -1, a = this._currentCopies; a;){
                    if (b = (r1 = (e = this.elemsData[_$i].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (_$i / (this._currentCopies - 1)), 0 !== _) {
                        for((0 !== _$i && 1 === s || _$i !== this._currentCopies - 1 && -1 === s) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), this.matrix.transform(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11], m[12], m[13], m[14], m[15]), v = 0; v < b; v += 1)r1[v] = this.matrix.props[v];
                        this.matrix.reset();
                    } else for(this.matrix.reset(), v = 0; v < b; v += 1)r1[v] = this.matrix.props[v];
                    _ += 1, a -= 1, _$i += s;
                }
            } else for(a = this._currentCopies, _$i = 0, s = 1; a;)r1 = (e = this.elemsData[_$i].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, a -= 1, _$i += s;
            return n;
        }, RepeaterModifier.prototype.addShape = function() {}, extendPrototype([
            ShapeModifier
        ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
        }, RoundCornersModifier.prototype.processPath = function(t, e) {
            var r1, _$i = shapePool.newElement();
            _$i.c = t.c;
            var s, a, n, o, h, l, p, c, f, u, d, m, y = t._length, g = 0;
            for(r1 = 0; r1 < y; r1 += 1)s = t.v[r1], n = t.o[r1], a = t.i[r1], s[0] === n[0] && s[1] === n[1] && s[0] === a[0] && s[1] === a[1] ? 0 !== r1 && r1 !== y - 1 || t.c ? (o = 0 === r1 ? t.v[y - 1] : t.v[r1 - 1], l = (h = Math.sqrt(Math.pow(s[0] - o[0], 2) + Math.pow(s[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = d = s[0] + (o[0] - s[0]) * l, c = m = s[1] - (s[1] - o[1]) * l, f = p - (p - s[0]) * roundCorner, u = c - (c - s[1]) * roundCorner, _$i.setTripleAt(p, c, f, u, d, m, g), g += 1, o = r1 === y - 1 ? t.v[0] : t.v[r1 + 1], l = (h = Math.sqrt(Math.pow(s[0] - o[0], 2) + Math.pow(s[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = f = s[0] + (o[0] - s[0]) * l, c = u = s[1] + (o[1] - s[1]) * l, d = p - (p - s[0]) * roundCorner, m = c - (c - s[1]) * roundCorner, _$i.setTripleAt(p, c, f, u, d, m, g), g += 1) : (_$i.setTripleAt(s[0], s[1], n[0], n[1], a[0], a[1], g), g += 1) : (_$i.setTripleAt(t.v[r1][0], t.v[r1][1], t.o[r1][0], t.o[r1][1], t.i[r1][0], t.i[r1][1], g), g += 1);
            return _$i;
        }, RoundCornersModifier.prototype.processShapes = function(t) {
            var e, r1, _$i, s, a, n, o = this.shapes.length, h = this.rd.v;
            if (0 !== h) for(r1 = 0; r1 < o; r1 += 1){
                if (n = (a = this.shapes[r1]).localShapeCollection, a.shape._mdf || this._mdf || t) for(n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, s = a.shape.paths._length, _$i = 0; _$i < s; _$i += 1)n.addShape(this.processPath(e[_$i], h));
                a.shape.paths = a.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, PolynomialBezier.prototype.point = function(t) {
            return [
                ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
                ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
            ];
        }, PolynomialBezier.prototype.derivative = function(t) {
            return [
                (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
                (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
            ];
        }, PolynomialBezier.prototype.tangentAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[1], e[0]);
        }, PolynomialBezier.prototype.normalAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[0], e[1]);
        }, PolynomialBezier.prototype.inflectionPoints = function() {
            var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(t)) return [];
            var e = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t, r1 = e * e - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
            if (r1 < 0) return [];
            var _$i = Math.sqrt(r1);
            return floatZero(_$i) ? _$i > 0 && _$i < 1 ? [
                e
            ] : [] : [
                e - _$i,
                e + _$i
            ].filter(function(t) {
                return t > 0 && t < 1;
            });
        }, PolynomialBezier.prototype.split = function(t) {
            if (t <= 0) return [
                singlePoint(this.points[0]),
                this
            ];
            if (t >= 1) return [
                this,
                singlePoint(this.points[this.points.length - 1])
            ];
            var e = lerpPoint(this.points[0], this.points[1], t), r1 = lerpPoint(this.points[1], this.points[2], t), _$i = lerpPoint(this.points[2], this.points[3], t), s = lerpPoint(e, r1, t), a = lerpPoint(r1, _$i, t), n = lerpPoint(s, a, t);
            return [
                new PolynomialBezier(this.points[0], e, s, n, !0),
                new PolynomialBezier(n, a, _$i, this.points[3], !0)
            ];
        }, PolynomialBezier.prototype.bounds = function() {
            return {
                x: extrema(this, 0),
                y: extrema(this, 1)
            };
        }, PolynomialBezier.prototype.boundingBox = function() {
            var t = this.bounds();
            return {
                left: t.x.min,
                right: t.x.max,
                top: t.y.min,
                bottom: t.y.max,
                width: t.x.max - t.x.min,
                height: t.y.max - t.y.min,
                cx: (t.x.max + t.x.min) / 2,
                cy: (t.y.max + t.y.min) / 2
            };
        }, PolynomialBezier.prototype.intersections = function(t, e, r1) {
            void 0 === e && (e = 2), void 0 === r1 && (r1 = 7);
            var _$i = [];
            return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, _$i, r1), _$i;
        }, PolynomialBezier.shapeSegment = function(t, e) {
            var r1 = (e + 1) % t.length();
            return new PolynomialBezier(t.v[e], t.o[e], t.i[r1], t.v[r1], !0);
        }, PolynomialBezier.shapeSegmentInverted = function(t, e) {
            var r1 = (e + 1) % t.length();
            return new PolynomialBezier(t.v[r1], t.i[r1], t.o[e], t.v[e], !0);
        }, extendPrototype([
            ShapeModifier
        ], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this), this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this), this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length;
        }, ZigZagModifier.prototype.processPath = function(t, e, r1, i) {
            var s = t._length, a = shapePool.newElement();
            if (a.c = t.c, t.c || (s -= 1), 0 === s) return a;
            var n = -1, o = PolynomialBezier.shapeSegment(t, 0);
            zigZagCorner(a, t, 0, e, r1, i, n);
            for(var h = 0; h < s; h += 1)n = zigZagSegment(a, o, e, r1, i, -n), o = h !== s - 1 || t.c ? PolynomialBezier.shapeSegment(t, (h + 1) % s) : null, zigZagCorner(a, t, h + 1, e, r1, i, n);
            return a;
        }, ZigZagModifier.prototype.processShapes = function(t) {
            var e, r1, _$i, s, a, n, o = this.shapes.length, h = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), p = this.pointsType.v;
            if (0 !== h) for(r1 = 0; r1 < o; r1 += 1){
                if (n = (a = this.shapes[r1]).localShapeCollection, a.shape._mdf || this._mdf || t) for(n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, s = a.shape.paths._length, _$i = 0; _$i < s; _$i += 1)n.addShape(this.processPath(e[_$i], h, l, p));
                a.shape.paths = a.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, extendPrototype([
            ShapeModifier
        ], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this), this.lineJoin = e.lj, this._isAnimated = 0 !== this.amount.effectsSequence.length;
        }, OffsetPathModifier.prototype.processPath = function(t, e, r1, i) {
            var s = shapePool.newElement();
            s.c = t.c;
            var a, n, o, h = t.length();
            t.c || (h -= 1);
            var l = [];
            for(a = 0; a < h; a += 1)o = PolynomialBezier.shapeSegment(t, a), l.push(offsetSegmentSplit(o, e));
            if (!t.c) for(a = h - 1; a >= 0; a -= 1)o = PolynomialBezier.shapeSegmentInverted(t, a), l.push(offsetSegmentSplit(o, e));
            l = pruneIntersections(l);
            var p = null, c = null;
            for(a = 0; a < l.length; a += 1){
                var f = l[a];
                for(c && (p = joinLines(s, c, f[0], r1, i)), c = f[f.length - 1], n = 0; n < f.length; n += 1)o = f[n], p && pointEqual(o.points[0], p) ? s.setXYAt(o.points[1][0], o.points[1][1], "o", s.length() - 1) : s.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], s.length()), s.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], s.length()), p = o.points[3];
            }
            return l.length && joinLines(s, c, l[0][0], r1, i), s;
        }, OffsetPathModifier.prototype.processShapes = function(t) {
            var e, r1, _$i, s, a, n, o = this.shapes.length, h = this.amount.v, l = this.miterLimit.v, p = this.lineJoin;
            if (0 !== h) for(r1 = 0; r1 < o; r1 += 1){
                if (n = (a = this.shapes[r1]).localShapeCollection, a.shape._mdf || this._mdf || t) for(n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, s = a.shape.paths._length, _$i = 0; _$i < s; _$i += 1)n.addShape(this.processPath(e[_$i], h, p, l));
                a.shape.paths = a.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var FontManager = function() {
            var t = {
                w: 0,
                size: 0,
                shapes: [],
                data: {
                    shapes: []
                }
            }, e = [];
            e = e.concat([
                2304,
                2305,
                2306,
                2307,
                2362,
                2363,
                2364,
                2364,
                2366,
                2367,
                2368,
                2369,
                2370,
                2371,
                2372,
                2373,
                2374,
                2375,
                2376,
                2377,
                2378,
                2379,
                2380,
                2381,
                2382,
                2383,
                2387,
                2388,
                2389,
                2390,
                2391,
                2402,
                2403
            ]);
            var r1 = 127988, _$i = [
                "d83cdffb",
                "d83cdffc",
                "d83cdffd",
                "d83cdffe",
                "d83cdfff"
            ];
            function s(t, e) {
                var r1 = createTag("span");
                r1.setAttribute("aria-hidden", !0), r1.style.fontFamily = e;
                var _$i = createTag("span");
                _$i.innerText = "giItT1WQy@!-/#", r1.style.position = "absolute", r1.style.left = "-10000px", r1.style.top = "-10000px", r1.style.fontSize = "300px", r1.style.fontVariant = "normal", r1.style.fontStyle = "normal", r1.style.fontWeight = "normal", r1.style.letterSpacing = "0", r1.appendChild(_$i), document.body.appendChild(r1);
                var s = _$i.offsetWidth;
                return _$i.style.fontFamily = function(t) {
                    var _$e, r1 = t.split(","), _$i = r1.length, s = [];
                    for(_$e = 0; _$e < _$i; _$e += 1)"sans-serif" !== r1[_$e] && "monospace" !== r1[_$e] && s.push(r1[_$e]);
                    return s.join(",");
                }(t) + ", " + e, {
                    node: _$i,
                    w: s,
                    parent: r1
                };
            }
            function a(t, e) {
                var r1, _$i = document.body && e ? "svg" : "canvas", s = getFontProperties(t);
                if ("svg" === _$i) {
                    var a = createNS("text");
                    a.style.fontSize = "100px", a.setAttribute("font-family", t.fFamily), a.setAttribute("font-style", s.style), a.setAttribute("font-weight", s.weight), a.textContent = "1", t.fClass ? (a.style.fontFamily = "inherit", a.setAttribute("class", t.fClass)) : a.style.fontFamily = t.fFamily, e.appendChild(a), r1 = a;
                } else {
                    var n = new OffscreenCanvas(500, 500).getContext("2d");
                    n.font = s.style + " " + s.weight + " 100px " + t.fFamily, r1 = n;
                }
                return {
                    measureText: function measureText(t) {
                        return "svg" === _$i ? (r1.textContent = t, r1.getComputedTextLength()) : r1.measureText(t).width;
                    }
                };
            }
            function n(t) {
                var e = 0, r1 = t.charCodeAt(0);
                if (r1 >= 55296 && r1 <= 56319) {
                    var _$i = t.charCodeAt(1);
                    _$i >= 56320 && _$i <= 57343 && (e = 1024 * (r1 - 55296) + _$i - 56320 + 65536);
                }
                return e;
            }
            function o(t) {
                var e = n(t);
                return e >= 127462 && e <= 127487;
            }
            var h = function h() {
                this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
            };
            h.isModifier = function(t, e) {
                var r1 = t.toString(16) + e.toString(16);
                return -1 !== _$i.indexOf(r1);
            }, h.isZeroWidthJoiner = function(t) {
                return 8205 === t;
            }, h.isFlagEmoji = function(t) {
                return o(t.substr(0, 2)) && o(t.substr(2, 2));
            }, h.isRegionalCode = o, h.isCombinedCharacter = function(t) {
                return -1 !== e.indexOf(t);
            }, h.isRegionalFlag = function(t, e) {
                var _$i = n(t.substr(e, 2));
                if (_$i !== r1) return !1;
                var s = 0;
                for(e += 2; s < 5;){
                    if ((_$i = n(t.substr(e, 2))) < 917601 || _$i > 917626) return !1;
                    s += 1, e += 2;
                }
                return 917631 === n(t.substr(e, 2));
            }, h.isVariationSelector = function(t) {
                return 65039 === t;
            }, h.BLACK_FLAG_CODE_POINT = r1;
            var l = {
                addChars: function addChars(t) {
                    if (t) {
                        var e;
                        this.chars || (this.chars = []);
                        var r1, _$i, s = t.length, a = this.chars.length;
                        for(e = 0; e < s; e += 1){
                            for(r1 = 0, _$i = !1; r1 < a;)this.chars[r1].style === t[e].style && this.chars[r1].fFamily === t[e].fFamily && this.chars[r1].ch === t[e].ch && (_$i = !0), r1 += 1;
                            _$i || (this.chars.push(t[e]), a += 1);
                        }
                    }
                },
                addFonts: function addFonts(t, e) {
                    if (t) {
                        if (this.chars) return this.isLoaded = !0, void (this.fonts = t.list);
                        if (!document.body) return this.isLoaded = !0, t.list.forEach(function(t) {
                            t.helper = a(t), t.cache = {};
                        }), void (this.fonts = t.list);
                        var r1, _$i = t.list, n = _$i.length, _$o = n;
                        for(r1 = 0; r1 < n; r1 += 1){
                            var h, l, p = !0;
                            if (_$i[r1].loaded = !1, _$i[r1].monoCase = s(_$i[r1].fFamily, "monospace"), _$i[r1].sansCase = s(_$i[r1].fFamily, "sans-serif"), _$i[r1].fPath) {
                                if ("p" === _$i[r1].fOrigin || 3 === _$i[r1].origin) {
                                    if ((h = document.querySelectorAll('style[f-forigin="p"][f-family="' + _$i[r1].fFamily + '"], style[f-origin="3"][f-family="' + _$i[r1].fFamily + '"]')).length > 0 && (p = !1), p) {
                                        var c = createTag("style");
                                        c.setAttribute("f-forigin", _$i[r1].fOrigin), c.setAttribute("f-origin", _$i[r1].origin), c.setAttribute("f-family", _$i[r1].fFamily), c.type = "text/css", c.innerText = "@font-face {font-family: " + _$i[r1].fFamily + "; font-style: normal; src: url('" + _$i[r1].fPath + "');}", e.appendChild(c);
                                    }
                                } else if ("g" === _$i[r1].fOrigin || 1 === _$i[r1].origin) {
                                    for(h = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l = 0; l < h.length; l += 1)-1 !== h[l].href.indexOf(_$i[r1].fPath) && (p = !1);
                                    if (p) {
                                        var f = createTag("link");
                                        f.setAttribute("f-forigin", _$i[r1].fOrigin), f.setAttribute("f-origin", _$i[r1].origin), f.type = "text/css", f.rel = "stylesheet", f.href = _$i[r1].fPath, document.body.appendChild(f);
                                    }
                                } else if ("t" === _$i[r1].fOrigin || 2 === _$i[r1].origin) {
                                    for(h = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l = 0; l < h.length; l += 1)_$i[r1].fPath === h[l].src && (p = !1);
                                    if (p) {
                                        var u = createTag("link");
                                        u.setAttribute("f-forigin", _$i[r1].fOrigin), u.setAttribute("f-origin", _$i[r1].origin), u.setAttribute("rel", "stylesheet"), u.setAttribute("href", _$i[r1].fPath), e.appendChild(u);
                                    }
                                }
                            } else _$i[r1].loaded = !0, _$o -= 1;
                            _$i[r1].helper = a(_$i[r1], e), _$i[r1].cache = {}, this.fonts.push(_$i[r1]);
                        }
                        0 === _$o ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                    } else this.isLoaded = !0;
                },
                getCharData: function getCharData(e, r1, i) {
                    for(var s = 0, a = this.chars.length; s < a;){
                        if (this.chars[s].ch === e && this.chars[s].style === r1 && this.chars[s].fFamily === i) return this.chars[s];
                        s += 1;
                    }
                    return ("string" == typeof e && 13 !== e.charCodeAt(0) || !e) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", e, r1, i)), t;
                },
                getFontByName: function getFontByName(t) {
                    for(var e = 0, r1 = this.fonts.length; e < r1;){
                        if (this.fonts[e].fName === t) return this.fonts[e];
                        e += 1;
                    }
                    return this.fonts[0];
                },
                measureText: function measureText(t, e, r1) {
                    var _$i = this.getFontByName(e), s = t;
                    if (!_$i.cache[s]) {
                        var a = _$i.helper;
                        if (" " === t) {
                            var n = a.measureText("|" + t + "|"), _$o = a.measureText("||");
                            _$i.cache[s] = (n - _$o) / 100;
                        } else _$i.cache[s] = a.measureText(t) / 100;
                    }
                    return _$i.cache[s] * r1;
                },
                checkLoadedFonts: function checkLoadedFonts() {
                    var t, e, r1, _$i = this.fonts.length, s = _$i;
                    for(t = 0; t < _$i; t += 1)this.fonts[t].loaded ? s -= 1 : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin ? this.fonts[t].loaded = !0 : (e = this.fonts[t].monoCase.node, r1 = this.fonts[t].monoCase.w, e.offsetWidth !== r1 ? (s -= 1, this.fonts[t].loaded = !0) : (e = this.fonts[t].sansCase.node, r1 = this.fonts[t].sansCase.w, e.offsetWidth !== r1 && (s -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
                    0 !== s && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                },
                setIsLoaded: function setIsLoaded() {
                    this.isLoaded = !0;
                }
            };
            return h.prototype = l, h;
        }();
        function SlotManager(t) {
            this.animationData = t;
        }
        function slotFactory(t) {
            return new SlotManager(t);
        }
        function RenderableElement() {}
        SlotManager.prototype.getProp = function(t) {
            return this.animationData.slots && this.animationData.slots[t.sid] ? Object.assign(t, this.animationData.slots[t.sid].p) : t;
        }, RenderableElement.prototype = {
            initRenderable: function initRenderable() {
                this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
            },
            addRenderableComponent: function addRenderableComponent(t) {
                -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
            },
            removeRenderableComponent: function removeRenderableComponent(t) {
                -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
            },
            prepareRenderableFrame: function prepareRenderableFrame(t) {
                this.checkLayerLimits(t);
            },
            checkTransparency: function checkTransparency() {
                this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
            },
            checkLayerLimits: function checkLayerLimits(t) {
                this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
            },
            renderRenderable: function renderRenderable() {
                var t, e = this.renderableComponents.length;
                for(t = 0; t < e; t += 1)this.renderableComponents[t].renderFrame(this._isFirstFrame);
            },
            sourceRectAtTime: function sourceRectAtTime() {
                return {
                    top: 0,
                    left: 0,
                    width: 100,
                    height: 100
                };
            },
            getLayerSize: function getLayerSize() {
                return 5 === this.data.ty ? {
                    w: this.data.textData.width,
                    h: this.data.textData.height
                } : {
                    w: this.data.width,
                    h: this.data.height
                };
            }
        };
        var getBlendMode = (blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        }, function getBlendMode(t) {
            return blendModeEnums[t] || "";
        }), blendModeEnums;
        function SliderEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function AngleEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function ColorEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r1);
        }
        function PointEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r1);
        }
        function LayerIndexEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function MaskIndexEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function CheckboxEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function NoValueEffect() {
            this.p = {};
        }
        function EffectsManager(t, e) {
            var r1, _$i = t.ef || [];
            this.effectElements = [];
            var s, a = _$i.length;
            for(r1 = 0; r1 < a; r1 += 1)s = new GroupEffect(_$i[r1], e), this.effectElements.push(s);
        }
        function GroupEffect(t, e) {
            this.init(t, e);
        }
        function BaseElement() {}
        function FrameElement() {}
        function FootageElement(t, e, r1) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.footageData = e.imageLoader.getAsset(this.assetData), this.initBaseData(t, e, r1);
        }
        function AudioElement(t, e, r1) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, r1), this._isPlaying = !1, this._canPlay = !1;
            var _$i = this.globalData.getAssetsPath(this.assetData);
            this.audio = this.globalData.audioController.createAudio(_$i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            }, this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : {
                k: [
                    100
                ]
            }, 1, .01, this);
        }
        function BaseRenderer() {}
        extendPrototype([
            DynamicPropertyContainer
        ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t, e) {
            var r1;
            this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(e);
            var _$i, s = this.data.ef.length, a = this.data.ef;
            for(r1 = 0; r1 < s; r1 += 1){
                switch(_$i = null, a[r1].ty){
                    case 0:
                        _$i = new SliderEffect(a[r1], e, this);
                        break;
                    case 1:
                        _$i = new AngleEffect(a[r1], e, this);
                        break;
                    case 2:
                        _$i = new ColorEffect(a[r1], e, this);
                        break;
                    case 3:
                        _$i = new PointEffect(a[r1], e, this);
                        break;
                    case 4:
                    case 7:
                        _$i = new CheckboxEffect(a[r1], e, this);
                        break;
                    case 10:
                        _$i = new LayerIndexEffect(a[r1], e, this);
                        break;
                    case 11:
                        _$i = new MaskIndexEffect(a[r1], e, this);
                        break;
                    case 5:
                        _$i = new EffectsManager(a[r1], e, this);
                        break;
                    default:
                        _$i = new NoValueEffect(a[r1], e, this);
                }
                _$i && this.effectElements.push(_$i);
            }
        }, BaseElement.prototype = {
            checkMasks: function checkMasks() {
                if (!this.data.hasMask) return !1;
                for(var t = 0, e = this.data.masksProperties.length; t < e;){
                    if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
                    t += 1;
                }
                return !1;
            },
            initExpressions: function initExpressions() {
                var t = getExpressionInterfaces();
                if (t) {
                    var e = t("layer"), r1 = t("effects"), _$i = t("shape"), s = t("text"), a = t("comp");
                    this.layerInterface = e(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                    var n = r1.createEffectsInterface(this, this.layerInterface);
                    this.layerInterface.registerEffectsInterface(n), 0 === this.data.ty || this.data.xt ? this.compInterface = a(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = _$i(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = s(this), this.layerInterface.text = this.layerInterface.textInterface);
                }
            },
            setBlendMode: function setBlendMode() {
                var t = getBlendMode(this.data.bm);
                (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
            },
            initBaseData: function initBaseData(t, e, r1) {
                this.globalData = e, this.comp = r1, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
            },
            getType: function getType() {
                return this.type;
            },
            sourceRectAtTime: function sourceRectAtTime() {}
        }, FrameElement.prototype = {
            initFrame: function initFrame() {
                this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
            },
            prepareProperties: function prepareProperties(t, e) {
                var r1, _$i = this.dynamicProperties.length;
                for(r1 = 0; r1 < _$i; r1 += 1)(e || this._isParent && "transform" === this.dynamicProperties[r1].propType) && (this.dynamicProperties[r1].getValue(), this.dynamicProperties[r1]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
            },
            addDynamicProperty: function addDynamicProperty(t) {
                -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
            }
        }, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], FootageElement), FootageElement.prototype.getBaseElement = function() {
            return null;
        }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
            var t = getExpressionInterfaces();
            if (t) {
                var e = t("footage");
                this.layerInterface = e(this);
            }
        }, FootageElement.prototype.getFootageData = function() {
            return this.footageData;
        }, AudioElement.prototype.prepareFrame = function(t) {
            if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;
            else {
                var e = this.tm.v;
                this._currentTime = e;
            }
            this._volume = this.lv.v[0];
            var r1 = this._volume * this._volumeMultiplier;
            this._previousVolume !== r1 && (this._previousVolume = r1, this.audio.volume(r1));
        }, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], AudioElement), AudioElement.prototype.renderFrame = function() {
            this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
        }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
            this.audio.pause(), this._isPlaying = !1;
        }, AudioElement.prototype.pause = function() {
            this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
        }, AudioElement.prototype.resume = function() {
            this._canPlay = !0;
        }, AudioElement.prototype.setRate = function(t) {
            this.audio.rate(t);
        }, AudioElement.prototype.volume = function(t) {
            this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
        }, AudioElement.prototype.getBaseElement = function() {
            return null;
        }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, BaseRenderer.prototype.checkLayers = function(t) {
            var e, r1, _$i = this.layers.length;
            for(this.completeLayers = !0, e = _$i - 1; e >= 0; e -= 1)this.elements[e] || (r1 = this.layers[e]).ip - r1.st <= t - this.layers[e].st && r1.op - r1.st > t - this.layers[e].st && this.buildItem(e), this.completeLayers = !!this.elements[e] && this.completeLayers;
            this.checkPendingElements();
        }, BaseRenderer.prototype.createItem = function(t) {
            switch(t.ty){
                case 2:
                    return this.createImage(t);
                case 0:
                    return this.createComp(t);
                case 1:
                    return this.createSolid(t);
                case 3:
                default:
                    return this.createNull(t);
                case 4:
                    return this.createShape(t);
                case 5:
                    return this.createText(t);
                case 6:
                    return this.createAudio(t);
                case 13:
                    return this.createCamera(t);
                case 15:
                    return this.createFootage(t);
            }
        }, BaseRenderer.prototype.createCamera = function() {
            throw new Error("You're using a 3d camera. Try the html renderer.");
        }, BaseRenderer.prototype.createAudio = function(t) {
            return new AudioElement(t, this.globalData, this);
        }, BaseRenderer.prototype.createFootage = function(t) {
            return new FootageElement(t, this.globalData, this);
        }, BaseRenderer.prototype.buildAllItems = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.buildItem(t);
            this.checkPendingElements();
        }, BaseRenderer.prototype.includeLayers = function(t) {
            var e;
            this.completeLayers = !1;
            var r1, _$i = t.length, s = this.layers.length;
            for(e = 0; e < _$i; e += 1)for(r1 = 0; r1 < s;){
                if (this.layers[r1].id === t[e].id) {
                    this.layers[r1] = t[e];
                    break;
                }
                r1 += 1;
            }
        }, BaseRenderer.prototype.setProjectInterface = function(t) {
            this.globalData.projectInterface = t;
        }, BaseRenderer.prototype.initItems = function() {
            this.globalData.progressiveLoad || this.buildAllItems();
        }, BaseRenderer.prototype.buildElementParenting = function(t, e, r1) {
            for(var _$i = this.elements, s = this.layers, a = 0, n = s.length; a < n;)s[a].ind == e && (_$i[a] && !0 !== _$i[a] ? (r1.push(_$i[a]), _$i[a].setAsParent(), void 0 !== s[a].parent ? this.buildElementParenting(t, s[a].parent, r1) : t.setHierarchy(r1)) : (this.buildItem(a), this.addPendingElement(t))), a += 1;
        }, BaseRenderer.prototype.addPendingElement = function(t) {
            this.pendingElements.push(t);
        }, BaseRenderer.prototype.searchExtraCompositions = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)if (t[e].xt) {
                var _$i = this.createComp(t[e]);
                _$i.initExpressions(), this.globalData.projectInterface.registerComposition(_$i);
            }
        }, BaseRenderer.prototype.getElementById = function(t) {
            var e, r1 = this.elements.length;
            for(e = 0; e < r1; e += 1)if (this.elements[e].data.ind === t) return this.elements[e];
            return null;
        }, BaseRenderer.prototype.getElementByPath = function(t) {
            var e, r1 = t.shift();
            if ("number" == typeof r1) e = this.elements[r1];
            else {
                var _$i, s = this.elements.length;
                for(_$i = 0; _$i < s; _$i += 1)if (this.elements[_$i].data.nm === r1) {
                    e = this.elements[_$i];
                    break;
                }
            }
            return 0 === t.length ? e : e.getElementByPath(t);
        }, BaseRenderer.prototype.setupGlobalData = function(t, e) {
            this.globalData.fontManager = new FontManager, this.globalData.slotManager = slotFactory(t), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
                w: t.w,
                h: t.h
            };
        };
        var effectTypes = {
            TRANSFORM_EFFECT: "transformEFfect"
        };
        function TransformElement() {}
        function MaskElement(t, e, r1) {
            this.data = t, this.element = e, this.globalData = r1, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
            var _$i, s, a = this.globalData.defs, n = this.masksProperties ? this.masksProperties.length : 0;
            this.viewData = createSizedArray(n), this.solidPath = "";
            var o, h, l, p, c, f, u = this.masksProperties, d = 0, m = [], y = createElementID(), g = "clipPath", v = "clip-path";
            for(_$i = 0; _$i < n; _$i += 1)if (("a" !== u[_$i].mode && "n" !== u[_$i].mode || u[_$i].inv || 100 !== u[_$i].o.k || u[_$i].o.x) && (g = "mask", v = "mask"), "s" !== u[_$i].mode && "i" !== u[_$i].mode || 0 !== d ? l = null : ((l = createNS("rect")).setAttribute("fill", "#ffffff"), l.setAttribute("width", this.element.comp.data.w || 0), l.setAttribute("height", this.element.comp.data.h || 0), m.push(l)), s = createNS("path"), "n" === u[_$i].mode) this.viewData[_$i] = {
                op: PropertyFactory.getProp(this.element, u[_$i].o, 0, .01, this.element),
                prop: ShapePropertyFactory.getShapeProp(this.element, u[_$i], 3),
                elem: s,
                lastPath: ""
            }, a.appendChild(s);
            else {
                var b;
                if (d += 1, s.setAttribute("fill", "s" === u[_$i].mode ? "#000000" : "#ffffff"), s.setAttribute("clip-rule", "nonzero"), 0 !== u[_$i].x.k ? (g = "mask", v = "mask", f = PropertyFactory.getProp(this.element, u[_$i].x, 0, null, this.element), b = createElementID(), (p = createNS("filter")).setAttribute("id", b), (c = createNS("feMorphology")).setAttribute("operator", "erode"), c.setAttribute("in", "SourceGraphic"), c.setAttribute("radius", "0"), p.appendChild(c), a.appendChild(p), s.setAttribute("stroke", "s" === u[_$i].mode ? "#000000" : "#ffffff")) : (c = null, f = null), this.storedData[_$i] = {
                    elem: s,
                    x: f,
                    expan: c,
                    lastPath: "",
                    lastOperator: "",
                    filterId: b,
                    lastRadius: 0
                }, "i" === u[_$i].mode) {
                    h = m.length;
                    var _ = createNS("g");
                    for(o = 0; o < h; o += 1)_.appendChild(m[o]);
                    var _$P = createNS("mask");
                    _$P.setAttribute("mask-type", "alpha"), _$P.setAttribute("id", y + "_" + d), _$P.appendChild(s), a.appendChild(_$P), _.setAttribute("mask", "url(" + getLocationHref() + "#" + y + "_" + d + ")"), m.length = 0, m.push(_);
                } else m.push(s);
                u[_$i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[_$i] = {
                    elem: s,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, u[_$i].o, 0, .01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, u[_$i], 3),
                    invRect: l
                }, this.viewData[_$i].prop.k || this.drawPath(u[_$i], this.viewData[_$i].prop.v, this.viewData[_$i]);
            }
            for(this.maskElement = createNS(g), n = m.length, _$i = 0; _$i < n; _$i += 1)this.maskElement.appendChild(m[_$i]);
            d > 0 && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute(v, "url(" + getLocationHref() + "#" + y + ")"), a.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
        }
        TransformElement.prototype = {
            initTransform: function initTransform() {
                var t = new Matrix;
                this.finalTransform = {
                    mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                        o: 0
                    },
                    _matMdf: !1,
                    _localMatMdf: !1,
                    _opMdf: !1,
                    mat: t,
                    localMat: t,
                    localOpacity: 1
                }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
            },
            renderTransform: function renderTransform() {
                if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                    var t, e = this.finalTransform.mat, r1 = 0, _$i = this.hierarchy.length;
                    if (!this.finalTransform._matMdf) for(; r1 < _$i;){
                        if (this.hierarchy[r1].finalTransform.mProp._mdf) {
                            this.finalTransform._matMdf = !0;
                            break;
                        }
                        r1 += 1;
                    }
                    if (this.finalTransform._matMdf) for(t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), r1 = 0; r1 < _$i; r1 += 1)e.multiply(this.hierarchy[r1].finalTransform.mProp.v);
                }
                this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
            },
            renderLocalTransform: function renderLocalTransform() {
                if (this.localTransforms) {
                    var t = 0, e = this.localTransforms.length;
                    if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf) for(; t < e;)this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
                    if (this.finalTransform._localMatMdf) {
                        var r1 = this.finalTransform.localMat;
                        for(this.localTransforms[0].matrix.clone(r1), t = 1; t < e; t += 1){
                            var _$i = this.localTransforms[t].matrix;
                            r1.multiply(_$i);
                        }
                        r1.multiply(this.finalTransform.mat);
                    }
                    if (this.finalTransform._opMdf) {
                        var s = this.finalTransform.localOpacity;
                        for(t = 0; t < e; t += 1)s *= .01 * this.localTransforms[t].opacity;
                        this.finalTransform.localOpacity = s;
                    }
                }
            },
            searchEffectTransforms: function searchEffectTransforms() {
                if (this.renderableEffectsManager) {
                    var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                    if (t.length) {
                        this.localTransforms = [], this.finalTransform.localMat = new Matrix;
                        var e = 0, r1 = t.length;
                        for(e = 0; e < r1; e += 1)this.localTransforms.push(t[e]);
                    }
                }
            },
            globalToLocal: function globalToLocal(t) {
                var e = [];
                e.push(this.finalTransform);
                for(var r1, _$i = !0, s = this.comp; _$i;)s.finalTransform ? (s.data.hasMask && e.splice(0, 0, s.finalTransform), s = s.comp) : _$i = !1;
                var a, n = e.length;
                for(r1 = 0; r1 < n; r1 += 1)a = e[r1].mat.applyToPointArray(0, 0, 0), t = [
                    t[0] - a[0],
                    t[1] - a[1],
                    0
                ];
                return t;
            },
            mHelper: new Matrix
        }, MaskElement.prototype.getMaskProperty = function(t) {
            return this.viewData[t].prop;
        }, MaskElement.prototype.renderFrame = function(t) {
            var e, r1 = this.element.finalTransform.mat, _$i = this.masksProperties.length;
            for(e = 0; e < _$i; e += 1)if ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]), (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v), "n" !== this.masksProperties[e].mode && (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", r1.getInverseMatrix().to2dCSS()), this.storedData[e].x && (this.storedData[e].x._mdf || t))) {
                var s = this.storedData[e].expan;
                this.storedData[e].x.v < 0 ? ("erode" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "erode", this.storedData[e].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e].filterId + ")")), s.setAttribute("radius", -this.storedData[e].x.v)) : ("dilate" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "dilate", this.storedData[e].elem.setAttribute("filter", null)), this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
            }
        }, MaskElement.prototype.getMaskelement = function() {
            return this.maskElement;
        }, MaskElement.prototype.createLayerSolidPath = function() {
            var t = "M0,0 ";
            return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
        }, MaskElement.prototype.drawPath = function(t, e, r1) {
            var _$i, s, a = " M" + e.v[0][0] + "," + e.v[0][1];
            for(s = e._length, _$i = 1; _$i < s; _$i += 1)a += " C" + e.o[_$i - 1][0] + "," + e.o[_$i - 1][1] + " " + e.i[_$i][0] + "," + e.i[_$i][1] + " " + e.v[_$i][0] + "," + e.v[_$i][1];
            if (e.c && s > 1 && (a += " C" + e.o[_$i - 1][0] + "," + e.o[_$i - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), r1.lastPath !== a) {
                var n = "";
                r1.elem && (e.c && (n = t.inv ? this.solidPath + a : a), r1.elem.setAttribute("d", n)), r1.lastPath = a;
            }
        }, MaskElement.prototype.destroy = function() {
            this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
        };
        var filtersFactory = function() {
            var t = {
                createFilter: function createFilter(t, e) {
                    var r1 = createNS("filter");
                    return r1.setAttribute("id", t), !0 !== e && (r1.setAttribute("filterUnits", "objectBoundingBox"), r1.setAttribute("x", "0%"), r1.setAttribute("y", "0%"), r1.setAttribute("width", "100%"), r1.setAttribute("height", "100%")), r1;
                },
                createAlphaToLuminanceFilter: function createAlphaToLuminanceFilter() {
                    var t = createNS("feColorMatrix");
                    return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
                }
            };
            return t;
        }(), featureSupport = function() {
            var t = {
                maskType: !0,
                svgLumaHidden: !0,
                offscreenCanvas: "undefined" != typeof OffscreenCanvas
            };
            return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
        }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
        function SVGEffects(t) {
            var e, r1, _$i = "SourceGraphic", s = t.data.ef ? t.data.ef.length : 0, a = createElementID(), n = filtersFactory.createFilter(a, !0), o = 0;
            for(this.filters = [], e = 0; e < s; e += 1){
                r1 = null;
                var h = t.data.ef[e].ty;
                registeredEffects$1[h] && (r1 = new registeredEffects$1[h].effect(n, t.effectsManager.effectElements[e], t, idPrefix + o, _$i), _$i = idPrefix + o, registeredEffects$1[h].countsAsEffect && (o += 1)), r1 && this.filters.push(r1);
            }
            o && (t.globalData.defs.appendChild(n), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + a + ")")), this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect$1(t, e, r1) {
            registeredEffects$1[t] = {
                effect: e,
                countsAsEffect: r1
            };
        }
        function SVGBaseElement() {}
        function HierarchyElement() {}
        function RenderableDOMElement() {}
        function IImageElement(t, e, r1) {
            this.assetData = e.getAssetData(t.refId), this.assetData && this.assetData.sid && (this.assetData = e.slotManager.getProp(this.assetData)), this.initElement(t, e, r1), this.sourceRect = {
                top: 0,
                left: 0,
                width: this.assetData.w,
                height: this.assetData.h
            };
        }
        function ProcessedElement(t, e) {
            this.elem = t, this.pos = e;
        }
        function IShapeElement() {}
        SVGEffects.prototype.renderFrame = function(t) {
            var e, r1 = this.filters.length;
            for(e = 0; e < r1; e += 1)this.filters[e].renderFrame(t);
        }, SVGEffects.prototype.getEffects = function(t) {
            var e, r1 = this.filters.length, _$i = [];
            for(e = 0; e < r1; e += 1)this.filters[e].type === t && _$i.push(this.filters[e]);
            return _$i;
        }, SVGBaseElement.prototype = {
            initRendererElement: function initRendererElement() {
                this.layerElement = createNS("g");
            },
            createContainerElements: function createContainerElements() {
                this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                var t = null;
                if (this.data.td) {
                    this.matteMasks = {};
                    var e = createNS("g");
                    e.setAttribute("id", this.layerId), e.appendChild(this.layerElement), t = e, this.globalData.defs.appendChild(e);
                } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                    var r1 = createNS("clipPath"), _$i = createNS("path");
                    _$i.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var s = createElementID();
                    if (r1.setAttribute("id", s), r1.appendChild(_$i), this.globalData.defs.appendChild(r1), this.checkMasks()) {
                        var a = createNS("g");
                        a.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), a.appendChild(this.layerElement), this.transformedElement = a, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                    } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")");
                }
                0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function renderElement() {
                this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
            },
            destroyBaseElement: function destroyBaseElement() {
                this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
            },
            getBaseElement: function getBaseElement() {
                return this.data.hd ? null : this.baseElement;
            },
            createRenderableComponents: function createRenderableComponents() {
                this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
            },
            getMatte: function getMatte(t) {
                if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
                    var e, r1, _$i, s, a = this.layerId + "_" + t;
                    if (1 === t || 3 === t) {
                        var n = createNS("mask");
                        n.setAttribute("id", a), n.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"), (_$i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), n.appendChild(_$i), this.globalData.defs.appendChild(n), featureSupport.maskType || 1 !== t || (n.setAttribute("mask-type", "luminance"), e = createElementID(), r1 = filtersFactory.createFilter(e), this.globalData.defs.appendChild(r1), r1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (s = createNS("g")).appendChild(_$i), n.appendChild(s), s.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"));
                    } else if (2 === t) {
                        var o = createNS("mask");
                        o.setAttribute("id", a), o.setAttribute("mask-type", "alpha");
                        var h = createNS("g");
                        o.appendChild(h), e = createElementID(), r1 = filtersFactory.createFilter(e);
                        var l = createNS("feComponentTransfer");
                        l.setAttribute("in", "SourceGraphic"), r1.appendChild(l);
                        var p = createNS("feFuncA");
                        p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), l.appendChild(p), this.globalData.defs.appendChild(r1);
                        var c = createNS("rect");
                        c.setAttribute("width", this.comp.data.w), c.setAttribute("height", this.comp.data.h), c.setAttribute("x", "0"), c.setAttribute("y", "0"), c.setAttribute("fill", "#ffffff"), c.setAttribute("opacity", "0"), h.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"), h.appendChild(c), (_$i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h.appendChild(_$i), featureSupport.maskType || (o.setAttribute("mask-type", "luminance"), r1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), s = createNS("g"), h.appendChild(c), s.appendChild(this.layerElement), h.appendChild(s)), this.globalData.defs.appendChild(o);
                    }
                    this.matteMasks[t] = a;
                }
                return this.matteMasks[t];
            },
            setMatte: function setMatte(t) {
                this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
            }
        }, HierarchyElement.prototype = {
            initHierarchy: function initHierarchy() {
                this.hierarchy = [], this._isParent = !1, this.checkParenting();
            },
            setHierarchy: function setHierarchy(t) {
                this.hierarchy = t;
            },
            setAsParent: function setAsParent() {
                this._isParent = !0;
            },
            checkParenting: function checkParenting() {
                void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
            }
        }, extendPrototype([
            RenderableElement,
            createProxyFunction({
                initElement: function initElement(t, e, r1) {
                    this.initFrame(), this.initBaseData(t, e, r1), this.initTransform(t, e, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
                },
                hide: function hide() {
                    this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
                },
                show: function show() {
                    this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
                },
                renderFrame: function renderFrame() {
                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                },
                renderInnerContent: function renderInnerContent() {},
                prepareFrame: function prepareFrame(t) {
                    this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
                },
                destroy: function destroy() {
                    this.innerElem = null, this.destroyBaseElement();
                }
            })
        ], RenderableDOMElement), extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], IImageElement), IImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData);
            this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
        }, IImageElement.prototype.sourceRectAtTime = function() {
            return this.sourceRect;
        }, IShapeElement.prototype = {
            addShapeToModifiers: function addShapeToModifiers(t) {
                var e, r1 = this.shapeModifiers.length;
                for(e = 0; e < r1; e += 1)this.shapeModifiers[e].addShape(t);
            },
            isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(t) {
                for(var e = this.shapeModifiers.length; 0 < e;)if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                return !1;
            },
            renderModifiers: function renderModifiers() {
                if (this.shapeModifiers.length) {
                    var t, e = this.shapes.length;
                    for(t = 0; t < e; t += 1)this.shapes[t].sh.reset();
                    for(t = (e = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
                }
            },
            searchProcessedElement: function searchProcessedElement(t) {
                for(var e = this.processedElements, r1 = 0, _$i = e.length; r1 < _$i;){
                    if (e[r1].elem === t) return e[r1].pos;
                    r1 += 1;
                }
                return 0;
            },
            addProcessedElement: function addProcessedElement(t, e) {
                for(var r1 = this.processedElements, _$i = r1.length; _$i;)if (r1[_$i -= 1].elem === t) return void (r1[_$i].pos = e);
                r1.push(new ProcessedElement(t, e));
            },
            prepareFrame: function prepareFrame(t) {
                this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
            }
        };
        var lineCapEnum = {
            1: "butt",
            2: "round",
            3: "square"
        }, lineJoinEnum = {
            1: "miter",
            2: "round",
            3: "bevel"
        };
        function SVGShapeData(t, e, r1) {
            this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = r1, this.lvl = e, this._isAnimated = !!r1.k;
            for(var _$i = 0, s = t.length; _$i < s;){
                if (t[_$i].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break;
                }
                _$i += 1;
            }
        }
        function SVGStyleData(t, e) {
            this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = !0 === t.hd, this.pElem = createNS("path"), this.msElem = null;
        }
        function DashProperty(t, e, r1, i) {
            var s;
            this.elem = t, this.frameId = -1, this.dataProps = createSizedArray(e.length), this.renderer = r1, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e.length ? e.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i);
            var a, n = e.length || 0;
            for(s = 0; s < n; s += 1)a = PropertyFactory.getProp(t, e[s].v, 0, 0, this), this.k = a.k || this.k, this.dataProps[s] = {
                n: e[s].n,
                p: a
            };
            this.k || this.getValue(!0), this._isAnimated = this.k;
        }
        function SVGStrokeStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r1, this._isAnimated = !!this._isAnimated;
        }
        function SVGFillStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r1;
        }
        function SVGNoStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = r1;
        }
        function GradientProperty(t, e, r1) {
            this.data = e, this.c = createTypedArray("uint8c", 4 * e.p);
            var _$i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
            this.o = createTypedArray("float32", _$i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = _$i, this.initDynamicPropertyContainer(r1), this.prop = PropertyFactory.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
        }
        function SVGGradientFillStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, r1);
        }
        function SVGGradientStrokeStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.initGradientData(t, e, r1), this._isAnimated = !!this._isAnimated;
        }
        function ShapeGroupData() {
            this.it = [], this.prevViewData = [], this.gr = createNS("g");
        }
        function SVGTransformData(t, e, r1) {
            this.transform = {
                mProps: t,
                op: e,
                container: r1
            }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
        }
        SVGShapeData.prototype.setAsAnimated = function() {
            this._isAnimated = !0;
        }, SVGStyleData.prototype.reset = function() {
            this.d = "", this._mdf = !1;
        }, DashProperty.prototype.getValue = function(t) {
            if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
                var e = 0, r1 = this.dataProps.length;
                for("svg" === this.renderer && (this.dashStr = ""), e = 0; e < r1; e += 1)"o" !== this.dataProps[e].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], DashProperty), extendPrototype([
            DynamicPropertyContainer
        ], SVGStrokeStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGFillStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t, e) {
            for(var r1 = 0, _$i = this.o.length / 2; r1 < _$i;){
                if (Math.abs(t[4 * r1] - t[4 * e + 2 * r1]) > .01) return !1;
                r1 += 1;
            }
            return !0;
        }, GradientProperty.prototype.checkCollapsable = function() {
            if (this.o.length / 2 != this.c.length / 4) return !1;
            if (this.data.k.k[0].s) for(var t = 0, e = this.data.k.k.length; t < e;){
                if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                t += 1;
            }
            else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
            return !0;
        }, GradientProperty.prototype.getValue = function(t) {
            if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
                var e, r1, _$i, s = 4 * this.data.p;
                for(e = 0; e < s; e += 1)r1 = e % 4 == 0 ? 100 : 255, _$i = Math.round(this.prop.v[e] * r1), this.c[e] !== _$i && (this.c[e] = _$i, this._cmdf = !t);
                if (this.o.length) for(s = this.prop.v.length, e = 4 * this.data.p; e < s; e += 1)r1 = e % 2 == 0 ? 100 : 1, _$i = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e], this.o[e - 4 * this.data.p] !== _$i && (this.o[e - 4 * this.data.p] = _$i, this._omdf = !t);
                this._mdf = !t;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t, e, r1) {
            this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.s = PropertyFactory.getProp(t, e.s, 1, null, this), this.e = PropertyFactory.getProp(t, e.e, 1, null, this), this.h = PropertyFactory.getProp(t, e.h || {
                k: 0
            }, 0, .01, this), this.a = PropertyFactory.getProp(t, e.a || {
                k: 0
            }, 0, degToRads, this), this.g = new GradientProperty(t, e.g, this), this.style = r1, this.stops = [], this.setGradientData(r1.pElem, e), this.setGradientOpacity(e, r1), this._isAnimated = !!this._isAnimated;
        }, SVGGradientFillStyleData.prototype.setGradientData = function(t, e) {
            var r1 = createElementID(), _$i = createNS(1 === e.t ? "linearGradient" : "radialGradient");
            _$i.setAttribute("id", r1), _$i.setAttribute("spreadMethod", "pad"), _$i.setAttribute("gradientUnits", "userSpaceOnUse");
            var s, a, n, o = [];
            for(n = 4 * e.g.p, a = 0; a < n; a += 4)s = createNS("stop"), _$i.appendChild(s), o.push(s);
            t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r1 + ")"), this.gf = _$i, this.cst = o;
        }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, e) {
            if (this.g._hasOpacity && !this.g._collapsable) {
                var r1, _$i, s, a = createNS("mask"), n = createNS("path");
                a.appendChild(n);
                var o = createElementID(), h = createElementID();
                a.setAttribute("id", h);
                var l = createNS(1 === t.t ? "linearGradient" : "radialGradient");
                l.setAttribute("id", o), l.setAttribute("spreadMethod", "pad"), l.setAttribute("gradientUnits", "userSpaceOnUse"), s = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
                var p = this.stops;
                for(_$i = 4 * t.g.p; _$i < s; _$i += 2)(r1 = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l.appendChild(r1), p.push(r1);
                n.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o + ")"), "gs" === t.ty && (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), 1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)), this.of = l, this.ms = a, this.ost = p, this.maskId = h, e.msElem = n;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], SVGGradientFillStyleData), extendPrototype([
            SVGGradientFillStyleData,
            DynamicPropertyContainer
        ], SVGGradientStrokeStyleData);
        var buildShapeString = function buildShapeString(t, e, r1, i) {
            if (0 === e) return "";
            var s, a = t.o, n = t.i, o = t.v, h = " M" + i.applyToPointStringified(o[0][0], o[0][1]);
            for(s = 1; s < e; s += 1)h += " C" + i.applyToPointStringified(a[s - 1][0], a[s - 1][1]) + " " + i.applyToPointStringified(n[s][0], n[s][1]) + " " + i.applyToPointStringified(o[s][0], o[s][1]);
            return r1 && e && (h += " C" + i.applyToPointStringified(a[s - 1][0], a[s - 1][1]) + " " + i.applyToPointStringified(n[0][0], n[0][1]) + " " + i.applyToPointStringified(o[0][0], o[0][1]), h += "z"), h;
        }, SVGElementsRenderer = function() {
            var t = new Matrix, e = new Matrix;
            function r1(t, e, r1) {
                (r1 || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (r1 || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
            }
            function i() {}
            function s(r1, i, s) {
                var a, n, o, h, l, p, c, f, u, d, m = i.styles.length, y = i.lvl;
                for(p = 0; p < m; p += 1){
                    if (h = i.sh._mdf || s, i.styles[p].lvl < y) {
                        for(f = e.reset(), u = y - i.styles[p].lvl, d = i.transformers.length - 1; !h && u > 0;)h = i.transformers[d].mProps._mdf || h, u -= 1, d -= 1;
                        if (h) for(u = y - i.styles[p].lvl, d = i.transformers.length - 1; u > 0;)f.multiply(i.transformers[d].mProps.v), u -= 1, d -= 1;
                    } else f = t;
                    if (n = (c = i.sh.paths)._length, h) {
                        for(o = "", a = 0; a < n; a += 1)(l = c.shapes[a]) && l._length && (o += buildShapeString(l, l._length, l.c, f));
                        i.caches[p] = o;
                    } else o = i.caches[p];
                    i.styles[p].d += !0 === r1.hd ? "" : o, i.styles[p]._mdf = h || i.styles[p]._mdf;
                }
            }
            function a(t, e, r1) {
                var _$i = e.style;
                (e.c._mdf || r1) && _$i.pElem.setAttribute("fill", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r1) && _$i.pElem.setAttribute("fill-opacity", e.o.v);
            }
            function n(t, e, r1) {
                o(t, e, r1), h(0, e, r1);
            }
            function o(t, e, r1) {
                var _$i, s, a, n, o, h = e.gf, l = e.g._hasOpacity, p = e.s.v, c = e.e.v;
                if (e.o._mdf || r1) {
                    var f = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                    e.style.pElem.setAttribute(f, e.o.v);
                }
                if (e.s._mdf || r1) {
                    var u = 1 === t.t ? "x1" : "cx", d = "x1" === u ? "y1" : "cy";
                    h.setAttribute(u, p[0]), h.setAttribute(d, p[1]), l && !e.g._collapsable && (e.of.setAttribute(u, p[0]), e.of.setAttribute(d, p[1]));
                }
                if (e.g._cmdf || r1) {
                    _$i = e.cst;
                    var m = e.g.c;
                    for(a = _$i.length, s = 0; s < a; s += 1)(n = _$i[s]).setAttribute("offset", m[4 * s] + "%"), n.setAttribute("stop-color", "rgb(" + m[4 * s + 1] + "," + m[4 * s + 2] + "," + m[4 * s + 3] + ")");
                }
                if (l && (e.g._omdf || r1)) {
                    var y = e.g.o;
                    for(a = (_$i = e.g._collapsable ? e.cst : e.ost).length, s = 0; s < a; s += 1)n = _$i[s], e.g._collapsable || n.setAttribute("offset", y[2 * s] + "%"), n.setAttribute("stop-opacity", y[2 * s + 1]);
                }
                if (1 === t.t) (e.e._mdf || r1) && (h.setAttribute("x2", c[0]), h.setAttribute("y2", c[1]), l && !e.g._collapsable && (e.of.setAttribute("x2", c[0]), e.of.setAttribute("y2", c[1])));
                else if ((e.s._mdf || e.e._mdf || r1) && (o = Math.sqrt(Math.pow(p[0] - c[0], 2) + Math.pow(p[1] - c[1], 2)), h.setAttribute("r", o), l && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || r1) {
                    o || (o = Math.sqrt(Math.pow(p[0] - c[0], 2) + Math.pow(p[1] - c[1], 2)));
                    var g = Math.atan2(c[1] - p[1], c[0] - p[0]), v = e.h.v;
                    v >= 1 ? v = .99 : v <= -1 && (v = -0.99);
                    var b = o * v, _ = Math.cos(g + e.a.v) * b + p[0], _$P = Math.sin(g + e.a.v) * b + p[1];
                    h.setAttribute("fx", _), h.setAttribute("fy", _$P), l && !e.g._collapsable && (e.of.setAttribute("fx", _), e.of.setAttribute("fy", _$P));
                }
            }
            function h(t, e, r1) {
                var _$i = e.style, s = e.d;
                s && (s._mdf || r1) && s.dashStr && (_$i.pElem.setAttribute("stroke-dasharray", s.dashStr), _$i.pElem.setAttribute("stroke-dashoffset", s.dashoffset[0])), e.c && (e.c._mdf || r1) && _$i.pElem.setAttribute("stroke", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r1) && _$i.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || r1) && (_$i.pElem.setAttribute("stroke-width", e.w.v), _$i.msElem && _$i.msElem.setAttribute("stroke-width", e.w.v));
            }
            return {
                createRenderFunction: function createRenderFunction(t) {
                    switch(t.ty){
                        case "fl":
                            return a;
                        case "gf":
                            return o;
                        case "gs":
                            return n;
                        case "st":
                            return h;
                        case "sh":
                        case "el":
                        case "rc":
                        case "sr":
                            return s;
                        case "tr":
                            return r1;
                        case "no":
                            return i;
                        default:
                            return null;
                    }
                }
            };
        }();
        function SVGShapeElement(t, e, r1) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, r1), this.prevViewData = [];
        }
        function LetterProps(t, e, r1, i, s, a) {
            this.o = t, this.sw = e, this.sc = r1, this.fc = i, this.m = s, this.p = a, this._mdf = {
                o: !0,
                sw: !!e,
                sc: !!r1,
                fc: !!i,
                m: !0,
                p: !0
            };
        }
        function TextProperty(t, e) {
            this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, e.d && e.d.sid && (e.d = t.globalData.slotManager.getProp(e.d)), this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                ascent: 0,
                boxWidth: this.defaultBoxWidth,
                f: "",
                fStyle: "",
                fWeight: "",
                fc: "",
                j: "",
                justifyOffset: "",
                l: [],
                lh: 0,
                lineWidths: [],
                ls: "",
                of: "",
                s: "",
                sc: "",
                sw: 0,
                t: 0,
                tr: 0,
                sz: 0,
                ps: null,
                fillColorAnim: !1,
                strokeColorAnim: !1,
                strokeWidthAnim: !1,
                yOffset: 0,
                finalSize: 0,
                finalText: [],
                finalLineHeight: 0,
                __complete: !1
            }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
        }, SVGShapeElement.prototype.filterUniqueShapes = function() {
            var t, e, r1, _$i, s = this.shapes.length, a = this.stylesList.length, n = [], o = !1;
            for(r1 = 0; r1 < a; r1 += 1){
                for(_$i = this.stylesList[r1], o = !1, n.length = 0, t = 0; t < s; t += 1)-1 !== (e = this.shapes[t]).styles.indexOf(_$i) && (n.push(e), o = e._isAnimated || o);
                n.length > 1 && o && this.setShapesAsAnimated(n);
            }
        }, SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)t[e].setAsAnimated();
        }, SVGShapeElement.prototype.createStyleElement = function(t, e) {
            var r1, _$i = new SVGStyleData(t, e), s = _$i.pElem;
            return "st" === t.ty ? r1 = new SVGStrokeStyleData(this, t, _$i) : "fl" === t.ty ? r1 = new SVGFillStyleData(this, t, _$i) : "gf" === t.ty || "gs" === t.ty ? (r1 = new ("gf" === t.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, _$i), this.globalData.defs.appendChild(r1.gf), r1.maskId && (this.globalData.defs.appendChild(r1.ms), this.globalData.defs.appendChild(r1.of), s.setAttribute("mask", "url(" + getLocationHref() + "#" + r1.maskId + ")"))) : "no" === t.ty && (r1 = new SVGNoStyleData(this, t, _$i)), "st" !== t.ty && "gs" !== t.ty || (s.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), s.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), s.setAttribute("fill-opacity", "0"), 1 === t.lj && s.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && s.setAttribute("fill-rule", "evenodd"), t.ln && s.setAttribute("id", t.ln), t.cl && s.setAttribute("class", t.cl), t.bm && (s.style["mix-blend-mode"] = getBlendMode(t.bm)), this.stylesList.push(_$i), this.addToAnimatedContents(t, r1), r1;
        }, SVGShapeElement.prototype.createGroupElement = function(t) {
            var e = new ShapeGroupData;
            return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), e;
        }, SVGShapeElement.prototype.createTransformElement = function(t, e) {
            var r1 = TransformPropertyFactory.getTransformProperty(this, t, this), _$i = new SVGTransformData(r1, r1.o, e);
            return this.addToAnimatedContents(t, _$i), _$i;
        }, SVGShapeElement.prototype.createShapeElement = function(t, e, r1) {
            var _$i = 4;
            "rc" === t.ty ? _$i = 5 : "el" === t.ty ? _$i = 6 : "sr" === t.ty && (_$i = 7);
            var s = new SVGShapeData(e, r1, ShapePropertyFactory.getShapeProp(this, t, _$i, this));
            return this.shapes.push(s), this.addShapeToModifiers(s), this.addToAnimatedContents(t, s), s;
        }, SVGShapeElement.prototype.addToAnimatedContents = function(t, e) {
            for(var r1 = 0, _$i = this.animatedContents.length; r1 < _$i;){
                if (this.animatedContents[r1].element === e) return;
                r1 += 1;
            }
            this.animatedContents.push({
                fn: SVGElementsRenderer.createRenderFunction(t),
                element: e,
                data: t
            });
        }, SVGShapeElement.prototype.setElementStyles = function(t) {
            var e, r1 = t.styles, _$i = this.stylesList.length;
            for(e = 0; e < _$i; e += 1)this.stylesList[e].closed || r1.push(this.stylesList[e]);
        }, SVGShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers();
        }, SVGShapeElement.prototype.searchShapes = function(t, e, r1, i, s, a, n) {
            var o, h, l, p, c, f, u = [].concat(a), d = t.length - 1, m = [], y = [];
            for(o = d; o >= 0; o -= 1){
                if ((f = this.searchProcessedElement(t[o])) ? e[o] = r1[f - 1] : t[o]._render = n, "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty) f ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], s), t[o]._render && e[o].style.pElem.parentNode !== i && i.appendChild(e[o].style.pElem), m.push(e[o].style);
                else if ("gr" === t[o].ty) {
                    if (f) for(l = e[o].it.length, h = 0; h < l; h += 1)e[o].prevViewData[h] = e[o].it[h];
                    else e[o] = this.createGroupElement(t[o]);
                    this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, s + 1, u, n), t[o]._render && e[o].gr.parentNode !== i && i.appendChild(e[o].gr);
                } else "tr" === t[o].ty ? (f || (e[o] = this.createTransformElement(t[o], i)), p = e[o].transform, u.push(p)) : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty ? (f || (e[o] = this.createShapeElement(t[o], u, s)), this.setElementStyles(e[o])) : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty || "zz" === t[o].ty || "op" === t[o].ty ? (f ? (c = e[o]).closed = !1 : ((c = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]), e[o] = c, this.shapeModifiers.push(c)), y.push(c)) : "rp" === t[o].ty && (f ? (c = e[o]).closed = !0 : (c = ShapeModifiers.getModifier(t[o].ty), e[o] = c, c.init(this, t, o, e), this.shapeModifiers.push(c), n = !1), y.push(c));
                this.addProcessedElement(t[o], o + 1);
            }
            for(d = m.length, o = 0; o < d; o += 1)m[o].closed = !0;
            for(d = y.length, o = 0; o < d; o += 1)y[o].closed = !0;
        }, SVGShapeElement.prototype.renderInnerContent = function() {
            var t;
            this.renderModifiers();
            var e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].reset();
            for(this.renderShape(), t = 0; t < e; t += 1)(this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
        }, SVGShapeElement.prototype.renderShape = function() {
            var t, e, r1 = this.animatedContents.length;
            for(t = 0; t < r1; t += 1)e = this.animatedContents[t], (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
        }, SVGShapeElement.prototype.destroy = function() {
            this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
        }, LetterProps.prototype.update = function(t, e, r1, i, s, a) {
            this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
            var n = !1;
            return this.o !== t && (this.o = t, this._mdf.o = !0, n = !0), this.sw !== e && (this.sw = e, this._mdf.sw = !0, n = !0), this.sc !== r1 && (this.sc = r1, this._mdf.sc = !0, n = !0), this.fc !== i && (this.fc = i, this._mdf.fc = !0, n = !0), this.m !== s && (this.m = s, this._mdf.m = !0, n = !0), !a.length || this.p[0] === a[0] && this.p[1] === a[1] && this.p[4] === a[4] && this.p[5] === a[5] && this.p[12] === a[12] && this.p[13] === a[13] || (this.p = a, this._mdf.p = !0, n = !0), n;
        }, TextProperty.prototype.defaultBoxWidth = [
            0,
            0
        ], TextProperty.prototype.copyData = function(t, e) {
            for(var r1 in e)Object.prototype.hasOwnProperty.call(e, r1) && (t[r1] = e[r1]);
            return t;
        }, TextProperty.prototype.setCurrentData = function(t) {
            t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
        }, TextProperty.prototype.searchProperty = function() {
            return this.searchKeyframes();
        }, TextProperty.prototype.searchKeyframes = function() {
            return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
        }, TextProperty.prototype.addEffect = function(t) {
            this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.getValue = function(t) {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
                this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                var e = this.currentData, r1 = this.keysIndex;
                if (this.lock) this.setCurrentData(this.currentData);
                else {
                    var _$i;
                    this.lock = !0, this._mdf = !1;
                    var s = this.effectsSequence.length, a = t || this.data.d.k[this.keysIndex].s;
                    for(_$i = 0; _$i < s; _$i += 1)a = r1 !== this.keysIndex ? this.effectsSequence[_$i](a, a.t) : this.effectsSequence[_$i](this.currentData, a.t);
                    e !== a && this.setCurrentData(a), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }, TextProperty.prototype.getKeyframeValue = function() {
            for(var t = this.data.d.k, e = this.elem.comp.renderedFrame, r1 = 0, _$i = t.length; r1 <= _$i - 1 && !(r1 === _$i - 1 || t[r1 + 1].t > e);)r1 += 1;
            return this.keysIndex !== r1 && (this.keysIndex = r1), this.data.d.k[this.keysIndex].s;
        }, TextProperty.prototype.buildFinalText = function(t) {
            for(var e, r1, _$i = [], s = 0, a = t.length, n = !1, o = !1, h = ""; s < a;)n = o, o = !1, e = t.charCodeAt(s), h = t.charAt(s), FontManager.isCombinedCharacter(e) ? n = !0 : e >= 55296 && e <= 56319 ? FontManager.isRegionalFlag(t, s) ? h = t.substr(s, 14) : (r1 = t.charCodeAt(s + 1)) >= 56320 && r1 <= 57343 && (FontManager.isModifier(e, r1) ? (h = t.substr(s, 2), n = !0) : h = FontManager.isFlagEmoji(t.substr(s, 4)) ? t.substr(s, 4) : t.substr(s, 2)) : e > 56319 ? (r1 = t.charCodeAt(s + 1), FontManager.isVariationSelector(e) && (n = !0)) : FontManager.isZeroWidthJoiner(e) && (n = !0, o = !0), n ? (_$i[_$i.length - 1] += h, n = !1) : _$i.push(h), s += h.length;
            return _$i;
        }, TextProperty.prototype.completeTextData = function(t) {
            t.__complete = !0;
            var e, r1, _$i, s, a, n, o, h = this.elem.globalData.fontManager, l = this.data, p = [], c = 0, f = l.m.g, u = 0, d = 0, m = 0, y = [], g = 0, v = 0, b = h.getFontByName(t.f), _ = 0, _$P = getFontProperties(b);
            t.fWeight = _$P.weight, t.fStyle = _$P.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), r1 = t.finalText.length, t.finalLineHeight = t.lh;
            var S, E = t.tr / 1e3 * t.finalSize;
            if (t.sz) for(var x, C, A = !0, w = t.sz[0], k = t.sz[1]; A;){
                x = 0, g = 0, r1 = (C = this.buildFinalText(t.t)).length, E = t.tr / 1e3 * t.finalSize;
                var T = -1;
                for(e = 0; e < r1; e += 1)S = C[e].charCodeAt(0), _$i = !1, " " === C[e] ? T = e : 13 !== S && 3 !== S || (g = 0, _$i = !0, x += t.finalLineHeight || 1.2 * t.finalSize), h.chars ? (o = h.getCharData(C[e], b.fStyle, b.fFamily), _ = _$i ? 0 : o.w * t.finalSize / 100) : _ = h.measureText(C[e], t.f, t.finalSize), g + _ > w && " " !== C[e] ? (-1 === T ? r1 += 1 : e = T, x += t.finalLineHeight || 1.2 * t.finalSize, C.splice(e, T === e ? 1 : 0, "\r"), T = -1, g = 0) : (g += _, g += E);
                x += b.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && k < x ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = C, r1 = t.finalText.length, A = !1);
            }
            g = -E, _ = 0;
            var M, D = 0;
            for(e = 0; e < r1; e += 1)if (_$i = !1, 13 === (S = (M = t.finalText[e]).charCodeAt(0)) || 3 === S ? (D = 0, y.push(g), v = g > v ? g : v, g = -2 * E, s = "", _$i = !0, m += 1) : s = M, h.chars ? (o = h.getCharData(M, b.fStyle, h.getFontByName(t.f).fFamily), _ = _$i ? 0 : o.w * t.finalSize / 100) : _ = h.measureText(s, t.f, t.finalSize), " " === M ? D += _ + E : (g += _ + E + D, D = 0), p.push({
                l: _,
                an: _,
                add: u,
                n: _$i,
                anIndexes: [],
                val: s,
                line: m,
                animatorJustifyOffset: 0
            }), 2 == f) {
                if (u += _, "" === s || " " === s || e === r1 - 1) {
                    for("" !== s && " " !== s || (u -= _); d <= e;)p[d].an = u, p[d].ind = c, p[d].extra = _, d += 1;
                    c += 1, u = 0;
                }
            } else if (3 == f) {
                if (u += _, "" === s || e === r1 - 1) {
                    for("" === s && (u -= _); d <= e;)p[d].an = u, p[d].ind = c, p[d].extra = _, d += 1;
                    u = 0, c += 1;
                }
            } else p[c].ind = c, p[c].extra = 0, c += 1;
            if (t.l = p, v = g > v ? g : v, y.push(g), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;
            else switch(t.boxWidth = v, t.j){
                case 1:
                    t.justifyOffset = -t.boxWidth;
                    break;
                case 2:
                    t.justifyOffset = -t.boxWidth / 2;
                    break;
                default:
                    t.justifyOffset = 0;
            }
            t.lineWidths = y;
            var F, I, R, L, V = l.a;
            n = V.length;
            var B = [];
            for(a = 0; a < n; a += 1){
                for((F = V[a]).a.sc && (t.strokeColorAnim = !0), F.a.sw && (t.strokeWidthAnim = !0), (F.a.fc || F.a.fh || F.a.fs || F.a.fb) && (t.fillColorAnim = !0), L = 0, R = F.s.b, e = 0; e < r1; e += 1)(I = p[e]).anIndexes[a] = L, (1 == R && "" !== I.val || 2 == R && "" !== I.val && " " !== I.val || 3 == R && (I.n || " " == I.val || e == r1 - 1) || 4 == R && (I.n || e == r1 - 1)) && (1 === F.s.rn && B.push(L), L += 1);
                l.a[a].s.totalChars = L;
                var O, $ = -1;
                if (1 === F.s.rn) for(e = 0; e < r1; e += 1)$ != (I = p[e]).anIndexes[a] && ($ = I.anIndexes[a], O = B.splice(Math.floor(Math.random() * B.length), 1)[0]), I.anIndexes[a] = O;
            }
            t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100;
        }, TextProperty.prototype.updateDocumentData = function(t, e) {
            e = void 0 === e ? this.keysIndex : e;
            var r1 = this.copyData({}, this.data.d.k[e].s);
            r1 = this.copyData(r1, t), this.data.d.k[e].s = r1, this.recalculate(e), this.setCurrentData(r1), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.recalculate = function(t) {
            var e = this.data.d.k[t].s;
            e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e);
        }, TextProperty.prototype.canResizeFont = function(t) {
            this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.setMinimumFontSize = function(t) {
            this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        };
        var TextSelectorProp = function() {
            var t = Math.max, e = Math.min, r1 = Math.floor;
            function i(t, e) {
                this._currentTextLength = -1, this.k = !1, this.data = e, this.elem = t, this.comp = t.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t), this.s = PropertyFactory.getProp(t, e.s || {
                    k: 0
                }, 0, 0, this), this.e = "e" in e ? PropertyFactory.getProp(t, e.e, 0, 0, this) : {
                    v: 100
                }, this.o = PropertyFactory.getProp(t, e.o || {
                    k: 0
                }, 0, 0, this), this.xe = PropertyFactory.getProp(t, e.xe || {
                    k: 0
                }, 0, 0, this), this.ne = PropertyFactory.getProp(t, e.ne || {
                    k: 0
                }, 0, 0, this), this.sm = PropertyFactory.getProp(t, e.sm || {
                    k: 100
                }, 0, 0, this), this.a = PropertyFactory.getProp(t, e.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
            }
            return i.prototype = {
                getMult: function getMult(i) {
                    this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                    var s = 0, a = 0, n = 1, o = 1;
                    this.ne.v > 0 ? s = this.ne.v / 100 : a = -this.ne.v / 100, this.xe.v > 0 ? n = 1 - this.xe.v / 100 : o = 1 + this.xe.v / 100;
                    var h = BezierFactory.getBezierEasing(s, a, n, o).get, l = 0, p = this.finalS, c = this.finalE, f = this.data.sh;
                    if (2 === f) l = h(l = c === p ? i >= c ? 1 : 0 : t(0, e(.5 / (c - p) + (i - p) / (c - p), 1)));
                    else if (3 === f) l = h(l = c === p ? i >= c ? 0 : 1 : 1 - t(0, e(.5 / (c - p) + (i - p) / (c - p), 1)));
                    else if (4 === f) c === p ? l = 0 : (l = t(0, e(.5 / (c - p) + (i - p) / (c - p), 1))) < .5 ? l *= 2 : l = 1 - 2 * (l - .5), l = h(l);
                    else if (5 === f) {
                        if (c === p) l = 0;
                        else {
                            var u = c - p, d = -u / 2 + (i = e(t(0, i + .5 - p), c - p)), m = u / 2;
                            l = Math.sqrt(1 - d * d / (m * m));
                        }
                        l = h(l);
                    } else 6 === f ? (c === p ? l = 0 : (i = e(t(0, i + .5 - p), c - p), l = (1 + Math.cos(Math.PI + 2 * Math.PI * i / (c - p))) / 2), l = h(l)) : (i >= r1(p) && (l = t(0, e(i - p < 0 ? e(c, 1) - (p - i) : c - i, 1))), l = h(l));
                    if (100 !== this.sm.v) {
                        var y = .01 * this.sm.v;
                        0 === y && (y = 1e-8);
                        var g = .5 - .5 * y;
                        l < g ? l = 0 : (l = (l - g) / y) > 1 && (l = 1);
                    }
                    return l * this.a.v;
                },
                getValue: function getValue(t) {
                    this.iterateDynamicProperties(), this._mdf = t || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                    var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars, r1 = this.o.v / e, _$i = this.s.v / e + r1, s = this.e.v / e + r1;
                    if (_$i > s) {
                        var a = _$i;
                        _$i = s, s = a;
                    }
                    this.finalS = _$i, this.finalE = s;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], i), {
                getTextSelectorProp: function getTextSelectorProp(t, e, r1) {
                    return new i(t, e, r1);
                }
            };
        }();
        function TextAnimatorDataProperty(t, e, r1) {
            var _$i = {
                propType: !1
            }, s = PropertyFactory.getProp, a = e.a;
            this.a = {
                r: a.r ? s(t, a.r, 0, degToRads, r1) : _$i,
                rx: a.rx ? s(t, a.rx, 0, degToRads, r1) : _$i,
                ry: a.ry ? s(t, a.ry, 0, degToRads, r1) : _$i,
                sk: a.sk ? s(t, a.sk, 0, degToRads, r1) : _$i,
                sa: a.sa ? s(t, a.sa, 0, degToRads, r1) : _$i,
                s: a.s ? s(t, a.s, 1, .01, r1) : _$i,
                a: a.a ? s(t, a.a, 1, 0, r1) : _$i,
                o: a.o ? s(t, a.o, 0, .01, r1) : _$i,
                p: a.p ? s(t, a.p, 1, 0, r1) : _$i,
                sw: a.sw ? s(t, a.sw, 0, 0, r1) : _$i,
                sc: a.sc ? s(t, a.sc, 1, 0, r1) : _$i,
                fc: a.fc ? s(t, a.fc, 1, 0, r1) : _$i,
                fh: a.fh ? s(t, a.fh, 0, 0, r1) : _$i,
                fs: a.fs ? s(t, a.fs, 0, .01, r1) : _$i,
                fb: a.fb ? s(t, a.fb, 0, .01, r1) : _$i,
                t: a.t ? s(t, a.t, 0, 0, r1) : _$i
            }, this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r1), this.s.t = e.s.t;
        }
        function TextAnimatorProperty(t, e, r1) {
            this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = r1, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                alignment: {}
            }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r1);
        }
        function ITextElement() {}
        TextAnimatorProperty.prototype.searchProperties = function() {
            var t, e, r1 = this._textData.a.length, _$i = PropertyFactory.getProp;
            for(t = 0; t < r1; t += 1)e = this._textData.a[t], this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, e, this);
            this._textData.p && "m" in this._textData.p ? (this._pathData = {
                a: _$i(this._elem, this._textData.p.a, 0, 0, this),
                f: _$i(this._elem, this._textData.p.f, 0, 0, this),
                l: _$i(this._elem, this._textData.p.l, 0, 0, this),
                r: _$i(this._elem, this._textData.p.r, 0, 0, this),
                p: _$i(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = _$i(this._elem, this._textData.m.a, 1, 0, this);
        }, TextAnimatorProperty.prototype.getMeasures = function(t, e) {
            if (this.lettersChangedFlag = e, this._mdf || this._isFirstFrame || e || this._hasMaskedPath && this._pathData.m._mdf) {
                this._isFirstFrame = !1;
                var r1, _$i, s, a, n, o, h, l, p, c, f, u, d, m, y, g, v, b, _, _$P = this._moreOptions.alignment.v, S = this._animatorsData, E = this._textData, x = this.mHelper, C = this._renderType, A = this.renderedLetters.length, w = t.l;
                if (this._hasMaskedPath) {
                    if (_ = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                        var k, T = _.v;
                        for(this._pathData.r.v && (T = T.reverse()), n = {
                            tLength: 0,
                            segments: []
                        }, a = T._length - 1, g = 0, s = 0; s < a; s += 1)k = bez.buildBezierData(T.v[s], T.v[s + 1], [
                            T.o[s][0] - T.v[s][0],
                            T.o[s][1] - T.v[s][1]
                        ], [
                            T.i[s + 1][0] - T.v[s + 1][0],
                            T.i[s + 1][1] - T.v[s + 1][1]
                        ]), n.tLength += k.segmentLength, n.segments.push(k), g += k.segmentLength;
                        s = a, _.v.c && (k = bez.buildBezierData(T.v[s], T.v[0], [
                            T.o[s][0] - T.v[s][0],
                            T.o[s][1] - T.v[s][1]
                        ], [
                            T.i[0][0] - T.v[0][0],
                            T.i[0][1] - T.v[0][1]
                        ]), n.tLength += k.segmentLength, n.segments.push(k), g += k.segmentLength), this._pathData.pi = n;
                    }
                    if (n = this._pathData.pi, o = this._pathData.f.v, f = 0, c = 1, l = 0, p = !0, m = n.segments, o < 0 && _.v.c) for(n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength), c = (d = m[f = m.length - 1].points).length - 1; o < 0;)o += d[c].partialLength, (c -= 1) < 0 && (c = (d = m[f -= 1].points).length - 1);
                    u = (d = m[f].points)[c - 1], y = (h = d[c]).partialLength;
                }
                a = w.length, r1 = 0, _$i = 0;
                var M, D, F, I, R, L = 1.2 * t.finalSize * .714, V = !0;
                F = S.length;
                var B, O, $, z, G, N, j, H, q, W, U, Y, J = -1, X = o, K = f, Z = c, Q = -1, tt = "", et = this.defaultPropsArray;
                if (2 === t.j || 1 === t.j) {
                    var rt = 0, it = 0, st = 2 === t.j ? -0.5 : -1, at = 0, nt = !0;
                    for(s = 0; s < a; s += 1)if (w[s].n) {
                        for(rt && (rt += it); at < s;)w[at].animatorJustifyOffset = rt, at += 1;
                        rt = 0, nt = !0;
                    } else {
                        for(D = 0; D < F; D += 1)(M = S[D].a).t.propType && (nt && 2 === t.j && (it += M.t.v * st), (R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? rt += M.t.v * R[0] * st : rt += M.t.v * R * st);
                        nt = !1;
                    }
                    for(rt && (rt += it); at < s;)w[at].animatorJustifyOffset = rt, at += 1;
                }
                for(s = 0; s < a; s += 1){
                    if (x.reset(), z = 1, w[s].n) r1 = 0, _$i += t.yOffset, _$i += V ? 1 : 0, o = X, V = !1, this._hasMaskedPath && (c = Z, u = (d = m[f = K].points)[c - 1], y = (h = d[c]).partialLength, l = 0), tt = "", U = "", q = "", Y = "", et = this.defaultPropsArray;
                    else {
                        if (this._hasMaskedPath) {
                            if (Q !== w[s].line) {
                                switch(t.j){
                                    case 1:
                                        o += g - t.lineWidths[w[s].line];
                                        break;
                                    case 2:
                                        o += (g - t.lineWidths[w[s].line]) / 2;
                                }
                                Q = w[s].line;
                            }
                            J !== w[s].ind && (w[J] && (o += w[J].extra), o += w[s].an / 2, J = w[s].ind), o += _$P[0] * w[s].an * .005;
                            var ot = 0;
                            for(D = 0; D < F; D += 1)(M = S[D].a).p.propType && ((R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? ot += M.p.v[0] * R[0] : ot += M.p.v[0] * R), M.a.propType && ((R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? ot += M.a.v[0] * R[0] : ot += M.a.v[0] * R);
                            for(p = !0, this._pathData.a.v && (o = .5 * w[0].an + (g - this._pathData.f.v - .5 * w[0].an - .5 * w[w.length - 1].an) * J / (a - 1), o += this._pathData.f.v); p;)l + y >= o + ot || !d ? (v = (o + ot - l) / h.partialLength, O = u.point[0] + (h.point[0] - u.point[0]) * v, $ = u.point[1] + (h.point[1] - u.point[1]) * v, x.translate(-_$P[0] * w[s].an * .005, -_$P[1] * L * .01), p = !1) : d && (l += h.partialLength, (c += 1) >= d.length && (c = 0, m[f += 1] ? d = m[f].points : _.v.c ? (c = 0, d = m[f = 0].points) : (l -= h.partialLength, d = null)), d && (u = h, y = (h = d[c]).partialLength));
                            B = w[s].an / 2 - w[s].add, x.translate(-B, 0, 0);
                        } else B = w[s].an / 2 - w[s].add, x.translate(-B, 0, 0), x.translate(-_$P[0] * w[s].an * .005, -_$P[1] * L * .01, 0);
                        for(D = 0; D < F; D += 1)(M = S[D].a).t.propType && (R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars), 0 === r1 && 0 === t.j || (this._hasMaskedPath ? R.length ? o += M.t.v * R[0] : o += M.t.v * R : R.length ? r1 += M.t.v * R[0] : r1 += M.t.v * R));
                        for(t.strokeWidthAnim && (N = t.sw || 0), t.strokeColorAnim && (G = t.sc ? [
                            t.sc[0],
                            t.sc[1],
                            t.sc[2]
                        ] : [
                            0,
                            0,
                            0
                        ]), t.fillColorAnim && t.fc && (j = [
                            t.fc[0],
                            t.fc[1],
                            t.fc[2]
                        ]), D = 0; D < F; D += 1)(M = S[D].a).a.propType && ((R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? x.translate(-M.a.v[0] * R[0], -M.a.v[1] * R[1], M.a.v[2] * R[2]) : x.translate(-M.a.v[0] * R, -M.a.v[1] * R, M.a.v[2] * R));
                        for(D = 0; D < F; D += 1)(M = S[D].a).s.propType && ((R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? x.scale(1 + (M.s.v[0] - 1) * R[0], 1 + (M.s.v[1] - 1) * R[1], 1) : x.scale(1 + (M.s.v[0] - 1) * R, 1 + (M.s.v[1] - 1) * R, 1));
                        for(D = 0; D < F; D += 1){
                            if (M = S[D].a, R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars), M.sk.propType && (R.length ? x.skewFromAxis(-M.sk.v * R[0], M.sa.v * R[1]) : x.skewFromAxis(-M.sk.v * R, M.sa.v * R)), M.r.propType && (R.length ? x.rotateZ(-M.r.v * R[2]) : x.rotateZ(-M.r.v * R)), M.ry.propType && (R.length ? x.rotateY(M.ry.v * R[1]) : x.rotateY(M.ry.v * R)), M.rx.propType && (R.length ? x.rotateX(M.rx.v * R[0]) : x.rotateX(M.rx.v * R)), M.o.propType && (R.length ? z += (M.o.v * R[0] - z) * R[0] : z += (M.o.v * R - z) * R), t.strokeWidthAnim && M.sw.propType && (R.length ? N += M.sw.v * R[0] : N += M.sw.v * R), t.strokeColorAnim && M.sc.propType) for(H = 0; H < 3; H += 1)R.length ? G[H] += (M.sc.v[H] - G[H]) * R[0] : G[H] += (M.sc.v[H] - G[H]) * R;
                            if (t.fillColorAnim && t.fc) {
                                if (M.fc.propType) for(H = 0; H < 3; H += 1)R.length ? j[H] += (M.fc.v[H] - j[H]) * R[0] : j[H] += (M.fc.v[H] - j[H]) * R;
                                M.fh.propType && (j = R.length ? addHueToRGB(j, M.fh.v * R[0]) : addHueToRGB(j, M.fh.v * R)), M.fs.propType && (j = R.length ? addSaturationToRGB(j, M.fs.v * R[0]) : addSaturationToRGB(j, M.fs.v * R)), M.fb.propType && (j = R.length ? addBrightnessToRGB(j, M.fb.v * R[0]) : addBrightnessToRGB(j, M.fb.v * R));
                            }
                        }
                        for(D = 0; D < F; D += 1)(M = S[D].a).p.propType && (R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars), this._hasMaskedPath ? R.length ? x.translate(0, M.p.v[1] * R[0], -M.p.v[2] * R[1]) : x.translate(0, M.p.v[1] * R, -M.p.v[2] * R) : R.length ? x.translate(M.p.v[0] * R[0], M.p.v[1] * R[1], -M.p.v[2] * R[2]) : x.translate(M.p.v[0] * R, M.p.v[1] * R, -M.p.v[2] * R));
                        if (t.strokeWidthAnim && (q = N < 0 ? 0 : N), t.strokeColorAnim && (W = "rgb(" + Math.round(255 * G[0]) + "," + Math.round(255 * G[1]) + "," + Math.round(255 * G[2]) + ")"), t.fillColorAnim && t.fc && (U = "rgb(" + Math.round(255 * j[0]) + "," + Math.round(255 * j[1]) + "," + Math.round(255 * j[2]) + ")"), this._hasMaskedPath) {
                            if (x.translate(0, -t.ls), x.translate(0, _$P[1] * L * .01 + _$i, 0), this._pathData.p.v) {
                                b = (h.point[1] - u.point[1]) / (h.point[0] - u.point[0]);
                                var ht = 180 * Math.atan(b) / Math.PI;
                                h.point[0] < u.point[0] && (ht += 180), x.rotate(-ht * Math.PI / 180);
                            }
                            x.translate(O, $, 0), o -= _$P[0] * w[s].an * .005, w[s + 1] && J !== w[s + 1].ind && (o += w[s].an / 2, o += .001 * t.tr * t.finalSize);
                        } else {
                            switch(x.translate(r1, _$i, 0), t.ps && x.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j){
                                case 1:
                                    x.translate(w[s].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[w[s].line]), 0, 0);
                                    break;
                                case 2:
                                    x.translate(w[s].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[w[s].line]) / 2, 0, 0);
                            }
                            x.translate(0, -t.ls), x.translate(B, 0, 0), x.translate(_$P[0] * w[s].an * .005, _$P[1] * L * .01, 0), r1 += w[s].l + .001 * t.tr * t.finalSize;
                        }
                        "html" === C ? tt = x.toCSS() : "svg" === C ? tt = x.to2dCSS() : et = [
                            x.props[0],
                            x.props[1],
                            x.props[2],
                            x.props[3],
                            x.props[4],
                            x.props[5],
                            x.props[6],
                            x.props[7],
                            x.props[8],
                            x.props[9],
                            x.props[10],
                            x.props[11],
                            x.props[12],
                            x.props[13],
                            x.props[14],
                            x.props[15]
                        ], Y = z;
                    }
                    A <= s ? (I = new LetterProps(Y, q, W, U, tt, et), this.renderedLetters.push(I), A += 1, this.lettersChangedFlag = !0) : (I = this.renderedLetters[s], this.lettersChangedFlag = I.update(Y, q, W, U, tt, et) || this.lettersChangedFlag);
                }
            }
        }, TextAnimatorProperty.prototype.getValue = function() {
            this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
        }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
            DynamicPropertyContainer
        ], TextAnimatorProperty), ITextElement.prototype.initElement = function(t, e, r1) {
            this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, r1), this.textProperty = new TextProperty(this, t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this), this.initTransform(t, e, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
        }, ITextElement.prototype.prepareFrame = function(t) {
            this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
        }, ITextElement.prototype.createPathShape = function(t, e) {
            var r1, _$i, s = e.length, a = "";
            for(r1 = 0; r1 < s; r1 += 1)"sh" === e[r1].ty && (_$i = e[r1].ks.k, a += buildShapeString(_$i, _$i.i.length, !0, t));
            return a;
        }, ITextElement.prototype.updateDocumentData = function(t, e) {
            this.textProperty.updateDocumentData(t, e);
        }, ITextElement.prototype.canResizeFont = function(t) {
            this.textProperty.canResizeFont(t);
        }, ITextElement.prototype.setMinimumFontSize = function(t) {
            this.textProperty.setMinimumFontSize(t);
        }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t, e, r1, i, s) {
            switch(t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j){
                case 1:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r1]), 0, 0);
                    break;
                case 2:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r1]) / 2, 0, 0);
            }
            e.translate(i, s, 0);
        }, ITextElement.prototype.buildColor = function(t) {
            return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
        }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {}, ITextElement.prototype.validateText = function() {
            (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
        };
        var emptyShapeData = {
            shapes: []
        };
        function SVGTextLottieElement(t, e, r1) {
            this.textSpans = [], this.renderType = "svg", this.initElement(t, e, r1);
        }
        function ISolidElement(t, e, r1) {
            this.initElement(t, e, r1);
        }
        function NullElement(t, e, r1) {
            this.initFrame(), this.initBaseData(t, e, r1), this.initFrame(), this.initTransform(t, e, r1), this.initHierarchy();
        }
        function SVGRendererBase() {}
        function ICompElement() {}
        function SVGCompElement(t, e, r1) {
            this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r1), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function SVGRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
            var r1 = "";
            if (e && e.title) {
                var _$i = createNS("title"), s = createElementID();
                _$i.setAttribute("id", s), _$i.textContent = e.title, this.svgElement.appendChild(_$i), r1 += s;
            }
            if (e && e.description) {
                var a = createNS("desc"), n = createElementID();
                a.setAttribute("id", n), a.textContent = e.description, this.svgElement.appendChild(a), r1 += " " + n;
            }
            r1 && this.svgElement.setAttribute("aria-labelledby", r1);
            var o = createNS("defs");
            this.svgElement.appendChild(o);
            var h = createNS("g");
            this.svgElement.appendChild(h), this.layerElement = h, this.renderConfig = {
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                progressiveLoad: e && e.progressiveLoad || !1,
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                viewBoxOnly: e && e.viewBoxOnly || !1,
                viewBoxSize: e && e.viewBoxSize || !1,
                className: e && e.className || "",
                id: e && e.id || "",
                focusable: e && e.focusable,
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "100%",
                    height: e && e.filterSize && e.filterSize.height || "100%",
                    x: e && e.filterSize && e.filterSize.x || "0%",
                    y: e && e.filterSize && e.filterSize.y || "0%"
                },
                width: e && e.width,
                height: e && e.height,
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                defs: o,
                renderConfig: this.renderConfig
            }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
        }
        function ShapeTransformManager() {
            this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
            this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
        }, SVGTextLottieElement.prototype.buildTextContents = function(t) {
            for(var e = 0, r1 = t.length, _$i = [], s = ""; e < r1;)t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (_$i.push(s), s = "") : s += t[e], e += 1;
            return _$i.push(s), _$i;
        }, SVGTextLottieElement.prototype.buildShapeData = function(t, e) {
            if (t.shapes && t.shapes.length) {
                var r1 = t.shapes[0];
                if (r1.it) {
                    var _$i = r1.it[r1.it.length - 1];
                    _$i.s && (_$i.s.k[0] = e, _$i.s.k[1] = e);
                }
            }
            return t;
        }, SVGTextLottieElement.prototype.buildNewText = function() {
            var t, e;
            this.addDynamicProperty(this);
            var r1 = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(r1 ? r1.l.length : 0), r1.fc ? this.layerElement.setAttribute("fill", this.buildColor(r1.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r1.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r1.sc)), this.layerElement.setAttribute("stroke-width", r1.sw)), this.layerElement.setAttribute("font-size", r1.finalSize);
            var _$i = this.globalData.fontManager.getFontByName(r1.f);
            if (_$i.fClass) this.layerElement.setAttribute("class", _$i.fClass);
            else {
                this.layerElement.setAttribute("font-family", _$i.fFamily);
                var s = r1.fWeight, a = r1.fStyle;
                this.layerElement.setAttribute("font-style", a), this.layerElement.setAttribute("font-weight", s);
            }
            this.layerElement.setAttribute("aria-label", r1.t);
            var n, o = r1.l || [], h = !!this.globalData.fontManager.chars;
            e = o.length;
            var l = this.mHelper, p = this.data.singleShape, c = 0, f = 0, u = !0, d = .001 * r1.tr * r1.finalSize;
            if (!p || h || r1.sz) {
                var m, y = this.textSpans.length;
                for(t = 0; t < e; t += 1){
                    if (this.textSpans[t] || (this.textSpans[t] = {
                        span: null,
                        childSpan: null,
                        glyph: null
                    }), !h || !p || 0 === t) {
                        if (n = y > t ? this.textSpans[t].span : createNS(h ? "g" : "text"), y <= t) {
                            if (n.setAttribute("stroke-linecap", "butt"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = n, h) {
                                var g = createNS("g");
                                n.appendChild(g), this.textSpans[t].childSpan = g;
                            }
                            this.textSpans[t].span = n, this.layerElement.appendChild(n);
                        }
                        n.style.display = "inherit";
                    }
                    if (l.reset(), p && (o[t].n && (c = -d, f += r1.yOffset, f += u ? 1 : 0, u = !1), this.applyTextPropertiesToMatrix(r1, l, o[t].line, c, f), c += o[t].l || 0, c += d), h) {
                        var v;
                        if (1 === (m = this.globalData.fontManager.getCharData(r1.finalText[t], _$i.fStyle, this.globalData.fontManager.getFontByName(r1.f).fFamily)).t) v = new SVGCompElement(m.data, this.globalData, this);
                        else {
                            var b = emptyShapeData;
                            m.data && m.data.shapes && (b = this.buildShapeData(m.data, r1.finalSize)), v = new SVGShapeElement(b, this.globalData, this);
                        }
                        if (this.textSpans[t].glyph) {
                            var _ = this.textSpans[t].glyph;
                            this.textSpans[t].childSpan.removeChild(_.layerElement), _.destroy();
                        }
                        this.textSpans[t].glyph = v, v._debug = !0, v.prepareFrame(0), v.renderFrame(), this.textSpans[t].childSpan.appendChild(v.layerElement), 1 === m.t && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + r1.finalSize / 100 + "," + r1.finalSize / 100 + ")");
                    } else p && n.setAttribute("transform", "translate(" + l.props[12] + "," + l.props[13] + ")"), n.textContent = o[t].val, n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                }
                p && n && n.setAttribute("d", "");
            } else {
                var _$P = this.textContainer, S = "start";
                switch(r1.j){
                    case 1:
                        S = "end";
                        break;
                    case 2:
                        S = "middle";
                        break;
                    default:
                        S = "start";
                }
                _$P.setAttribute("text-anchor", S), _$P.setAttribute("letter-spacing", d);
                var E = this.buildTextContents(r1.finalText);
                for(e = E.length, f = r1.ps ? r1.ps[1] + r1.ascent : 0, t = 0; t < e; t += 1)(n = this.textSpans[t].span || createNS("tspan")).textContent = E[t], n.setAttribute("x", 0), n.setAttribute("y", f), n.style.display = "inherit", _$P.appendChild(n), this.textSpans[t] || (this.textSpans[t] = {
                    span: null,
                    glyph: null
                }), this.textSpans[t].span = n, f += r1.finalLineHeight;
                this.layerElement.appendChild(_$P);
            }
            for(; t < this.textSpans.length;)this.textSpans[t].span.style.display = "none", t += 1;
            this._sizeChanged = !0;
        }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
            if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                this._sizeChanged = !1;
                var t = this.layerElement.getBBox();
                this.bbox = {
                    top: t.y,
                    left: t.x,
                    width: t.width,
                    height: t.height
                };
            }
            return this.bbox;
        }, SVGTextLottieElement.prototype.getValue = function() {
            var t, e, r1 = this.textSpans.length;
            for(this.renderedFrame = this.comp.renderedFrame, t = 0; t < r1; t += 1)(e = this.textSpans[t].glyph) && (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0));
        }, SVGTextLottieElement.prototype.renderInnerContent = function() {
            if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                var t, e;
                this._sizeChanged = !0;
                var r1, _$i, s, a = this.textAnimator.renderedLetters, n = this.textProperty.currentData.l;
                for(e = n.length, t = 0; t < e; t += 1)n[t].n || (r1 = a[t], _$i = this.textSpans[t].span, (s = this.textSpans[t].glyph) && s.renderFrame(), r1._mdf.m && _$i.setAttribute("transform", r1.m), r1._mdf.o && _$i.setAttribute("opacity", r1.o), r1._mdf.sw && _$i.setAttribute("stroke-width", r1.sw), r1._mdf.sc && _$i.setAttribute("stroke", r1.sc), r1._mdf.fc && _$i.setAttribute("fill", r1.fc));
            }
        }, extendPrototype([
            IImageElement
        ], ISolidElement), ISolidElement.prototype.createContent = function() {
            var t = createNS("rect");
            t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
        }, NullElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
            return null;
        }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement
        ], NullElement), extendPrototype([
            BaseRenderer
        ], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t) {
            return new NullElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createShape = function(t) {
            return new SVGShapeElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createText = function(t) {
            return new SVGTextLottieElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createImage = function(t) {
            return new IImageElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createSolid = function(t) {
            return new ISolidElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.configAnimation = function(t) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
            var e = this.globalData.defs;
            this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
            var r1 = createNS("clipPath"), _$i = createNS("rect");
            _$i.setAttribute("width", t.w), _$i.setAttribute("height", t.h), _$i.setAttribute("x", 0), _$i.setAttribute("y", 0);
            var s = createElementID();
            r1.setAttribute("id", s), r1.appendChild(_$i), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), e.appendChild(r1), this.layers = t.layers, this.elements = createSizedArray(t.layers.length);
        }, SVGRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, SVGRendererBase.prototype.updateContainerSize = function() {}, SVGRendererBase.prototype.findIndexByInd = function(t) {
            var e = 0, r1 = this.layers.length;
            for(e = 0; e < r1; e += 1)if (this.layers[e].ind === t) return e;
            return -1;
        }, SVGRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                e[t] = !0;
                var r1 = this.createItem(this.layers[t]);
                if (e[t] = r1, getExpressionsPlugin() && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(r1), r1.initExpressions()), this.appendElementInPos(r1, t), this.layers[t].tt) {
                    var _$i = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                    if (-1 === _$i) return;
                    if (this.elements[_$i] && !0 !== this.elements[_$i]) {
                        var s = e[_$i].getMatte(this.layers[t].tt);
                        r1.setMatte(s);
                    } else this.buildItem(_$i), this.addPendingElement(r1);
                }
            }
        }, SVGRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;){
                var t = this.pendingElements.pop();
                if (t.checkParenting(), t.data.tt) for(var e = 0, r1 = this.elements.length; e < r1;){
                    if (this.elements[e] === t) {
                        var _$i = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1, s = this.elements[_$i].getMatte(this.layers[e].tt);
                        t.setMatte(s);
                        break;
                    }
                    e += 1;
                }
            }
        }, SVGRendererBase.prototype.renderFrame = function(t) {
            if (this.renderedFrame !== t && !this.destroyed) {
                var e;
                null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
                var r1 = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), e = r1 - 1; e >= 0; e -= 1)(this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                if (this.globalData._mdf) for(e = 0; e < r1; e += 1)(this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
            }
        }, SVGRendererBase.prototype.appendElementInPos = function(t, e) {
            var r1 = t.getBaseElement();
            if (r1) {
                for(var _$i, s = 0; s < e;)this.elements[s] && !0 !== this.elements[s] && this.elements[s].getBaseElement() && (_$i = this.elements[s].getBaseElement()), s += 1;
                _$i ? this.layerElement.insertBefore(r1, _$i) : this.layerElement.appendChild(r1);
            }
        }, SVGRendererBase.prototype.hide = function() {
            this.layerElement.style.display = "none";
        }, SVGRendererBase.prototype.show = function() {
            this.layerElement.style.display = "block";
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], ICompElement), ICompElement.prototype.initElement = function(t, e, r1) {
            this.initFrame(), this.initBaseData(t, e, r1), this.initTransform(t, e, r1), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e.progressiveLoad || this.buildAllItems(), this.hide();
        }, ICompElement.prototype.prepareFrame = function(t) {
            if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
                if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                else {
                    var e = this.tm.v;
                    e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e;
                }
                var r1, _$i = this.elements.length;
                for(this.completeLayers || this.checkLayers(this.renderedFrame), r1 = _$i - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && (this.elements[r1].prepareFrame(this.renderedFrame - this.layers[r1].st), this.elements[r1]._mdf && (this._mdf = !0));
            }
        }, ICompElement.prototype.renderInnerContent = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, ICompElement.prototype.setElements = function(t) {
            this.elements = t;
        }, ICompElement.prototype.getElements = function() {
            return this.elements;
        }, ICompElement.prototype.destroyElements = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy();
        }, ICompElement.prototype.destroy = function() {
            this.destroyElements(), this.destroyBaseElement();
        }, extendPrototype([
            SVGRendererBase,
            ICompElement,
            SVGBaseElement
        ], SVGCompElement), SVGCompElement.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            SVGRendererBase
        ], SVGRenderer), SVGRenderer.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, ShapeTransformManager.prototype = {
            addTransformSequence: function addTransformSequence(t) {
                var e, r1 = t.length, _$i = "_";
                for(e = 0; e < r1; e += 1)_$i += t[e].transform.key + "_";
                var s = this.sequences[_$i];
                return s || (s = {
                    transforms: [].concat(t),
                    finalTransform: new Matrix,
                    _mdf: !1
                }, this.sequences[_$i] = s, this.sequenceList.push(s)), s;
            },
            processSequence: function processSequence(t, e) {
                for(var r1 = 0, _$i = t.transforms.length, s = e; r1 < _$i && !e;){
                    if (t.transforms[r1].transform.mProps._mdf) {
                        s = !0;
                        break;
                    }
                    r1 += 1;
                }
                if (s) for(t.finalTransform.reset(), r1 = _$i - 1; r1 >= 0; r1 -= 1)t.finalTransform.multiply(t.transforms[r1].transform.mProps.v);
                t._mdf = s;
            },
            processSequences: function processSequences(t) {
                var e, r1 = this.sequenceList.length;
                for(e = 0; e < r1; e += 1)this.processSequence(this.sequenceList[e], t);
            },
            getNewKey: function getNewKey() {
                return this.transform_key_count += 1, "_" + this.transform_key_count;
            }
        };
        var lumaLoader = function lumaLoader() {
            var t = "__lottie_element_luma_buffer", e = null, r1 = null, _$i = null;
            function s() {
                var _$s, a, n;
                e || (_$s = createNS("svg"), a = createNS("filter"), n = createNS("feColorMatrix"), a.setAttribute("id", t), n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), a.appendChild(n), _$s.appendChild(a), _$s.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (_$s.style.display = "none"), _$i = _$s, document.body.appendChild(_$i), e = createTag("canvas"), (r1 = e.getContext("2d")).filter = "url(#" + t + ")", r1.fillStyle = "rgba(0,0,0,0)", r1.fillRect(0, 0, 1, 1));
            }
            return {
                load: s,
                get: function get(i) {
                    return e || s(), e.width = i.width, e.height = i.height, r1.filter = "url(#" + t + ")", e;
                }
            };
        };
        function createCanvas(t, e) {
            if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t, e);
            var r1 = createTag("canvas");
            return r1.width = t, r1.height = e, r1;
        }
        var assetLoader = {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        }, registeredEffects = {};
        function CVEffects(t) {
            var e, r1, _$i = t.data.ef ? t.data.ef.length : 0;
            for(this.filters = [], e = 0; e < _$i; e += 1){
                r1 = null;
                var s = t.data.ef[e].ty;
                registeredEffects[s] && (r1 = new registeredEffects[s].effect(t.effectsManager.effectElements[e], t)), r1 && this.filters.push(r1);
            }
            this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect(t, e) {
            registeredEffects[t] = {
                effect: e
            };
        }
        function CVMaskElement(t, e) {
            var r1;
            this.data = t, this.element = e, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
            var _$i = this.masksProperties.length, s = !1;
            for(r1 = 0; r1 < _$i; r1 += 1)"n" !== this.masksProperties[r1].mode && (s = !0), this.viewData[r1] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r1], 3);
            this.hasMasks = s, s && this.element.addRenderableComponent(this);
        }
        function CVBaseElement() {}
        CVEffects.prototype.renderFrame = function(t) {
            var e, r1 = this.filters.length;
            for(e = 0; e < r1; e += 1)this.filters[e].renderFrame(t);
        }, CVEffects.prototype.getEffects = function(t) {
            var e, r1 = this.filters.length, _$i = [];
            for(e = 0; e < r1; e += 1)this.filters[e].type === t && _$i.push(this.filters[e]);
            return _$i;
        }, CVMaskElement.prototype.renderFrame = function() {
            if (this.hasMasks) {
                var t, e, r1, _$i, s = this.element.finalTransform.mat, a = this.element.canvasContext, n = this.masksProperties.length;
                for(a.beginPath(), t = 0; t < n; t += 1)if ("n" !== this.masksProperties[t].mode) {
                    var o;
                    this.masksProperties[t].inv && (a.moveTo(0, 0), a.lineTo(this.element.globalData.compSize.w, 0), a.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), a.lineTo(0, this.element.globalData.compSize.h), a.lineTo(0, 0)), _$i = this.viewData[t].v, e = s.applyToPointArray(_$i.v[0][0], _$i.v[0][1], 0), a.moveTo(e[0], e[1]);
                    var h = _$i._length;
                    for(o = 1; o < h; o += 1)r1 = s.applyToTriplePoints(_$i.o[o - 1], _$i.i[o], _$i.v[o]), a.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
                    r1 = s.applyToTriplePoints(_$i.o[o - 1], _$i.i[0], _$i.v[0]), a.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
                }
                this.element.globalData.renderer.save(!0), a.clip();
            }
        }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
            this.element = null;
        };
        var operationsMap = {
            1: "source-in",
            2: "source-out",
            3: "source-in",
            4: "source-out"
        };
        function CVShapeData(t, e, r1, i) {
            this.styledShapes = [], this.tr = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var s, a = 4;
            "rc" === e.ty ? a = 5 : "el" === e.ty ? a = 6 : "sr" === e.ty && (a = 7), this.sh = ShapePropertyFactory.getShapeProp(t, e, a, t);
            var n, o = r1.length;
            for(s = 0; s < o; s += 1)r1[s].closed || (n = {
                transforms: i.addTransformSequence(r1[s].transforms),
                trNodes: []
            }, this.styledShapes.push(n), r1[s].elements.push(n));
        }
        function CVShapeElement(t, e, r1) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t, e, r1);
        }
        function CVTextElement(t, e, r1) {
            this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
                fill: "rgba(0,0,0,0)",
                stroke: "rgba(0,0,0,0)",
                sWidth: 0,
                fValue: ""
            }, this.initElement(t, e, r1);
        }
        function CVImageElement(t, e, r1) {
            this.assetData = e.getAssetData(t.refId), this.img = e.imageLoader.getAsset(this.assetData), this.initElement(t, e, r1);
        }
        function CVSolidElement(t, e, r1) {
            this.initElement(t, e, r1);
        }
        function CanvasRendererBase() {}
        function CanvasContext() {
            this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
        }
        function CVContextData() {
            var t;
            for(this.stack = [], this.cArrPos = 0, this.cTr = new Matrix, t = 0; t < 15; t += 1){
                var e = new CanvasContext;
                this.stack[t] = e;
            }
            this._length = 15, this.nativeContext = null, this.transformMat = new Matrix, this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
        }
        function CVCompElement(t, e, r1) {
            this.completeLayers = !1, this.layers = t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t, e, r1), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function CanvasRenderer(t, e) {
            this.animationItem = t, this.renderConfig = {
                clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                context: e && e.context || null,
                progressiveLoad: e && e.progressiveLoad || !1,
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                className: e && e.className || "",
                id: e && e.id || "",
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.renderConfig.dpr = e && e.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e && e.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
        }
        function HBaseElement() {}
        function HSolidElement(t, e, r1) {
            this.initElement(t, e, r1);
        }
        function HShapeElement(t, e, r1) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t, e, r1), this.prevViewData = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            };
        }
        function HTextElement(t, e, r1) {
            this.textSpans = [], this.textPaths = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            }, this.renderType = "svg", this.isMasked = !1, this.initElement(t, e, r1);
        }
        function HCameraElement(t, e, r1) {
            this.initFrame(), this.initBaseData(t, e, r1), this.initHierarchy();
            var _$i = PropertyFactory.getProp;
            if (this.pe = _$i(this, t.pe, 0, 0, this), t.ks.p.s ? (this.px = _$i(this, t.ks.p.x, 1, 0, this), this.py = _$i(this, t.ks.p.y, 1, 0, this), this.pz = _$i(this, t.ks.p.z, 1, 0, this)) : this.p = _$i(this, t.ks.p, 1, 0, this), t.ks.a && (this.a = _$i(this, t.ks.a, 1, 0, this)), t.ks.or.k.length && t.ks.or.k[0].to) {
                var s, a = t.ks.or.k.length;
                for(s = 0; s < a; s += 1)t.ks.or.k[s].to = null, t.ks.or.k[s].ti = null;
            }
            this.or = _$i(this, t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = _$i(this, t.ks.rx, 0, degToRads, this), this.ry = _$i(this, t.ks.ry, 0, degToRads, this), this.rz = _$i(this, t.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
                mProp: this
            };
        }
        function HImageElement(t, e, r1) {
            this.assetData = e.getAssetData(t.refId), this.initElement(t, e, r1);
        }
        function HybridRendererBase(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                }
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        function HCompElement(t, e, r1) {
            this.layers = t.layers, this.supports3d = !t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r1), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function HybridRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                },
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        CVBaseElement.prototype = {
            createElements: function createElements() {},
            initRendererElement: function initRendererElement() {},
            createContainerElements: function createContainerElements() {
                if (this.data.tt >= 1) {
                    this.buffers = [];
                    var t = this.globalData.canvasContext, e = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(e);
                    var r1 = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(r1), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
                }
                this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
            },
            createContent: function createContent() {},
            setBlendMode: function setBlendMode() {
                var t = this.globalData;
                if (t.blendMode !== this.data.bm) {
                    t.blendMode = this.data.bm;
                    var e = getBlendMode(this.data.bm);
                    t.canvasContext.globalCompositeOperation = e;
                }
            },
            createRenderableComponents: function createRenderableComponents() {
                this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
            },
            hideElement: function hideElement() {
                this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
            },
            showElement: function showElement() {
                this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
            },
            clearCanvas: function clearCanvas(t) {
                t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
            },
            prepareLayer: function prepareLayer() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[0].getContext("2d");
                    this.clearCanvas(t), t.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
                }
            },
            exitLayer: function exitLayer() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[1], e = t.getContext("2d");
                    if (this.clearCanvas(e), e.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
                        var r1 = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                        r1.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(r1, 0, 0);
                    }
                    this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
                }
            },
            renderFrame: function renderFrame(t) {
                if (!this.hidden && !this.data.hd && (1 !== this.data.td || t)) {
                    this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
                    var e = 0 === this.data.ty;
                    this.prepareLayer(), this.globalData.renderer.save(e), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(e), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
                }
            },
            destroy: function destroy() {
                this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
            },
            mHelper: new Matrix
        }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1
        }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
        }, CVShapeElement.prototype.createStyleElement = function(t, e) {
            var r1 = {
                data: t,
                type: t.ty,
                preTransforms: this.transformsManager.addTransformSequence(e),
                transforms: [],
                elements: [],
                closed: !0 === t.hd
            }, _$i = {};
            if ("fl" === t.ty || "st" === t.ty ? (_$i.c = PropertyFactory.getProp(this, t.c, 1, 255, this), _$i.c.k || (r1.co = "rgb(" + bmFloor(_$i.c.v[0]) + "," + bmFloor(_$i.c.v[1]) + "," + bmFloor(_$i.c.v[2]) + ")")) : "gf" !== t.ty && "gs" !== t.ty || (_$i.s = PropertyFactory.getProp(this, t.s, 1, null, this), _$i.e = PropertyFactory.getProp(this, t.e, 1, null, this), _$i.h = PropertyFactory.getProp(this, t.h || {
                k: 0
            }, 0, .01, this), _$i.a = PropertyFactory.getProp(this, t.a || {
                k: 0
            }, 0, degToRads, this), _$i.g = new GradientProperty(this, t.g, this)), _$i.o = PropertyFactory.getProp(this, t.o, 0, .01, this), "st" === t.ty || "gs" === t.ty) {
                if (r1.lc = lineCapEnum[t.lc || 2], r1.lj = lineJoinEnum[t.lj || 2], 1 == t.lj && (r1.ml = t.ml), _$i.w = PropertyFactory.getProp(this, t.w, 0, null, this), _$i.w.k || (r1.wi = _$i.w.v), t.d) {
                    var s = new DashProperty(this, t.d, "canvas", this);
                    _$i.d = s, _$i.d.k || (r1.da = _$i.d.dashArray, r1.do = _$i.d.dashoffset[0]);
                }
            } else r1.r = 2 === t.r ? "evenodd" : "nonzero";
            return this.stylesList.push(r1), _$i.style = r1, _$i;
        }, CVShapeElement.prototype.createGroupElement = function() {
            return {
                it: [],
                prevViewData: []
            };
        }, CVShapeElement.prototype.createTransformElement = function(t) {
            return {
                transform: {
                    opacity: 1,
                    _opMdf: !1,
                    key: this.transformsManager.getNewKey(),
                    op: PropertyFactory.getProp(this, t.o, 0, .01, this),
                    mProps: TransformPropertyFactory.getTransformProperty(this, t, this)
                }
            };
        }, CVShapeElement.prototype.createShapeElement = function(t) {
            var e = new CVShapeData(this, t, this.stylesList, this.transformsManager);
            return this.shapes.push(e), this.addShapeToModifiers(e), e;
        }, CVShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
        }, CVShapeElement.prototype.addTransformToStyleList = function(t) {
            var e, r1 = this.stylesList.length;
            for(e = 0; e < r1; e += 1)this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
        }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
            var t, e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].closed || this.stylesList[t].transforms.pop();
        }, CVShapeElement.prototype.closeStyles = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)t[e].closed = !0;
        }, CVShapeElement.prototype.searchShapes = function(t, e, r1, i, s) {
            var a, n, o, h, l, p, c = t.length - 1, f = [], u = [], d = [].concat(s);
            for(a = c; a >= 0; a -= 1){
                if ((h = this.searchProcessedElement(t[a])) ? e[a] = r1[h - 1] : t[a]._shouldRender = i, "fl" === t[a].ty || "st" === t[a].ty || "gf" === t[a].ty || "gs" === t[a].ty) h ? e[a].style.closed = !1 : e[a] = this.createStyleElement(t[a], d), f.push(e[a].style);
                else if ("gr" === t[a].ty) {
                    if (h) for(o = e[a].it.length, n = 0; n < o; n += 1)e[a].prevViewData[n] = e[a].it[n];
                    else e[a] = this.createGroupElement(t[a]);
                    this.searchShapes(t[a].it, e[a].it, e[a].prevViewData, i, d);
                } else "tr" === t[a].ty ? (h || (p = this.createTransformElement(t[a]), e[a] = p), d.push(e[a]), this.addTransformToStyleList(e[a])) : "sh" === t[a].ty || "rc" === t[a].ty || "el" === t[a].ty || "sr" === t[a].ty ? h || (e[a] = this.createShapeElement(t[a])) : "tm" === t[a].ty || "rd" === t[a].ty || "pb" === t[a].ty || "zz" === t[a].ty || "op" === t[a].ty ? (h ? (l = e[a]).closed = !1 : ((l = ShapeModifiers.getModifier(t[a].ty)).init(this, t[a]), e[a] = l, this.shapeModifiers.push(l)), u.push(l)) : "rp" === t[a].ty && (h ? (l = e[a]).closed = !0 : (l = ShapeModifiers.getModifier(t[a].ty), e[a] = l, l.init(this, t, a, e), this.shapeModifiers.push(l), i = !1), u.push(l));
                this.addProcessedElement(t[a], a + 1);
            }
            for(this.removeTransformFromStyleList(), this.closeStyles(f), c = u.length, a = 0; a < c; a += 1)u[a].closed = !0;
        }, CVShapeElement.prototype.renderInnerContent = function() {
            this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
        }, CVShapeElement.prototype.renderShapeTransform = function(t, e) {
            (t._opMdf || e.op._mdf || this._isFirstFrame) && (e.opacity = t.opacity, e.opacity *= e.op.v, e._opMdf = !0);
        }, CVShapeElement.prototype.drawLayer = function() {
            var t, e, r1, _$i, s, a, n, o, h, l = this.stylesList.length, p = this.globalData.renderer, c = this.globalData.canvasContext;
            for(t = 0; t < l; t += 1)if (("st" !== (o = (h = this.stylesList[t]).type) && "gs" !== o || 0 !== h.wi) && h.data._shouldRender && 0 !== h.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                for(p.save(), a = h.elements, "st" === o || "gs" === o ? (p.ctxStrokeStyle("st" === o ? h.co : h.grd), p.ctxLineWidth(h.wi), p.ctxLineCap(h.lc), p.ctxLineJoin(h.lj), p.ctxMiterLimit(h.ml || 0)) : p.ctxFillStyle("fl" === o ? h.co : h.grd), p.ctxOpacity(h.coOp), "st" !== o && "gs" !== o && c.beginPath(), p.ctxTransform(h.preTransforms.finalTransform.props), r1 = a.length, e = 0; e < r1; e += 1){
                    for("st" !== o && "gs" !== o || (c.beginPath(), h.da && (c.setLineDash(h.da), c.lineDashOffset = h.do)), s = (n = a[e].trNodes).length, _$i = 0; _$i < s; _$i += 1)"m" === n[_$i].t ? c.moveTo(n[_$i].p[0], n[_$i].p[1]) : "c" === n[_$i].t ? c.bezierCurveTo(n[_$i].pts[0], n[_$i].pts[1], n[_$i].pts[2], n[_$i].pts[3], n[_$i].pts[4], n[_$i].pts[5]) : c.closePath();
                    "st" !== o && "gs" !== o || (p.ctxStroke(), h.da && c.setLineDash(this.dashResetter));
                }
                "st" !== o && "gs" !== o && this.globalData.renderer.ctxFill(h.r), p.restore();
            }
        }, CVShapeElement.prototype.renderShape = function(t, e, r1, i) {
            var s, a;
            for(a = t, s = e.length - 1; s >= 0; s -= 1)"tr" === e[s].ty ? (a = r1[s].transform, this.renderShapeTransform(t, a)) : "sh" === e[s].ty || "el" === e[s].ty || "rc" === e[s].ty || "sr" === e[s].ty ? this.renderPath(e[s], r1[s]) : "fl" === e[s].ty ? this.renderFill(e[s], r1[s], a) : "st" === e[s].ty ? this.renderStroke(e[s], r1[s], a) : "gf" === e[s].ty || "gs" === e[s].ty ? this.renderGradientFill(e[s], r1[s], a) : "gr" === e[s].ty ? this.renderShape(a, e[s].it, r1[s].it) : e[s].ty;
            i && this.drawLayer();
        }, CVShapeElement.prototype.renderStyledShape = function(t, e) {
            if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                var r1, _$i, s, a = t.trNodes, n = e.paths, o = n._length;
                a.length = 0;
                var h = t.transforms.finalTransform;
                for(s = 0; s < o; s += 1){
                    var l = n.shapes[s];
                    if (l && l.v) {
                        for(_$i = l._length, r1 = 1; r1 < _$i; r1 += 1)1 === r1 && a.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), a.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r1 - 1], l.i[r1], l.v[r1])
                        });
                        1 === _$i && a.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), l.c && _$i && (a.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r1 - 1], l.i[0], l.v[0])
                        }), a.push({
                            t: "z"
                        }));
                    }
                }
                t.trNodes = a;
            }
        }, CVShapeElement.prototype.renderPath = function(t, e) {
            if (!0 !== t.hd && t._shouldRender) {
                var r1, _$i = e.styledShapes.length;
                for(r1 = 0; r1 < _$i; r1 += 1)this.renderStyledShape(e.styledShapes[r1], e.sh);
            }
        }, CVShapeElement.prototype.renderFill = function(t, e, r1) {
            var _$i = e.style;
            (e.c._mdf || this._isFirstFrame) && (_$i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r1._opMdf || this._isFirstFrame) && (_$i.coOp = e.o.v * r1.opacity);
        }, CVShapeElement.prototype.renderGradientFill = function(t, e, r1) {
            var _$i, s = e.style;
            if (!s.grd || e.g._mdf || e.s._mdf || e.e._mdf || 1 !== t.t && (e.h._mdf || e.a._mdf)) {
                var a, n = this.globalData.canvasContext, o = e.s.v, h = e.e.v;
                if (1 === t.t) _$i = n.createLinearGradient(o[0], o[1], h[0], h[1]);
                else {
                    var l = Math.sqrt(Math.pow(o[0] - h[0], 2) + Math.pow(o[1] - h[1], 2)), p = Math.atan2(h[1] - o[1], h[0] - o[0]), c = e.h.v;
                    c >= 1 ? c = .99 : c <= -1 && (c = -0.99);
                    var f = l * c, u = Math.cos(p + e.a.v) * f + o[0], d = Math.sin(p + e.a.v) * f + o[1];
                    _$i = n.createRadialGradient(u, d, 0, o[0], o[1], l);
                }
                var m = t.g.p, y = e.g.c, g = 1;
                for(a = 0; a < m; a += 1)e.g._hasOpacity && e.g._collapsable && (g = e.g.o[2 * a + 1]), _$i.addColorStop(y[4 * a] / 100, "rgba(" + y[4 * a + 1] + "," + y[4 * a + 2] + "," + y[4 * a + 3] + "," + g + ")");
                s.grd = _$i;
            }
            s.coOp = e.o.v * r1.opacity;
        }, CVShapeElement.prototype.renderStroke = function(t, e, r1) {
            var _$i = e.style, s = e.d;
            s && (s._mdf || this._isFirstFrame) && (_$i.da = s.dashArray, _$i.do = s.dashoffset[0]), (e.c._mdf || this._isFirstFrame) && (_$i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r1._opMdf || this._isFirstFrame) && (_$i.coOp = e.o.v * r1.opacity), (e.w._mdf || this._isFirstFrame) && (_$i.wi = e.w.v);
        }, CVShapeElement.prototype.destroy = function() {
            this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement,
            ITextElement
        ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = !1;
            t.fc ? (e = !0, this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e;
            var r1 = !1;
            t.sc && (r1 = !0, this.values.stroke = this.buildColor(t.sc), this.values.sWidth = t.sw);
            var _$i, s, a, n, o, h, l, p, c, f, u, d, m = this.globalData.fontManager.getFontByName(t.f), y = t.l, g = this.mHelper;
            this.stroke = r1, this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, s = t.finalText.length;
            var v = this.data.singleShape, b = .001 * t.tr * t.finalSize, _ = 0, _$P = 0, S = !0, E = 0;
            for(_$i = 0; _$i < s; _$i += 1){
                n = (a = this.globalData.fontManager.getCharData(t.finalText[_$i], m.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily)) && a.data || {}, g.reset(), v && y[_$i].n && (_ = -b, _$P += t.yOffset, _$P += S ? 1 : 0, S = !1), c = (l = n.shapes ? n.shapes[0].it : []).length, g.scale(t.finalSize / 100, t.finalSize / 100), v && this.applyTextPropertiesToMatrix(t, g, y[_$i].line, _, _$P), u = createSizedArray(c - 1);
                var x = 0;
                for(p = 0; p < c; p += 1)if ("sh" === l[p].ty) {
                    for(h = l[p].ks.k.i.length, f = l[p].ks.k, d = [], o = 1; o < h; o += 1)1 === o && d.push(g.applyToX(f.v[0][0], f.v[0][1], 0), g.applyToY(f.v[0][0], f.v[0][1], 0)), d.push(g.applyToX(f.o[o - 1][0], f.o[o - 1][1], 0), g.applyToY(f.o[o - 1][0], f.o[o - 1][1], 0), g.applyToX(f.i[o][0], f.i[o][1], 0), g.applyToY(f.i[o][0], f.i[o][1], 0), g.applyToX(f.v[o][0], f.v[o][1], 0), g.applyToY(f.v[o][0], f.v[o][1], 0));
                    d.push(g.applyToX(f.o[o - 1][0], f.o[o - 1][1], 0), g.applyToY(f.o[o - 1][0], f.o[o - 1][1], 0), g.applyToX(f.i[0][0], f.i[0][1], 0), g.applyToY(f.i[0][0], f.i[0][1], 0), g.applyToX(f.v[0][0], f.v[0][1], 0), g.applyToY(f.v[0][0], f.v[0][1], 0)), u[x] = d, x += 1;
                }
                v && (_ += y[_$i].l, _ += b), this.textSpans[E] ? this.textSpans[E].elem = u : this.textSpans[E] = {
                    elem: u
                }, E += 1;
            }
        }, CVTextElement.prototype.renderInnerContent = function() {
            var t, e, r1, _$i, s, a;
            this.validateText(), this.canvasContext.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            var n, o = this.textAnimator.renderedLetters, h = this.textProperty.currentData.l;
            e = h.length;
            var l, p, c = null, f = null, u = null, d = this.globalData.renderer;
            for(t = 0; t < e; t += 1)if (!h[t].n) {
                if ((n = o[t]) && (d.save(), d.ctxTransform(n.p), d.ctxOpacity(n.o)), this.fill) {
                    for(n && n.fc ? c !== n.fc && (d.ctxFillStyle(n.fc), c = n.fc) : c !== this.values.fill && (c = this.values.fill, d.ctxFillStyle(this.values.fill)), _$i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < _$i; r1 += 1)for(a = (p = l[r1]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), s = 2; s < a; s += 6)this.globalData.canvasContext.bezierCurveTo(p[s], p[s + 1], p[s + 2], p[s + 3], p[s + 4], p[s + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxFill();
                }
                if (this.stroke) {
                    for(n && n.sw ? u !== n.sw && (u = n.sw, d.ctxLineWidth(n.sw)) : u !== this.values.sWidth && (u = this.values.sWidth, d.ctxLineWidth(this.values.sWidth)), n && n.sc ? f !== n.sc && (f = n.sc, d.ctxStrokeStyle(n.sc)) : f !== this.values.stroke && (f = this.values.stroke, d.ctxStrokeStyle(this.values.stroke)), _$i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < _$i; r1 += 1)for(a = (p = l[r1]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), s = 2; s < a; s += 6)this.globalData.canvasContext.bezierCurveTo(p[s], p[s + 1], p[s + 2], p[s + 3], p[s + 4], p[s + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxStroke();
                }
                n && this.globalData.renderer.restore();
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
            if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                var t = createTag("canvas");
                t.width = this.assetData.w, t.height = this.assetData.h;
                var e, r1, _$i = t.getContext("2d"), s = this.img.width, a = this.img.height, n = s / a, o = this.assetData.w / this.assetData.h, h = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                n > o && "xMidYMid slice" === h || n < o && "xMidYMid slice" !== h ? e = (r1 = a) * o : r1 = (e = s) / o, _$i.drawImage(this.img, (s - e) / 2, (a - r1) / 2, e, r1, 0, 0, this.assetData.w, this.assetData.h), this.img = t;
            }
        }, CVImageElement.prototype.renderInnerContent = function() {
            this.canvasContext.drawImage(this.img, 0, 0);
        }, CVImageElement.prototype.destroy = function() {
            this.img = null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
            this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
        }, extendPrototype([
            BaseRenderer
        ], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t) {
            return new CVShapeElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createText = function(t) {
            return new CVTextElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createImage = function(t) {
            return new CVImageElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createSolid = function(t) {
            return new CVSolidElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t) {
            1 === t[0] && 0 === t[1] && 0 === t[4] && 1 === t[5] && 0 === t[12] && 0 === t[13] || this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
        }, CanvasRendererBase.prototype.ctxOpacity = function(t) {
            this.canvasContext.globalAlpha *= t < 0 ? 0 : t;
        }, CanvasRendererBase.prototype.ctxFillStyle = function(t) {
            this.canvasContext.fillStyle = t;
        }, CanvasRendererBase.prototype.ctxStrokeStyle = function(t) {
            this.canvasContext.strokeStyle = t;
        }, CanvasRendererBase.prototype.ctxLineWidth = function(t) {
            this.canvasContext.lineWidth = t;
        }, CanvasRendererBase.prototype.ctxLineCap = function(t) {
            this.canvasContext.lineCap = t;
        }, CanvasRendererBase.prototype.ctxLineJoin = function(t) {
            this.canvasContext.lineJoin = t;
        }, CanvasRendererBase.prototype.ctxMiterLimit = function(t) {
            this.canvasContext.miterLimit = t;
        }, CanvasRendererBase.prototype.ctxFill = function(t) {
            this.canvasContext.fill(t);
        }, CanvasRendererBase.prototype.ctxFillRect = function(t, e, r1, i) {
            this.canvasContext.fillRect(t, e, r1, i);
        }, CanvasRendererBase.prototype.ctxStroke = function() {
            this.canvasContext.stroke();
        }, CanvasRendererBase.prototype.reset = function() {
            this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.save = function() {
            this.canvasContext.save();
        }, CanvasRendererBase.prototype.restore = function(t) {
            this.renderConfig.clearCanvas ? (t && (this.globalData.blendMode = "source-over"), this.contextData.restore(t)) : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.configAnimation = function(t) {
            if (this.animationItem.wrapper) {
                this.animationItem.container = createTag("canvas");
                var e = this.animationItem.container.style;
                e.width = "100%", e.height = "100%";
                var r1 = "0px 0px 0px";
                e.transformOrigin = r1, e.mozTransformOrigin = r1, e.webkitTransformOrigin = r1, e["-webkit-transform"] = r1, e.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
            } else this.canvasContext = this.renderConfig.context;
            this.contextData.setContext(this.canvasContext), this.data = t, this.layers = t.layers, this.transformCanvas = {
                w: t.w,
                h: t.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0
            }, this.setupGlobalData(t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t.layers.length), this.updateContainerSize();
        }, CanvasRendererBase.prototype.updateContainerSize = function(t, e) {
            var r1, _$i, s, a;
            if (this.reset(), t ? (r1 = t, _$i = e, this.canvasContext.canvas.width = r1, this.canvasContext.canvas.height = _$i) : (this.animationItem.wrapper && this.animationItem.container ? (r1 = this.animationItem.wrapper.offsetWidth, _$i = this.animationItem.wrapper.offsetHeight) : (r1 = this.canvasContext.canvas.width, _$i = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r1 * this.renderConfig.dpr, this.canvasContext.canvas.height = _$i * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
                var n = this.renderConfig.preserveAspectRatio.split(" "), o = n[1] || "meet", h = n[0] || "xMidYMid", l = h.substr(0, 4), p = h.substr(4);
                s = r1 / _$i, (a = this.transformCanvas.w / this.transformCanvas.h) > s && "meet" === o || a < s && "slice" === o ? (this.transformCanvas.sx = r1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r1 / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = _$i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = _$i / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === l && (a < s && "meet" === o || a > s && "slice" === o) ? (r1 - this.transformCanvas.w * (_$i / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === l && (a < s && "meet" === o || a > s && "slice" === o) ? (r1 - this.transformCanvas.w * (_$i / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === p && (a > s && "meet" === o || a < s && "slice" === o) ? (_$i - this.transformCanvas.h * (r1 / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === p && (a > s && "meet" === o || a < s && "slice" === o) ? (_$i - this.transformCanvas.h * (r1 / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
            } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = r1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = _$i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
            this.transformCanvas.props = [
                this.transformCanvas.sx,
                0,
                0,
                0,
                0,
                this.transformCanvas.sy,
                0,
                0,
                0,
                0,
                1,
                0,
                this.transformCanvas.tx,
                this.transformCanvas.ty,
                0,
                1
            ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
        }, CanvasRendererBase.prototype.destroy = function() {
            var t;
            for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t = (this.layers ? this.layers.length : 0) - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
        }, CanvasRendererBase.prototype.renderFrame = function(t, e) {
            if ((this.renderedFrame !== t || !0 !== this.renderConfig.clearCanvas || e) && !this.destroyed && -1 !== t) {
                var r1;
                this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e, this.globalData.projectInterface.currentFrame = t;
                var _$i = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), r1 = _$i - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].prepareFrame(t - this.layers[r1].st);
                if (this.globalData._mdf) {
                    for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r1 = _$i - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].renderFrame();
                    !0 !== this.renderConfig.clearCanvas && this.restore();
                }
            }
        }, CanvasRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                var r1 = this.createItem(this.layers[t], this, this.globalData);
                e[t] = r1, r1.initExpressions();
            }
        }, CanvasRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, CanvasRendererBase.prototype.hide = function() {
            this.animationItem.container.style.display = "none";
        }, CanvasRendererBase.prototype.show = function() {
            this.animationItem.container.style.display = "block";
        }, CVContextData.prototype.duplicate = function() {
            var t = 2 * this._length, e = 0;
            for(e = this._length; e < t; e += 1)this.stack[e] = new CanvasContext;
            this._length = t;
        }, CVContextData.prototype.reset = function() {
            this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
        }, CVContextData.prototype.restore = function(t) {
            this.cArrPos -= 1;
            var e, r1 = this.stack[this.cArrPos], _$i = r1.transform, s = this.cTr.props;
            for(e = 0; e < 16; e += 1)s[e] = _$i[e];
            if (t) {
                this.nativeContext.restore();
                var a = this.stack[this.cArrPos + 1];
                this.appliedFillStyle = a.fillStyle, this.appliedStrokeStyle = a.strokeStyle, this.appliedLineWidth = a.lineWidth, this.appliedLineCap = a.lineCap, this.appliedLineJoin = a.lineJoin, this.appliedMiterLimit = a.miterLimit;
            }
            this.nativeContext.setTransform(_$i[0], _$i[1], _$i[4], _$i[5], _$i[12], _$i[13]), (t || -1 !== r1.opacity && this.currentOpacity !== r1.opacity) && (this.nativeContext.globalAlpha = r1.opacity, this.currentOpacity = r1.opacity), this.currentFillStyle = r1.fillStyle, this.currentStrokeStyle = r1.strokeStyle, this.currentLineWidth = r1.lineWidth, this.currentLineCap = r1.lineCap, this.currentLineJoin = r1.lineJoin, this.currentMiterLimit = r1.miterLimit;
        }, CVContextData.prototype.save = function(t) {
            t && this.nativeContext.save();
            var e = this.cTr.props;
            this._length <= this.cArrPos && this.duplicate();
            var r1, _$i = this.stack[this.cArrPos];
            for(r1 = 0; r1 < 16; r1 += 1)_$i.transform[r1] = e[r1];
            this.cArrPos += 1;
            var s = this.stack[this.cArrPos];
            s.opacity = _$i.opacity, s.fillStyle = _$i.fillStyle, s.strokeStyle = _$i.strokeStyle, s.lineWidth = _$i.lineWidth, s.lineCap = _$i.lineCap, s.lineJoin = _$i.lineJoin, s.miterLimit = _$i.miterLimit;
        }, CVContextData.prototype.setOpacity = function(t) {
            this.stack[this.cArrPos].opacity = t;
        }, CVContextData.prototype.setContext = function(t) {
            this.nativeContext = t;
        }, CVContextData.prototype.fillStyle = function(t) {
            this.stack[this.cArrPos].fillStyle !== t && (this.currentFillStyle = t, this.stack[this.cArrPos].fillStyle = t);
        }, CVContextData.prototype.strokeStyle = function(t) {
            this.stack[this.cArrPos].strokeStyle !== t && (this.currentStrokeStyle = t, this.stack[this.cArrPos].strokeStyle = t);
        }, CVContextData.prototype.lineWidth = function(t) {
            this.stack[this.cArrPos].lineWidth !== t && (this.currentLineWidth = t, this.stack[this.cArrPos].lineWidth = t);
        }, CVContextData.prototype.lineCap = function(t) {
            this.stack[this.cArrPos].lineCap !== t && (this.currentLineCap = t, this.stack[this.cArrPos].lineCap = t);
        }, CVContextData.prototype.lineJoin = function(t) {
            this.stack[this.cArrPos].lineJoin !== t && (this.currentLineJoin = t, this.stack[this.cArrPos].lineJoin = t);
        }, CVContextData.prototype.miterLimit = function(t) {
            this.stack[this.cArrPos].miterLimit !== t && (this.currentMiterLimit = t, this.stack[this.cArrPos].miterLimit = t);
        }, CVContextData.prototype.transform = function(t) {
            this.transformMat.cloneFromProps(t);
            var e = this.cTr;
            this.transformMat.multiply(e), e.cloneFromProps(this.transformMat.props);
            var r1 = e.props;
            this.nativeContext.setTransform(r1[0], r1[1], r1[4], r1[5], r1[12], r1[13]);
        }, CVContextData.prototype.opacity = function(t) {
            var e = this.stack[this.cArrPos].opacity;
            e *= t < 0 ? 0 : t, this.stack[this.cArrPos].opacity !== e && (this.currentOpacity !== t && (this.nativeContext.globalAlpha = t, this.currentOpacity = t), this.stack[this.cArrPos].opacity = e);
        }, CVContextData.prototype.fill = function(t) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(t);
        }, CVContextData.prototype.fillRect = function(t, e, r1, i) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(t, e, r1, i);
        }, CVContextData.prototype.stroke = function() {
            this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
        }, extendPrototype([
            CanvasRendererBase,
            ICompElement,
            CVBaseElement
        ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
            var t, e = this.canvasContext;
            for(e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip(), t = this.layers.length - 1; t >= 0; t -= 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, CVCompElement.prototype.destroy = function() {
            var t;
            for(t = this.layers.length - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy();
            this.layers = null, this.elements = null;
        }, CVCompElement.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, extendPrototype([
            CanvasRendererBase
        ], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, HBaseElement.prototype = {
            checkBlendMode: function checkBlendMode() {},
            initRendererElement: function initRendererElement() {
                this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
            },
            createContainerElements: function createContainerElements() {
                this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function renderElement() {
                var t = this.transformedElement ? this.transformedElement.style : {};
                if (this.finalTransform._matMdf) {
                    var e = this.finalTransform.mat.toCSS();
                    t.transform = e, t.webkitTransform = e;
                }
                this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
            },
            renderFrame: function renderFrame() {
                this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
            },
            destroy: function destroy() {
                this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
            },
            createRenderableComponents: function createRenderableComponents() {
                this.maskManager = new MaskElement(this.data, this, this.globalData);
            },
            addEffects: function addEffects() {},
            setMatte: function setMatte() {}
        }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], HSolidElement), HSolidElement.prototype.createContent = function() {
            var t;
            this.data.hasMask ? ((t = createNS("rect")).setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t = createTag("div")).style.width = this.data.sw + "px", t.style.height = this.data.sh + "px", t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t);
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HSolidElement,
            SVGShapeElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
            var t;
            if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t = this.svgElement;
            else {
                t = createNS("svg");
                var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                t.setAttribute("width", e.w), t.setAttribute("height", e.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
            }
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t;
        }, HShapeElement.prototype.getTransformedPoint = function(t, e) {
            var r1, _$i = t.length;
            for(r1 = 0; r1 < _$i; r1 += 1)e = t[r1].mProps.v.applyToPointArray(e[0], e[1], 0);
            return e;
        }, HShapeElement.prototype.calculateShapeBoundingBox = function(t, e) {
            var r1, _$i, s, a, n, o = t.sh.v, h = t.transformers, l = o._length;
            if (!(l <= 1)) {
                for(r1 = 0; r1 < l - 1; r1 += 1)_$i = this.getTransformedPoint(h, o.v[r1]), s = this.getTransformedPoint(h, o.o[r1]), a = this.getTransformedPoint(h, o.i[r1 + 1]), n = this.getTransformedPoint(h, o.v[r1 + 1]), this.checkBounds(_$i, s, a, n, e);
                o.c && (_$i = this.getTransformedPoint(h, o.v[r1]), s = this.getTransformedPoint(h, o.o[r1]), a = this.getTransformedPoint(h, o.i[0]), n = this.getTransformedPoint(h, o.v[0]), this.checkBounds(_$i, s, a, n, e));
            }
        }, HShapeElement.prototype.checkBounds = function(t, e, r1, i, s) {
            this.getBoundsOfCurve(t, e, r1, i);
            var a = this.shapeBoundingBox;
            s.x = bmMin(a.left, s.x), s.xMax = bmMax(a.right, s.xMax), s.y = bmMin(a.top, s.y), s.yMax = bmMax(a.bottom, s.yMax);
        }, HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0
        }, HShapeElement.prototype.getBoundsOfCurve = function(t, e, r1, i) {
            for(var s, a, n, o, h, l, p, c = [
                [
                    t[0],
                    i[0]
                ],
                [
                    t[1],
                    i[1]
                ]
            ], f = 0; f < 2; ++f)a = 6 * t[f] - 12 * e[f] + 6 * r1[f], s = -3 * t[f] + 9 * e[f] - 9 * r1[f] + 3 * i[f], n = 3 * e[f] - 3 * t[f], a |= 0, n |= 0, 0 == (s |= 0) && 0 === a || (0 === s ? (o = -n / a) > 0 && o < 1 && c[f].push(this.calculateF(o, t, e, r1, i, f)) : (h = a * a - 4 * n * s) >= 0 && ((l = (-a + bmSqrt(h)) / (2 * s)) > 0 && l < 1 && c[f].push(this.calculateF(l, t, e, r1, i, f)), (p = (-a - bmSqrt(h)) / (2 * s)) > 0 && p < 1 && c[f].push(this.calculateF(p, t, e, r1, i, f))));
            this.shapeBoundingBox.left = bmMin.apply(null, c[0]), this.shapeBoundingBox.top = bmMin.apply(null, c[1]), this.shapeBoundingBox.right = bmMax.apply(null, c[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, c[1]);
        }, HShapeElement.prototype.calculateF = function(t, e, r1, i, s, a) {
            return bmPow(1 - t, 3) * e[a] + 3 * bmPow(1 - t, 2) * t * r1[a] + 3 * (1 - t) * bmPow(t, 2) * i[a] + bmPow(t, 3) * s[a];
        }, HShapeElement.prototype.calculateBoundingBox = function(t, e) {
            var r1, _$i = t.length;
            for(r1 = 0; r1 < _$i; r1 += 1)t[r1] && t[r1].sh ? this.calculateShapeBoundingBox(t[r1], e) : t[r1] && t[r1].it ? this.calculateBoundingBox(t[r1].it, e) : t[r1] && t[r1].style && t[r1].w && this.expandStrokeBoundingBox(t[r1].w, e);
        }, HShapeElement.prototype.expandStrokeBoundingBox = function(t, e) {
            var r1 = 0;
            if (t.keyframes) {
                for(var _$i = 0; _$i < t.keyframes.length; _$i += 1){
                    var s = t.keyframes[_$i].s;
                    s > r1 && (r1 = s);
                }
                r1 *= t.mult;
            } else r1 = t.v * t.mult;
            e.x -= r1, e.xMax += r1, e.y -= r1, e.yMax += r1;
        }, HShapeElement.prototype.currentBoxContains = function(t) {
            return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
        }, HShapeElement.prototype.renderInnerContent = function() {
            if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
                var t = this.tempBoundingBox, e = 999999;
                if (t.x = e, t.xMax = -e, t.y = e, t.yMax = -e, this.calculateBoundingBox(this.itemsData, t), t.width = t.xMax < t.x ? 0 : t.xMax - t.x, t.height = t.yMax < t.y ? 0 : t.yMax - t.y, this.currentBoxContains(t)) return;
                var r1 = !1;
                if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width, this.shapeCont.setAttribute("width", t.width), r1 = !0), this.currentBBox.h !== t.height && (this.currentBBox.h = t.height, this.shapeCont.setAttribute("height", t.height), r1 = !0), r1 || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
                    this.currentBBox.w = t.width, this.currentBBox.h = t.height, this.currentBBox.x = t.x, this.currentBBox.y = t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                    var _$i = this.shapeCont.style, s = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    _$i.transform = s, _$i.webkitTransform = s;
                }
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], HTextElement), HTextElement.prototype.createContent = function() {
            if (this.isMasked = this.checkMasks(), this.isMasked) {
                this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                var t = createNS("g");
                this.maskedElement.appendChild(t), this.innerElem = t;
            } else this.renderType = "html", this.innerElem = this.layerElement;
            this.checkParenting();
        }, HTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = this.innerElem.style, r1 = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
            e.fill = r1, e.color = r1, t.sc && (e.stroke = this.buildColor(t.sc), e.strokeWidth = t.sw + "px");
            var _$i, s, a = this.globalData.fontManager.getFontByName(t.f);
            if (!this.globalData.fontManager.chars) {
                if (e.fontSize = t.finalSize + "px", e.lineHeight = t.finalSize + "px", a.fClass) this.innerElem.className = a.fClass;
                else {
                    e.fontFamily = a.fFamily;
                    var n = t.fWeight, o = t.fStyle;
                    e.fontStyle = o, e.fontWeight = n;
                }
            }
            var h, l, p, c = t.l;
            s = c.length;
            var f, u = this.mHelper, d = "", m = 0;
            for(_$i = 0; _$i < s; _$i += 1){
                if (this.globalData.fontManager.chars ? (this.textPaths[m] ? h = this.textPaths[m] : ((h = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h.setAttribute("stroke-linejoin", lineJoinEnum[2]), h.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[m] ? p = (l = this.textSpans[m]).children[0] : ((l = createTag("div")).style.lineHeight = 0, (p = createNS("svg")).appendChild(h), styleDiv(l)))) : this.isMasked ? h = this.textPaths[m] ? this.textPaths[m] : createNS("text") : this.textSpans[m] ? (l = this.textSpans[m], h = this.textPaths[m]) : (styleDiv(l = createTag("span")), styleDiv(h = createTag("span")), l.appendChild(h)), this.globalData.fontManager.chars) {
                    var y, g = this.globalData.fontManager.getCharData(t.finalText[_$i], a.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
                    if (y = g ? g.data : null, u.reset(), y && y.shapes && y.shapes.length && (f = y.shapes[0].it, u.scale(t.finalSize / 100, t.finalSize / 100), d = this.createPathShape(u, f), h.setAttribute("d", d)), this.isMasked) this.innerElem.appendChild(h);
                    else {
                        if (this.innerElem.appendChild(l), y && y.shapes) {
                            document.body.appendChild(p);
                            var v = p.getBBox();
                            p.setAttribute("width", v.width + 2), p.setAttribute("height", v.height + 2), p.setAttribute("viewBox", v.x - 1 + " " + (v.y - 1) + " " + (v.width + 2) + " " + (v.height + 2));
                            var b = p.style, _ = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)";
                            b.transform = _, b.webkitTransform = _, c[_$i].yOffset = v.y - 1;
                        } else p.setAttribute("width", 1), p.setAttribute("height", 1);
                        l.appendChild(p);
                    }
                } else if (h.textContent = c[_$i].val, h.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h);
                else {
                    this.innerElem.appendChild(l);
                    var _$P = h.style, S = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
                    _$P.transform = S, _$P.webkitTransform = S;
                }
                this.isMasked ? this.textSpans[m] = h : this.textSpans[m] = l, this.textSpans[m].style.display = "block", this.textPaths[m] = h, m += 1;
            }
            for(; m < this.textSpans.length;)this.textSpans[m].style.display = "none", m += 1;
        }, HTextElement.prototype.renderInnerContent = function() {
            var t;
            if (this.validateText(), this.data.singleShape) {
                if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                if (this.isMasked && this.finalTransform._matMdf) {
                    this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t = this.svgElement.style;
                    var e = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                    t.transform = e, t.webkitTransform = e;
                }
            }
            if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                var r1, _$i, s, a, n, o = 0, h = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
                for(_$i = l.length, r1 = 0; r1 < _$i; r1 += 1)l[r1].n ? o += 1 : (a = this.textSpans[r1], n = this.textPaths[r1], s = h[o], o += 1, s._mdf.m && (this.isMasked ? a.setAttribute("transform", s.m) : (a.style.webkitTransform = s.m, a.style.transform = s.m)), a.style.opacity = s.o, s.sw && s._mdf.sw && n.setAttribute("stroke-width", s.sw), s.sc && s._mdf.sc && n.setAttribute("stroke", s.sc), s.fc && s._mdf.fc && (n.setAttribute("fill", s.fc), n.style.color = s.fc));
                if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var p = this.innerElem.getBBox();
                    if (this.currentBBox.w !== p.width && (this.currentBBox.w = p.width, this.svgElement.setAttribute("width", p.width)), this.currentBBox.h !== p.height && (this.currentBBox.h = p.height, this.svgElement.setAttribute("height", p.height)), this.currentBBox.w !== p.width + 2 || this.currentBBox.h !== p.height + 2 || this.currentBBox.x !== p.x - 1 || this.currentBBox.y !== p.y - 1) {
                        this.currentBBox.w = p.width + 2, this.currentBBox.h = p.height + 2, this.currentBBox.x = p.x - 1, this.currentBBox.y = p.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t = this.svgElement.style;
                        var c = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        t.transform = c, t.webkitTransform = c;
                    }
                }
            }
        }, extendPrototype([
            BaseElement,
            FrameElement,
            HierarchyElement
        ], HCameraElement), HCameraElement.prototype.setup = function() {
            var t, e, r1, _$i, s = this.comp.threeDElements.length;
            for(t = 0; t < s; t += 1)if ("3d" === (e = this.comp.threeDElements[t]).type) {
                r1 = e.perspectiveElem.style, _$i = e.container.style;
                var a = this.pe.v + "px", n = "0px 0px 0px", o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                r1.perspective = a, r1.webkitPerspective = a, _$i.transformOrigin = n, _$i.mozTransformOrigin = n, _$i.webkitTransformOrigin = n, r1.transform = o, r1.webkitTransform = o;
            }
        }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
            var t, e, r1 = this._isFirstFrame;
            if (this.hierarchy) for(e = this.hierarchy.length, t = 0; t < e; t += 1)r1 = this.hierarchy[t].finalTransform.mProp._mdf || r1;
            if (r1 || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                if (this.mat.reset(), this.hierarchy) for(t = e = this.hierarchy.length - 1; t >= 0; t -= 1){
                    var _$i = this.hierarchy[t].finalTransform.mProp;
                    this.mat.translate(-_$i.p.v[0], -_$i.p.v[1], _$i.p.v[2]), this.mat.rotateX(-_$i.or.v[0]).rotateY(-_$i.or.v[1]).rotateZ(_$i.or.v[2]), this.mat.rotateX(-_$i.rx.v).rotateY(-_$i.ry.v).rotateZ(_$i.rz.v), this.mat.scale(1 / _$i.s.v[0], 1 / _$i.s.v[1], 1 / _$i.s.v[2]), this.mat.translate(_$i.a.v[0], _$i.a.v[1], _$i.a.v[2]);
                }
                if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                    var s;
                    s = this.p ? [
                        this.p.v[0] - this.a.v[0],
                        this.p.v[1] - this.a.v[1],
                        this.p.v[2] - this.a.v[2]
                    ] : [
                        this.px.v - this.a.v[0],
                        this.py.v - this.a.v[1],
                        this.pz.v - this.a.v[2]
                    ];
                    var a = Math.sqrt(Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2)), n = [
                        s[0] / a,
                        s[1] / a,
                        s[2] / a
                    ], o = Math.sqrt(n[2] * n[2] + n[0] * n[0]), h = Math.atan2(n[1], o), l = Math.atan2(n[0], -n[2]);
                    this.mat.rotateY(l).rotateX(-h);
                }
                this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
                var p = !this._prevMat.equals(this.mat);
                if ((p || this.pe._mdf) && this.comp.threeDElements) {
                    var c, f, u;
                    for(e = this.comp.threeDElements.length, t = 0; t < e; t += 1)if ("3d" === (c = this.comp.threeDElements[t]).type) {
                        if (p) {
                            var d = this.mat.toCSS();
                            (u = c.container.style).transform = d, u.webkitTransform = d;
                        }
                        this.pe._mdf && ((f = c.perspectiveElem.style).perspective = this.pe.v + "px", f.webkitPerspective = this.pe.v + "px");
                    }
                    this.mat.clone(this._prevMat);
                }
            }
            this._isFirstFrame = !1;
        }, HCameraElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
            return null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HSolidElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HImageElement), HImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData), e = new Image;
            this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e), e.crossOrigin = "anonymous", e.src = t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
        }, extendPrototype([
            BaseRenderer
        ], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, HybridRendererBase.prototype.appendElementInPos = function(t, e) {
            var r1 = t.getBaseElement();
            if (r1) {
                var _$i = this.layers[e];
                if (_$i.ddd && this.supports3d) this.addTo3dContainer(r1, e);
                else if (this.threeDElements) this.addTo3dContainer(r1, e);
                else {
                    for(var s, a, n = 0; n < e;)this.elements[n] && !0 !== this.elements[n] && this.elements[n].getBaseElement && (a = this.elements[n], s = (this.layers[n].ddd ? this.getThreeDContainerByPos(n) : a.getBaseElement()) || s), n += 1;
                    s ? _$i.ddd && this.supports3d || this.layerElement.insertBefore(r1, s) : _$i.ddd && this.supports3d || this.layerElement.appendChild(r1);
                }
            }
        }, HybridRendererBase.prototype.createShape = function(t) {
            return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createText = function(t) {
            return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createCamera = function(t) {
            return this.camera = new HCameraElement(t, this.globalData, this), this.camera;
        }, HybridRendererBase.prototype.createImage = function(t) {
            return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createSolid = function(t) {
            return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
            for(var e = 0, r1 = this.threeDElements.length; e < r1;){
                if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t) return this.threeDElements[e].perspectiveElem;
                e += 1;
            }
            return null;
        }, HybridRendererBase.prototype.createThreeDContainer = function(t, e) {
            var r1, _$i, s = createTag("div");
            styleDiv(s);
            var a = createTag("div");
            if (styleDiv(a), "3d" === e) {
                (r1 = s.style).width = this.globalData.compSize.w + "px", r1.height = this.globalData.compSize.h + "px";
                var n = "50% 50%";
                r1.webkitTransformOrigin = n, r1.mozTransformOrigin = n, r1.transformOrigin = n;
                var o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                (_$i = a.style).transform = o, _$i.webkitTransform = o;
            }
            s.appendChild(a);
            var h = {
                container: a,
                perspectiveElem: s,
                startPos: t,
                endPos: t,
                type: e
            };
            return this.threeDElements.push(h), h;
        }, HybridRendererBase.prototype.build3dContainers = function() {
            var t, e, r1 = this.layers.length, _$i = "";
            for(t = 0; t < r1; t += 1)this.layers[t].ddd && 3 !== this.layers[t].ty ? ("3d" !== _$i && (_$i = "3d", e = this.createThreeDContainer(t, "3d")), e.endPos = Math.max(e.endPos, t)) : ("2d" !== _$i && (_$i = "2d", e = this.createThreeDContainer(t, "2d")), e.endPos = Math.max(e.endPos, t));
            for(t = (r1 = this.threeDElements.length) - 1; t >= 0; t -= 1)this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
        }, HybridRendererBase.prototype.addTo3dContainer = function(t, e) {
            for(var r1 = 0, _$i = this.threeDElements.length; r1 < _$i;){
                if (e <= this.threeDElements[r1].endPos) {
                    for(var s, a = this.threeDElements[r1].startPos; a < e;)this.elements[a] && this.elements[a].getBaseElement && (s = this.elements[a].getBaseElement()), a += 1;
                    s ? this.threeDElements[r1].container.insertBefore(t, s) : this.threeDElements[r1].container.appendChild(t);
                    break;
                }
                r1 += 1;
            }
        }, HybridRendererBase.prototype.configAnimation = function(t) {
            var e = createTag("div"), r1 = this.animationItem.wrapper, _$i = e.style;
            _$i.width = t.w + "px", _$i.height = t.h + "px", this.resizerElem = e, styleDiv(e), _$i.transformStyle = "flat", _$i.mozTransformStyle = "flat", _$i.webkitTransformStyle = "flat", this.renderConfig.className && e.setAttribute("class", this.renderConfig.className), r1.appendChild(e), _$i.overflow = "hidden";
            var s = createNS("svg");
            s.setAttribute("width", "1"), s.setAttribute("height", "1"), styleDiv(s), this.resizerElem.appendChild(s);
            var a = createNS("defs");
            s.appendChild(a), this.data = t, this.setupGlobalData(t, s), this.globalData.defs = a, this.layers = t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
        }, HybridRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, HybridRendererBase.prototype.updateContainerSize = function() {
            var t, e, r1, _$i, s = this.animationItem.wrapper.offsetWidth, a = this.animationItem.wrapper.offsetHeight, n = s / a;
            this.globalData.compSize.w / this.globalData.compSize.h > n ? (t = s / this.globalData.compSize.w, e = s / this.globalData.compSize.w, r1 = 0, _$i = (a - this.globalData.compSize.h * (s / this.globalData.compSize.w)) / 2) : (t = a / this.globalData.compSize.h, e = a / this.globalData.compSize.h, r1 = (s - this.globalData.compSize.w * (a / this.globalData.compSize.h)) / 2, _$i = 0);
            var o = this.resizerElem.style;
            o.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + e + ",0,0,0,0,1,0," + r1 + "," + _$i + ",0,1)", o.transform = o.webkitTransform;
        }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
            this.resizerElem.style.display = "none";
        }, HybridRendererBase.prototype.show = function() {
            this.resizerElem.style.display = "block";
        }, HybridRendererBase.prototype.initItems = function() {
            if (this.buildAllItems(), this.camera) this.camera.setup();
            else {
                var t, e = this.globalData.compSize.w, r1 = this.globalData.compSize.h, _$i = this.threeDElements.length;
                for(t = 0; t < _$i; t += 1){
                    var s = this.threeDElements[t].perspectiveElem.style;
                    s.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(r1, 2)) + "px", s.perspective = s.webkitPerspective;
                }
            }
        }, HybridRendererBase.prototype.searchExtraCompositions = function(t) {
            var e, r1 = t.length, _$i = createTag("div");
            for(e = 0; e < r1; e += 1)if (t[e].xt) {
                var s = this.createComp(t[e], _$i, this.globalData.comp, null);
                s.initExpressions(), this.globalData.projectInterface.registerComposition(s);
            }
        }, extendPrototype([
            HybridRendererBase,
            ICompElement,
            HBaseElement
        ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
            this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
        }, HCompElement.prototype.addTo3dContainer = function(t, e) {
            for(var r1, _$i = 0; _$i < e;)this.elements[_$i] && this.elements[_$i].getBaseElement && (r1 = this.elements[_$i].getBaseElement()), _$i += 1;
            r1 ? this.layerElement.insertBefore(t, r1) : this.layerElement.appendChild(t);
        }, HCompElement.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            HybridRendererBase
        ], HybridRenderer), HybridRenderer.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        };
        var CompExpressionInterface = function CompExpressionInterface(t) {
            function e(e) {
                for(var r1 = 0, _$i = t.layers.length; r1 < _$i;){
                    if (t.layers[r1].nm === e || t.layers[r1].ind === e) return t.elements[r1].layerInterface;
                    r1 += 1;
                }
                return null;
            }
            return Object.defineProperty(e, "_name", {
                value: t.data.nm
            }), e.layer = e, e.pixelAspect = 1, e.height = t.data.h || t.globalData.compSize.h, e.width = t.data.w || t.globalData.compSize.w, e.pixelAspect = 1, e.frameDuration = 1 / t.globalData.frameRate, e.displayStartTime = 0, e.numLayers = t.layers.length, e;
        };
        function _typeof$2(t) {
            return _typeof$2 = "function" == typeof Symbol && "symbol" == (0, $l0HdX._)(Symbol.iterator) ? function _typeof$21(t) {
                return typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            }, _typeof$2(t);
        }
        function seedRandom(t, e) {
            var r1 = this, _$i = 256, s = e.pow(_$i, 6), a = e.pow(2, 52), n = 2 * a, o = 255;
            function h(t) {
                var _$e, r1 = t.length, s = this, a = 0, n = s.i = s.j = 0, h = s.S = [];
                for(r1 || (t = [
                    r1++
                ]); a < _$i;)h[a] = a++;
                for(a = 0; a < _$i; a++)h[a] = h[n = o & n + t[a % r1] + (_$e = h[a])], h[n] = _$e;
                s.g = function(t) {
                    for(var _$e, r1 = 0, a = s.i, n = s.j, h = s.S; t--;)_$e = h[a = o & a + 1], r1 = r1 * _$i + h[o & (h[a] = h[n = o & n + _$e]) + (h[n] = _$e)];
                    return s.i = a, s.j = n, r1;
                };
            }
            function l(t, e) {
                return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
            }
            function p(t, e) {
                var r1, _$i = [], s = _typeof$2(t);
                if (e && "object" == s) for(r1 in t)try {
                    _$i.push(p(t[r1], e - 1));
                } catch (t) {}
                return _$i.length ? _$i : "string" == s ? t : t + "\0";
            }
            function c(t, e) {
                for(var r1, _$i = t + "", s = 0; s < _$i.length;)e[o & s] = o & (r1 ^= 19 * e[o & s]) + _$i.charCodeAt(s++);
                return f(e);
            }
            function f(t) {
                return String.fromCharCode.apply(0, t);
            }
            e.seedrandom = function(o, u, d) {
                var m = [], y = c(p((u = !0 === u ? {
                    entropy: !0
                } : u || {}).entropy ? [
                    o,
                    f(t)
                ] : null === o ? function() {
                    try {
                        var _$e = new Uint8Array(_$i);
                        return (r1.crypto || r1.msCrypto).getRandomValues(_$e), f(_$e);
                    } catch (e) {
                        var s = r1.navigator, a = s && s.plugins;
                        return [
                            +new Date,
                            r1,
                            a,
                            r1.screen,
                            f(t)
                        ];
                    }
                }() : o, 3), m), g = new h(m), v = function v() {
                    for(var _$t = g.g(6), _$e = s, r1 = 0; _$t < a;)_$t = (_$t + r1) * _$i, _$e *= _$i, r1 = g.g(1);
                    for(; _$t >= n;)_$t /= 2, _$e /= 2, r1 >>>= 1;
                    return (_$t + r1) / _$e;
                };
                return v.int32 = function() {
                    return 0 | g.g(4);
                }, v.quick = function() {
                    return g.g(4) / 4294967296;
                }, v.double = v, c(f(g.S), t), (u.pass || d || function(t, r1, i, s) {
                    return s && (s.S && l(s, g), t.state = function() {
                        return l(g, {});
                    }), i ? (e.random = t, r1) : t;
                })(v, y, "global" in u ? u.global : this == e, u.state);
            }, c(e.random(), t);
        }
        function initialize$2(t) {
            seedRandom([], t);
        }
        var propTypes = {
            SHAPE: "shape"
        };
        function _typeof$1(t) {
            return _typeof$1 = "function" == typeof Symbol && "symbol" == (0, $l0HdX._)(Symbol.iterator) ? function _typeof$11(t) {
                return typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            }, _typeof$1(t);
        }
        var ExpressionManager = function() {
            var ob = {}, _$Math = BMMath, _$window = null, _$document = null, XMLHttpRequest1 = null, fetch1 = null, frames = null, _lottieGlobal = {};
            function resetFrame() {
                _lottieGlobal = {};
            }
            function $bm_isInstanceOfArray(t) {
                return t.constructor === Array || t.constructor === Float32Array;
            }
            function isNumerable(t, e) {
                return "number" === t || e instanceof Number || "boolean" === t || "string" === t;
            }
            function $bm_neg(t) {
                var e = _typeof$1(t);
                if ("number" === e || t instanceof Number || "boolean" === e) return -t;
                if ($bm_isInstanceOfArray(t)) {
                    var r1, _$i = t.length, s = [];
                    for(r1 = 0; r1 < _$i; r1 += 1)s[r1] = -t[r1];
                    return s;
                }
                return t.propType ? t.v : -t;
            }
            initialize$2(BMMath);
            var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
            function sum(t, e) {
                var r1 = _typeof$1(t), _$i = _typeof$1(e);
                if (isNumerable(r1, t) && isNumerable(_$i, e) || "string" === r1 || "string" === _$i) return t + e;
                if ($bm_isInstanceOfArray(t) && isNumerable(_$i, e)) return (t = t.slice(0))[0] += e, t;
                if (isNumerable(r1, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t + e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var s = 0, a = t.length, n = e.length, o = []; s < a || s < n;)("number" == typeof t[s] || t[s] instanceof Number) && ("number" == typeof e[s] || e[s] instanceof Number) ? o[s] = t[s] + e[s] : o[s] = void 0 === e[s] ? t[s] : t[s] || e[s], s += 1;
                    return o;
                }
                return 0;
            }
            var add = sum;
            function sub(t, e) {
                var r1 = _typeof$1(t), _$i = _typeof$1(e);
                if (isNumerable(r1, t) && isNumerable(_$i, e)) return "string" === r1 && (t = parseInt(t, 10)), "string" === _$i && (e = parseInt(e, 10)), t - e;
                if ($bm_isInstanceOfArray(t) && isNumerable(_$i, e)) return (t = t.slice(0))[0] -= e, t;
                if (isNumerable(r1, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t - e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var s = 0, a = t.length, n = e.length, o = []; s < a || s < n;)("number" == typeof t[s] || t[s] instanceof Number) && ("number" == typeof e[s] || e[s] instanceof Number) ? o[s] = t[s] - e[s] : o[s] = void 0 === e[s] ? t[s] : t[s] || e[s], s += 1;
                    return o;
                }
                return 0;
            }
            function mul(t, e) {
                var r1, _$i, s, a = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(a, t) && isNumerable(n, e)) return t * e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(s = t.length, r1 = createTypedArray("float32", s), _$i = 0; _$i < s; _$i += 1)r1[_$i] = t[_$i] * e;
                    return r1;
                }
                if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
                    for(s = e.length, r1 = createTypedArray("float32", s), _$i = 0; _$i < s; _$i += 1)r1[_$i] = t * e[_$i];
                    return r1;
                }
                return 0;
            }
            function div(t, e) {
                var r1, _$i, s, a = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(a, t) && isNumerable(n, e)) return t / e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(s = t.length, r1 = createTypedArray("float32", s), _$i = 0; _$i < s; _$i += 1)r1[_$i] = t[_$i] / e;
                    return r1;
                }
                if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
                    for(s = e.length, r1 = createTypedArray("float32", s), _$i = 0; _$i < s; _$i += 1)r1[_$i] = t / e[_$i];
                    return r1;
                }
                return 0;
            }
            function mod(t, e) {
                return "string" == typeof t && (t = parseInt(t, 10)), "string" == typeof e && (e = parseInt(e, 10)), t % e;
            }
            var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
            function clamp(t, e, r1) {
                if (e > r1) {
                    var _$i = r1;
                    r1 = e, e = _$i;
                }
                return _$Math.min(_$Math.max(t, e), r1);
            }
            function radiansToDegrees(t) {
                return t / degToRads;
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(t) {
                return t * degToRads;
            }
            var degrees_to_radians = radiansToDegrees, helperLengthArray = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            function length(t, e) {
                if ("number" == typeof t || t instanceof Number) return e = e || 0, _$Math.abs(t - e);
                var r1;
                e || (e = helperLengthArray);
                var _$i = _$Math.min(t.length, e.length), s = 0;
                for(r1 = 0; r1 < _$i; r1 += 1)s += _$Math.pow(e[r1] - t[r1], 2);
                return _$Math.sqrt(s);
            }
            function normalize(t) {
                return div(t, length(t));
            }
            function rgbToHsl(t) {
                var e, r1, _$i = t[0], s = t[1], a = t[2], n = _$Math.max(_$i, s, a), o = _$Math.min(_$i, s, a), h = (n + o) / 2;
                if (n === o) e = 0, r1 = 0;
                else {
                    var l = n - o;
                    switch(r1 = h > .5 ? l / (2 - n - o) : l / (n + o), n){
                        case _$i:
                            e = (s - a) / l + (s < a ? 6 : 0);
                            break;
                        case s:
                            e = (a - _$i) / l + 2;
                            break;
                        case a:
                            e = (_$i - s) / l + 4;
                    }
                    e /= 6;
                }
                return [
                    e,
                    r1,
                    h,
                    t[3]
                ];
            }
            function hue2rgb(t, e, r1) {
                return r1 < 0 && (r1 += 1), r1 > 1 && (r1 -= 1), r1 < 1 / 6 ? t + 6 * (e - t) * r1 : r1 < .5 ? e : r1 < 2 / 3 ? t + (e - t) * (2 / 3 - r1) * 6 : t;
            }
            function hslToRgb(t) {
                var e, r1, _$i, s = t[0], a = t[1], n = t[2];
                if (0 === a) e = n, _$i = n, r1 = n;
                else {
                    var o = n < .5 ? n * (1 + a) : n + a - n * a, h = 2 * n - o;
                    e = hue2rgb(h, o, s + 1 / 3), r1 = hue2rgb(h, o, s), _$i = hue2rgb(h, o, s - 1 / 3);
                }
                return [
                    e,
                    r1,
                    _$i,
                    t[3]
                ];
            }
            function linear(t, e, r1, i, s) {
                if (void 0 !== i && void 0 !== s || (i = e, s = r1, e = 0, r1 = 1), r1 < e) {
                    var a = r1;
                    r1 = e, e = a;
                }
                if (t <= e) return i;
                if (t >= r1) return s;
                var n, o = r1 === e ? 0 : (t - e) / (r1 - e);
                if (!i.length) return i + (s - i) * o;
                var h = i.length, l = createTypedArray("float32", h);
                for(n = 0; n < h; n += 1)l[n] = i[n] + (s[n] - i[n]) * o;
                return l;
            }
            function random(t, e) {
                if (void 0 === e && (void 0 === t ? (t = 0, e = 1) : (e = t, t = void 0)), e.length) {
                    var r1, _$i = e.length;
                    t || (t = createTypedArray("float32", _$i));
                    var s = createTypedArray("float32", _$i), a = BMMath.random();
                    for(r1 = 0; r1 < _$i; r1 += 1)s[r1] = t[r1] + a * (e[r1] - t[r1]);
                    return s;
                }
                return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
            }
            function createPath(t, e, r1, i) {
                var s, a = t.length, n = shapePool.newElement();
                n.setPathData(!!i, a);
                var o, h, l = [
                    0,
                    0
                ];
                for(s = 0; s < a; s += 1)o = e && e[s] ? e[s] : l, h = r1 && r1[s] ? r1[s] : l, n.setTripleAt(t[s][0], t[s][1], h[0] + t[s][0], h[1] + t[s][1], o[0] + t[s][0], o[1] + t[s][1], s, !0);
                return n;
            }
            function initiateExpression(elem, data, property) {
                function noOp(t) {
                    return t;
                }
                if (!elem.globalData.renderConfig.runExpressions) return noOp;
                var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                    get: function get() {
                        return thisProperty.v;
                    }
                }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
                var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t, e) {
                    var r1, _$i, s = this.pv.length ? this.pv.length : 1, a = createTypedArray("float32", s), n = _$Math.floor(5 * time);
                    for(r1 = 0, _$i = 0; r1 < n;){
                        for(_$i = 0; _$i < s; _$i += 1)a[_$i] += -e + 2 * e * BMMath.random();
                        r1 += 1;
                    }
                    var o = 5 * time, h = o - _$Math.floor(o), l = createTypedArray("float32", s);
                    if (s > 1) {
                        for(_$i = 0; _$i < s; _$i += 1)l[_$i] = this.pv[_$i] + a[_$i] + (-e + 2 * e * BMMath.random()) * h;
                        return l;
                    }
                    return this.pv + a[0] + (-e + 2 * e * BMMath.random()) * h;
                }).bind(this);
                function loopInDuration(t, e) {
                    return loopIn(t, e, !0);
                }
                function loopOutDuration(t, e) {
                    return loopOut(t, e, !0);
                }
                thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
                function lookAt(t, e) {
                    var r1 = [
                        e[0] - t[0],
                        e[1] - t[1],
                        e[2] - t[2]
                    ], _$i = _$Math.atan2(r1[0], _$Math.sqrt(r1[1] * r1[1] + r1[2] * r1[2])) / degToRads;
                    return [
                        -_$Math.atan2(r1[1], r1[2]) / degToRads,
                        _$i,
                        0
                    ];
                }
                function easeOut(t, e, r1, i, s) {
                    return applyEase(easeOutBez, t, e, r1, i, s);
                }
                function easeIn(t, e, r1, i, s) {
                    return applyEase(easeInBez, t, e, r1, i, s);
                }
                function ease(t, e, r1, i, s) {
                    return applyEase(easeInOutBez, t, e, r1, i, s);
                }
                function applyEase(t, e, r1, i, s, a) {
                    void 0 === s ? (s = r1, a = i) : e = (e - r1) / (i - r1), e > 1 ? e = 1 : e < 0 && (e = 0);
                    var n = t(e);
                    if ($bm_isInstanceOfArray(s)) {
                        var o, h = s.length, l = createTypedArray("float32", h);
                        for(o = 0; o < h; o += 1)l[o] = (a[o] - s[o]) * n + s[o];
                        return l;
                    }
                    return (a - s) * n + s;
                }
                function nearestKey(t) {
                    var e, r1, _$i, s = data.k.length;
                    if (data.k.length && "number" != typeof data.k[0]) {
                        if (r1 = -1, (t *= elem.comp.globalData.frameRate) < data.k[0].t) r1 = 1, _$i = data.k[0].t;
                        else {
                            for(e = 0; e < s - 1; e += 1){
                                if (t === data.k[e].t) {
                                    r1 = e + 1, _$i = data.k[e].t;
                                    break;
                                }
                                if (t > data.k[e].t && t < data.k[e + 1].t) {
                                    t - data.k[e].t > data.k[e + 1].t - t ? (r1 = e + 2, _$i = data.k[e + 1].t) : (r1 = e + 1, _$i = data.k[e].t);
                                    break;
                                }
                            }
                            -1 === r1 && (r1 = e + 1, _$i = data.k[e].t);
                        }
                    } else r1 = 0, _$i = 0;
                    var a = {};
                    return a.index = r1, a.time = _$i / elem.comp.globalData.frameRate, a;
                }
                function key(t) {
                    var e, r1, _$i;
                    if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t);
                    t -= 1, e = {
                        time: data.k[t].t / elem.comp.globalData.frameRate,
                        value: []
                    };
                    var s = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
                    for(_$i = s.length, r1 = 0; r1 < _$i; r1 += 1)e[r1] = s[r1], e.value[r1] = s[r1];
                    return e;
                }
                function framesToTime(t, e) {
                    return e || (e = elem.comp.globalData.frameRate), t / e;
                }
                function timeToFrames(t, e) {
                    return t || 0 === t || (t = time), e || (e = elem.comp.globalData.frameRate), t * e;
                }
                function seedRandom(t) {
                    BMMath.seedrandom(randSeed + t);
                }
                function sourceRectAtTime() {
                    return elem.sourceRectAtTime();
                }
                function substring(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substring(t) : value.substring(t, e) : "";
                }
                function substr(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substr(t) : value.substr(t, e) : "";
                }
                function posterizeTime(t) {
                    time = 0 === t ? 0 : _$Math.floor(time * t) / t, value = valueAtTime(time);
                }
                var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = _$Math.floor(1e6 * _$Math.random()), globalData = elem.globalData;
                function executeExpression(t) {
                    return value = t, this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
                }
                return executeExpression.__preventDeadCodeRemoval = [
                    $bm_transform,
                    anchorPoint,
                    time,
                    velocity,
                    inPoint,
                    outPoint,
                    width,
                    height,
                    name,
                    loop_in,
                    loop_out,
                    smooth,
                    toComp,
                    fromCompToSurface,
                    toWorld,
                    fromWorld,
                    mask,
                    position,
                    rotation,
                    scale,
                    thisComp,
                    numKeys,
                    active,
                    wiggle,
                    loopInDuration,
                    loopOutDuration,
                    comp,
                    lookAt,
                    easeOut,
                    easeIn,
                    ease,
                    nearestKey,
                    key,
                    text,
                    textIndex,
                    textTotal,
                    selectorValue,
                    framesToTime,
                    timeToFrames,
                    sourceRectAtTime,
                    substring,
                    substr,
                    posterizeTime,
                    index,
                    globalData
                ], executeExpression;
            }
            return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [
                _$window,
                _$document,
                XMLHttpRequest1,
                fetch1,
                frames,
                $bm_neg,
                add,
                $bm_sum,
                $bm_sub,
                $bm_mul,
                $bm_div,
                $bm_mod,
                clamp,
                radians_to_degrees,
                degreesToRadians,
                degrees_to_radians,
                normalize,
                rgbToHsl,
                hslToRgb,
                linear,
                random,
                createPath,
                _lottieGlobal
            ], ob.resetFrame = resetFrame, ob;
        }(), Expressions = function() {
            var t = {
                initExpressions: function initExpressions(t) {
                    var e = 0, r1 = [];
                    t.renderer.compInterface = CompExpressionInterface(t.renderer), t.renderer.globalData.projectInterface.registerComposition(t.renderer), t.renderer.globalData.pushExpression = function() {
                        e += 1;
                    }, t.renderer.globalData.popExpression = function() {
                        0 == (e -= 1) && function() {
                            var _$t, e = r1.length;
                            for(_$t = 0; _$t < e; _$t += 1)r1[_$t].release();
                            r1.length = 0;
                        }();
                    }, t.renderer.globalData.registerExpressionProperty = function(t) {
                        -1 === r1.indexOf(t) && r1.push(t);
                    };
                }
            };
            return t.resetFrame = ExpressionManager.resetFrame, t;
        }(), MaskManagerInterface = function() {
            function t(t, e) {
                this._mask = t, this._data = e;
            }
            return Object.defineProperty(t.prototype, "maskPath", {
                get: function get() {
                    return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                }
            }), Object.defineProperty(t.prototype, "maskOpacity", {
                get: function get() {
                    return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                }
            }), function(e) {
                var r1, _$i = createSizedArray(e.viewData.length), s = e.viewData.length;
                for(r1 = 0; r1 < s; r1 += 1)_$i[r1] = new t(e.viewData[r1], e.masksProperties[r1]);
                return function(t) {
                    for(r1 = 0; r1 < s;){
                        if (e.masksProperties[r1].nm === t) return _$i[r1];
                        r1 += 1;
                    }
                    return null;
                };
            };
        }(), ExpressionPropertyInterface = function() {
            var t = {
                pv: 0,
                v: 0,
                mult: 1
            }, e = {
                pv: [
                    0,
                    0,
                    0
                ],
                v: [
                    0,
                    0,
                    0
                ],
                mult: 1
            };
            function r1(t, e, r1) {
                Object.defineProperty(t, "velocity", {
                    get: function get() {
                        return e.getVelocityAtTime(e.comp.currentFrame);
                    }
                }), t.numKeys = e.keyframes ? e.keyframes.length : 0, t.key = function(i) {
                    if (!t.numKeys) return 0;
                    var s = "";
                    s = "s" in e.keyframes[i - 1] ? e.keyframes[i - 1].s : "e" in e.keyframes[i - 2] ? e.keyframes[i - 2].e : e.keyframes[i - 2].s;
                    var a = "unidimensional" === r1 ? new Number(s) : Object.assign({}, s);
                    return a.time = e.keyframes[i - 1].t / e.elem.comp.globalData.frameRate, a.value = "unidimensional" === r1 ? s[0] : s, a;
                }, t.valueAtTime = e.getValueAtTime, t.speedAtTime = e.getSpeedAtTime, t.velocityAtTime = e.getVelocityAtTime, t.propertyGroup = e.propertyGroup;
            }
            function i() {
                return t;
            }
            return function(s) {
                return s ? "unidimensional" === s.propType ? function(e) {
                    e && "pv" in e || (e = t);
                    var _$i = 1 / e.mult, _$s = e.pv * _$i, a = new Number(_$s);
                    return a.value = _$s, r1(a, e, "unidimensional"), function() {
                        return e.k && e.getValue(), _$s = e.v * _$i, a.value !== _$s && ((a = new Number(_$s)).value = _$s, r1(a, e, "unidimensional")), a;
                    };
                }(s) : function(t) {
                    t && "pv" in t || (t = e);
                    var _$i = 1 / t.mult, _$s = t.data && t.data.l || t.pv.length, a = createTypedArray("float32", _$s), n = createTypedArray("float32", _$s);
                    return a.value = n, r1(a, t, "multidimensional"), function() {
                        t.k && t.getValue();
                        for(var e = 0; e < _$s; e += 1)n[e] = t.v[e] * _$i, a[e] = n[e];
                        return a;
                    };
                }(s) : i;
            };
        }(), TransformExpressionInterface = function TransformExpressionInterface(t) {
            function e(t) {
                switch(t){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return e.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return e.rotation;
                    case "ADBE Rotate X":
                        return e.xRotation;
                    case "ADBE Rotate Y":
                        return e.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return e.position;
                    case "ADBE Position_0":
                        return e.xPosition;
                    case "ADBE Position_1":
                        return e.yPosition;
                    case "ADBE Position_2":
                        return e.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return e.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return e.opacity;
                    default:
                        return null;
                }
            }
            var r1, _$i, s, a;
            return Object.defineProperty(e, "rotation", {
                get: ExpressionPropertyInterface(t.r || t.rz)
            }), Object.defineProperty(e, "zRotation", {
                get: ExpressionPropertyInterface(t.rz || t.r)
            }), Object.defineProperty(e, "xRotation", {
                get: ExpressionPropertyInterface(t.rx)
            }), Object.defineProperty(e, "yRotation", {
                get: ExpressionPropertyInterface(t.ry)
            }), Object.defineProperty(e, "scale", {
                get: ExpressionPropertyInterface(t.s)
            }), t.p ? a = ExpressionPropertyInterface(t.p) : (r1 = ExpressionPropertyInterface(t.px), _$i = ExpressionPropertyInterface(t.py), t.pz && (s = ExpressionPropertyInterface(t.pz))), Object.defineProperty(e, "position", {
                get: function get() {
                    return t.p ? a() : [
                        r1(),
                        _$i(),
                        s ? s() : 0
                    ];
                }
            }), Object.defineProperty(e, "xPosition", {
                get: ExpressionPropertyInterface(t.px)
            }), Object.defineProperty(e, "yPosition", {
                get: ExpressionPropertyInterface(t.py)
            }), Object.defineProperty(e, "zPosition", {
                get: ExpressionPropertyInterface(t.pz)
            }), Object.defineProperty(e, "anchorPoint", {
                get: ExpressionPropertyInterface(t.a)
            }), Object.defineProperty(e, "opacity", {
                get: ExpressionPropertyInterface(t.o)
            }), Object.defineProperty(e, "skew", {
                get: ExpressionPropertyInterface(t.sk)
            }), Object.defineProperty(e, "skewAxis", {
                get: ExpressionPropertyInterface(t.sa)
            }), Object.defineProperty(e, "orientation", {
                get: ExpressionPropertyInterface(t.or)
            }), e;
        }, LayerExpressionInterface = function() {
            function t(t) {
                var e = new Matrix;
                return void 0 !== t ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e) : this._elem.finalTransform.mProp.applyToMatrix(e), e;
            }
            function e(t, e) {
                var r1 = this.getMatrix(e);
                return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.applyPoint(r1, t);
            }
            function r1(t, e) {
                var r1 = this.getMatrix(e);
                return this.applyPoint(r1, t);
            }
            function i(t, e) {
                var r1 = this.getMatrix(e);
                return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.invertPoint(r1, t);
            }
            function s(t, e) {
                var r1 = this.getMatrix(e);
                return this.invertPoint(r1, t);
            }
            function a(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, _$i = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < _$i; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t);
                }
                return t.applyToPointArray(e[0], e[1], e[2] || 0);
            }
            function n(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, _$i = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < _$i; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t);
                }
                return t.inversePoint(e);
            }
            function o(t) {
                var e = new Matrix;
                if (e.reset(), this._elem.finalTransform.mProp.applyToMatrix(e), this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, _$i = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < _$i; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(e);
                    return e.inversePoint(t);
                }
                return e.inversePoint(t);
            }
            function h() {
                return [
                    1,
                    1,
                    1,
                    1
                ];
            }
            return function(l) {
                var p;
                function c(t) {
                    switch(t){
                        case "ADBE Root Vectors Group":
                        case "Contents":
                        case 2:
                            return c.shapeInterface;
                        case 1:
                        case 6:
                        case "Transform":
                        case "transform":
                        case "ADBE Transform Group":
                            return p;
                        case 4:
                        case "ADBE Effect Parade":
                        case "effects":
                        case "Effects":
                            return c.effect;
                        case "ADBE Text Properties":
                            return c.textInterface;
                        default:
                            return null;
                    }
                }
                c.getMatrix = t, c.invertPoint = n, c.applyPoint = a, c.toWorld = r1, c.toWorldVec = e, c.fromWorld = s, c.fromWorldVec = i, c.toComp = r1, c.fromComp = o, c.sampleImage = h, c.sourceRectAtTime = l.sourceRectAtTime.bind(l), c._elem = l;
                var f = getDescriptor(p = TransformExpressionInterface(l.finalTransform.mProp), "anchorPoint");
                return Object.defineProperties(c, {
                    hasParent: {
                        get: function get() {
                            return l.hierarchy.length;
                        }
                    },
                    parent: {
                        get: function get() {
                            return l.hierarchy[0].layerInterface;
                        }
                    },
                    rotation: getDescriptor(p, "rotation"),
                    scale: getDescriptor(p, "scale"),
                    position: getDescriptor(p, "position"),
                    opacity: getDescriptor(p, "opacity"),
                    anchorPoint: f,
                    anchor_point: f,
                    transform: {
                        get: function get() {
                            return p;
                        }
                    },
                    active: {
                        get: function get() {
                            return l.isInRange;
                        }
                    }
                }), c.startTime = l.data.st, c.index = l.data.ind, c.source = l.data.refId, c.height = 0 === l.data.ty ? l.data.h : 100, c.width = 0 === l.data.ty ? l.data.w : 100, c.inPoint = l.data.ip / l.comp.globalData.frameRate, c.outPoint = l.data.op / l.comp.globalData.frameRate, c._name = l.data.nm, c.registerMaskInterface = function(t) {
                    c.mask = new MaskManagerInterface(t, l);
                }, c.registerEffectsInterface = function(t) {
                    c.effect = t;
                }, c;
            };
        }(), propertyGroupFactory = function propertyGroupFactory(t, e) {
            return function(r1) {
                return (r1 = void 0 === r1 ? 1 : r1) <= 0 ? t : e(r1 - 1);
            };
        }, PropertyInterface = function PropertyInterface(t, e) {
            var r1 = {
                _name: t
            };
            return function(t) {
                return (t = void 0 === t ? 1 : t) <= 0 ? r1 : e(t - 1);
            };
        }, EffectsExpressionInterface = function() {
            var t = {
                createEffectsInterface: function createEffectsInterface(t, r1) {
                    if (t.effectsManager) {
                        var _$i, s = [], a = t.data.ef, n = t.effectsManager.effectElements.length;
                        for(_$i = 0; _$i < n; _$i += 1)s.push(e(a[_$i], t.effectsManager.effectElements[_$i], r1, t));
                        var o = t.data.ef || [], h = function h(t) {
                            for(_$i = 0, n = o.length; _$i < n;){
                                if (t === o[_$i].nm || t === o[_$i].mn || t === o[_$i].ix) return s[_$i];
                                _$i += 1;
                            }
                            return null;
                        };
                        return Object.defineProperty(h, "numProperties", {
                            get: function get() {
                                return o.length;
                            }
                        }), h;
                    }
                    return null;
                }
            };
            function e(t, i, s, a) {
                function n(e) {
                    for(var _$r = t.ef, _$i = 0, _$s = _$r.length; _$i < _$s;){
                        if (e === _$r[_$i].nm || e === _$r[_$i].mn || e === _$r[_$i].ix) return 5 === _$r[_$i].ty ? l[_$i] : l[_$i]();
                        _$i += 1;
                    }
                    throw new Error;
                }
                var o, h = propertyGroupFactory(n, s), l = [], p = t.ef.length;
                for(o = 0; o < p; o += 1)5 === t.ef[o].ty ? l.push(e(t.ef[o], i.effectElements[o], i.effectElements[o].propertyGroup, a)) : l.push(r1(i.effectElements[o], t.ef[o].ty, a, h));
                return "ADBE Color Control" === t.mn && Object.defineProperty(n, "color", {
                    get: function get() {
                        return l[0]();
                    }
                }), Object.defineProperties(n, {
                    numProperties: {
                        get: function get() {
                            return t.np;
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    propertyGroup: {
                        value: h
                    }
                }), n.enabled = 0 !== t.en, n.active = n.enabled, n;
            }
            function r1(t, e, r1, i) {
                var s = ExpressionPropertyInterface(t.p);
                return t.p.setGroupProperty && t.p.setGroupProperty(PropertyInterface("", i)), function() {
                    return 10 === e ? r1.comp.compInterface(t.p.v) : s();
                };
            }
            return t;
        }(), ShapePathInterface = function ShapePathInterface(t, e, r1) {
            var _$i = e.sh;
            function s(t) {
                return "Shape" === t || "shape" === t || "Path" === t || "path" === t || "ADBE Vector Shape" === t || 2 === t ? s.path : null;
            }
            var a = propertyGroupFactory(s, r1);
            return _$i.setGroupProperty(PropertyInterface("Path", a)), Object.defineProperties(s, {
                path: {
                    get: function get() {
                        return _$i.k && _$i.getValue(), _$i;
                    }
                },
                shape: {
                    get: function get() {
                        return _$i.k && _$i.getValue(), _$i;
                    }
                },
                _name: {
                    value: t.nm
                },
                ix: {
                    value: t.ix
                },
                propertyIndex: {
                    value: t.ix
                },
                mn: {
                    value: t.mn
                },
                propertyGroup: {
                    value: r1
                }
            }), s;
        }, ShapeExpressionInterface = function() {
            function t(t, n, f) {
                var u, d = [], m = t ? t.length : 0;
                for(u = 0; u < m; u += 1)"gr" === t[u].ty ? d.push(e(t[u], n[u], f)) : "fl" === t[u].ty ? d.push(r1(t[u], n[u], f)) : "st" === t[u].ty ? d.push(s(t[u], n[u], f)) : "tm" === t[u].ty ? d.push(a(t[u], n[u], f)) : "tr" === t[u].ty || ("el" === t[u].ty ? d.push(o(t[u], n[u], f)) : "sr" === t[u].ty ? d.push(h(t[u], n[u], f)) : "sh" === t[u].ty ? d.push(ShapePathInterface(t[u], n[u], f)) : "rc" === t[u].ty ? d.push(l(t[u], n[u], f)) : "rd" === t[u].ty ? d.push(p(t[u], n[u], f)) : "rp" === t[u].ty ? d.push(c(t[u], n[u], f)) : "gf" === t[u].ty ? d.push(i(t[u], n[u], f)) : d.push((t[u], n[u], function() {
                    return null;
                })));
                return d;
            }
            function e(e, r1, i) {
                var s = function s1(t) {
                    switch(t){
                        case "ADBE Vectors Group":
                        case "Contents":
                        case 2:
                            return s.content;
                        default:
                            return s.transform;
                    }
                };
                s.propertyGroup = propertyGroupFactory(s, i);
                var a = function(e, r1, i) {
                    var s, a = function a(t) {
                        for(var _$e = 0, _$r = s.length; _$e < _$r;){
                            if (s[_$e]._name === t || s[_$e].mn === t || s[_$e].propertyIndex === t || s[_$e].ix === t || s[_$e].ind === t) return s[_$e];
                            _$e += 1;
                        }
                        return "number" == typeof t ? s[t - 1] : null;
                    };
                    a.propertyGroup = propertyGroupFactory(a, i), s = t(e.it, r1.it, a.propertyGroup), a.numProperties = s.length;
                    var o = n(e.it[e.it.length - 1], r1.it[r1.it.length - 1], a.propertyGroup);
                    return a.transform = o, a.propertyIndex = e.cix, a._name = e.nm, a;
                }(e, r1, s.propertyGroup), o = n(e.it[e.it.length - 1], r1.it[r1.it.length - 1], s.propertyGroup);
                return s.content = a, s.transform = o, Object.defineProperty(s, "_name", {
                    get: function get() {
                        return e.nm;
                    }
                }), s.numProperties = e.np, s.propertyIndex = e.ix, s.nm = e.nm, s.mn = e.mn, s;
            }
            function r1(t, e, r1) {
                function i(t) {
                    return "Color" === t || "color" === t ? i.color : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", r1)), e.o.setGroupProperty(PropertyInterface("Opacity", r1)), i;
            }
            function i(t, e, r1) {
                function i(t) {
                    return "Start Point" === t || "start point" === t ? i.startPoint : "End Point" === t || "end point" === t ? i.endPoint : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    startPoint: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    endPoint: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    type: {
                        get: function get() {
                            return "a";
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.s.setGroupProperty(PropertyInterface("Start Point", r1)), e.e.setGroupProperty(PropertyInterface("End Point", r1)), e.o.setGroupProperty(PropertyInterface("Opacity", r1)), i;
            }
            function s(t, e, r1) {
                var _$i, s = propertyGroupFactory(l, r1), a = propertyGroupFactory(h, s);
                function n(r1) {
                    Object.defineProperty(h, t.d[r1].nm, {
                        get: ExpressionPropertyInterface(e.d.dataProps[r1].p)
                    });
                }
                var o = t.d ? t.d.length : 0, h = {};
                for(_$i = 0; _$i < o; _$i += 1)n(_$i), e.d.dataProps[_$i].p.setGroupProperty(a);
                function l(t) {
                    return "Color" === t || "color" === t ? l.color : "Opacity" === t || "opacity" === t ? l.opacity : "Stroke Width" === t || "stroke width" === t ? l.strokeWidth : null;
                }
                return Object.defineProperties(l, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    strokeWidth: {
                        get: ExpressionPropertyInterface(e.w)
                    },
                    dash: {
                        get: function get() {
                            return h;
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", s)), e.o.setGroupProperty(PropertyInterface("Opacity", s)), e.w.setGroupProperty(PropertyInterface("Stroke Width", s)), l;
            }
            function a(t, e, r1) {
                function i(e) {
                    return e === t.e.ix || "End" === e || "end" === e ? i.end : e === t.s.ix ? i.start : e === t.o.ix ? i.offset : null;
                }
                var s = propertyGroupFactory(i, r1);
                return i.propertyIndex = t.ix, e.s.setGroupProperty(PropertyInterface("Start", s)), e.e.setGroupProperty(PropertyInterface("End", s)), e.o.setGroupProperty(PropertyInterface("Offset", s)), i.propertyIndex = t.ix, i.propertyGroup = r1, Object.defineProperties(i, {
                    start: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    end: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function n(t, e, r1) {
                function i(e) {
                    return t.a.ix === e || "Anchor Point" === e ? i.anchorPoint : t.o.ix === e || "Opacity" === e ? i.opacity : t.p.ix === e || "Position" === e ? i.position : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e ? i.rotation : t.s.ix === e || "Scale" === e ? i.scale : t.sk && t.sk.ix === e || "Skew" === e ? i.skew : t.sa && t.sa.ix === e || "Skew Axis" === e ? i.skewAxis : null;
                }
                var s = propertyGroupFactory(i, r1);
                return e.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", s)), e.transform.mProps.p.setGroupProperty(PropertyInterface("Position", s)), e.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", s)), e.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", s)), e.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", s)), e.transform.mProps.sk && (e.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", s)), e.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", s))), e.transform.op.setGroupProperty(PropertyInterface("Opacity", s)), Object.defineProperties(i, {
                    opacity: {
                        get: ExpressionPropertyInterface(e.transform.mProps.o)
                    },
                    position: {
                        get: ExpressionPropertyInterface(e.transform.mProps.p)
                    },
                    anchorPoint: {
                        get: ExpressionPropertyInterface(e.transform.mProps.a)
                    },
                    scale: {
                        get: ExpressionPropertyInterface(e.transform.mProps.s)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(e.transform.mProps.r)
                    },
                    skew: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sk)
                    },
                    skewAxis: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sa)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.ty = "tr", i.mn = t.mn, i.propertyGroup = r1, i;
            }
            function o(t, e, r1) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.s.ix === e ? i.size : null;
                }
                var s = propertyGroupFactory(i, r1);
                i.propertyIndex = t.ix;
                var a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return a.s.setGroupProperty(PropertyInterface("Size", s)), a.p.setGroupProperty(PropertyInterface("Position", s)), Object.defineProperties(i, {
                    size: {
                        get: ExpressionPropertyInterface(a.s)
                    },
                    position: {
                        get: ExpressionPropertyInterface(a.p)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function h(t, e, r1) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.rotation : t.pt.ix === e ? i.points : t.or.ix === e || "ADBE Vector Star Outer Radius" === e ? i.outerRadius : t.os.ix === e ? i.outerRoundness : !t.ir || t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e ? t.is && t.is.ix === e ? i.innerRoundness : null : i.innerRadius;
                }
                var s = propertyGroupFactory(i, r1), a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, a.or.setGroupProperty(PropertyInterface("Outer Radius", s)), a.os.setGroupProperty(PropertyInterface("Outer Roundness", s)), a.pt.setGroupProperty(PropertyInterface("Points", s)), a.p.setGroupProperty(PropertyInterface("Position", s)), a.r.setGroupProperty(PropertyInterface("Rotation", s)), t.ir && (a.ir.setGroupProperty(PropertyInterface("Inner Radius", s)), a.is.setGroupProperty(PropertyInterface("Inner Roundness", s))), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(a.p)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(a.r)
                    },
                    points: {
                        get: ExpressionPropertyInterface(a.pt)
                    },
                    outerRadius: {
                        get: ExpressionPropertyInterface(a.or)
                    },
                    outerRoundness: {
                        get: ExpressionPropertyInterface(a.os)
                    },
                    innerRadius: {
                        get: ExpressionPropertyInterface(a.ir)
                    },
                    innerRoundness: {
                        get: ExpressionPropertyInterface(a.is)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function l(t, e, r1) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.roundness : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e ? i.size : null;
                }
                var s = propertyGroupFactory(i, r1), a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, a.p.setGroupProperty(PropertyInterface("Position", s)), a.s.setGroupProperty(PropertyInterface("Size", s)), a.r.setGroupProperty(PropertyInterface("Rotation", s)), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(a.p)
                    },
                    roundness: {
                        get: ExpressionPropertyInterface(a.r)
                    },
                    size: {
                        get: ExpressionPropertyInterface(a.s)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function p(t, e, r1) {
                function i(e) {
                    return t.r.ix === e || "Round Corners 1" === e ? i.radius : null;
                }
                var s = propertyGroupFactory(i, r1), a = e;
                return i.propertyIndex = t.ix, a.rd.setGroupProperty(PropertyInterface("Radius", s)), Object.defineProperties(i, {
                    radius: {
                        get: ExpressionPropertyInterface(a.rd)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function c(t, e, r1) {
                function i(e) {
                    return t.c.ix === e || "Copies" === e ? i.copies : t.o.ix === e || "Offset" === e ? i.offset : null;
                }
                var s = propertyGroupFactory(i, r1), a = e;
                return i.propertyIndex = t.ix, a.c.setGroupProperty(PropertyInterface("Copies", s)), a.o.setGroupProperty(PropertyInterface("Offset", s)), Object.defineProperties(i, {
                    copies: {
                        get: ExpressionPropertyInterface(a.c)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(a.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            return function(e, r1, i) {
                var s;
                function a(t) {
                    if ("number" == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? i : s[t - 1];
                    for(var _$e = 0, _$r = s.length; _$e < _$r;){
                        if (s[_$e]._name === t) return s[_$e];
                        _$e += 1;
                    }
                    return null;
                }
                return a.propertyGroup = propertyGroupFactory(a, function() {
                    return i;
                }), s = t(e, r1, a.propertyGroup), a.numProperties = s.length, a._name = "Contents", a;
            };
        }(), TextExpressionInterface = function TextExpressionInterface(t) {
            var e;
            function r1(t) {
                return "ADBE Text Document" === t ? r1.sourceText : null;
            }
            return Object.defineProperty(r1, "sourceText", {
                get: function get() {
                    t.textProperty.getValue();
                    var _$r = t.textProperty.currentData.t;
                    return e && _$r === e.value || ((e = new String(_$r)).value = _$r || new String(_$r), Object.defineProperty(e, "style", {
                        get: function get() {
                            return {
                                fillColor: t.textProperty.currentData.fc
                            };
                        }
                    })), e;
                }
            }), r1;
        };
        function _typeof(t) {
            return _typeof = "function" == typeof Symbol && "symbol" == (0, $l0HdX._)(Symbol.iterator) ? function _typeof1(t) {
                return typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
            }, _typeof(t);
        }
        var FootageInterface = (dataInterfaceFactory = function dataInterfaceFactory(t) {
            function e(t) {
                return "Outline" === t ? e.outlineInterface() : null;
            }
            return e._name = "Outline", e.outlineInterface = function(t) {
                var _$e = "", r1 = t.getFootageData();
                function i(t) {
                    if (r1[t]) return _$e = t, "object" === _typeof(r1 = r1[t]) ? i : r1;
                    var s = t.indexOf(_$e);
                    if (-1 !== s) {
                        var a = parseInt(t.substr(s + _$e.length), 10);
                        return "object" === _typeof(r1 = r1[a]) ? i : r1;
                    }
                    return "";
                }
                return function() {
                    return _$e = "", r1 = t.getFootageData(), i;
                };
            }(t), e;
        }, function FootageInterface(t) {
            function e(t) {
                return "Data" === t ? e.dataInterface : null;
            }
            return e._name = "Data", e.dataInterface = dataInterfaceFactory(t), e;
        }), dataInterfaceFactory, interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface
        };
        function getInterface(t) {
            return interfaces[t] || null;
        }
        var expressionHelpers = {
            searchExpressions: function searchExpressions(t, e, r1) {
                e.x && (r1.k = !0, r1.x = !0, r1.initiateExpression = ExpressionManager.initiateExpression, r1.effectsSequence.push(r1.initiateExpression(t, e, r1).bind(r1)));
            },
            getSpeedAtTime: function getSpeedAtTime(t) {
                var e = this.getValueAtTime(t), r1 = this.getValueAtTime(t + -0.01), _$i = 0;
                if (e.length) {
                    var s;
                    for(s = 0; s < e.length; s += 1)_$i += Math.pow(r1[s] - e[s], 2);
                    _$i = 100 * Math.sqrt(_$i);
                } else _$i = 0;
                return _$i;
            },
            getVelocityAtTime: function getVelocityAtTime(t) {
                if (void 0 !== this.vel) return this.vel;
                var e, r1, _$i = -0.001, s = this.getValueAtTime(t), a = this.getValueAtTime(t + _$i);
                if (s.length) for(e = createTypedArray("float32", s.length), r1 = 0; r1 < s.length; r1 += 1)e[r1] = (a[r1] - s[r1]) / _$i;
                else e = (a - s) / _$i;
                return e;
            },
            getValueAtTime: function getValueAtTime(t) {
                return t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime), this._cachingAtTime.lastFrame = t), this._cachingAtTime.value;
            },
            getStaticValueAtTime: function getStaticValueAtTime() {
                return this.pv;
            },
            setGroupProperty: function setGroupProperty(t) {
                this.propertyGroup = t;
            }
        };
        function addPropertyDecorator() {
            function t(t, e, r1) {
                if (!this.k || !this.keyframes) return this.pv;
                t = t ? t.toLowerCase() : "";
                var _$i, s, a, n, o, h = this.comp.renderedFrame, _$l = this.keyframes, p = _$l[_$l.length - 1].t;
                if (h <= p) return this.pv;
                if (r1 ? s = p - (_$i = e ? Math.abs(p - this.elem.comp.globalData.frameRate * e) : Math.max(0, p - this.elem.data.ip)) : ((!e || e > _$l.length - 1) && (e = _$l.length - 1), _$i = p - (s = _$l[_$l.length - 1 - e].t)), "pingpong" === t) {
                    if (Math.floor((h - s) / _$i) % 2 != 0) return this.getValueAtTime((_$i - (h - s) % _$i + s) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var c = this.getValueAtTime(s / this.comp.globalData.frameRate, 0), f = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), u = this.getValueAtTime(((h - s) % _$i + s) / this.comp.globalData.frameRate, 0), d = Math.floor((h - s) / _$i);
                        if (this.pv.length) {
                            for(n = (o = new Array(c.length)).length, a = 0; a < n; a += 1)o[a] = (f[a] - c[a]) * d + u[a];
                            return o;
                        }
                        return (f - c) * d + u;
                    }
                    if ("continue" === t) {
                        var m = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p - .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(m.length)).length, a = 0; a < n; a += 1)o[a] = m[a] + (m[a] - y[a]) * ((h - p) / this.comp.globalData.frameRate) / 5e-4;
                            return o;
                        }
                        return m + (h - p) / .001 * (m - y);
                    }
                }
                return this.getValueAtTime(((h - s) % _$i + s) / this.comp.globalData.frameRate, 0);
            }
            function e(t, e, r1) {
                if (!this.k) return this.pv;
                t = t ? t.toLowerCase() : "";
                var _$i, s, a, n, o, h = this.comp.renderedFrame, _$l = this.keyframes, p = _$l[0].t;
                if (h >= p) return this.pv;
                if (r1 ? s = p + (_$i = e ? Math.abs(this.elem.comp.globalData.frameRate * e) : Math.max(0, this.elem.data.op - p)) : ((!e || e > _$l.length - 1) && (e = _$l.length - 1), _$i = (s = _$l[e].t) - p), "pingpong" === t) {
                    if (Math.floor((p - h) / _$i) % 2 == 0) return this.getValueAtTime(((p - h) % _$i + p) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var c = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), f = this.getValueAtTime(s / this.comp.globalData.frameRate, 0), u = this.getValueAtTime((_$i - (p - h) % _$i + p) / this.comp.globalData.frameRate, 0), d = Math.floor((p - h) / _$i) + 1;
                        if (this.pv.length) {
                            for(n = (o = new Array(c.length)).length, a = 0; a < n; a += 1)o[a] = u[a] - (f[a] - c[a]) * d;
                            return o;
                        }
                        return u - (f - c) * d;
                    }
                    if ("continue" === t) {
                        var m = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p + .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(m.length)).length, a = 0; a < n; a += 1)o[a] = m[a] + (m[a] - y[a]) * (p - h) / .001;
                            return o;
                        }
                        return m + (m - y) * (p - h) / .001;
                    }
                }
                return this.getValueAtTime((_$i - ((p - h) % _$i + p)) / this.comp.globalData.frameRate, 0);
            }
            function r1(t, e) {
                if (!this.k) return this.pv;
                if (t = .5 * (t || .4), (e = Math.floor(e || 5)) <= 1) return this.pv;
                var r1, _$i, s = this.comp.renderedFrame / this.comp.globalData.frameRate, a = s - t, n = e > 1 ? (s + t - a) / (e - 1) : 1, o = 0, h = 0;
                for(r1 = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o < e;){
                    if (_$i = this.getValueAtTime(a + o * n), this.pv.length) for(h = 0; h < this.pv.length; h += 1)r1[h] += _$i[h];
                    else r1 += _$i;
                    o += 1;
                }
                if (this.pv.length) for(h = 0; h < this.pv.length; h += 1)r1[h] /= e;
                else r1 /= e;
                return r1;
            }
            function i(t) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var e = this._transformCachingAtTime.v;
                if (e.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                    var r1 = this.a.getValueAtTime(t);
                    e.translate(-r1[0] * this.a.mult, -r1[1] * this.a.mult, r1[2] * this.a.mult);
                }
                if (this.appliedTransformations < 2) {
                    var _$i = this.s.getValueAtTime(t);
                    e.scale(_$i[0] * this.s.mult, _$i[1] * this.s.mult, _$i[2] * this.s.mult);
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var s = this.sk.getValueAtTime(t), a = this.sa.getValueAtTime(t);
                    e.skewFromAxis(-s * this.sk.mult, a * this.sa.mult);
                }
                if (this.r && this.appliedTransformations < 4) {
                    var n = this.r.getValueAtTime(t);
                    e.rotate(-n * this.r.mult);
                } else if (!this.r && this.appliedTransformations < 4) {
                    var o = this.rz.getValueAtTime(t), h = this.ry.getValueAtTime(t), _$l = this.rx.getValueAtTime(t), p = this.or.getValueAtTime(t);
                    e.rotateZ(-o * this.rz.mult).rotateY(h * this.ry.mult).rotateX(_$l * this.rx.mult).rotateZ(-p[2] * this.or.mult).rotateY(p[1] * this.or.mult).rotateX(p[0] * this.or.mult);
                }
                if (this.data.p && this.data.p.s) {
                    var c = this.px.getValueAtTime(t), f = this.py.getValueAtTime(t);
                    if (this.data.p.z) {
                        var u = this.pz.getValueAtTime(t);
                        e.translate(c * this.px.mult, f * this.py.mult, -u * this.pz.mult);
                    } else e.translate(c * this.px.mult, f * this.py.mult, 0);
                } else {
                    var d = this.p.getValueAtTime(t);
                    e.translate(d[0] * this.p.mult, d[1] * this.p.mult, -d[2] * this.p.mult);
                }
                return e;
            }
            function s() {
                return this.v.clone(new Matrix);
            }
            var a = TransformPropertyFactory.getTransformProperty;
            TransformPropertyFactory.getTransformProperty = function(t, e, r1) {
                var n = a(t, e, r1);
                return n.dynamicProperties.length ? n.getValueAtTime = i.bind(n) : n.getValueAtTime = s.bind(n), n.setGroupProperty = expressionHelpers.setGroupProperty, n;
            };
            var n = PropertyFactory.getProp;
            PropertyFactory.getProp = function(i, s, a, o, h) {
                var _$l = n(i, s, a, o, h);
                _$l.kf ? _$l.getValueAtTime = expressionHelpers.getValueAtTime.bind(_$l) : _$l.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(_$l), _$l.setGroupProperty = expressionHelpers.setGroupProperty, _$l.loopOut = t, _$l.loopIn = e, _$l.smooth = r1, _$l.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(_$l), _$l.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(_$l), _$l.numKeys = 1 === s.a ? s.k.length : 0, _$l.propertyIndex = s.ix;
                var p = 0;
                return 0 !== a && (p = createTypedArray("float32", 1 === s.a ? s.k[0].s.length : s.k.length)), _$l._cachingAtTime = {
                    lastFrame: initialDefaultFrame,
                    lastIndex: 0,
                    value: p
                }, expressionHelpers.searchExpressions(i, s, _$l), _$l.k && h.addDynamicProperty(_$l), _$l;
            };
            var o = ShapePropertyFactory.getConstructorFunction(), h = ShapePropertyFactory.getKeyframedConstructorFunction();
            function l() {}
            l.prototype = {
                vertices: function vertices(t, e) {
                    this.k && this.getValue();
                    var r1, _$i = this.v;
                    void 0 !== e && (_$i = this.getValueAtTime(e, 0));
                    var s = _$i._length, a = _$i[t], n = _$i.v, o = createSizedArray(s);
                    for(r1 = 0; r1 < s; r1 += 1)o[r1] = "i" === t || "o" === t ? [
                        a[r1][0] - n[r1][0],
                        a[r1][1] - n[r1][1]
                    ] : [
                        a[r1][0],
                        a[r1][1]
                    ];
                    return o;
                },
                points: function points(t) {
                    return this.vertices("v", t);
                },
                inTangents: function inTangents(t) {
                    return this.vertices("i", t);
                },
                outTangents: function outTangents(t) {
                    return this.vertices("o", t);
                },
                isClosed: function isClosed() {
                    return this.v.c;
                },
                pointOnPath: function pointOnPath(t, e) {
                    var r1 = this.v;
                    void 0 !== e && (r1 = this.getValueAtTime(e, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r1));
                    for(var _$i, s = this._segmentsLength, a = s.lengths, n = s.totalLength * t, o = 0, h = a.length, _$l = 0; o < h;){
                        if (_$l + a[o].addedLength > n) {
                            var p = o, c = r1.c && o === h - 1 ? 0 : o + 1, f = (n - _$l) / a[o].addedLength;
                            _$i = bez.getPointInSegment(r1.v[p], r1.v[c], r1.o[p], r1.i[c], f, a[o]);
                            break;
                        }
                        _$l += a[o].addedLength, o += 1;
                    }
                    return _$i || (_$i = r1.c ? [
                        r1.v[0][0],
                        r1.v[0][1]
                    ] : [
                        r1.v[r1._length - 1][0],
                        r1.v[r1._length - 1][1]
                    ]), _$i;
                },
                vectorOnPath: function vectorOnPath(t, e, r1) {
                    1 == t ? t = this.v.c : 0 == t && (t = .999);
                    var _$i = this.pointOnPath(t, e), s = this.pointOnPath(t + .001, e), a = s[0] - _$i[0], n = s[1] - _$i[1], o = Math.sqrt(Math.pow(a, 2) + Math.pow(n, 2));
                    return 0 === o ? [
                        0,
                        0
                    ] : "tangent" === r1 ? [
                        a / o,
                        n / o
                    ] : [
                        -n / o,
                        a / o
                    ];
                },
                tangentOnPath: function tangentOnPath(t, e) {
                    return this.vectorOnPath(t, e, "tangent");
                },
                normalOnPath: function normalOnPath(t, e) {
                    return this.vectorOnPath(t, e, "normal");
                },
                setGroupProperty: expressionHelpers.setGroupProperty,
                getValueAtTime: expressionHelpers.getStaticValueAtTime
            }, extendPrototype([
                l
            ], o), extendPrototype([
                l
            ], h), h.prototype.getValueAtTime = function(t) {
                return this._cachingAtTime || (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame
                }), t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t, this.interpolateShape(t, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
            }, h.prototype.initiateExpression = ExpressionManager.initiateExpression;
            var p = ShapePropertyFactory.getShapeProp;
            ShapePropertyFactory.getShapeProp = function(t, e, r1, i, s) {
                var a = p(t, e, r1, i, s);
                return a.propertyIndex = e.ix, a.lock = !1, 3 === r1 ? expressionHelpers.searchExpressions(t, e.pt, a) : 4 === r1 && expressionHelpers.searchExpressions(t, e.ks, a), a.k && t.addDynamicProperty(a), a;
            };
        }
        function initialize$1() {
            addPropertyDecorator();
        }
        function addDecorator() {
            TextProperty.prototype.getExpressionValue = function(t, e) {
                var r1 = this.calculateExpression(e);
                if (t.t !== r1) {
                    var _$i = {};
                    return this.copyData(_$i, t), _$i.t = r1.toString(), _$i.__complete = !1, _$i;
                }
                return t;
            }, TextProperty.prototype.searchProperty = function() {
                var t = this.searchKeyframes(), e = this.searchExpressions();
                return this.kf = t || e, this.kf;
            }, TextProperty.prototype.searchExpressions = function() {
                return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
            };
        }
        function initialize() {
            addDecorator();
        }
        function SVGComposableEffect() {}
        SVGComposableEffect.prototype = {
            createMergeNode: function createMergeNode(t, e) {
                var r1, _$i, s = createNS("feMerge");
                for(s.setAttribute("result", t), _$i = 0; _$i < e.length; _$i += 1)(r1 = createNS("feMergeNode")).setAttribute("in", e[_$i]), s.appendChild(r1), s.appendChild(r1);
                return s;
            }
        };
        var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
        function SVGTintFilter(t, e, r1, i, s) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = a, a.setAttribute("result", i + "_tint_1"), t.appendChild(a), (a = createNS("feColorMatrix")).setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", i + "_tint_2"), t.appendChild(a), this.matrixFilter = a;
            var n = this.createMergeNode(i, [
                s,
                i + "_tint_1",
                i + "_tint_2"
            ]);
            t.appendChild(n);
        }
        function SVGFillFilter(t, e, r1, i) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", i), t.appendChild(s), this.matrixFilter = s;
        }
        function SVGStrokeEffect(t, e, r1) {
            this.initialized = !1, this.filterManager = e, this.elem = r1, this.paths = [];
        }
        function SVGTritoneFilter(t, e, r1, i) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t.appendChild(s);
            var a = createNS("feComponentTransfer");
            a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", i), this.matrixFilter = a;
            var n = createNS("feFuncR");
            n.setAttribute("type", "table"), a.appendChild(n), this.feFuncR = n;
            var o = createNS("feFuncG");
            o.setAttribute("type", "table"), a.appendChild(o), this.feFuncG = o;
            var h = createNS("feFuncB");
            h.setAttribute("type", "table"), a.appendChild(h), this.feFuncB = h, t.appendChild(a);
        }
        function SVGProLevelsFilter(t, e, r1, i) {
            this.filterManager = e;
            var s = this.filterManager.effectElements, a = createNS("feComponentTransfer");
            (s[10].p.k || 0 !== s[10].p.v || s[11].p.k || 1 !== s[11].p.v || s[12].p.k || 1 !== s[12].p.v || s[13].p.k || 0 !== s[13].p.v || s[14].p.k || 1 !== s[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", a)), (s[17].p.k || 0 !== s[17].p.v || s[18].p.k || 1 !== s[18].p.v || s[19].p.k || 1 !== s[19].p.v || s[20].p.k || 0 !== s[20].p.v || s[21].p.k || 1 !== s[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", a)), (s[24].p.k || 0 !== s[24].p.v || s[25].p.k || 1 !== s[25].p.v || s[26].p.k || 1 !== s[26].p.v || s[27].p.k || 0 !== s[27].p.v || s[28].p.k || 1 !== s[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", a)), (s[31].p.k || 0 !== s[31].p.v || s[32].p.k || 1 !== s[32].p.v || s[33].p.k || 1 !== s[33].p.v || s[34].p.k || 0 !== s[34].p.v || s[35].p.k || 1 !== s[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", a)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (a.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(a)), (s[3].p.k || 0 !== s[3].p.v || s[4].p.k || 1 !== s[4].p.v || s[5].p.k || 1 !== s[5].p.v || s[6].p.k || 0 !== s[6].p.v || s[7].p.k || 1 !== s[7].p.v) && ((a = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", i), t.appendChild(a), this.feFuncRComposed = this.createFeFunc("feFuncR", a), this.feFuncGComposed = this.createFeFunc("feFuncG", a), this.feFuncBComposed = this.createFeFunc("feFuncB", a));
        }
        function SVGDropShadowEffect(t, e, r1, i, s) {
            var a = e.container.globalData.renderConfig.filterSize, n = e.data.fs || a;
            t.setAttribute("x", n.x || a.x), t.setAttribute("y", n.y || a.y), t.setAttribute("width", n.width || a.width), t.setAttribute("height", n.height || a.height), this.filterManager = e;
            var o = createNS("feGaussianBlur");
            o.setAttribute("in", "SourceAlpha"), o.setAttribute("result", i + "_drop_shadow_1"), o.setAttribute("stdDeviation", "0"), this.feGaussianBlur = o, t.appendChild(o);
            var h = createNS("feOffset");
            h.setAttribute("dx", "25"), h.setAttribute("dy", "0"), h.setAttribute("in", i + "_drop_shadow_1"), h.setAttribute("result", i + "_drop_shadow_2"), this.feOffset = h, t.appendChild(h);
            var l = createNS("feFlood");
            l.setAttribute("flood-color", "#00ff00"), l.setAttribute("flood-opacity", "1"), l.setAttribute("result", i + "_drop_shadow_3"), this.feFlood = l, t.appendChild(l);
            var p = createNS("feComposite");
            p.setAttribute("in", i + "_drop_shadow_3"), p.setAttribute("in2", i + "_drop_shadow_2"), p.setAttribute("operator", "in"), p.setAttribute("result", i + "_drop_shadow_4"), t.appendChild(p);
            var c = this.createMergeNode(i, [
                i + "_drop_shadow_4",
                s
            ]);
            t.appendChild(c);
        }
        extendPrototype([
            SVGComposableEffect
        ], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, _$i = this.filterManager.effectElements[2].p.v / 100;
                this.linearFilter.setAttribute("values", linearFilterValue + " " + _$i + " 0"), this.matrixFilter.setAttribute("values", r1[0] - e[0] + " 0 0 0 " + e[0] + " " + (r1[1] - e[1]) + " 0 0 0 " + e[1] + " " + (r1[2] - e[2]) + " 0 0 0 " + e[2] + " 0 0 0 1 0");
            }
        }, SVGFillFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[2].p.v, r1 = this.filterManager.effectElements[6].p.v;
                this.matrixFilter.setAttribute("values", "0 0 0 0 " + e[0] + " 0 0 0 0 " + e[1] + " 0 0 0 0 " + e[2] + " 0 0 0 " + r1 + " 0");
            }
        }, SVGStrokeEffect.prototype.initialize = function() {
            var t, e, r1, _$i, s = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            for(1 === this.filterManager.effectElements[1].p.v ? (_$i = this.elem.maskManager.masksProperties.length, r1 = 0) : _$i = 1 + (r1 = this.filterManager.effectElements[0].p.v - 1), (e = createNS("g")).setAttribute("fill", "none"), e.setAttribute("stroke-linecap", "round"), e.setAttribute("stroke-dashoffset", 1); r1 < _$i; r1 += 1)t = createNS("path"), e.appendChild(t), this.paths.push({
                p: t,
                m: r1
            });
            if (3 === this.filterManager.effectElements[10].p.v) {
                var a = createNS("mask"), n = createElementID();
                a.setAttribute("id", n), a.setAttribute("mask-type", "alpha"), a.appendChild(e), this.elem.globalData.defs.appendChild(a);
                var o = createNS("g");
                for(o.setAttribute("mask", "url(" + getLocationHref() + "#" + n + ")"); s[0];)o.appendChild(s[0]);
                this.elem.layerElement.appendChild(o), this.masker = a, e.setAttribute("stroke", "#fff");
            } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                if (2 === this.filterManager.effectElements[10].p.v) for(s = this.elem.layerElement.children || this.elem.layerElement.childNodes; s.length;)this.elem.layerElement.removeChild(s[0]);
                this.elem.layerElement.appendChild(e), this.elem.layerElement.removeAttribute("mask"), e.setAttribute("stroke", "#fff");
            }
            this.initialized = !0, this.pathMasker = e;
        }, SVGStrokeEffect.prototype.renderFrame = function(t) {
            var e;
            this.initialized || this.initialize();
            var r1, _$i, s = this.paths.length;
            for(e = 0; e < s; e += 1)if (-1 !== this.paths[e].m && (r1 = this.elem.maskManager.viewData[this.paths[e].m], _$i = this.paths[e].p, (t || this.filterManager._mdf || r1.prop._mdf) && _$i.setAttribute("d", r1.lastPath), t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || r1.prop._mdf)) {
                var a;
                if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                    var n = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h = _$i.getTotalLength();
                    a = "0 0 0 " + h * n + " ";
                    var l, p = h * (o - n), c = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, f = Math.floor(p / c);
                    for(l = 0; l < f; l += 1)a += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                    a += "0 " + 10 * h + " 0 0";
                } else a = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
                _$i.setAttribute("stroke-dasharray", a);
            }
            if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t || this.filterManager.effectElements[3].p._mdf)) {
                var u = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * u[0]) + "," + bmFloor(255 * u[1]) + "," + bmFloor(255 * u[2]) + ")");
            }
        }, SVGTritoneFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, _$i = this.filterManager.effectElements[2].p.v, s = _$i[0] + " " + r1[0] + " " + e[0], a = _$i[1] + " " + r1[1] + " " + e[1], n = _$i[2] + " " + r1[2] + " " + e[2];
                this.feFuncR.setAttribute("tableValues", s), this.feFuncG.setAttribute("tableValues", a), this.feFuncB.setAttribute("tableValues", n);
            }
        }, SVGProLevelsFilter.prototype.createFeFunc = function(t, e) {
            var r1 = createNS(t);
            return r1.setAttribute("type", "table"), e.appendChild(r1), r1;
        }, SVGProLevelsFilter.prototype.getTableValue = function(t, e, r1, i, s) {
            for(var a, n, o = 0, h = Math.min(t, e), l = Math.max(t, e), p = Array.call(null, {
                length: 256
            }), c = 0, f = s - i, u = e - t; o <= 256;)n = (a = o / 256) <= h ? u < 0 ? s : i : a >= l ? u < 0 ? i : s : i + f * Math.pow((a - t) / u, 1 / r1), p[c] = n, c += 1, o += 256 / 255;
            return p.join(" ");
        }, SVGProLevelsFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e, r1 = this.filterManager.effectElements;
                this.feFuncRComposed && (t || r1[3].p._mdf || r1[4].p._mdf || r1[5].p._mdf || r1[6].p._mdf || r1[7].p._mdf) && (e = this.getTableValue(r1[3].p.v, r1[4].p.v, r1[5].p.v, r1[6].p.v, r1[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e), this.feFuncGComposed.setAttribute("tableValues", e), this.feFuncBComposed.setAttribute("tableValues", e)), this.feFuncR && (t || r1[10].p._mdf || r1[11].p._mdf || r1[12].p._mdf || r1[13].p._mdf || r1[14].p._mdf) && (e = this.getTableValue(r1[10].p.v, r1[11].p.v, r1[12].p.v, r1[13].p.v, r1[14].p.v), this.feFuncR.setAttribute("tableValues", e)), this.feFuncG && (t || r1[17].p._mdf || r1[18].p._mdf || r1[19].p._mdf || r1[20].p._mdf || r1[21].p._mdf) && (e = this.getTableValue(r1[17].p.v, r1[18].p.v, r1[19].p.v, r1[20].p.v, r1[21].p.v), this.feFuncG.setAttribute("tableValues", e)), this.feFuncB && (t || r1[24].p._mdf || r1[25].p._mdf || r1[26].p._mdf || r1[27].p._mdf || r1[28].p._mdf) && (e = this.getTableValue(r1[24].p.v, r1[25].p.v, r1[26].p.v, r1[27].p.v, r1[28].p.v), this.feFuncB.setAttribute("tableValues", e)), this.feFuncA && (t || r1[31].p._mdf || r1[32].p._mdf || r1[33].p._mdf || r1[34].p._mdf || r1[35].p._mdf) && (e = this.getTableValue(r1[31].p.v, r1[32].p.v, r1[33].p.v, r1[34].p.v, r1[35].p.v), this.feFuncA.setAttribute("tableValues", e));
            }
        }, extendPrototype([
            SVGComposableEffect
        ], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf) {
                    var e = this.filterManager.effectElements[0].p.v;
                    this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e[0]), Math.round(255 * e[1]), Math.round(255 * e[2])));
                }
                if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                    var r1 = this.filterManager.effectElements[3].p.v, _$i = (this.filterManager.effectElements[2].p.v - 90) * degToRads, s = r1 * Math.cos(_$i), a = r1 * Math.sin(_$i);
                    this.feOffset.setAttribute("dx", s), this.feOffset.setAttribute("dy", a);
                }
            }
        };
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(t, e, r1) {
            this.initialized = !1, this.filterManager = e, this.filterElem = t, this.elem = r1, r1.matteElement = createNS("g"), r1.matteElement.appendChild(r1.layerElement), r1.matteElement.appendChild(r1.transformedElement), r1.baseElement = r1.matteElement;
        }
        function SVGGaussianBlurEffect(t, e, r1, i) {
            t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), this.filterManager = e;
            var s = createNS("feGaussianBlur");
            s.setAttribute("result", i), t.appendChild(s), this.feGaussianBlur = s;
        }
        function TransformEffect() {}
        function SVGTransformEffect(t, e) {
            this.init(e);
        }
        function CVTransformEffect(t) {
            this.init(t);
        }
        return SVGMatte3Effect.prototype.findSymbol = function(t) {
            for(var e = 0, r1 = _svgMatteSymbols.length; e < r1;){
                if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
                e += 1;
            }
            return null;
        }, SVGMatte3Effect.prototype.replaceInParent = function(t, e) {
            var r1 = t.layerElement.parentNode;
            if (r1) {
                for(var _$i, s = r1.children, a = 0, n = s.length; a < n && s[a] !== t.layerElement;)a += 1;
                a <= n - 2 && (_$i = s[a + 1]);
                var o = createNS("use");
                o.setAttribute("href", "#" + e), _$i ? r1.insertBefore(o, _$i) : r1.appendChild(o);
            }
        }, SVGMatte3Effect.prototype.setElementAsMask = function(t, e) {
            if (!this.findSymbol(e)) {
                var r1 = createElementID(), _$i = createNS("mask");
                _$i.setAttribute("id", e.layerId), _$i.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e);
                var s = t.globalData.defs;
                s.appendChild(_$i);
                var a = createNS("symbol");
                a.setAttribute("id", r1), this.replaceInParent(e, r1), a.appendChild(e.layerElement), s.appendChild(a);
                var n = createNS("use");
                n.setAttribute("href", "#" + r1), _$i.appendChild(n), e.data.hd = !1, e.show();
            }
            t.setMatte(e.layerId);
        }, SVGMatte3Effect.prototype.initialize = function() {
            for(var t = this.filterManager.effectElements[0].p.v, e = this.elem.comp.elements, r1 = 0, _$i = e.length; r1 < _$i;)e[r1] && e[r1].data.ind === t && this.setElementAsMask(this.elem, e[r1]), r1 += 1;
            this.initialized = !0;
        }, SVGMatte3Effect.prototype.renderFrame = function() {
            this.initialized || this.initialize();
        }, SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = .3 * this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, _$i = 3 == r1 ? 0 : e, s = 2 == r1 ? 0 : e;
                this.feGaussianBlur.setAttribute("stdDeviation", _$i + " " + s);
                var a = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                this.feGaussianBlur.setAttribute("edgeMode", a);
            }
        }, TransformEffect.prototype.init = function(t) {
            this.effectsManager = t, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix, this.opacity = -1, this._mdf = !1, this._opMdf = !1;
        }, TransformEffect.prototype.renderFrame = function(t) {
            if (this._opMdf = !1, this._mdf = !1, t || this.effectsManager._mdf) {
                var e = this.effectsManager.effectElements, r1 = e[0].p.v, _$i = e[1].p.v, s = 1 === e[2].p.v, a = e[3].p.v, n = s ? a : e[4].p.v, o = e[5].p.v, h = e[6].p.v, l = e[7].p.v;
                this.matrix.reset(), this.matrix.translate(-r1[0], -r1[1], r1[2]), this.matrix.scale(.01 * n, .01 * a, 1), this.matrix.rotate(-l * degToRads), this.matrix.skewFromAxis(-o * degToRads, (h + 90) * degToRads), this.matrix.translate(_$i[0], _$i[1], 0), this._mdf = !0, this.opacity !== e[8].p.v && (this.opacity = e[8].p.v, this._opMdf = !0);
            }
        }, extendPrototype([
            TransformEffect
        ], SVGTransformEffect), extendPrototype([
            TransformEffect
        ], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
    }, module.exports = factory());
})(lottie$1, lottie$1.exports);
var lottie = lottie$1.exports, _templateObject$1, styles = r$3(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral([
    "\n  * {\n    box-sizing: border-box;\n  }\n\n  :host {\n    --lottie-player-toolbar-height: 35px;\n    --lottie-player-toolbar-background-color: transparent;\n    --lottie-player-toolbar-icon-color: #999;\n    --lottie-player-toolbar-icon-hover-color: #222;\n    --lottie-player-toolbar-icon-active-color: #555;\n    --lottie-player-seeker-track-color: #ccc;\n    --lottie-player-seeker-thumb-color: rgba(0, 107, 120, 0.8);\n    --lottie-player-seeker-display: block;\n\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n  .main {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n  }\n\n  .animation {\n    width: 100%;\n    height: 100%;\n    display: flex;\n  }\n  .animation.controls {\n    height: calc(100% - 35px);\n  }\n\n  .toolbar {\n    display: flex;\n    align-items: center;\n    justify-items: center;\n    background-color: var(--lottie-player-toolbar-background-color);\n    margin: 0 5px;\n    height: 35px;\n  }\n\n  .toolbar button {\n    cursor: pointer;\n    fill: var(--lottie-player-toolbar-icon-color);\n    display: flex;\n    background: none;\n    border: 0;\n    padding: 0;\n    outline: none;\n    height: 100%;\n  }\n\n  .toolbar button:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button.active {\n    fill: var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button.active:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button:focus {\n    outline: 1px dotted var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button svg {\n  }\n\n  .toolbar button.disabled svg {\n    display: none;\n  }\n\n  .seeker {\n    -webkit-appearance: none;\n    width: 95%;\n    outline: none;\n    background-color: var(--lottie-player-toolbar-background-color);\n    display: var(--lottie-player-seeker-display);\n  }\n\n  .seeker::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-webkit-slider-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: -5px;\n  }\n  .seeker:focus::-webkit-slider-runnable-track {\n    background: #999;\n  }\n  .seeker::-moz-range-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-moz-range-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker::-ms-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: transparent;\n    border-color: transparent;\n    color: transparent;\n  }\n  .seeker::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-thumb {\n    border: 0;\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker:focus::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n  }\n  .seeker:focus::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n  }\n\n  .error {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    align-items: center;\n  }\n"
]))), name = "@lottiefiles/lottie-player", version = "2.0.12", description = "Lottie animation and Telegram Sticker player web components.", main = "dist/lottie-player.js", module = "dist/lottie-player.esm.js", types = "dist/lottie-player.d.ts", homepage = "https://lottiefiles.com/web-player", repository = "https://github.com/LottieFiles/lottie-player.git", bugs = "https://github.com/LottieFiles/lottie-player/issues", author = "Jawish Hameed <jawish@lottiefiles.com>", license = "MIT", scripts = {
    start: "npm run cleanup && rollup -c --watch",
    build: "npm run cleanup && npm run build-lottie && npm run build-tgs",
    "build-with-coverage": "npm run cleanup && CODE_COVERAGE=true npm run build-lottie && CODE_COVERAGE=true npm run build-tgs",
    "build-lottie": "rollup -c ",
    "build-tgs": "rollup -c rollup-tgs.config.js",
    "watch-lottie": "npm run cleanup && rollup -c --watch",
    "watch-tgs": "npm run cleanup && rollup -c rollup-tgs.config.js --watch",
    cleanup: "shx rm -rf dist && shx mkdir dist",
    release: "semantic-release",
    lint: "eslint . --ext .ts,.tsx,.js",
    "lint:fix": "eslint . --ext .ts,.tsx,.js --fix",
    serve: "node ./cypress/pages/server.js -p 8000 &",
    "start-cypress": "yarn run cypress run && npx nyc report --reporter=text-summary",
    "run-tests": "yarn run build-with-coverage && yarn run serve && yarn run start-cypress",
    "postrun-tests": "kill $(lsof -t -i:8000)"
}, dependencies = {
    "@types/pako": "^1.0.1",
    lit: "^2.1.2",
    "lottie-web": "^5.12.2",
    pako: "^2.0.4",
    "resize-observer-polyfill": "^1.5.1"
}, devDependencies = {
    "@babel/core": "^7.11.0",
    "@babel/plugin-proposal-class-properties": "^7.10.4",
    "@babel/plugin-proposal-decorators": "^7.10.5",
    "@babel/preset-env": "^7.11.0",
    "@babel/preset-typescript": "^7.10.4",
    "@commitlint/cli": "^16.1.0",
    "@commitlint/config-conventional": "^16.0.0",
    "@cypress/code-coverage": "^3.9.12",
    "@istanbuljs/nyc-config-typescript": "^1.0.2",
    "@rollup/plugin-babel": "^5.1.0",
    "@rollup/plugin-commonjs": "^21.0.1",
    "@rollup/plugin-json": "^6.1.0",
    "@rollup/plugin-node-resolve": "^13.1.3",
    "@semantic-release/changelog": "^6.0.1",
    "@semantic-release/commit-analyzer": "^9.0.2",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^8.0.2",
    "@semantic-release/npm": "^9.0.0",
    "@semantic-release/release-notes-generator": "^10.0.3",
    "babel-eslint": "^10.1.0",
    "babel-plugin-istanbul": "^6.1.1",
    cypress: "^9.2.1",
    "cypress-real-events": "^1.6.0",
    eslint: "^7.27.0",
    "eslint-plugin-only-warn": "^1.0.2",
    fastify: "^3.25.3",
    "fastify-static": "^4.5.0",
    husky: ">=4",
    lerna: "^4.0.0",
    "lint-staged": "^12.3.2",
    "parcel-bundler": "^1.12.4",
    prettier: "^2.3.0",
    rollup: "^2.23.0",
    "rollup-plugin-copy": "^3.3.0",
    "rollup-plugin-filesize": "^9.0.2",
    "rollup-plugin-serve": "^1.0.3",
    "rollup-plugin-terser": "^7.0.2",
    "rollup-plugin-typescript2": "^0.31.1",
    "rollup-plugin-uglify": "^6.0.4",
    "rollup-plugin-visualizer": "^5.5.4",
    "semantic-release": "^19.0.2",
    shx: "^0.3.4",
    "source-map-support": "^0.5.21",
    "ts-node": "^10.4.0",
    typescript: "^4.5.5",
    "unicode-canonical-property-names-ecmascript": "^2.0.0"
}, files = [
    "dist/"
], keywords = [
    "lottie",
    "animation",
    "lottiefiles",
    "web component",
    "component",
    "lit-element",
    "player",
    "telegram sticker",
    "tgs"
], browserslist = [
    "> 3%"
], publishConfig = {
    access: "public",
    provenance: !0
}, husky = {
    hooks: {
        "commit-msg": "commitlint -E HUSKY_GIT_PARAMS",
        "pre-commit": "lint-staged"
    }
}, nyc = {
    extends: "@istanbuljs/nyc-config-typescript",
    all: !0
}, packageManager = "yarn@1.22.19+sha1.4ba7fc5c6e704fce2066ecbfb0b0d8976fe62447", _package = {
    name: name,
    version: version,
    description: description,
    main: main,
    module: module,
    types: types,
    homepage: homepage,
    repository: repository,
    bugs: bugs,
    author: author,
    license: license,
    scripts: scripts,
    dependencies: dependencies,
    devDependencies: devDependencies,
    files: files,
    keywords: keywords,
    browserslist: browserslist,
    publishConfig: publishConfig,
    husky: husky,
    "lint-staged": {
        "src/**/*.{css,scss,md}": [
            "prettier --write"
        ],
        "src/**/*.{js,jsx,ts,tsx,json}": [
            "eslint . --ext .ts,.tsx,.js --fix"
        ]
    },
    nyc: nyc,
    packageManager: packageManager
}, _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, PlayerState, PlayMode, PlayerEvents;
function parseSrc(t) {
    if ("object" == (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t))) return t;
    try {
        return JSON.parse(t);
    } catch (e) {
        return new URL(t, window.location.href).toString();
    }
}
function isLottie(t) {
    return [
        "v",
        "ip",
        "op",
        "layers",
        "fr",
        "w",
        "h"
    ].every(function(e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    });
}
function fromURL(t) {
    return _fromURL.apply(this, arguments);
}
function _fromURL() {
    return (_fromURL = _asyncToGenerator(function(t) {
        var e, r1, _$i, t1;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ("string" != typeof t) throw new Error("The url value must be a string");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    r1 = new URL(t);
                    return [
                        4,
                        fetch(r1.toString())
                    ];
                case 2:
                    _$i = _state.sent();
                    return [
                        4,
                        _$i.json()
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    t1 = _state.sent();
                    throw new Error("An error occurred while trying to load the Lottie file from URL");
                case 5:
                    return [
                        2,
                        e
                    ];
            }
        });
    })).apply(this, arguments);
}
!function(t) {
    t.Destroyed = "destroyed", t.Error = "error", t.Frozen = "frozen", t.Loading = "loading", t.Paused = "paused", t.Playing = "playing", t.Stopped = "stopped";
}(PlayerState || (PlayerState = {})), function(t) {
    t.Bounce = "bounce", t.Normal = "normal";
}(PlayMode || (PlayMode = {})), function(t) {
    t.Complete = "complete", t.Destroyed = "destroyed", t.Error = "error", t.Frame = "frame", t.Freeze = "freeze", t.Load = "load", t.Loop = "loop", t.Pause = "pause", t.Play = "play", t.Ready = "ready", t.Rendered = "rendered", t.Stop = "stop";
}(PlayerEvents || (PlayerEvents = {}));
var LottiePlayer = /*#__PURE__*/ function(s) {
    "use strict";
    (0, $dcsZi._)(LottiePlayer, s);
    function LottiePlayer() {
        (0, $4GJKx._)(this, LottiePlayer);
        var _this;
        _this = (0, $cYr9j._)(this, LottiePlayer, arguments), _this.autoplay = !1, _this.background = "transparent", _this.controls = !1, _this.currentState = PlayerState.Loading, _this.description = "Lottie animation", _this.direction = 1, _this.disableCheck = !1, _this.disableShadowDOM = !1, _this.hover = !1, _this.intermission = 1, _this.loop = !1, _this.mode = PlayMode.Normal, _this.preserveAspectRatio = "xMidYMid meet", _this.renderer = "svg", _this.speed = 1, _this._io = void 0, _this._counter = 1, _this._onVisibilityChange = function() {
            !0 === document.hidden && _this.currentState === PlayerState.Playing ? _this.freeze() : _this.currentState === PlayerState.Frozen && _this.play();
        };
        return _this;
    }
    (0, $1wc17._)(LottiePlayer, [
        {
            key: "load",
            value: function load(t) {
                var e = this;
                return _asyncToGenerator(function() {
                    var r1, _$i, _$s, a, _tmp, _tmp1, t1;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                r1 = {
                                    container: e.container,
                                    loop: !1,
                                    autoplay: !1,
                                    renderer: e.renderer,
                                    rendererSettings: Object.assign({
                                        preserveAspectRatio: e.preserveAspectRatio,
                                        clearCanvas: !1,
                                        progressiveLoad: !0,
                                        hideOnTransparent: !0
                                    }, e.viewBoxSize && {
                                        viewBoxSize: e.viewBoxSize
                                    })
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                _$i = parseSrc(t), _$s = {}, a = "string" == typeof _$i ? "path" : "animationData";
                                e._lottie && e._lottie.destroy(), e.webworkers && lottie$1.exports.useWebWorker(!0), e._lottie = lottie$1.exports.loadAnimation(Object.assign(Object.assign({}, r1), (0, $3sHb8._)({}, a, _$i))), e._attachEventListeners();
                                _tmp = e.disableCheck;
                                if (_tmp) return [
                                    3,
                                    5
                                ];
                                if (!("path" === a)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    fromURL(_$i)
                                ];
                            case 2:
                                _tmp1 = (_$s = _state.sent(), a = "animationData");
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _tmp1 = _$s = _$i;
                                _state.label = 4;
                            case 4:
                                _tmp = (_tmp1, isLottie(_$s) || (e.currentState = PlayerState.Error, e.dispatchEvent(new CustomEvent(PlayerEvents.Error))));
                                _state.label = 5;
                            case 5:
                                _tmp;
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                t1 = _state.sent();
                                e.currentState = PlayerState.Error, e.dispatchEvent(new CustomEvent(PlayerEvents.Error));
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLottie",
            value: function getLottie() {
                return this._lottie;
            }
        },
        {
            key: "getVersions",
            value: function getVersions() {
                return {
                    lottieWebVersion: dependencies["lottie-web"],
                    lottiePlayerVersion: version
                };
            }
        },
        {
            key: "play",
            value: function play() {
                this._lottie && (this._lottie.play(), this.currentState = PlayerState.Playing, this.dispatchEvent(new CustomEvent(PlayerEvents.Play)));
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._lottie && (this._lottie.pause(), this.currentState = PlayerState.Paused, this.dispatchEvent(new CustomEvent(PlayerEvents.Pause)));
            }
        },
        {
            key: "stop",
            value: function stop() {
                this._lottie && (this._counter = 1, this._lottie.stop(), this.currentState = PlayerState.Stopped, this.dispatchEvent(new CustomEvent(PlayerEvents.Stop)));
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._lottie && (this._lottie.destroy(), this._lottie = null, this.currentState = PlayerState.Destroyed, this.dispatchEvent(new CustomEvent(PlayerEvents.Destroyed)), this.remove());
            }
        },
        {
            key: "seek",
            value: function seek(t) {
                if (this._lottie) {
                    var e = /^(\d+)(%?)$/.exec(t.toString());
                    if (e) {
                        var r1 = "%" === e[2] ? this._lottie.totalFrames * Number(e[1]) / 100 : Number(e[1]);
                        this.seeker = r1, this.currentState === PlayerState.Playing ? this._lottie.goToAndPlay(r1, !0) : (this._lottie.goToAndStop(r1, !0), this._lottie.pause());
                    }
                }
            }
        },
        {
            key: "snapshot",
            value: function snapshot() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                if (this.shadowRoot) {
                    var e = this.shadowRoot.querySelector(".animation svg"), r1 = (new XMLSerializer).serializeToString(e);
                    if (t) {
                        var _$i = document.createElement("a");
                        _$i.href = "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(r1)), _$i.download = "download_".concat(this.seeker, ".svg"), document.body.appendChild(_$i), _$i.click(), document.body.removeChild(_$i);
                    }
                    return r1;
                }
            }
        },
        {
            key: "setSpeed",
            value: function setSpeed() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
                this._lottie && this._lottie.setSpeed(t);
            }
        },
        {
            key: "setDirection",
            value: function setDirection(t) {
                this._lottie && this._lottie.setDirection(t);
            }
        },
        {
            key: "setLooping",
            value: function setLooping(t) {
                this._lottie && (this.loop = t, this._lottie.loop = t);
            }
        },
        {
            key: "togglePlay",
            value: function togglePlay() {
                return this.currentState === PlayerState.Playing ? this.pause() : this.play();
            }
        },
        {
            key: "toggleLooping",
            value: function toggleLooping() {
                this.setLooping(!this.loop);
            }
        },
        {
            key: "resize",
            value: function resize() {
                this._lottie && this._lottie.resize();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.isConnected || (this._io && (this._io.disconnect(), this._io = void 0), document.removeEventListener("visibilitychange", this._onVisibilityChange), this.destroy());
            }
        },
        {
            key: "render",
            value: function render() {
                var t = this.controls ? "main controls" : "main", e = this.controls ? "animation controls" : "animation";
                return $(_templateObject || (_templateObject = _taggedTemplateLiteral([
                    ' <div\n      id="animation-container"\n      class=',
                    '\n      lang="en"\n      aria-label=',
                    '\n      role="img"\n    >\n      <div\n        id="animation"\n        class=',
                    '\n        style="background:',
                    ';"\n      >\n        ',
                    "\n      </div>\n      ",
                    "\n    </div>"
                ])), t, this.description, e, this.background, this.currentState === PlayerState.Error ? $(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
                    '<div class="error">\u26A0\uFE0F</div>'
                ]))) : void 0, this.controls && !this.disableShadowDOM ? this.renderControls() : void 0);
            }
        },
        {
            key: "createRenderRoot",
            value: function createRenderRoot() {
                return this.disableShadowDOM && (this.style.display = "block"), this.disableShadowDOM ? this : (0, $04RAu._)((0, $b8Rim._)(LottiePlayer.prototype), "createRenderRoot", this).call(this);
            }
        },
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                "IntersectionObserver" in window && (this._io = new IntersectionObserver(function(t) {
                    t[0].isIntersecting ? _this.currentState === PlayerState.Frozen && _this.play() : _this.currentState === PlayerState.Playing && _this.freeze();
                }), this._io.observe(this.container)), void 0 !== document.hidden && document.addEventListener("visibilitychange", this._onVisibilityChange), this.src && this.load(this.src), this.dispatchEvent(new CustomEvent(PlayerEvents.Rendered));
            }
        },
        {
            key: "renderControls",
            value: function renderControls() {
                var _this = this;
                var t = this.currentState === PlayerState.Playing, e = this.currentState === PlayerState.Paused, r1 = this.currentState === PlayerState.Stopped;
                return $(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
                    '\n      <div\n        id="lottie-controls"\n        aria-label="lottie-animation-controls"\n        class="toolbar"\n      >\n        <button\n          id="lottie-play-button"\n          @click=',
                    "\n          class=",
                    '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="play-pause"\n        >\n          ',
                    '\n        </button>\n        <button\n          id="lottie-stop-button"\n          @click=',
                    "\n          class=",
                    '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="stop"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path d="M6 6h12v12H6V6z" />\n          </svg>\n        </button>\n        <input\n          id="lottie-seeker-input"\n          class="seeker"\n          type="range"\n          min="0"\n          step="1"\n          max="100"\n          .value=',
                    "\n          @input=",
                    "\n          @mousedown=",
                    "\n          @mouseup=",
                    '\n          aria-valuemin="1"\n          aria-valuemax="100"\n          role="slider"\n          aria-valuenow=',
                    '\n          tabindex="0"\n          aria-label="lottie-seek-input"\n        />\n        <button\n          id="lottie-loop-toggle"\n          @click=',
                    "\n          class=",
                    '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="loop-toggle"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path\n              d="M17.016 17.016v-4.031h1.969v6h-12v3l-3.984-3.984 3.984-3.984v3h10.031zM6.984 6.984v4.031H5.015v-6h12v-3l3.984 3.984-3.984 3.984v-3H6.984z"\n            />\n          </svg>\n        </button>\n      </div>\n    '
                ])), this.togglePlay, t || e ? "active" : "", $(t ? _templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
                    '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path\n                  d="M14.016 5.016H18v13.969h-3.984V5.016zM6 18.984V5.015h3.984v13.969H6z"\n                />\n              </svg>'
                ])) : _templateObject5 || (_templateObject5 = _taggedTemplateLiteral([
                    '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z" />\n              </svg>'
                ]))), this.stop, r1 ? "active" : "", this.seeker, this._handleSeekChange, function() {
                    _this._prevState = _this.currentState, _this.freeze();
                }, function() {
                    _this._prevState === PlayerState.Playing && _this.play();
                }, this.seeker, this.toggleLooping, this.loop ? "active" : "");
            }
        },
        {
            key: "_handleSeekChange",
            value: function _handleSeekChange(t) {
                if (this._lottie && !isNaN(t.target.value)) {
                    var e = t.target.value / 100 * this._lottie.totalFrames;
                    this.seek(e);
                }
            }
        },
        {
            key: "_attachEventListeners",
            value: function _attachEventListeners() {
                var _this = this;
                this._lottie.addEventListener("enterFrame", function() {
                    _this.seeker = _this._lottie.currentFrame / _this._lottie.totalFrames * 100, _this.dispatchEvent(new CustomEvent(PlayerEvents.Frame, {
                        detail: {
                            frame: _this._lottie.currentFrame,
                            seeker: _this.seeker
                        }
                    }));
                }), this._lottie.addEventListener("complete", function() {
                    if (_this.currentState === PlayerState.Playing) {
                        if (!_this.loop || _this.count && _this._counter >= _this.count) {
                            if (_this.dispatchEvent(new CustomEvent(PlayerEvents.Complete)), _this.mode !== PlayMode.Bounce) return;
                            if (0 === _this._lottie.currentFrame) return;
                        }
                        _this.mode === PlayMode.Bounce ? (_this.count && (_this._counter += .5), setTimeout(function() {
                            _this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)), _this.currentState === PlayerState.Playing && (_this._lottie.setDirection(-1 * _this._lottie.playDirection), _this._lottie.play());
                        }, _this.intermission)) : (_this.count && (_this._counter += 1), window.setTimeout(function() {
                            _this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)), _this.currentState === PlayerState.Playing && (-1 === _this.direction ? (_this.seek("99%"), _this.play()) : (_this._lottie.stop(), _this._lottie.play()));
                        }, _this.intermission));
                    } else _this.dispatchEvent(new CustomEvent(PlayerEvents.Complete));
                }), this._lottie.addEventListener("DOMLoaded", function() {
                    _this.setSpeed(_this.speed), _this.setDirection(_this.direction), _this.autoplay && (-1 === _this.direction && _this.seek("100%"), _this.play()), _this.dispatchEvent(new CustomEvent(PlayerEvents.Ready));
                }), this._lottie.addEventListener("data_ready", function() {
                    _this.dispatchEvent(new CustomEvent(PlayerEvents.Load));
                }), this._lottie.addEventListener("data_failed", function() {
                    _this.currentState = PlayerState.Error, _this.dispatchEvent(new CustomEvent(PlayerEvents.Error));
                }), this.container.addEventListener("mouseenter", function() {
                    _this.hover && _this.currentState !== PlayerState.Playing && _this.play();
                }), this.container.addEventListener("mouseleave", function() {
                    _this.hover && _this.currentState === PlayerState.Playing && _this.stop();
                });
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this._lottie && (this._lottie.pause(), this.currentState = PlayerState.Frozen, this.dispatchEvent(new CustomEvent(PlayerEvents.Freeze)));
            }
        }
    ], [
        {
            key: "styles",
            get: function get() {
                return styles;
            }
        }
    ]);
    return LottiePlayer;
}(s);
__decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "autoplay", void 0), __decorate([
    e$5({
        type: String,
        reflect: !0
    })
], LottiePlayer.prototype, "background", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "controls", void 0), __decorate([
    e$5({
        type: Number
    })
], LottiePlayer.prototype, "count", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "currentState", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "description", void 0), __decorate([
    e$5({
        type: Number
    })
], LottiePlayer.prototype, "direction", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "disableCheck", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "disableShadowDOM", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "hover", void 0), __decorate([
    e$5()
], LottiePlayer.prototype, "intermission", void 0), __decorate([
    e$5({
        type: Boolean,
        reflect: !0
    })
], LottiePlayer.prototype, "loop", void 0), __decorate([
    e$5()
], LottiePlayer.prototype, "mode", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "preserveAspectRatio", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "renderer", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "viewBoxSize", void 0), __decorate([
    e$5()
], LottiePlayer.prototype, "seeker", void 0), __decorate([
    e$5({
        type: Number
    })
], LottiePlayer.prototype, "speed", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "src", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "webworkers", void 0), __decorate([
    i(".animation")
], LottiePlayer.prototype, "container", void 0), LottiePlayer = __decorate([
    n$1("lottie-player")
], LottiePlayer);

});
parcelRegister("cYr9j", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $972025e4d4e45634$export$71511d61b312f219; });

var $b8Rim = parcelRequire("b8Rim");

var $9yjJS = parcelRequire("9yjJS");

var $3U0IP = parcelRequire("3U0IP");
function $972025e4d4e45634$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $b8Rim._)(derived);
    return (0, $3U0IP._)(_this, (0, $9yjJS._)() ? Reflect.construct(derived, args || [], (0, $b8Rim._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("b8Rim", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $81c9c858187986cb$export$71511d61b312f219; });
function $81c9c858187986cb$export$71511d61b312f219(o) {
    $81c9c858187986cb$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $81c9c858187986cb$export$71511d61b312f219(o);
}

});

parcelRegister("9yjJS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6f4699ca644cfb51$export$71511d61b312f219; });
function $6f4699ca644cfb51$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($6f4699ca644cfb51$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("3U0IP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2d772972bd4fe337$export$71511d61b312f219; });

var $d3H5E = parcelRequire("d3H5E");

var $l0HdX = parcelRequire("l0HdX");
function $2d772972bd4fe337$export$71511d61b312f219(self, call) {
    if (call && ((0, $l0HdX._)(call) === "object" || typeof call === "function")) return call;
    return (0, $d3H5E._)(self);
}

});
parcelRegister("d3H5E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $981cfaf5c821609e$export$71511d61b312f219; });
function $981cfaf5c821609e$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("l0HdX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f4bb2077aa61b74c$export$71511d61b312f219; });
function $f4bb2077aa61b74c$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("4GJKx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $369e92947825c2b5$export$71511d61b312f219; });
function $369e92947825c2b5$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("1wc17", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $11b219ef186b1c94$export$71511d61b312f219; });
function $11b219ef186b1c94$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $11b219ef186b1c94$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $11b219ef186b1c94$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11b219ef186b1c94$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("3sHb8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $28557b013f37bb6b$export$71511d61b312f219; });
function $28557b013f37bb6b$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("04RAu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $00e9f136d8b86c33$export$71511d61b312f219; });

var $9Fj1i = parcelRequire("9Fj1i");
function $00e9f136d8b86c33$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $00e9f136d8b86c33$export$71511d61b312f219 = Reflect.get;
    else $00e9f136d8b86c33$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $9Fj1i._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $00e9f136d8b86c33$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("9Fj1i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7096b25b59c4b2c1$export$71511d61b312f219; });

var $b8Rim = parcelRequire("b8Rim");
function $7096b25b59c4b2c1$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $b8Rim._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("dcsZi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99c2e1b2c4a01e52$export$71511d61b312f219; });

var $koVwh = parcelRequire("koVwh");
function $99c2e1b2c4a01e52$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $koVwh._)(subClass, superClass);
}

});
parcelRegister("koVwh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $eda2aabf2c4b7bd6$export$71511d61b312f219; });
function $eda2aabf2c4b7bd6$export$71511d61b312f219(o, p) {
    $eda2aabf2c4b7bd6$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eda2aabf2c4b7bd6$export$71511d61b312f219(o, p);
}

});


parcelRegister("cv9Rk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $91a007218046315e$export$71511d61b312f219; });

var $hrk7H = parcelRequire("hrk7H");

var $fBJYg = parcelRequire("fBJYg");

var $e8oCh = parcelRequire("e8oCh");

var $1hjNY = parcelRequire("1hjNY");
function $91a007218046315e$export$71511d61b312f219(arr, i) {
    return (0, $hrk7H._)(arr) || (0, $fBJYg._)(arr, i) || (0, $1hjNY._)(arr, i) || (0, $e8oCh._)();
}

});
parcelRegister("hrk7H", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cb24915816a1cfc9$export$71511d61b312f219; });
function $cb24915816a1cfc9$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("fBJYg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b5cdf895c6f08ea2$export$71511d61b312f219; });
function $b5cdf895c6f08ea2$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("e8oCh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a4a4e8541bb818da$export$71511d61b312f219; });
function $a4a4e8541bb818da$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("1hjNY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0ee6bdd820e270f4$export$71511d61b312f219; });

var $QCMVH = parcelRequire("QCMVH");
function $0ee6bdd820e270f4$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $QCMVH._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $QCMVH._)(o, minLen);
}

});
parcelRegister("QCMVH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09e2f1f84ceddf09$export$71511d61b312f219; });
function $09e2f1f84ceddf09$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("c6Xmf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8d1416c8f734345e$export$71511d61b312f219; });

var $2BACi = parcelRequire("2BACi");

var $djrl5 = parcelRequire("djrl5");

var $jix3C = parcelRequire("jix3C");

var $1hjNY = parcelRequire("1hjNY");
function $8d1416c8f734345e$export$71511d61b312f219(arr) {
    return (0, $2BACi._)(arr) || (0, $djrl5._)(arr) || (0, $1hjNY._)(arr) || (0, $jix3C._)();
}

});
parcelRegister("2BACi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1e5b70c2c2307a84$export$71511d61b312f219; });

var $QCMVH = parcelRequire("QCMVH");
function $1e5b70c2c2307a84$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $QCMVH._)(arr);
}

});

parcelRegister("djrl5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9b1241b318447a2a$export$71511d61b312f219; });
function $9b1241b318447a2a$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("jix3C", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e0c9573dc9b3384a$export$71511d61b312f219; });
function $e0c9573dc9b3384a$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("FuVm8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $07cbd154cab12773$export$71511d61b312f219; });

var $5Gbgo = parcelRequire("5Gbgo");

var $b8Rim = parcelRequire("b8Rim");

var $19aQU = parcelRequire("19aQU");

var $koVwh = parcelRequire("koVwh");
function $07cbd154cab12773$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $07cbd154cab12773$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $19aQU._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $5Gbgo._)(Class, arguments, (0, $b8Rim._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $koVwh._)(Wrapper, Class);
    };
    return $07cbd154cab12773$export$71511d61b312f219(Class);
}

});
parcelRegister("5Gbgo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $42299caecbd14337$export$71511d61b312f219; });

var $9yjJS = parcelRequire("9yjJS");

var $koVwh = parcelRequire("koVwh");
function $42299caecbd14337$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $9yjJS._)()) $42299caecbd14337$export$71511d61b312f219 = Reflect.construct;
    else $42299caecbd14337$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $koVwh._)(instance, Class.prototype);
        return instance;
    };
    return $42299caecbd14337$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("19aQU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0d5f0cc57e65a7f7$export$71511d61b312f219; });
function $0d5f0cc57e65a7f7$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("l29cN", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $f500ece5c74d6d3d$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $l0HdX = parcelRequire("l0HdX");
var $f500ece5c74d6d3d$var$extendStatics = function extendStatics1(d, b) {
    $f500ece5c74d6d3d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f500ece5c74d6d3d$var$extendStatics(d, b);
};
function $f500ece5c74d6d3d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f500ece5c74d6d3d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f500ece5c74d6d3d$export$18ce0697a983be9b = function __assign1() {
    $f500ece5c74d6d3d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f500ece5c74d6d3d$export$18ce0697a983be9b.apply(this, arguments);
};
function $f500ece5c74d6d3d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f500ece5c74d6d3d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $l0HdX._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f500ece5c74d6d3d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f500ece5c74d6d3d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $l0HdX._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f500ece5c74d6d3d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f500ece5c74d6d3d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $l0HdX._)(x)) === "symbol" ? x : "".concat(x);
}
function $f500ece5c74d6d3d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $l0HdX._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f500ece5c74d6d3d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $l0HdX._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f500ece5c74d6d3d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f500ece5c74d6d3d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f500ece5c74d6d3d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f500ece5c74d6d3d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f500ece5c74d6d3d$export$45d3717a4c69092e(o, m, p);
}
function $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f500ece5c74d6d3d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f500ece5c74d6d3d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f500ece5c74d6d3d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f500ece5c74d6d3d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f500ece5c74d6d3d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f500ece5c74d6d3d$export$10c90e4f7922046c(v) {
    return this instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? (this.v = v, this) : new $f500ece5c74d6d3d$export$10c90e4f7922046c(v);
}
function $f500ece5c74d6d3d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f500ece5c74d6d3d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f500ece5c74d6d3d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f500ece5c74d6d3d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f500ece5c74d6d3d$export$19a8beecd37a4c45 === "function" ? $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f500ece5c74d6d3d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f500ece5c74d6d3d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f500ece5c74d6d3d$var$ownKeys = function ownKeys1(o) {
    $f500ece5c74d6d3d$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f500ece5c74d6d3d$var$ownKeys(o);
};
function $f500ece5c74d6d3d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f500ece5c74d6d3d$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f500ece5c74d6d3d$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f500ece5c74d6d3d$var$__setModuleDefault(result, mod);
    return result;
}
function $f500ece5c74d6d3d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f500ece5c74d6d3d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f500ece5c74d6d3d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f500ece5c74d6d3d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $l0HdX._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f500ece5c74d6d3d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f500ece5c74d6d3d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f500ece5c74d6d3d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f500ece5c74d6d3d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f500ece5c74d6d3d$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f500ece5c74d6d3d$export$2e2bcd8739ae039 = {
    __extends: $f500ece5c74d6d3d$export$a8ba968b8961cb8a,
    __assign: $f500ece5c74d6d3d$export$18ce0697a983be9b,
    __rest: $f500ece5c74d6d3d$export$3c9a16f847548506,
    __decorate: $f500ece5c74d6d3d$export$29e00dfd3077644b,
    __param: $f500ece5c74d6d3d$export$d5ad3fd78186038f,
    __esDecorate: $f500ece5c74d6d3d$export$3a84e1ae4e97e9b0,
    __runInitializers: $f500ece5c74d6d3d$export$d831c04e792af3d,
    __propKey: $f500ece5c74d6d3d$export$6a2a36740a146cb8,
    __setFunctionName: $f500ece5c74d6d3d$export$d1a06452d3489bc7,
    __metadata: $f500ece5c74d6d3d$export$f1db080c865becb9,
    __awaiter: $f500ece5c74d6d3d$export$1050f835b63b671e,
    __generator: $f500ece5c74d6d3d$export$67ebef60e6f28a6,
    __createBinding: $f500ece5c74d6d3d$export$45d3717a4c69092e,
    __exportStar: $f500ece5c74d6d3d$export$f33643c0debef087,
    __values: $f500ece5c74d6d3d$export$19a8beecd37a4c45,
    __read: $f500ece5c74d6d3d$export$8d051b38c9118094,
    __spread: $f500ece5c74d6d3d$export$afc72e2116322959,
    __spreadArrays: $f500ece5c74d6d3d$export$6388937ca91ccae8,
    __spreadArray: $f500ece5c74d6d3d$export$1216008129fb82ed,
    __await: $f500ece5c74d6d3d$export$10c90e4f7922046c,
    __asyncGenerator: $f500ece5c74d6d3d$export$e427f37a30a4de9b,
    __asyncDelegator: $f500ece5c74d6d3d$export$bbd80228419bb833,
    __asyncValues: $f500ece5c74d6d3d$export$e3b29a3d6162315f,
    __makeTemplateObject: $f500ece5c74d6d3d$export$4fb47efe1390b86f,
    __importStar: $f500ece5c74d6d3d$export$c21735bcef00d192,
    __importDefault: $f500ece5c74d6d3d$export$da59b14a69baef04,
    __classPrivateFieldGet: $f500ece5c74d6d3d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f500ece5c74d6d3d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f500ece5c74d6d3d$export$81fdc39f203e4e04,
    __addDisposableResource: $f500ece5c74d6d3d$export$88ac25d8e944e405,
    __disposeResources: $f500ece5c74d6d3d$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f500ece5c74d6d3d$export$889dfb5d17574b0b
};

});


var $e0866d2239c2031f$exports = {};
$parcel$extendImportMap({
    "jHiBg": "slider.b6713b1b.js",
    "jba44": "slider.a9ca6f69.css"
});

//import '../assets/css/styles.css';
var $bed8d47175edd3bc$var$header = document.querySelector('header.site-header');
if ($bed8d47175edd3bc$var$header) {
    var $bed8d47175edd3bc$var$headerLinks = document.querySelectorAll('.site-header .menu li a');
    $bed8d47175edd3bc$var$headerLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            $bed8d47175edd3bc$var$header.classList.remove('is-open');
        });
    });
    document.querySelector('.menu-trigger').addEventListener('click', function(e) {
        $bed8d47175edd3bc$var$header.classList.toggle('is-open');
    });
}
function $bed8d47175edd3bc$var$setResponsiveVideo() {
    var videos = document.querySelectorAll('video');
    if (videos) videos.forEach(function(video) {
        if (window.innerWidth < 800) video.setAttribute('src', video.dataset.src_mobile);
        else video.setAttribute('src', video.dataset.src);
    });
}
$bed8d47175edd3bc$var$setResponsiveVideo();
var $bed8d47175edd3bc$var$solutionsMenu = document.querySelector('li.solutions-menu');
if ($bed8d47175edd3bc$var$solutionsMenu) $bed8d47175edd3bc$var$solutionsMenu.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.classList.toggle('active');
    var megaMenu = this.querySelector('.mega-menu');
    if (megaMenu) {
        megaMenu.classList.toggle('hidden');
        megaMenu.addEventListener('click', function(e) {
            e.stopPropagation();
        });
    }
});
var $bed8d47175edd3bc$var$tabLinks = document.querySelectorAll('.tab-links a');
if ($bed8d47175edd3bc$var$tabLinks) $bed8d47175edd3bc$var$tabLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        var targetId = link.getAttribute('href').substring(1);
        var panel = document.getElementById(targetId);
        if (panel) {
            var allPanels = document.querySelectorAll('.tab-panels .panel');
            allPanels.forEach(function(p) {
                return p.classList.add('hidden');
            });
            panel.classList.remove('hidden');
            var allLinks = document.querySelectorAll('.tab-links a');
            allLinks.forEach(function(l) {
                return l.classList.remove('active');
            });
            link.classList.add('active');
        }
    });
});
/*document.querySelectorAll('.accordion details').forEach(detail => {
    const summary = detail.querySelector('summary');
    const content = detail.querySelector('.content');
    content.style.overflow = 'hidden';
    content.style.height = detail.open ? content.scrollHeight + 'px' : '0px';

    summary.addEventListener('click', function(e) {
        e.preventDefault();
        if (detail.open) {
            content.style.height = content.scrollHeight + 'px';
            requestAnimationFrame(() => {
                content.style.height = '0px';
            });
            content.addEventListener('transitionend', function handler() {
                detail.open = false;
                content.removeEventListener('transitionend', handler);
            });
        } else {
            detail.open = true;
            content.style.height = '0px';
            requestAnimationFrame(() => {
                content.style.height = content.scrollHeight + 'px';
            });
        }
    });
});*/ var $bed8d47175edd3bc$var$accordion = document.querySelector('.accordion');
if ($bed8d47175edd3bc$var$accordion) {
    var $bed8d47175edd3bc$var$details = $bed8d47175edd3bc$var$accordion.querySelectorAll('details');
    $bed8d47175edd3bc$var$details.forEach(function(detail) {
        detail.addEventListener('click', function(e) {
            $bed8d47175edd3bc$var$details.forEach(function(d) {
                if (d !== detail) d.removeAttribute('open');
            });
            var content = detail.querySelector('.content');
            detail.addEventListener('toggle', function() {
                if (detail.open) content.style.height = content.scrollHeight + 'px';
                else content.style.height = '0px';
            });
        });
    });
}
var $bed8d47175edd3bc$var$postsCategorySelect = document.querySelector('select[name="category"]');
if ($bed8d47175edd3bc$var$postsCategorySelect) // make fetch request to get posts by category with action get_posts_by_category
$bed8d47175edd3bc$var$postsCategorySelect.addEventListener('change', function() {
    // get selected option data-link attribute
    var link = this.options[this.selectedIndex].dataset.link;
    console.log(link);
    if (link) window.location.href = link;
/*let category = this.value;
        let data = new FormData();
        data.append('action', 'filter_posts_by_category');
        data.append('category', category);

        // get html from ajax request
        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: data
        }).then(response => response.text())
        .then(html => {
            let postsContainer = document.querySelector('.bg-gradient .wp-block-group__inner-container');
            if (postsContainer) {
                //postsContainer.innerHTML = html;

            }
        });*/ });


parcelRequire("6PUGT");
var $61428dc1a1443e1a$var$sectionSliders = document.querySelectorAll('.section-slider');

if ($61428dc1a1443e1a$var$sectionSliders.length > 0) (parcelRequire("1IVwU")).then(function(Slider) {
    new Slider.default();
}).catch(function(err) {
    console.error('Failed to load Slider module:', err);
});

})();
//# sourceMappingURL=index.js.map
